// Generated from King County Metro GTFS on 2026-09-26.
export const STOPS_E_0: [string, string][] = [
  ['1610', 'Prefontaine Pl S & Yesler Way'],
  ['538', '3rd Ave & Columbia St'],
  ['558', '3rd Ave & Seneca St'],
  ['575', '3rd Ave & Pike St'],
  ['600', '3rd Ave & Virginia St'],
  ['605', '3rd Ave & Bell St'],
  ['6236', '7th Ave N & Denny Way'],
  ['6237', '7th Ave N & Harrison St'],
  ['6300', 'Aurora Ave N & Galer St'],
  ['6320', 'Aurora Ave N & Lynn St'],
  ['75409', 'Aurora Ave N & N 46th St'],
  ['7630', 'Woodland Pl N & N 65th St'],
  ['7670', 'Linden Ave N & N 72nd St'],
  ['7690', 'Aurora Ave N & N 76th St'],
  ['7710', 'Aurora Ave N & N 80th St'],
  ['7730', 'Aurora Ave N & N 85th St'],
  ['7750', 'Aurora Ave N & N 91st St'],
  ['7770', 'Aurora Ave N & N 95th St'],
  ['7790', 'Aurora Ave N & N 100th St'],
  ['7810', 'Aurora Ave N & N Northgate Way'],
  ['7850', 'Aurora Ave N & N 115th St'],
  ['7880', 'Aurora Ave N & N 125th St'],
  ['7900', 'Aurora Ave N & N 130th St'],
  ['7912', 'Aurora Ave N & N 135th St'],
  ['75820', 'Aurora Ave N & N 145th St'],
  ['75830', 'Aurora Ave N & N 152nd St'],
  ['75840', 'Aurora Ave N & N 155th St'],
  ['75850', 'Aurora Ave N & N 160th St'],
  ['75860', 'Aurora Ave N & N 165th St'],
  ['75870', 'Aurora Ave N & N 170th St'],
  ['75881', 'Aurora Ave N & N 175th St'],
  ['75890', 'Aurora Ave N & N 180th St'],
  ['75901', 'Aurora Ave N & N 185th St'],
  ['75910', 'Aurora Ave N & N 192nd St'],
  ['75932', 'Aurora Ave N & N 200th St'],
  ['16103', 'Aurora Village Transit Center - Bay 3'],
];
export const TRIPS_E_0: [string, string, string, number[]][] = [
  [
    '761417661',
    '139986',
    'Aurora Village Transit Center',
    [
      645, 646, 648, 650, 651, 651, 652, 653, 656, 657, 663, 666, 668, 669, 670, 671, 672, 673, 674, 675, 677, 679, 680,
      681, 684, 685, 685, 686, 687, 688, 689, 690, 691, 692, 694, 697,
    ],
  ],
  [
    '761418001',
    '139986',
    'Aurora Village Transit Center',
    [
      848, 849, 851, 853, 854, 854, 856, 856, 859, 861, 867, 870, 872, 873, 874, 875, 876, 877, 878, 879, 881, 884, 885,
      886, 889, 890, 891, 892, 893, 894, 895, 896, 897, 899, 901, 904,
    ],
  ],
  [
    '761418431',
    '139986',
    'Aurora Village Transit Center',
    [
      720, 721, 723, 725, 726, 726, 727, 728, 731, 732, 738, 741, 743, 744, 745, 746, 747, 748, 749, 750, 752, 754, 755,
      756, 759, 760, 761, 761, 762, 764, 765, 766, 767, 768, 770, 773,
    ],
  ],
  [
    '761423801',
    '139986',
    'Aurora Village Transit Center',
    [
      420, 421, 423, 425, 426, 426, 427, 428, 431, 432, 438, 441, 442, 443, 444, 445, 446, 446, 447, 448, 450, 452, 453,
      454, 457, 458, 458, 459, 460, 461, 461, 462, 463, 464, 466, 468,
    ],
  ],
  [
    '768603371',
    '139986',
    'Aurora Village Transit Center',
    [
      510, 511, 513, 515, 516, 516, 517, 518, 521, 522, 528, 531, 533, 534, 535, 536, 537, 538, 539, 540, 542, 544, 545,
      546, 549, 550, 550, 551, 552, 553, 554, 555, 556, 557, 559, 561,
    ],
  ],
  [
    '768603481',
    '139986',
    'Aurora Village Transit Center',
    [
      295, 296, 298, 300, 300, 301, 302, 303, 305, 307, 312, 315, 316, 317, 318, 319, 319, 320, 321, 322, 324, 326, 327,
      328, 330, 330, 331, 332, 332, 333, 334, 335, 335, 336, 338, 340,
    ],
  ],
  [
    '768603491',
    '139986',
    'Aurora Village Transit Center',
    [
      728, 729, 731, 733, 734, 734, 735, 736, 739, 740, 746, 749, 751, 752, 753, 754, 755, 756, 757, 758, 760, 762, 763,
      764, 767, 768, 769, 769, 770, 772, 773, 774, 775, 776, 778, 781,
    ],
  ],
  [
    '768603701',
    '139986',
    'Aurora Village Transit Center',
    [
      325, 326, 328, 330, 330, 331, 332, 333, 335, 337, 342, 345, 346, 347, 348, 349, 349, 350, 351, 352, 354, 356, 357,
      358, 360, 361, 361, 362, 363, 364, 364, 365, 366, 367, 369, 371,
    ],
  ],
  [
    '768604231',
    '139986',
    'Aurora Village Transit Center',
    [
      960, 961, 964, 966, 967, 968, 969, 970, 973, 974, 981, 985, 986, 987, 988, 990, 991, 992, 993, 994, 996, 999,
      1000, 1001, 1004, 1005, 1006, 1007, 1008, 1009, 1010, 1011, 1012, 1014, 1016, 1019,
    ],
  ],
  [
    '813076421',
    '139986',
    'Aurora Village Transit Center',
    [
      380, 381, 383, 385, 386, 386, 387, 388, 391, 392, 398, 401, 402, 403, 404, 405, 406, 406, 407, 408, 410, 412, 413,
      414, 417, 418, 418, 419, 420, 421, 421, 422, 423, 424, 426, 428,
    ],
  ],
  [
    '813076451',
    '139986',
    'Aurora Village Transit Center',
    [
      345, 346, 348, 350, 351, 351, 352, 353, 356, 357, 363, 366, 367, 368, 369, 370, 371, 371, 372, 373, 375, 377, 378,
      379, 382, 383, 383, 384, 385, 386, 386, 387, 388, 389, 391, 393,
    ],
  ],
  [
    '813076491',
    '139986',
    'Aurora Village Transit Center',
    [
      360, 361, 363, 365, 366, 366, 367, 368, 371, 372, 378, 381, 382, 383, 384, 385, 386, 386, 387, 388, 390, 392, 393,
      394, 397, 398, 398, 399, 400, 401, 401, 402, 403, 404, 406, 408,
    ],
  ],
  [
    '813076921',
    '139986',
    'Aurora Village Transit Center',
    [
      370, 371, 373, 375, 376, 376, 377, 378, 381, 382, 388, 391, 392, 393, 394, 395, 396, 396, 397, 398, 400, 402, 403,
      404, 407, 408, 408, 409, 410, 411, 411, 412, 413, 414, 416, 418,
    ],
  ],
  [
    '813078131',
    '139986',
    'Aurora Village Transit Center',
    [
      840, 841, 843, 845, 846, 846, 848, 848, 851, 853, 859, 862, 864, 865, 866, 867, 868, 869, 870, 871, 873, 876, 877,
      878, 881, 882, 883, 884, 885, 886, 887, 888, 889, 891, 893, 896,
    ],
  ],
  [
    '833144431',
    '139986',
    'Aurora Village Transit Center',
    [
      1258, 1259, 1261, 1263, 1264, 1264, 1266, 1266, 1269, 1271, 1277, 1280, 1282, 1283, 1284, 1285, 1286, 1287, 1288,
      1289, 1291, 1294, 1295, 1296, 1299, 1300, 1300, 1301, 1302, 1303, 1303, 1304, 1305, 1306, 1308, 1310,
    ],
  ],
  [
    '833248121',
    '139986',
    'Aurora Village Transit Center',
    [
      965, 966, 969, 971, 972, 973, 974, 975, 978, 979, 986, 990, 991, 992, 993, 995, 996, 997, 998, 999, 1001, 1004,
      1005, 1006, 1009, 1010, 1011, 1012, 1013, 1014, 1015, 1016, 1017, 1019, 1021, 1024,
    ],
  ],
  [
    '847099501',
    '139986',
    'Aurora Village Transit Center',
    [
      465, 466, 468, 470, 471, 471, 472, 473, 476, 477, 483, 486, 488, 489, 490, 491, 492, 493, 494, 495, 497, 499, 500,
      501, 504, 505, 505, 506, 507, 508, 509, 510, 511, 512, 514, 516,
    ],
  ],
  [
    '849268751',
    '139986',
    'Aurora Village Transit Center',
    [
      1669, 1670, 1672, 1674, 1675, 1675, 1677, 1677, 1680, 1682, 1688, 1691, 1692, 1693, 1694, 1695, 1696, 1696, 1697,
      1698, 1700, 1702, 1703, 1704, 1707, 1707, 1708, 1709, 1709, 1710, 1711, 1712, 1712, 1713, 1715, 1717,
    ],
  ],
  [
    '849268841',
    '139986',
    'Aurora Village Transit Center',
    [
      492, 493, 495, 497, 498, 498, 499, 500, 503, 504, 510, 513, 515, 516, 517, 518, 519, 520, 521, 522, 524, 526, 527,
      528, 531, 532, 532, 533, 534, 535, 536, 537, 538, 539, 541, 543,
    ],
  ],
  [
    '849268871',
    '139986',
    'Aurora Village Transit Center',
    [
      636, 637, 639, 641, 642, 642, 643, 644, 647, 648, 654, 657, 659, 660, 661, 662, 663, 664, 665, 666, 668, 670, 671,
      672, 675, 676, 676, 677, 678, 679, 680, 681, 682, 683, 685, 688,
    ],
  ],
  [
    '849268881',
    '139986',
    'Aurora Village Transit Center',
    [
      654, 655, 657, 659, 660, 660, 661, 662, 665, 666, 672, 675, 677, 678, 679, 680, 681, 682, 683, 684, 686, 688, 689,
      690, 693, 694, 694, 695, 696, 697, 698, 699, 700, 701, 703, 706,
    ],
  ],
  [
    '849268931',
    '139986',
    'Aurora Village Transit Center',
    [
      429, 430, 432, 434, 435, 435, 436, 437, 440, 441, 447, 450, 451, 452, 453, 454, 455, 456, 457, 458, 460, 462, 463,
      464, 467, 468, 468, 469, 470, 471, 472, 473, 474, 475, 477, 479,
    ],
  ],
  [
    '849268961',
    '139986',
    'Aurora Village Transit Center',
    [
      573, 574, 576, 578, 579, 579, 580, 581, 584, 585, 591, 594, 596, 597, 598, 599, 600, 601, 602, 603, 605, 607, 608,
      609, 612, 613, 613, 614, 615, 616, 617, 618, 619, 620, 622, 625,
    ],
  ],
  [
    '849269001',
    '139986',
    'Aurora Village Transit Center',
    [
      400, 401, 403, 405, 406, 406, 407, 408, 411, 412, 418, 421, 422, 423, 424, 425, 426, 426, 427, 428, 430, 432, 433,
      434, 437, 438, 438, 439, 440, 441, 441, 442, 443, 444, 446, 448,
    ],
  ],
  [
    '849269021',
    '139986',
    'Aurora Village Transit Center',
    [
      872, 873, 876, 878, 879, 879, 881, 881, 884, 886, 892, 895, 897, 898, 899, 900, 901, 902, 903, 904, 906, 909, 910,
      911, 914, 915, 916, 917, 918, 919, 920, 921, 922, 924, 926, 929,
    ],
  ],
  [
    '849269041',
    '139986',
    'Aurora Village Transit Center',
    [
      936, 937, 940, 942, 943, 943, 945, 945, 948, 950, 956, 960, 961, 962, 963, 965, 966, 967, 968, 969, 971, 974, 975,
      976, 979, 980, 981, 982, 983, 984, 985, 986, 987, 989, 991, 994,
    ],
  ],
  [
    '849269051',
    '139986',
    'Aurora Village Transit Center',
    [
      410, 411, 413, 415, 416, 416, 417, 418, 421, 422, 428, 431, 432, 433, 434, 435, 436, 436, 437, 438, 440, 442, 443,
      444, 447, 448, 448, 449, 450, 451, 451, 452, 453, 454, 456, 458,
    ],
  ],
  [
    '849269121',
    '139986',
    'Aurora Village Transit Center',
    [
      1035, 1036, 1039, 1041, 1042, 1043, 1044, 1045, 1048, 1049, 1056, 1060, 1061, 1062, 1063, 1065, 1066, 1067, 1068,
      1069, 1071, 1074, 1075, 1076, 1079, 1080, 1081, 1081, 1082, 1084, 1085, 1086, 1087, 1088, 1090, 1093,
    ],
  ],
  [
    '849269131',
    '139986',
    'Aurora Village Transit Center',
    [
      1095, 1096, 1099, 1101, 1102, 1102, 1104, 1104, 1107, 1109, 1115, 1118, 1120, 1121, 1122, 1123, 1124, 1125, 1126,
      1127, 1129, 1132, 1133, 1134, 1137, 1138, 1138, 1139, 1140, 1141, 1142, 1143, 1144, 1145, 1147, 1150,
    ],
  ],
  [
    '849269161',
    '139986',
    'Aurora Village Transit Center',
    [
      438, 439, 441, 443, 444, 444, 445, 446, 449, 450, 456, 459, 460, 461, 462, 463, 464, 465, 466, 467, 469, 471, 472,
      473, 476, 477, 477, 478, 479, 480, 481, 482, 483, 484, 486, 488,
    ],
  ],
  [
    '849269181',
    '139986',
    'Aurora Village Transit Center',
    [
      1182, 1183, 1185, 1187, 1188, 1188, 1190, 1190, 1193, 1195, 1201, 1204, 1206, 1207, 1208, 1209, 1210, 1211, 1212,
      1213, 1215, 1218, 1219, 1220, 1223, 1224, 1224, 1225, 1226, 1227, 1227, 1228, 1229, 1230, 1232, 1235,
    ],
  ],
  [
    '849269191',
    '139986',
    'Aurora Village Transit Center',
    [
      447, 448, 450, 452, 453, 453, 454, 455, 458, 459, 465, 468, 470, 471, 472, 473, 474, 475, 476, 477, 479, 481, 482,
      483, 486, 487, 487, 488, 489, 490, 491, 492, 493, 494, 496, 498,
    ],
  ],
  [
    '849269281',
    '139986',
    'Aurora Village Transit Center',
    [
      1315, 1316, 1318, 1320, 1321, 1321, 1323, 1323, 1326, 1328, 1334, 1337, 1339, 1340, 1341, 1342, 1343, 1344, 1345,
      1346, 1348, 1350, 1351, 1352, 1355, 1356, 1356, 1357, 1358, 1359, 1359, 1360, 1361, 1362, 1364, 1366,
    ],
  ],
  [
    '849269311',
    '139986',
    'Aurora Village Transit Center',
    [
      792, 793, 795, 797, 798, 798, 799, 800, 803, 804, 810, 813, 815, 816, 817, 818, 819, 820, 821, 822, 824, 826, 827,
      828, 831, 832, 833, 833, 834, 836, 837, 838, 839, 840, 842, 845,
    ],
  ],
  [
    '849269331',
    '139986',
    'Aurora Village Transit Center',
    [
      390, 391, 393, 395, 396, 396, 397, 398, 401, 402, 408, 411, 412, 413, 414, 415, 416, 416, 417, 418, 420, 422, 423,
      424, 427, 428, 428, 429, 430, 431, 431, 432, 433, 434, 436, 438,
    ],
  ],
  [
    '849269351',
    '139986',
    'Aurora Village Transit Center',
    [
      519, 520, 522, 524, 525, 525, 526, 527, 530, 531, 537, 540, 542, 543, 544, 545, 546, 547, 548, 549, 551, 553, 554,
      555, 558, 559, 559, 560, 561, 562, 563, 564, 565, 566, 568, 570,
    ],
  ],
  [
    '849269371',
    '139986',
    'Aurora Village Transit Center',
    [
      1102, 1103, 1106, 1108, 1109, 1109, 1111, 1111, 1114, 1116, 1122, 1125, 1127, 1128, 1129, 1130, 1131, 1132, 1133,
      1134, 1136, 1139, 1140, 1141, 1144, 1145, 1145, 1146, 1147, 1148, 1149, 1150, 1151, 1152, 1154, 1157,
    ],
  ],
  [
    '849269381',
    '139986',
    'Aurora Village Transit Center',
    [
      944, 945, 948, 950, 951, 951, 953, 953, 956, 958, 964, 968, 969, 970, 971, 973, 974, 975, 976, 977, 979, 982, 983,
      984, 987, 988, 989, 990, 991, 992, 993, 994, 995, 997, 999, 1002,
    ],
  ],
  [
    '849269391',
    '139986',
    'Aurora Village Transit Center',
    [
      663, 664, 666, 668, 669, 669, 670, 671, 674, 675, 681, 684, 686, 687, 688, 689, 690, 691, 692, 693, 695, 697, 698,
      699, 702, 703, 703, 704, 705, 706, 707, 708, 709, 710, 712, 715,
    ],
  ],
  [
    '849269441',
    '139986',
    'Aurora Village Transit Center',
    [
      1166, 1167, 1169, 1171, 1172, 1172, 1174, 1174, 1177, 1179, 1185, 1188, 1190, 1191, 1192, 1193, 1194, 1195, 1196,
      1197, 1199, 1202, 1203, 1204, 1207, 1208, 1208, 1209, 1210, 1211, 1212, 1213, 1214, 1215, 1217, 1220,
    ],
  ],
  [
    '849269461',
    '139986',
    'Aurora Village Transit Center',
    [
      1005, 1006, 1009, 1011, 1012, 1013, 1014, 1015, 1018, 1019, 1026, 1030, 1031, 1032, 1033, 1035, 1036, 1037, 1038,
      1039, 1041, 1044, 1045, 1046, 1049, 1050, 1051, 1051, 1052, 1054, 1055, 1056, 1057, 1058, 1060, 1063,
    ],
  ],
  [
    '849269481',
    '139986',
    'Aurora Village Transit Center',
    [
      546, 547, 549, 551, 552, 552, 553, 554, 557, 558, 564, 567, 569, 570, 571, 572, 573, 574, 575, 576, 578, 580, 581,
      582, 585, 586, 586, 587, 588, 589, 590, 591, 592, 593, 595, 597,
    ],
  ],
  [
    '849269521',
    '139986',
    'Aurora Village Transit Center',
    [
      696, 697, 699, 701, 702, 702, 703, 704, 707, 708, 714, 717, 719, 720, 721, 722, 723, 724, 725, 726, 728, 730, 731,
      732, 735, 736, 737, 737, 738, 740, 741, 742, 743, 744, 746, 749,
    ],
  ],
  [
    '849269561',
    '139986',
    'Aurora Village Transit Center',
    [
      1134, 1135, 1138, 1140, 1141, 1141, 1143, 1143, 1146, 1148, 1154, 1157, 1159, 1160, 1161, 1162, 1163, 1164, 1165,
      1166, 1168, 1171, 1172, 1173, 1176, 1177, 1177, 1178, 1179, 1180, 1181, 1182, 1183, 1184, 1186, 1189,
    ],
  ],
  [
    '849269571',
    '139986',
    'Aurora Village Transit Center',
    [
      808, 809, 811, 813, 814, 814, 815, 816, 819, 820, 826, 829, 831, 832, 833, 834, 835, 836, 837, 838, 840, 843, 844,
      845, 848, 849, 850, 850, 851, 853, 854, 855, 856, 857, 859, 862,
    ],
  ],
  [
    '849269591',
    '139986',
    'Aurora Village Transit Center',
    [
      1270, 1271, 1273, 1275, 1276, 1276, 1278, 1278, 1281, 1283, 1289, 1292, 1294, 1295, 1296, 1297, 1298, 1299, 1300,
      1301, 1303, 1306, 1307, 1308, 1311, 1312, 1312, 1313, 1314, 1315, 1315, 1316, 1317, 1318, 1320, 1322,
    ],
  ],
  [
    '849269621',
    '139986',
    'Aurora Village Transit Center',
    [
      800, 801, 803, 805, 806, 806, 807, 808, 811, 812, 818, 821, 823, 824, 825, 826, 827, 828, 829, 830, 832, 835, 836,
      837, 840, 841, 842, 842, 843, 845, 846, 847, 848, 849, 851, 854,
    ],
  ],
  [
    '849269651',
    '139986',
    'Aurora Village Transit Center',
    [
      1110, 1111, 1114, 1116, 1117, 1117, 1119, 1119, 1122, 1124, 1130, 1133, 1135, 1136, 1137, 1138, 1139, 1140, 1141,
      1142, 1144, 1147, 1148, 1149, 1152, 1153, 1153, 1154, 1155, 1156, 1157, 1158, 1159, 1160, 1162, 1165,
    ],
  ],
  [
    '849269671',
    '139986',
    'Aurora Village Transit Center',
    [
      952, 953, 956, 958, 959, 959, 961, 961, 964, 966, 972, 976, 977, 978, 979, 981, 982, 983, 984, 985, 987, 990, 991,
      992, 995, 996, 997, 998, 999, 1000, 1001, 1002, 1003, 1005, 1007, 1010,
    ],
  ],
  [
    '849269691',
    '139986',
    'Aurora Village Transit Center',
    [
      1375, 1376, 1378, 1380, 1381, 1381, 1383, 1383, 1386, 1388, 1394, 1397, 1398, 1399, 1400, 1401, 1402, 1402, 1403,
      1404, 1406, 1408, 1409, 1410, 1413, 1413, 1414, 1415, 1415, 1416, 1417, 1418, 1418, 1419, 1421, 1423,
    ],
  ],
  [
    '849269701',
    '139986',
    'Aurora Village Transit Center',
    [
      1234, 1235, 1237, 1239, 1240, 1240, 1242, 1242, 1245, 1247, 1253, 1256, 1258, 1259, 1260, 1261, 1262, 1263, 1264,
      1265, 1267, 1270, 1271, 1272, 1275, 1276, 1276, 1277, 1278, 1279, 1279, 1280, 1281, 1282, 1284, 1287,
    ],
  ],
  [
    '849269711',
    '139986',
    'Aurora Village Transit Center',
    [
      980, 981, 984, 986, 987, 988, 989, 990, 993, 994, 1001, 1005, 1006, 1007, 1008, 1010, 1011, 1012, 1013, 1014,
      1016, 1019, 1020, 1021, 1024, 1025, 1026, 1027, 1028, 1029, 1030, 1031, 1032, 1034, 1036, 1039,
    ],
  ],
  [
    '849269721',
    '139986',
    'Aurora Village Transit Center',
    [
      990, 991, 994, 996, 997, 998, 999, 1000, 1003, 1004, 1011, 1015, 1016, 1017, 1018, 1020, 1021, 1022, 1023, 1024,
      1026, 1029, 1030, 1031, 1034, 1035, 1036, 1037, 1038, 1039, 1040, 1041, 1042, 1044, 1046, 1049,
    ],
  ],
  [
    '849269731',
    '139986',
    'Aurora Village Transit Center',
    [
      1118, 1119, 1122, 1124, 1125, 1125, 1127, 1127, 1130, 1132, 1138, 1141, 1143, 1144, 1145, 1146, 1147, 1148, 1149,
      1150, 1152, 1155, 1156, 1157, 1160, 1161, 1161, 1162, 1163, 1164, 1165, 1166, 1167, 1168, 1170, 1173,
    ],
  ],
  [
    '849269741',
    '139986',
    'Aurora Village Transit Center',
    [
      1150, 1151, 1153, 1155, 1156, 1156, 1158, 1158, 1161, 1163, 1169, 1172, 1174, 1175, 1176, 1177, 1178, 1179, 1180,
      1181, 1183, 1186, 1187, 1188, 1191, 1192, 1192, 1193, 1194, 1195, 1196, 1197, 1198, 1199, 1201, 1204,
    ],
  ],
  [
    '849269761',
    '139986',
    'Aurora Village Transit Center',
    [
      995, 996, 999, 1001, 1002, 1003, 1004, 1005, 1008, 1009, 1016, 1020, 1021, 1022, 1023, 1025, 1026, 1027, 1028,
      1029, 1031, 1034, 1035, 1036, 1039, 1040, 1041, 1041, 1042, 1044, 1045, 1046, 1047, 1048, 1050, 1053,
    ],
  ],
  [
    '849269781',
    '139986',
    'Aurora Village Transit Center',
    [
      1015, 1016, 1019, 1021, 1022, 1023, 1024, 1025, 1028, 1029, 1036, 1040, 1041, 1042, 1043, 1045, 1046, 1047, 1048,
      1049, 1051, 1054, 1055, 1056, 1059, 1060, 1061, 1061, 1062, 1064, 1065, 1066, 1067, 1068, 1070, 1073,
    ],
  ],
  [
    '849269791',
    '139986',
    'Aurora Village Transit Center',
    [
      1174, 1175, 1177, 1179, 1180, 1180, 1182, 1182, 1185, 1187, 1193, 1196, 1198, 1199, 1200, 1201, 1202, 1203, 1204,
      1205, 1207, 1210, 1211, 1212, 1215, 1216, 1216, 1217, 1218, 1219, 1219, 1220, 1221, 1222, 1224, 1227,
    ],
  ],
  [
    '849269801',
    '139986',
    'Aurora Village Transit Center',
    [
      1025, 1026, 1029, 1031, 1032, 1033, 1034, 1035, 1038, 1039, 1046, 1050, 1051, 1052, 1053, 1055, 1056, 1057, 1058,
      1059, 1061, 1064, 1065, 1066, 1069, 1070, 1071, 1071, 1072, 1074, 1075, 1076, 1077, 1078, 1080, 1083,
    ],
  ],
  [
    '849269811',
    '139986',
    'Aurora Village Transit Center',
    [
      1190, 1191, 1193, 1195, 1196, 1196, 1198, 1198, 1201, 1203, 1209, 1212, 1214, 1215, 1216, 1217, 1218, 1219, 1220,
      1221, 1223, 1226, 1227, 1228, 1231, 1232, 1232, 1233, 1234, 1235, 1235, 1236, 1237, 1238, 1240, 1243,
    ],
  ],
  [
    '849269831',
    '139986',
    'Aurora Village Transit Center',
    [
      1330, 1331, 1333, 1335, 1336, 1336, 1338, 1338, 1341, 1343, 1349, 1352, 1354, 1355, 1356, 1357, 1358, 1358, 1359,
      1360, 1362, 1364, 1365, 1366, 1369, 1370, 1370, 1371, 1372, 1373, 1373, 1374, 1375, 1376, 1378, 1380,
    ],
  ],
  [
    '849269851',
    '139986',
    'Aurora Village Transit Center',
    [
      1045, 1046, 1049, 1051, 1052, 1053, 1054, 1055, 1058, 1059, 1066, 1070, 1071, 1072, 1073, 1075, 1076, 1077, 1078,
      1079, 1081, 1084, 1085, 1086, 1089, 1090, 1091, 1091, 1092, 1094, 1095, 1096, 1097, 1098, 1100, 1103,
    ],
  ],
  [
    '849269871',
    '139986',
    'Aurora Village Transit Center',
    [
      1055, 1056, 1059, 1061, 1062, 1063, 1064, 1065, 1068, 1069, 1076, 1080, 1081, 1082, 1083, 1085, 1086, 1087, 1088,
      1089, 1091, 1094, 1095, 1096, 1099, 1100, 1100, 1101, 1102, 1103, 1104, 1105, 1106, 1107, 1109, 1112,
    ],
  ],
  [
    '849269891',
    '139986',
    'Aurora Village Transit Center',
    [
      1065, 1066, 1069, 1071, 1072, 1073, 1074, 1075, 1078, 1079, 1086, 1090, 1091, 1092, 1093, 1095, 1096, 1097, 1098,
      1099, 1101, 1104, 1105, 1106, 1109, 1110, 1110, 1111, 1112, 1113, 1114, 1115, 1116, 1117, 1119, 1122,
    ],
  ],
  [
    '849269901',
    '139986',
    'Aurora Village Transit Center',
    [
      1070, 1071, 1074, 1076, 1077, 1078, 1079, 1080, 1083, 1084, 1091, 1095, 1096, 1097, 1098, 1100, 1101, 1102, 1103,
      1104, 1106, 1109, 1110, 1111, 1114, 1115, 1115, 1116, 1117, 1118, 1119, 1120, 1121, 1122, 1124, 1127,
    ],
  ],
  [
    '849269911',
    '139986',
    'Aurora Village Transit Center',
    [
      1085, 1086, 1089, 1091, 1092, 1093, 1094, 1095, 1098, 1099, 1106, 1109, 1111, 1112, 1113, 1114, 1115, 1116, 1117,
      1118, 1120, 1123, 1124, 1125, 1128, 1129, 1129, 1130, 1131, 1132, 1133, 1134, 1135, 1136, 1138, 1141,
    ],
  ],
  [
    '849269921',
    '139986',
    'Aurora Village Transit Center',
    [
      1609, 1610, 1612, 1614, 1615, 1615, 1617, 1617, 1620, 1622, 1628, 1631, 1632, 1633, 1634, 1635, 1636, 1636, 1637,
      1638, 1640, 1642, 1643, 1644, 1647, 1647, 1648, 1649, 1649, 1650, 1651, 1652, 1652, 1653, 1655, 1657,
    ],
  ],
  [
    '849269941',
    '139986',
    'Aurora Village Transit Center',
    [
      1360, 1361, 1363, 1365, 1366, 1366, 1368, 1368, 1371, 1373, 1379, 1382, 1384, 1385, 1386, 1387, 1388, 1388, 1389,
      1390, 1392, 1394, 1395, 1396, 1399, 1399, 1400, 1401, 1401, 1402, 1403, 1404, 1404, 1405, 1407, 1409,
    ],
  ],
  [
    '849269961',
    '139986',
    'Aurora Village Transit Center',
    [
      1480, 1481, 1483, 1485, 1486, 1486, 1488, 1488, 1491, 1493, 1499, 1502, 1503, 1504, 1505, 1506, 1507, 1507, 1508,
      1509, 1511, 1513, 1514, 1515, 1518, 1518, 1519, 1520, 1520, 1521, 1522, 1523, 1523, 1524, 1526, 1528,
    ],
  ],
  [
    '849269991',
    '139986',
    'Aurora Village Transit Center',
    [
      1090, 1091, 1094, 1096, 1097, 1097, 1099, 1099, 1102, 1104, 1110, 1113, 1115, 1116, 1117, 1118, 1119, 1120, 1121,
      1122, 1124, 1127, 1128, 1129, 1132, 1133, 1133, 1134, 1135, 1136, 1137, 1138, 1139, 1140, 1142, 1145,
    ],
  ],
  [
    '849270001',
    '139986',
    'Aurora Village Transit Center',
    [
      1222, 1223, 1225, 1227, 1228, 1228, 1230, 1230, 1233, 1235, 1241, 1244, 1246, 1247, 1248, 1249, 1250, 1251, 1252,
      1253, 1255, 1258, 1259, 1260, 1263, 1264, 1264, 1265, 1266, 1267, 1267, 1268, 1269, 1270, 1272, 1275,
    ],
  ],
  [
    '849270031',
    '139986',
    'Aurora Village Transit Center',
    [
      1540, 1541, 1543, 1545, 1546, 1546, 1548, 1548, 1551, 1553, 1559, 1562, 1563, 1564, 1565, 1566, 1567, 1567, 1568,
      1569, 1571, 1573, 1574, 1575, 1578, 1578, 1579, 1580, 1580, 1581, 1582, 1583, 1583, 1584, 1586, 1588,
    ],
  ],
  [
    '849270051',
    '139986',
    'Aurora Village Transit Center',
    [
      1420, 1421, 1423, 1425, 1426, 1426, 1428, 1428, 1431, 1433, 1439, 1442, 1443, 1444, 1445, 1446, 1447, 1447, 1448,
      1449, 1451, 1453, 1454, 1455, 1458, 1458, 1459, 1460, 1460, 1461, 1462, 1463, 1463, 1464, 1466, 1468,
    ],
  ],
  [
    '849270061',
    '139986',
    'Aurora Village Transit Center',
    [
      1158, 1159, 1161, 1163, 1164, 1164, 1166, 1166, 1169, 1171, 1177, 1180, 1182, 1183, 1184, 1185, 1186, 1187, 1188,
      1189, 1191, 1194, 1195, 1196, 1199, 1200, 1200, 1201, 1202, 1203, 1204, 1205, 1206, 1207, 1209, 1212,
    ],
  ],
  [
    '849270071',
    '139986',
    'Aurora Village Transit Center',
    [
      1285, 1286, 1288, 1290, 1291, 1291, 1293, 1293, 1296, 1298, 1304, 1307, 1309, 1310, 1311, 1312, 1313, 1314, 1315,
      1316, 1318, 1321, 1322, 1323, 1326, 1327, 1327, 1328, 1329, 1330, 1330, 1331, 1332, 1333, 1335, 1337,
    ],
  ],
  [
    '849270111',
    '139986',
    'Aurora Village Transit Center',
    [
      456, 457, 459, 461, 462, 462, 463, 464, 467, 468, 474, 477, 479, 480, 481, 482, 483, 484, 485, 486, 488, 490, 491,
      492, 495, 496, 496, 497, 498, 499, 500, 501, 502, 503, 505, 507,
    ],
  ],
  [
    '849270161',
    '139986',
    'Aurora Village Transit Center',
    [
      474, 475, 477, 479, 480, 480, 481, 482, 485, 486, 492, 495, 497, 498, 499, 500, 501, 502, 503, 504, 506, 508, 509,
      510, 513, 514, 514, 515, 516, 517, 518, 519, 520, 521, 523, 525,
    ],
  ],
  [
    '849270181',
    '139986',
    'Aurora Village Transit Center',
    [
      483, 484, 486, 488, 489, 489, 490, 491, 494, 495, 501, 504, 506, 507, 508, 509, 510, 511, 512, 513, 515, 517, 518,
      519, 522, 523, 523, 524, 525, 526, 527, 528, 529, 530, 532, 534,
    ],
  ],
  [
    '849270221',
    '139986',
    'Aurora Village Transit Center',
    [
      600, 601, 603, 605, 606, 606, 607, 608, 611, 612, 618, 621, 623, 624, 625, 626, 627, 628, 629, 630, 632, 634, 635,
      636, 639, 640, 640, 641, 642, 643, 644, 645, 646, 647, 649, 652,
    ],
  ],
  [
    '849270231',
    '139986',
    'Aurora Village Transit Center',
    [
      618, 619, 621, 623, 624, 624, 625, 626, 629, 630, 636, 639, 641, 642, 643, 644, 645, 646, 647, 648, 650, 652, 653,
      654, 657, 658, 658, 659, 660, 661, 662, 663, 664, 665, 667, 670,
    ],
  ],
  [
    '849270261',
    '139986',
    'Aurora Village Transit Center',
    [
      501, 502, 504, 506, 507, 507, 508, 509, 512, 513, 519, 522, 524, 525, 526, 527, 528, 529, 530, 531, 533, 535, 536,
      537, 540, 541, 541, 542, 543, 544, 545, 546, 547, 548, 550, 552,
    ],
  ],
  [
    '849270311',
    '139986',
    'Aurora Village Transit Center',
    [
      752, 753, 755, 757, 758, 758, 759, 760, 763, 764, 770, 773, 775, 776, 777, 778, 779, 780, 781, 782, 784, 786, 787,
      788, 791, 792, 793, 793, 794, 796, 797, 798, 799, 800, 802, 805,
    ],
  ],
  [
    '849270321',
    '139986',
    'Aurora Village Transit Center',
    [
      768, 769, 771, 773, 774, 774, 775, 776, 779, 780, 786, 789, 791, 792, 793, 794, 795, 796, 797, 798, 800, 802, 803,
      804, 807, 808, 809, 809, 810, 812, 813, 814, 815, 816, 818, 821,
    ],
  ],
  [
    '849270331',
    '139986',
    'Aurora Village Transit Center',
    [
      528, 529, 531, 533, 534, 534, 535, 536, 539, 540, 546, 549, 551, 552, 553, 554, 555, 556, 557, 558, 560, 562, 563,
      564, 567, 568, 568, 569, 570, 571, 572, 573, 574, 575, 577, 579,
    ],
  ],
  [
    '849270371',
    '139986',
    'Aurora Village Transit Center',
    [
      784, 785, 787, 789, 790, 790, 791, 792, 795, 796, 802, 805, 807, 808, 809, 810, 811, 812, 813, 814, 816, 818, 819,
      820, 823, 824, 825, 825, 826, 828, 829, 830, 831, 832, 834, 837,
    ],
  ],
  [
    '849270381',
    '139986',
    'Aurora Village Transit Center',
    [
      672, 673, 675, 677, 678, 678, 679, 680, 683, 684, 690, 693, 695, 696, 697, 698, 699, 700, 701, 702, 704, 706, 707,
      708, 711, 712, 713, 713, 714, 716, 717, 718, 719, 720, 722, 725,
    ],
  ],
  [
    '849270411',
    '139986',
    'Aurora Village Transit Center',
    [
      896, 897, 900, 902, 903, 903, 905, 905, 908, 910, 916, 920, 921, 922, 923, 925, 926, 927, 928, 929, 931, 934, 935,
      936, 939, 940, 941, 942, 943, 944, 945, 946, 947, 949, 951, 954,
    ],
  ],
  [
    '849270451',
    '139986',
    'Aurora Village Transit Center',
    [
      824, 825, 827, 829, 830, 830, 832, 832, 835, 837, 843, 846, 848, 849, 850, 851, 852, 853, 854, 855, 857, 860, 861,
      862, 865, 866, 867, 868, 869, 870, 871, 872, 873, 875, 877, 880,
    ],
  ],
  [
    '849270461',
    '139986',
    'Aurora Village Transit Center',
    [
      537, 538, 540, 542, 543, 543, 544, 545, 548, 549, 555, 558, 560, 561, 562, 563, 564, 565, 566, 567, 569, 571, 572,
      573, 576, 577, 577, 578, 579, 580, 581, 582, 583, 584, 586, 588,
    ],
  ],
  [
    '849270471',
    '139986',
    'Aurora Village Transit Center',
    [
      912, 913, 916, 918, 919, 919, 921, 921, 924, 926, 932, 936, 937, 938, 939, 941, 942, 943, 944, 945, 947, 950, 951,
      952, 955, 956, 957, 958, 959, 960, 961, 962, 963, 965, 967, 970,
    ],
  ],
  [
    '849270481',
    '139986',
    'Aurora Village Transit Center',
    [
      928, 929, 932, 934, 935, 935, 937, 937, 940, 942, 948, 952, 953, 954, 955, 957, 958, 959, 960, 961, 963, 966, 967,
      968, 971, 972, 973, 974, 975, 976, 977, 978, 979, 981, 983, 986,
    ],
  ],
  [
    '849270491',
    '139986',
    'Aurora Village Transit Center',
    [
      816, 817, 819, 821, 822, 822, 823, 824, 827, 828, 834, 837, 839, 840, 841, 842, 843, 844, 845, 846, 848, 851, 852,
      853, 856, 857, 858, 858, 859, 861, 862, 863, 864, 865, 867, 870,
    ],
  ],
  [
    '849270521',
    '139986',
    'Aurora Village Transit Center',
    [
      680, 681, 683, 685, 686, 686, 687, 688, 691, 692, 698, 701, 703, 704, 705, 706, 707, 708, 709, 710, 712, 714, 715,
      716, 719, 720, 721, 721, 722, 724, 725, 726, 727, 728, 730, 733,
    ],
  ],
  [
    '849270561',
    '139986',
    'Aurora Village Transit Center',
    [
      555, 556, 558, 560, 561, 561, 562, 563, 566, 567, 573, 576, 578, 579, 580, 581, 582, 583, 584, 585, 587, 589, 590,
      591, 594, 595, 595, 596, 597, 598, 599, 600, 601, 602, 604, 607,
    ],
  ],
  [
    '849270571',
    '139986',
    'Aurora Village Transit Center',
    [
      704, 705, 707, 709, 710, 710, 711, 712, 715, 716, 722, 725, 727, 728, 729, 730, 731, 732, 733, 734, 736, 738, 739,
      740, 743, 744, 745, 745, 746, 748, 749, 750, 751, 752, 754, 757,
    ],
  ],
  [
    '849270621',
    '139986',
    'Aurora Village Transit Center',
    [
      970, 971, 974, 976, 977, 978, 979, 980, 983, 984, 991, 995, 996, 997, 998, 1000, 1001, 1002, 1003, 1004, 1006,
      1009, 1010, 1011, 1014, 1015, 1016, 1017, 1018, 1019, 1020, 1021, 1022, 1024, 1026, 1029,
    ],
  ],
  [
    '849270651',
    '139986',
    'Aurora Village Transit Center',
    [
      856, 857, 860, 862, 863, 863, 865, 865, 868, 870, 876, 879, 881, 882, 883, 884, 885, 886, 887, 888, 890, 893, 894,
      895, 898, 899, 900, 901, 902, 903, 904, 905, 906, 908, 910, 913,
    ],
  ],
  [
    '849270661',
    '139986',
    'Aurora Village Transit Center',
    [
      564, 565, 567, 569, 570, 570, 571, 572, 575, 576, 582, 585, 587, 588, 589, 590, 591, 592, 593, 594, 596, 598, 599,
      600, 603, 604, 604, 605, 606, 607, 608, 609, 610, 611, 613, 616,
    ],
  ],
  [
    '849270671',
    '139986',
    'Aurora Village Transit Center',
    [
      712, 713, 715, 717, 718, 718, 719, 720, 723, 724, 730, 733, 735, 736, 737, 738, 739, 740, 741, 742, 744, 746, 747,
      748, 751, 752, 753, 753, 754, 756, 757, 758, 759, 760, 762, 765,
    ],
  ],
  [
    '849270701',
    '139986',
    'Aurora Village Transit Center',
    [
      975, 976, 979, 981, 982, 983, 984, 985, 988, 989, 996, 1000, 1001, 1002, 1003, 1005, 1006, 1007, 1008, 1009, 1011,
      1014, 1015, 1016, 1019, 1020, 1021, 1022, 1023, 1024, 1025, 1026, 1027, 1029, 1031, 1034,
    ],
  ],
  [
    '849270721',
    '139986',
    'Aurora Village Transit Center',
    [
      1050, 1051, 1054, 1056, 1057, 1058, 1059, 1060, 1063, 1064, 1071, 1075, 1076, 1077, 1078, 1080, 1081, 1082, 1083,
      1084, 1086, 1089, 1090, 1091, 1094, 1095, 1096, 1096, 1097, 1099, 1100, 1101, 1102, 1103, 1105, 1108,
    ],
  ],
  [
    '849270731',
    '139986',
    'Aurora Village Transit Center',
    [
      1060, 1061, 1064, 1066, 1067, 1068, 1069, 1070, 1073, 1074, 1081, 1085, 1086, 1087, 1088, 1090, 1091, 1092, 1093,
      1094, 1096, 1099, 1100, 1101, 1104, 1105, 1105, 1106, 1107, 1108, 1109, 1110, 1111, 1112, 1114, 1117,
    ],
  ],
  [
    '849270741',
    '139986',
    'Aurora Village Transit Center',
    [
      1000, 1001, 1004, 1006, 1007, 1008, 1009, 1010, 1013, 1014, 1021, 1025, 1026, 1027, 1028, 1030, 1031, 1032, 1033,
      1034, 1036, 1039, 1040, 1041, 1044, 1045, 1046, 1046, 1047, 1049, 1050, 1051, 1052, 1053, 1055, 1058,
    ],
  ],
  [
    '849270751',
    '139986',
    'Aurora Village Transit Center',
    [
      736, 737, 739, 741, 742, 742, 743, 744, 747, 748, 754, 757, 759, 760, 761, 762, 763, 764, 765, 766, 768, 770, 771,
      772, 775, 776, 777, 777, 778, 780, 781, 782, 783, 784, 786, 789,
    ],
  ],
  [
    '849270761',
    '139986',
    'Aurora Village Transit Center',
    [
      582, 583, 585, 587, 588, 588, 589, 590, 593, 594, 600, 603, 605, 606, 607, 608, 609, 610, 611, 612, 614, 616, 617,
      618, 621, 622, 622, 623, 624, 625, 626, 627, 628, 629, 631, 634,
    ],
  ],
  [
    '849270781',
    '139986',
    'Aurora Village Transit Center',
    [
      1010, 1011, 1014, 1016, 1017, 1018, 1019, 1020, 1023, 1024, 1031, 1035, 1036, 1037, 1038, 1040, 1041, 1042, 1043,
      1044, 1046, 1049, 1050, 1051, 1054, 1055, 1056, 1056, 1057, 1059, 1060, 1061, 1062, 1063, 1065, 1068,
    ],
  ],
  [
    '849270811',
    '139986',
    'Aurora Village Transit Center',
    [
      880, 881, 884, 886, 887, 887, 889, 889, 892, 894, 900, 903, 905, 906, 907, 908, 909, 910, 911, 912, 914, 917, 918,
      919, 922, 923, 924, 925, 926, 927, 928, 929, 930, 932, 934, 937,
    ],
  ],
  [
    '849270821',
    '139986',
    'Aurora Village Transit Center',
    [
      1030, 1031, 1034, 1036, 1037, 1038, 1039, 1040, 1043, 1044, 1051, 1055, 1056, 1057, 1058, 1060, 1061, 1062, 1063,
      1064, 1066, 1069, 1070, 1071, 1074, 1075, 1076, 1076, 1077, 1079, 1080, 1081, 1082, 1083, 1085, 1088,
    ],
  ],
  [
    '849270841',
    '139986',
    'Aurora Village Transit Center',
    [
      591, 592, 594, 596, 597, 597, 598, 599, 602, 603, 609, 612, 614, 615, 616, 617, 618, 619, 620, 621, 623, 625, 626,
      627, 630, 631, 631, 632, 633, 634, 635, 636, 637, 638, 640, 643,
    ],
  ],
  [
    '849270861',
    '139986',
    'Aurora Village Transit Center',
    [
      609, 610, 612, 614, 615, 615, 616, 617, 620, 621, 627, 630, 632, 633, 634, 635, 636, 637, 638, 639, 641, 643, 644,
      645, 648, 649, 649, 650, 651, 652, 653, 654, 655, 656, 658, 661,
    ],
  ],
  [
    '849270891',
    '139986',
    'Aurora Village Transit Center',
    [
      744, 745, 747, 749, 750, 750, 751, 752, 755, 756, 762, 765, 767, 768, 769, 770, 771, 772, 773, 774, 776, 778, 779,
      780, 783, 784, 785, 785, 786, 788, 789, 790, 791, 792, 794, 797,
    ],
  ],
  [
    '849270911',
    '139986',
    'Aurora Village Transit Center',
    [
      888, 889, 892, 894, 895, 895, 897, 897, 900, 902, 908, 911, 913, 914, 915, 916, 917, 918, 919, 920, 922, 925, 926,
      927, 930, 931, 932, 933, 934, 935, 936, 937, 938, 940, 942, 945,
    ],
  ],
  [
    '849270921',
    '139986',
    'Aurora Village Transit Center',
    [
      1040, 1041, 1044, 1046, 1047, 1048, 1049, 1050, 1053, 1054, 1061, 1065, 1066, 1067, 1068, 1070, 1071, 1072, 1073,
      1074, 1076, 1079, 1080, 1081, 1084, 1085, 1086, 1086, 1087, 1089, 1090, 1091, 1092, 1093, 1095, 1098,
    ],
  ],
  [
    '849270931',
    '139986',
    'Aurora Village Transit Center',
    [
      904, 905, 908, 910, 911, 911, 913, 913, 916, 918, 924, 928, 929, 930, 931, 933, 934, 935, 936, 937, 939, 942, 943,
      944, 947, 948, 949, 950, 951, 952, 953, 954, 955, 957, 959, 962,
    ],
  ],
  [
    '849270961',
    '139986',
    'Aurora Village Transit Center',
    [
      760, 761, 763, 765, 766, 766, 767, 768, 771, 772, 778, 781, 783, 784, 785, 786, 787, 788, 789, 790, 792, 794, 795,
      796, 799, 800, 801, 801, 802, 804, 805, 806, 807, 808, 810, 813,
    ],
  ],
  [
    '849270981',
    '139986',
    'Aurora Village Transit Center',
    [
      1198, 1199, 1201, 1203, 1204, 1204, 1206, 1206, 1209, 1211, 1217, 1220, 1222, 1223, 1224, 1225, 1226, 1227, 1228,
      1229, 1231, 1234, 1235, 1236, 1239, 1240, 1240, 1241, 1242, 1243, 1243, 1244, 1245, 1246, 1248, 1251,
    ],
  ],
  [
    '849271011',
    '139986',
    'Aurora Village Transit Center',
    [
      776, 777, 779, 781, 782, 782, 783, 784, 787, 788, 794, 797, 799, 800, 801, 802, 803, 804, 805, 806, 808, 810, 811,
      812, 815, 816, 817, 817, 818, 820, 821, 822, 823, 824, 826, 829,
    ],
  ],
  [
    '849271021',
    '139986',
    'Aurora Village Transit Center',
    [
      627, 628, 630, 632, 633, 633, 634, 635, 638, 639, 645, 648, 650, 651, 652, 653, 654, 655, 656, 657, 659, 661, 662,
      663, 666, 667, 667, 668, 669, 670, 671, 672, 673, 674, 676, 679,
    ],
  ],
  [
    '849271031',
    '139986',
    'Aurora Village Transit Center',
    [
      1075, 1076, 1079, 1081, 1082, 1083, 1084, 1085, 1088, 1089, 1096, 1099, 1101, 1102, 1103, 1104, 1105, 1106, 1107,
      1108, 1110, 1113, 1114, 1115, 1118, 1119, 1119, 1120, 1121, 1122, 1123, 1124, 1125, 1126, 1128, 1131,
    ],
  ],
  [
    '849271091',
    '139986',
    'Aurora Village Transit Center',
    [
      688, 689, 691, 693, 694, 694, 695, 696, 699, 700, 706, 709, 711, 712, 713, 714, 715, 716, 717, 718, 720, 722, 723,
      724, 727, 728, 729, 729, 730, 732, 733, 734, 735, 736, 738, 741,
    ],
  ],
  [
    '849271101',
    '139986',
    'Aurora Village Transit Center',
    [
      1142, 1143, 1145, 1147, 1148, 1148, 1150, 1150, 1153, 1155, 1161, 1164, 1166, 1167, 1168, 1169, 1170, 1171, 1172,
      1173, 1175, 1178, 1179, 1180, 1183, 1184, 1184, 1185, 1186, 1187, 1188, 1189, 1190, 1191, 1193, 1196,
    ],
  ],
  [
    '849271111',
    '139986',
    'Aurora Village Transit Center',
    [
      832, 833, 835, 837, 838, 838, 840, 840, 843, 845, 851, 854, 856, 857, 858, 859, 860, 861, 862, 863, 865, 868, 869,
      870, 873, 874, 875, 876, 877, 878, 879, 880, 881, 883, 885, 888,
    ],
  ],
  [
    '849271131',
    '139986',
    'Aurora Village Transit Center',
    [
      985, 986, 989, 991, 992, 993, 994, 995, 998, 999, 1006, 1010, 1011, 1012, 1013, 1015, 1016, 1017, 1018, 1019,
      1021, 1024, 1025, 1026, 1029, 1030, 1031, 1032, 1033, 1034, 1035, 1036, 1037, 1039, 1041, 1044,
    ],
  ],
  [
    '849271141',
    '139986',
    'Aurora Village Transit Center',
    [
      1345, 1346, 1348, 1350, 1351, 1351, 1353, 1353, 1356, 1358, 1364, 1367, 1369, 1370, 1371, 1372, 1373, 1373, 1374,
      1375, 1377, 1379, 1380, 1381, 1384, 1385, 1385, 1386, 1387, 1388, 1388, 1389, 1390, 1391, 1393, 1395,
    ],
  ],
  [
    '849271181',
    '139986',
    'Aurora Village Transit Center',
    [
      1020, 1021, 1024, 1026, 1027, 1028, 1029, 1030, 1033, 1034, 1041, 1045, 1046, 1047, 1048, 1050, 1051, 1052, 1053,
      1054, 1056, 1059, 1060, 1061, 1064, 1065, 1066, 1066, 1067, 1069, 1070, 1071, 1072, 1073, 1075, 1078,
    ],
  ],
  [
    '849271191',
    '139986',
    'Aurora Village Transit Center',
    [
      864, 865, 868, 870, 871, 871, 873, 873, 876, 878, 884, 887, 889, 890, 891, 892, 893, 894, 895, 896, 898, 901, 902,
      903, 906, 907, 908, 909, 910, 911, 912, 913, 914, 916, 918, 921,
    ],
  ],
  [
    '849271231',
    '139986',
    'Aurora Village Transit Center',
    [
      1300, 1301, 1303, 1305, 1306, 1306, 1308, 1308, 1311, 1313, 1319, 1322, 1324, 1325, 1326, 1327, 1328, 1329, 1330,
      1331, 1333, 1335, 1336, 1337, 1340, 1341, 1341, 1342, 1343, 1344, 1344, 1345, 1346, 1347, 1349, 1351,
    ],
  ],
  [
    '849271251',
    '139986',
    'Aurora Village Transit Center',
    [
      1450, 1451, 1453, 1455, 1456, 1456, 1458, 1458, 1461, 1463, 1469, 1472, 1473, 1474, 1475, 1476, 1477, 1477, 1478,
      1479, 1481, 1483, 1484, 1485, 1488, 1488, 1489, 1490, 1490, 1491, 1492, 1493, 1493, 1494, 1496, 1498,
    ],
  ],
  [
    '849271261',
    '139986',
    'Aurora Village Transit Center',
    [
      1570, 1571, 1573, 1575, 1576, 1576, 1578, 1578, 1581, 1583, 1589, 1592, 1593, 1594, 1595, 1596, 1597, 1597, 1598,
      1599, 1601, 1603, 1604, 1605, 1608, 1608, 1609, 1610, 1610, 1611, 1612, 1613, 1613, 1614, 1616, 1618,
    ],
  ],
  [
    '849271281',
    '139986',
    'Aurora Village Transit Center',
    [
      1080, 1081, 1084, 1086, 1087, 1088, 1089, 1090, 1093, 1094, 1101, 1104, 1106, 1107, 1108, 1109, 1110, 1111, 1112,
      1113, 1115, 1118, 1119, 1120, 1123, 1124, 1124, 1125, 1126, 1127, 1128, 1129, 1130, 1131, 1133, 1136,
    ],
  ],
  [
    '849271291',
    '139986',
    'Aurora Village Transit Center',
    [
      1210, 1211, 1213, 1215, 1216, 1216, 1218, 1218, 1221, 1223, 1229, 1232, 1234, 1235, 1236, 1237, 1238, 1239, 1240,
      1241, 1243, 1246, 1247, 1248, 1251, 1252, 1252, 1253, 1254, 1255, 1255, 1256, 1257, 1258, 1260, 1263,
    ],
  ],
  [
    '849271311',
    '139986',
    'Aurora Village Transit Center',
    [
      920, 921, 924, 926, 927, 927, 929, 929, 932, 934, 940, 944, 945, 946, 947, 949, 950, 951, 952, 953, 955, 958, 959,
      960, 963, 964, 965, 966, 967, 968, 969, 970, 971, 973, 975, 978,
    ],
  ],
  [
    '849271361',
    '139986',
    'Aurora Village Transit Center',
    [
      1510, 1511, 1513, 1515, 1516, 1516, 1518, 1518, 1521, 1523, 1529, 1532, 1533, 1534, 1535, 1536, 1537, 1537, 1538,
      1539, 1541, 1543, 1544, 1545, 1548, 1548, 1549, 1550, 1550, 1551, 1552, 1553, 1553, 1554, 1556, 1558,
    ],
  ],
  [
    '849271381',
    '139986',
    'Aurora Village Transit Center',
    [
      1246, 1247, 1249, 1251, 1252, 1252, 1254, 1254, 1257, 1259, 1265, 1268, 1270, 1271, 1272, 1273, 1274, 1275, 1276,
      1277, 1279, 1282, 1283, 1284, 1287, 1288, 1288, 1289, 1290, 1291, 1291, 1292, 1293, 1294, 1296, 1298,
    ],
  ],
  [
    '849271391',
    '139986',
    'Aurora Village Transit Center',
    [
      1126, 1127, 1130, 1132, 1133, 1133, 1135, 1135, 1138, 1140, 1146, 1149, 1151, 1152, 1153, 1154, 1155, 1156, 1157,
      1158, 1160, 1163, 1164, 1165, 1168, 1169, 1169, 1170, 1171, 1172, 1173, 1174, 1175, 1176, 1178, 1181,
    ],
  ],
  [
    '849271411',
    '139986',
    'Aurora Village Transit Center',
    [
      1390, 1391, 1393, 1395, 1396, 1396, 1398, 1398, 1401, 1403, 1409, 1412, 1413, 1414, 1415, 1416, 1417, 1417, 1418,
      1419, 1421, 1423, 1424, 1425, 1428, 1428, 1429, 1430, 1430, 1431, 1432, 1433, 1433, 1434, 1436, 1438,
    ],
  ],
  [
    '811961221',
    '27238',
    'Aurora Village Transit Center',
    [
      353, 354, 355, 357, 358, 358, 359, 360, 363, 364, 370, 373, 374, 375, 376, 377, 378, 378, 379, 380, 382, 384, 385,
      386, 389, 390, 390, 391, 392, 393, 393, 394, 395, 396, 398, 400,
    ],
  ],
  [
    '811961301',
    '27238',
    'Aurora Village Transit Center',
    [
      490, 491, 492, 494, 495, 495, 496, 497, 500, 501, 507, 510, 511, 512, 513, 514, 515, 516, 517, 518, 520, 522, 523,
      524, 527, 528, 529, 529, 530, 532, 533, 534, 535, 536, 538, 540,
    ],
  ],
  [
    '811961451',
    '27238',
    'Aurora Village Transit Center',
    [
      630, 631, 632, 634, 635, 635, 637, 637, 640, 642, 648, 651, 653, 654, 655, 656, 657, 658, 659, 660, 662, 664, 665,
      666, 669, 670, 671, 672, 673, 674, 675, 676, 677, 679, 681, 683,
    ],
  ],
  [
    '811961551',
    '27238',
    'Aurora Village Transit Center',
    [
      730, 731, 732, 734, 735, 735, 737, 737, 740, 742, 748, 751, 753, 754, 755, 756, 757, 758, 759, 760, 762, 764, 765,
      766, 769, 770, 771, 772, 774, 775, 776, 777, 779, 780, 783, 785,
    ],
  ],
  [
    '811961561',
    '27238',
    'Aurora Village Transit Center',
    [
      750, 751, 752, 754, 755, 755, 757, 757, 760, 762, 768, 771, 773, 774, 775, 776, 777, 778, 779, 780, 782, 784, 785,
      786, 789, 790, 791, 792, 794, 795, 796, 797, 799, 800, 803, 805,
    ],
  ],
  [
    '811961621',
    '27238',
    'Aurora Village Transit Center',
    [
      781, 782, 783, 785, 786, 786, 788, 788, 791, 793, 799, 802, 804, 805, 806, 807, 808, 809, 810, 811, 813, 815, 816,
      817, 820, 821, 822, 823, 825, 826, 827, 828, 830, 831, 834, 836,
    ],
  ],
  [
    '811961711',
    '27238',
    'Aurora Village Transit Center',
    [
      900, 901, 902, 904, 905, 905, 907, 907, 910, 912, 918, 921, 923, 924, 925, 926, 927, 928, 929, 930, 932, 934, 935,
      936, 939, 940, 941, 942, 944, 945, 946, 947, 949, 950, 953, 955,
    ],
  ],
  [
    '811961721',
    '27238',
    'Aurora Village Transit Center',
    [
      880, 881, 882, 884, 885, 885, 887, 887, 890, 892, 898, 901, 903, 904, 905, 906, 907, 908, 909, 910, 912, 914, 915,
      916, 919, 920, 921, 922, 924, 925, 926, 927, 929, 930, 933, 935,
    ],
  ],
  [
    '811961741',
    '27238',
    'Aurora Village Transit Center',
    [
      930, 931, 932, 934, 935, 935, 937, 937, 940, 942, 948, 951, 953, 954, 955, 956, 957, 958, 959, 960, 962, 964, 965,
      966, 969, 970, 971, 972, 974, 975, 976, 977, 979, 980, 983, 985,
    ],
  ],
  [
    '811961811',
    '27238',
    'Aurora Village Transit Center',
    [
      550, 551, 552, 554, 555, 555, 556, 557, 560, 561, 567, 570, 571, 572, 573, 574, 575, 576, 577, 578, 580, 582, 583,
      584, 587, 588, 589, 589, 590, 592, 593, 594, 595, 596, 598, 600,
    ],
  ],
  [
    '811961831',
    '27238',
    'Aurora Village Transit Center',
    [
      415, 416, 417, 419, 420, 420, 421, 422, 425, 426, 432, 435, 436, 437, 438, 439, 440, 441, 442, 443, 445, 447, 448,
      449, 452, 453, 453, 454, 455, 456, 457, 458, 459, 460, 462, 464,
    ],
  ],
  [
    '811961901',
    '27238',
    'Aurora Village Transit Center',
    [
      950, 951, 952, 954, 955, 955, 957, 957, 960, 962, 968, 971, 973, 974, 975, 976, 977, 978, 979, 980, 982, 984, 985,
      986, 989, 990, 991, 992, 994, 995, 996, 997, 999, 1000, 1003, 1005,
    ],
  ],
  [
    '811961981',
    '27238',
    'Aurora Village Transit Center',
    [
      1000, 1001, 1002, 1004, 1005, 1005, 1007, 1007, 1010, 1012, 1018, 1021, 1023, 1024, 1025, 1026, 1027, 1028, 1029,
      1030, 1032, 1034, 1035, 1036, 1039, 1040, 1041, 1042, 1043, 1045, 1046, 1047, 1048, 1050, 1052, 1054,
    ],
  ],
  [
    '811961991',
    '27238',
    'Aurora Village Transit Center',
    [
      710, 711, 712, 714, 715, 715, 717, 717, 720, 722, 728, 731, 733, 734, 735, 736, 737, 738, 739, 740, 742, 744, 745,
      746, 749, 750, 751, 752, 753, 755, 756, 757, 758, 760, 762, 764,
    ],
  ],
  [
    '811962001',
    '27238',
    'Aurora Village Transit Center',
    [
      570, 571, 572, 574, 575, 575, 576, 577, 580, 581, 587, 590, 591, 592, 593, 594, 595, 596, 597, 598, 600, 602, 603,
      604, 607, 608, 609, 610, 611, 612, 613, 614, 615, 617, 619, 621,
    ],
  ],
  [
    '811962011',
    '27238',
    'Aurora Village Transit Center',
    [
      860, 861, 862, 864, 865, 865, 867, 867, 870, 872, 878, 881, 883, 884, 885, 886, 887, 888, 889, 890, 892, 894, 895,
      896, 899, 900, 901, 902, 904, 905, 906, 907, 909, 910, 913, 915,
    ],
  ],
  [
    '811962031',
    '27238',
    'Aurora Village Transit Center',
    [
      435, 436, 437, 439, 440, 440, 441, 442, 445, 446, 452, 455, 456, 457, 458, 459, 460, 461, 462, 463, 465, 467, 468,
      469, 472, 473, 473, 474, 475, 476, 477, 478, 479, 480, 482, 484,
    ],
  ],
  [
    '811962071',
    '27238',
    'Aurora Village Transit Center',
    [
      1010, 1011, 1012, 1014, 1015, 1015, 1017, 1017, 1020, 1022, 1028, 1031, 1033, 1034, 1035, 1036, 1037, 1038, 1039,
      1040, 1042, 1044, 1045, 1046, 1049, 1050, 1051, 1052, 1053, 1055, 1056, 1057, 1058, 1060, 1062, 1064,
    ],
  ],
  [
    '811962081',
    '27238',
    'Aurora Village Transit Center',
    [
      1050, 1051, 1052, 1054, 1055, 1055, 1057, 1057, 1060, 1062, 1068, 1071, 1073, 1074, 1075, 1076, 1077, 1078, 1079,
      1080, 1082, 1084, 1085, 1086, 1089, 1090, 1091, 1092, 1093, 1095, 1096, 1097, 1098, 1100, 1102, 1104,
    ],
  ],
  [
    '811962091',
    '27238',
    'Aurora Village Transit Center',
    [
      1030, 1031, 1032, 1034, 1035, 1035, 1037, 1037, 1040, 1042, 1048, 1051, 1053, 1054, 1055, 1056, 1057, 1058, 1059,
      1060, 1062, 1064, 1065, 1066, 1069, 1070, 1071, 1072, 1073, 1075, 1076, 1077, 1078, 1080, 1082, 1084,
    ],
  ],
  [
    '811962111',
    '27238',
    'Aurora Village Transit Center',
    [
      1080, 1081, 1082, 1084, 1085, 1085, 1087, 1087, 1090, 1092, 1098, 1101, 1103, 1104, 1105, 1106, 1107, 1108, 1109,
      1110, 1112, 1114, 1115, 1116, 1119, 1120, 1121, 1122, 1123, 1124, 1125, 1126, 1127, 1129, 1131, 1133,
    ],
  ],
  [
    '811962161',
    '27238',
    'Aurora Village Transit Center',
    [
      920, 921, 922, 924, 925, 925, 927, 927, 930, 932, 938, 941, 943, 944, 945, 946, 947, 948, 949, 950, 952, 954, 955,
      956, 959, 960, 961, 962, 964, 965, 966, 967, 969, 970, 973, 975,
    ],
  ],
  [
    '811962171',
    '27238',
    'Aurora Village Transit Center',
    [
      770, 771, 772, 774, 775, 775, 777, 777, 780, 782, 788, 791, 793, 794, 795, 796, 797, 798, 799, 800, 802, 804, 805,
      806, 809, 810, 811, 812, 814, 815, 816, 817, 819, 820, 823, 825,
    ],
  ],
  [
    '811962201',
    '27238',
    'Aurora Village Transit Center',
    [
      1070, 1071, 1072, 1074, 1075, 1075, 1077, 1077, 1080, 1082, 1088, 1091, 1093, 1094, 1095, 1096, 1097, 1098, 1099,
      1100, 1102, 1104, 1105, 1106, 1109, 1110, 1111, 1112, 1113, 1114, 1115, 1116, 1117, 1119, 1121, 1123,
    ],
  ],
  [
    '811962221',
    '27238',
    'Aurora Village Transit Center',
    [
      480, 481, 482, 484, 485, 485, 486, 487, 490, 491, 497, 500, 501, 502, 503, 504, 505, 506, 507, 508, 510, 512, 513,
      514, 517, 518, 518, 519, 520, 521, 522, 523, 524, 525, 527, 529,
    ],
  ],
  [
    '811962251',
    '27238',
    'Aurora Village Transit Center',
    [
      620, 621, 622, 624, 625, 625, 627, 627, 630, 632, 638, 641, 643, 644, 645, 646, 647, 648, 649, 650, 652, 654, 655,
      656, 659, 660, 661, 662, 663, 664, 665, 666, 667, 669, 671, 673,
    ],
  ],
  [
    '811962281',
    '27238',
    'Aurora Village Transit Center',
    [
      850, 851, 852, 854, 855, 855, 857, 857, 860, 862, 868, 871, 873, 874, 875, 876, 877, 878, 879, 880, 882, 884, 885,
      886, 889, 890, 891, 892, 894, 895, 896, 897, 899, 900, 903, 905,
    ],
  ],
  [
    '811962301',
    '27238',
    'Aurora Village Transit Center',
    [
      700, 701, 702, 704, 705, 705, 707, 707, 710, 712, 718, 721, 723, 724, 725, 726, 727, 728, 729, 730, 732, 734, 735,
      736, 739, 740, 741, 742, 743, 745, 746, 747, 748, 750, 752, 754,
    ],
  ],
  [
    '811962311',
    '27238',
    'Aurora Village Transit Center',
    [
      560, 561, 562, 564, 565, 565, 566, 567, 570, 571, 577, 580, 581, 582, 583, 584, 585, 586, 587, 588, 590, 592, 593,
      594, 597, 598, 599, 599, 600, 602, 603, 604, 605, 606, 608, 610,
    ],
  ],
  [
    '811962401',
    '27238',
    'Aurora Village Transit Center',
    [
      1170, 1171, 1172, 1174, 1175, 1175, 1177, 1177, 1180, 1182, 1188, 1191, 1193, 1194, 1195, 1196, 1197, 1198, 1199,
      1200, 1202, 1204, 1205, 1206, 1209, 1210, 1211, 1211, 1212, 1214, 1215, 1216, 1217, 1218, 1220, 1222,
    ],
  ],
  [
    '811962421',
    '27238',
    'Aurora Village Transit Center',
    [
      1100, 1101, 1102, 1104, 1105, 1105, 1107, 1107, 1110, 1112, 1118, 1121, 1123, 1124, 1125, 1126, 1127, 1128, 1129,
      1130, 1132, 1134, 1135, 1136, 1139, 1140, 1141, 1142, 1143, 1144, 1145, 1146, 1147, 1149, 1151, 1153,
    ],
  ],
  [
    '811962511',
    '27238',
    'Aurora Village Transit Center',
    [
      1150, 1151, 1152, 1154, 1155, 1155, 1157, 1157, 1160, 1162, 1168, 1171, 1173, 1174, 1175, 1176, 1177, 1178, 1179,
      1180, 1182, 1184, 1185, 1186, 1189, 1190, 1191, 1191, 1192, 1194, 1195, 1196, 1197, 1198, 1200, 1202,
    ],
  ],
  [
    '811962531',
    '27238',
    'Aurora Village Transit Center',
    [
      650, 651, 652, 654, 655, 655, 657, 657, 660, 662, 668, 671, 673, 674, 675, 676, 677, 678, 679, 680, 682, 684, 685,
      686, 689, 690, 691, 692, 693, 694, 695, 696, 697, 699, 701, 703,
    ],
  ],
  [
    '811962551',
    '27238',
    'Aurora Village Transit Center',
    [
      800, 801, 802, 804, 805, 805, 807, 807, 810, 812, 818, 821, 823, 824, 825, 826, 827, 828, 829, 830, 832, 834, 835,
      836, 839, 840, 841, 842, 844, 845, 846, 847, 849, 850, 853, 855,
    ],
  ],
  [
    '811962611',
    '27238',
    'Aurora Village Transit Center',
    [
      510, 511, 512, 514, 515, 515, 516, 517, 520, 521, 527, 530, 531, 532, 533, 534, 535, 536, 537, 538, 540, 542, 543,
      544, 547, 548, 549, 549, 550, 552, 553, 554, 555, 556, 558, 560,
    ],
  ],
  [
    '811962661',
    '27238',
    'Aurora Village Transit Center',
    [
      1160, 1161, 1162, 1164, 1165, 1165, 1167, 1167, 1170, 1172, 1178, 1181, 1183, 1184, 1185, 1186, 1187, 1188, 1189,
      1190, 1192, 1194, 1195, 1196, 1199, 1200, 1201, 1201, 1202, 1204, 1205, 1206, 1207, 1208, 1210, 1212,
    ],
  ],
  [
    '811962671',
    '27238',
    'Aurora Village Transit Center',
    [
      1020, 1021, 1022, 1024, 1025, 1025, 1027, 1027, 1030, 1032, 1038, 1041, 1043, 1044, 1045, 1046, 1047, 1048, 1049,
      1050, 1052, 1054, 1055, 1056, 1059, 1060, 1061, 1062, 1063, 1065, 1066, 1067, 1068, 1070, 1072, 1074,
    ],
  ],
  [
    '811962701',
    '27238',
    'Aurora Village Transit Center',
    [
      870, 871, 872, 874, 875, 875, 877, 877, 880, 882, 888, 891, 893, 894, 895, 896, 897, 898, 899, 900, 902, 904, 905,
      906, 909, 910, 911, 912, 914, 915, 916, 917, 919, 920, 923, 925,
    ],
  ],
  [
    '811962731',
    '27238',
    'Aurora Village Transit Center',
    [
      720, 721, 722, 724, 725, 725, 727, 727, 730, 732, 738, 741, 743, 744, 745, 746, 747, 748, 749, 750, 752, 754, 755,
      756, 759, 760, 761, 762, 763, 765, 766, 767, 768, 770, 772, 774,
    ],
  ],
  [
    '811962741',
    '27238',
    'Aurora Village Transit Center',
    [
      580, 581, 582, 584, 585, 585, 586, 587, 590, 591, 597, 600, 601, 602, 603, 604, 605, 606, 607, 608, 610, 612, 613,
      614, 617, 618, 619, 620, 621, 622, 623, 624, 625, 627, 629, 631,
    ],
  ],
  [
    '811962751',
    '27238',
    'Aurora Village Transit Center',
    [
      1249, 1250, 1251, 1253, 1254, 1254, 1256, 1256, 1259, 1261, 1267, 1270, 1272, 1273, 1274, 1275, 1276, 1277, 1278,
      1279, 1281, 1283, 1284, 1285, 1288, 1289, 1290, 1290, 1291, 1293, 1294, 1295, 1296, 1297, 1299, 1301,
    ],
  ],
  [
    '811962811',
    '27238',
    'Aurora Village Transit Center',
    [
      1223, 1224, 1225, 1227, 1228, 1228, 1230, 1230, 1233, 1235, 1241, 1244, 1246, 1247, 1248, 1249, 1250, 1251, 1252,
      1253, 1255, 1257, 1258, 1259, 1262, 1263, 1264, 1264, 1265, 1267, 1268, 1269, 1270, 1271, 1273, 1275,
    ],
  ],
  [
    '811962831',
    '27238',
    'Aurora Village Transit Center',
    [
      1210, 1211, 1212, 1214, 1215, 1215, 1217, 1217, 1220, 1222, 1228, 1231, 1233, 1234, 1235, 1236, 1237, 1238, 1239,
      1240, 1242, 1244, 1245, 1246, 1249, 1250, 1251, 1251, 1252, 1254, 1255, 1256, 1257, 1258, 1260, 1262,
    ],
  ],
  [
    '811962861',
    '27238',
    'Aurora Village Transit Center',
    [
      1309, 1310, 1312, 1314, 1315, 1315, 1317, 1317, 1320, 1322, 1328, 1331, 1333, 1334, 1335, 1336, 1337, 1338, 1339,
      1340, 1342, 1344, 1345, 1346, 1349, 1350, 1350, 1351, 1352, 1353, 1354, 1355, 1356, 1357, 1359, 1361,
    ],
  ],
  [
    '811962881',
    '27238',
    'Aurora Village Transit Center',
    [
      1339, 1340, 1342, 1344, 1345, 1345, 1347, 1347, 1350, 1352, 1358, 1361, 1363, 1364, 1365, 1366, 1367, 1368, 1369,
      1370, 1372, 1374, 1375, 1376, 1379, 1380, 1380, 1381, 1382, 1383, 1384, 1385, 1386, 1387, 1389, 1391,
    ],
  ],
  [
    '811962891',
    '27238',
    'Aurora Village Transit Center',
    [
      1369, 1370, 1372, 1374, 1375, 1375, 1377, 1377, 1380, 1382, 1388, 1391, 1393, 1394, 1395, 1396, 1397, 1398, 1399,
      1400, 1402, 1404, 1405, 1406, 1409, 1410, 1410, 1411, 1412, 1413, 1414, 1415, 1416, 1417, 1419, 1421,
    ],
  ],
  [
    '811962961',
    '27238',
    'Aurora Village Transit Center',
    [
      1399, 1400, 1402, 1404, 1405, 1405, 1407, 1407, 1410, 1412, 1418, 1421, 1423, 1424, 1425, 1426, 1427, 1428, 1429,
      1430, 1432, 1434, 1435, 1436, 1439, 1440, 1440, 1441, 1442, 1443, 1443, 1444, 1445, 1446, 1448, 1450,
    ],
  ],
  [
    '811963011',
    '27238',
    'Aurora Village Transit Center',
    [
      1489, 1490, 1492, 1494, 1495, 1495, 1497, 1497, 1500, 1502, 1508, 1511, 1512, 1513, 1514, 1515, 1516, 1516, 1517,
      1518, 1520, 1522, 1523, 1524, 1527, 1527, 1528, 1529, 1529, 1530, 1531, 1532, 1532, 1533, 1535, 1537,
    ],
  ],
  [
    '811963021',
    '27238',
    'Aurora Village Transit Center',
    [
      1519, 1520, 1522, 1524, 1525, 1525, 1527, 1527, 1530, 1532, 1538, 1541, 1542, 1543, 1544, 1545, 1546, 1546, 1547,
      1548, 1550, 1552, 1553, 1554, 1557, 1557, 1558, 1559, 1559, 1560, 1561, 1562, 1562, 1563, 1565, 1567,
    ],
  ],
  [
    '811963051',
    '27238',
    'Aurora Village Transit Center',
    [
      1549, 1550, 1552, 1554, 1555, 1555, 1557, 1557, 1560, 1562, 1568, 1571, 1572, 1573, 1574, 1575, 1576, 1576, 1577,
      1578, 1580, 1582, 1583, 1584, 1587, 1587, 1588, 1589, 1589, 1590, 1591, 1592, 1592, 1593, 1595, 1597,
    ],
  ],
  [
    '811963081',
    '27238',
    'Aurora Village Transit Center',
    [
      1324, 1325, 1327, 1329, 1330, 1330, 1332, 1332, 1335, 1337, 1343, 1346, 1348, 1349, 1350, 1351, 1352, 1353, 1354,
      1355, 1357, 1359, 1360, 1361, 1364, 1365, 1365, 1366, 1367, 1368, 1369, 1370, 1371, 1372, 1374, 1376,
    ],
  ],
  [
    '811963121',
    '27238',
    'Aurora Village Transit Center',
    [
      1180, 1181, 1182, 1184, 1185, 1185, 1187, 1187, 1190, 1192, 1198, 1201, 1203, 1204, 1205, 1206, 1207, 1208, 1209,
      1210, 1212, 1214, 1215, 1216, 1219, 1220, 1221, 1221, 1222, 1224, 1225, 1226, 1227, 1228, 1230, 1232,
    ],
  ],
  [
    '811963161',
    '27238',
    'Aurora Village Transit Center',
    [
      600, 601, 602, 604, 605, 605, 607, 607, 610, 612, 618, 621, 622, 623, 624, 625, 626, 627, 628, 629, 631, 633, 634,
      635, 638, 639, 640, 641, 642, 643, 644, 645, 646, 648, 650, 652,
    ],
  ],
  [
    '855201681',
    '27238',
    'Aurora Village Transit Center',
    [
      1673, 1674, 1676, 1678, 1679, 1679, 1681, 1681, 1684, 1686, 1692, 1695, 1696, 1697, 1698, 1699, 1700, 1700, 1701,
      1702, 1704, 1706, 1707, 1708, 1711, 1711, 1712, 1713, 1713, 1714, 1715, 1716, 1716, 1717, 1719, 1721,
    ],
  ],
  [
    '855239821',
    '27238',
    'Aurora Village Transit Center',
    [
      1612, 1613, 1615, 1617, 1618, 1618, 1620, 1620, 1623, 1625, 1631, 1634, 1635, 1636, 1637, 1638, 1639, 1639, 1640,
      1641, 1643, 1645, 1646, 1647, 1650, 1650, 1651, 1652, 1652, 1653, 1654, 1655, 1655, 1656, 1658, 1660,
    ],
  ],
  [
    '855239851',
    '27238',
    'Aurora Village Transit Center',
    [
      1459, 1460, 1462, 1464, 1465, 1465, 1467, 1467, 1470, 1472, 1478, 1481, 1482, 1483, 1484, 1485, 1486, 1486, 1487,
      1488, 1490, 1492, 1493, 1494, 1497, 1497, 1498, 1499, 1499, 1500, 1501, 1502, 1502, 1503, 1505, 1507,
    ],
  ],
  [
    '855239861',
    '27238',
    'Aurora Village Transit Center',
    [
      1429, 1430, 1432, 1434, 1435, 1435, 1437, 1437, 1440, 1442, 1448, 1451, 1452, 1453, 1454, 1455, 1456, 1456, 1457,
      1458, 1460, 1462, 1463, 1464, 1467, 1468, 1468, 1469, 1470, 1471, 1471, 1472, 1473, 1474, 1476, 1478,
    ],
  ],
  [
    '855239881',
    '27238',
    'Aurora Village Transit Center',
    [
      1579, 1580, 1582, 1584, 1585, 1585, 1587, 1587, 1590, 1592, 1598, 1601, 1602, 1603, 1604, 1605, 1606, 1606, 1607,
      1608, 1610, 1612, 1613, 1614, 1617, 1617, 1618, 1619, 1619, 1620, 1621, 1622, 1622, 1623, 1625, 1627,
    ],
  ],
  [
    '855239921',
    '27238',
    'Aurora Village Transit Center',
    [
      1279, 1280, 1282, 1284, 1285, 1285, 1287, 1287, 1290, 1292, 1298, 1301, 1303, 1304, 1305, 1306, 1307, 1308, 1309,
      1310, 1312, 1314, 1315, 1316, 1319, 1320, 1321, 1321, 1322, 1324, 1325, 1326, 1327, 1328, 1330, 1332,
    ],
  ],
  [
    '855239931',
    '27238',
    'Aurora Village Transit Center',
    [
      1294, 1295, 1297, 1299, 1300, 1300, 1302, 1302, 1305, 1307, 1313, 1316, 1318, 1319, 1320, 1321, 1322, 1323, 1324,
      1325, 1327, 1329, 1330, 1331, 1334, 1335, 1335, 1336, 1337, 1338, 1339, 1340, 1341, 1342, 1344, 1346,
    ],
  ],
  [
    '855239941',
    '27238',
    'Aurora Village Transit Center',
    [
      1264, 1265, 1267, 1269, 1270, 1270, 1272, 1272, 1275, 1277, 1283, 1286, 1288, 1289, 1290, 1291, 1292, 1293, 1294,
      1295, 1297, 1299, 1300, 1301, 1304, 1305, 1306, 1306, 1307, 1309, 1310, 1311, 1312, 1313, 1315, 1317,
    ],
  ],
  [
    '855239961',
    '27238',
    'Aurora Village Transit Center',
    [
      1236, 1237, 1238, 1240, 1241, 1241, 1243, 1243, 1246, 1248, 1254, 1257, 1259, 1260, 1261, 1262, 1263, 1264, 1265,
      1266, 1268, 1270, 1271, 1272, 1275, 1276, 1277, 1277, 1278, 1280, 1281, 1282, 1283, 1284, 1286, 1288,
    ],
  ],
  [
    '855240011',
    '27238',
    'Aurora Village Transit Center',
    [
      1130, 1131, 1132, 1134, 1135, 1135, 1137, 1137, 1140, 1142, 1148, 1151, 1153, 1154, 1155, 1156, 1157, 1158, 1159,
      1160, 1162, 1164, 1165, 1166, 1169, 1170, 1171, 1172, 1173, 1174, 1175, 1176, 1177, 1179, 1181, 1183,
    ],
  ],
  [
    '855240021',
    '27238',
    'Aurora Village Transit Center',
    [
      1120, 1121, 1122, 1124, 1125, 1125, 1127, 1127, 1130, 1132, 1138, 1141, 1143, 1144, 1145, 1146, 1147, 1148, 1149,
      1150, 1152, 1154, 1155, 1156, 1159, 1160, 1161, 1162, 1163, 1164, 1165, 1166, 1167, 1169, 1171, 1173,
    ],
  ],
  [
    '855240031',
    '27238',
    'Aurora Village Transit Center',
    [
      1140, 1141, 1142, 1144, 1145, 1145, 1147, 1147, 1150, 1152, 1158, 1161, 1163, 1164, 1165, 1166, 1167, 1168, 1169,
      1170, 1172, 1174, 1175, 1176, 1179, 1180, 1181, 1182, 1183, 1184, 1185, 1186, 1187, 1189, 1191, 1193,
    ],
  ],
  [
    '855240041',
    '27238',
    'Aurora Village Transit Center',
    [
      1090, 1091, 1092, 1094, 1095, 1095, 1097, 1097, 1100, 1102, 1108, 1111, 1113, 1114, 1115, 1116, 1117, 1118, 1119,
      1120, 1122, 1124, 1125, 1126, 1129, 1130, 1131, 1132, 1133, 1134, 1135, 1136, 1137, 1139, 1141, 1143,
    ],
  ],
  [
    '855240081',
    '27238',
    'Aurora Village Transit Center',
    [
      1110, 1111, 1112, 1114, 1115, 1115, 1117, 1117, 1120, 1122, 1128, 1131, 1133, 1134, 1135, 1136, 1137, 1138, 1139,
      1140, 1142, 1144, 1145, 1146, 1149, 1150, 1151, 1152, 1153, 1154, 1155, 1156, 1157, 1159, 1161, 1163,
    ],
  ],
  [
    '855240121',
    '27238',
    'Aurora Village Transit Center',
    [
      970, 971, 972, 974, 975, 975, 977, 977, 980, 982, 988, 991, 993, 994, 995, 996, 997, 998, 999, 1000, 1002, 1004,
      1005, 1006, 1009, 1010, 1011, 1012, 1013, 1015, 1016, 1017, 1018, 1020, 1022, 1024,
    ],
  ],
  [
    '855240131',
    '27238',
    'Aurora Village Transit Center',
    [
      980, 981, 982, 984, 985, 985, 987, 987, 990, 992, 998, 1001, 1003, 1004, 1005, 1006, 1007, 1008, 1009, 1010, 1012,
      1014, 1015, 1016, 1019, 1020, 1021, 1022, 1023, 1025, 1026, 1027, 1028, 1030, 1032, 1034,
    ],
  ],
  [
    '855240141',
    '27238',
    'Aurora Village Transit Center',
    [
      991, 992, 993, 995, 996, 996, 998, 998, 1001, 1003, 1009, 1012, 1014, 1015, 1016, 1017, 1018, 1019, 1020, 1021,
      1023, 1025, 1026, 1027, 1030, 1031, 1032, 1033, 1034, 1036, 1037, 1038, 1039, 1041, 1043, 1045,
    ],
  ],
  [
    '855240151',
    '27238',
    'Aurora Village Transit Center',
    [
      960, 961, 962, 964, 965, 965, 967, 967, 970, 972, 978, 981, 983, 984, 985, 986, 987, 988, 989, 990, 992, 994, 995,
      996, 999, 1000, 1001, 1002, 1004, 1005, 1006, 1007, 1009, 1010, 1013, 1015,
    ],
  ],
  [
    '855240181',
    '27238',
    'Aurora Village Transit Center',
    [
      910, 911, 912, 914, 915, 915, 917, 917, 920, 922, 928, 931, 933, 934, 935, 936, 937, 938, 939, 940, 942, 944, 945,
      946, 949, 950, 951, 952, 954, 955, 956, 957, 959, 960, 963, 965,
    ],
  ],
  [
    '855240191',
    '27238',
    'Aurora Village Transit Center',
    [
      1060, 1061, 1062, 1064, 1065, 1065, 1067, 1067, 1070, 1072, 1078, 1081, 1083, 1084, 1085, 1086, 1087, 1088, 1089,
      1090, 1092, 1094, 1095, 1096, 1099, 1100, 1101, 1102, 1103, 1104, 1105, 1106, 1107, 1109, 1111, 1113,
    ],
  ],
  [
    '855240221',
    '27238',
    'Aurora Village Transit Center',
    [
      941, 942, 943, 945, 946, 946, 948, 948, 951, 953, 959, 962, 964, 965, 966, 967, 968, 969, 970, 971, 973, 975, 976,
      977, 980, 981, 982, 983, 985, 986, 987, 988, 990, 991, 994, 996,
    ],
  ],
  [
    '855240231',
    '27238',
    'Aurora Village Transit Center',
    [
      1200, 1201, 1202, 1204, 1205, 1205, 1207, 1207, 1210, 1212, 1218, 1221, 1223, 1224, 1225, 1226, 1227, 1228, 1229,
      1230, 1232, 1234, 1235, 1236, 1239, 1240, 1241, 1241, 1242, 1244, 1245, 1246, 1247, 1248, 1250, 1252,
    ],
  ],
  [
    '855240271',
    '27238',
    'Aurora Village Transit Center',
    [
      820, 821, 822, 824, 825, 825, 827, 827, 830, 832, 838, 841, 843, 844, 845, 846, 847, 848, 849, 850, 852, 854, 855,
      856, 859, 860, 861, 862, 864, 865, 866, 867, 869, 870, 873, 875,
    ],
  ],
  [
    '855240291',
    '27238',
    'Aurora Village Transit Center',
    [
      830, 831, 832, 834, 835, 835, 837, 837, 840, 842, 848, 851, 853, 854, 855, 856, 857, 858, 859, 860, 862, 864, 865,
      866, 869, 870, 871, 872, 874, 875, 876, 877, 879, 880, 883, 885,
    ],
  ],
  [
    '855240301',
    '27238',
    'Aurora Village Transit Center',
    [
      840, 841, 842, 844, 845, 845, 847, 847, 850, 852, 858, 861, 863, 864, 865, 866, 867, 868, 869, 870, 872, 874, 875,
      876, 879, 880, 881, 882, 884, 885, 886, 887, 889, 890, 893, 895,
    ],
  ],
  [
    '855240311',
    '27238',
    'Aurora Village Transit Center',
    [
      790, 791, 792, 794, 795, 795, 797, 797, 800, 802, 808, 811, 813, 814, 815, 816, 817, 818, 819, 820, 822, 824, 825,
      826, 829, 830, 831, 832, 834, 835, 836, 837, 839, 840, 843, 845,
    ],
  ],
  [
    '855240321',
    '27238',
    'Aurora Village Transit Center',
    [
      810, 811, 812, 814, 815, 815, 817, 817, 820, 822, 828, 831, 833, 834, 835, 836, 837, 838, 839, 840, 842, 844, 845,
      846, 849, 850, 851, 852, 854, 855, 856, 857, 859, 860, 863, 865,
    ],
  ],
  [
    '855240331',
    '27238',
    'Aurora Village Transit Center',
    [
      1190, 1191, 1192, 1194, 1195, 1195, 1197, 1197, 1200, 1202, 1208, 1211, 1213, 1214, 1215, 1216, 1217, 1218, 1219,
      1220, 1222, 1224, 1225, 1226, 1229, 1230, 1231, 1231, 1232, 1234, 1235, 1236, 1237, 1238, 1240, 1242,
    ],
  ],
  [
    '855240361',
    '27238',
    'Aurora Village Transit Center',
    [
      1354, 1355, 1357, 1359, 1360, 1360, 1362, 1362, 1365, 1367, 1373, 1376, 1378, 1379, 1380, 1381, 1382, 1383, 1384,
      1385, 1387, 1389, 1390, 1391, 1394, 1395, 1395, 1396, 1397, 1398, 1399, 1400, 1401, 1402, 1404, 1406,
    ],
  ],
  [
    '855240381',
    '27238',
    'Aurora Village Transit Center',
    [
      890, 891, 892, 894, 895, 895, 897, 897, 900, 902, 908, 911, 913, 914, 915, 916, 917, 918, 919, 920, 922, 924, 925,
      926, 929, 930, 931, 932, 934, 935, 936, 937, 939, 940, 943, 945,
    ],
  ],
  [
    '855240391',
    '27238',
    'Aurora Village Transit Center',
    [
      1040, 1041, 1042, 1044, 1045, 1045, 1047, 1047, 1050, 1052, 1058, 1061, 1063, 1064, 1065, 1066, 1067, 1068, 1069,
      1070, 1072, 1074, 1075, 1076, 1079, 1080, 1081, 1082, 1083, 1085, 1086, 1087, 1088, 1090, 1092, 1094,
    ],
  ],
  [
    '855240441',
    '27238',
    'Aurora Village Transit Center',
    [
      760, 761, 762, 764, 765, 765, 767, 767, 770, 772, 778, 781, 783, 784, 785, 786, 787, 788, 789, 790, 792, 794, 795,
      796, 799, 800, 801, 802, 804, 805, 806, 807, 809, 810, 813, 815,
    ],
  ],
  [
    '855240481',
    '27238',
    'Aurora Village Transit Center',
    [
      740, 741, 742, 744, 745, 745, 747, 747, 750, 752, 758, 761, 763, 764, 765, 766, 767, 768, 769, 770, 772, 774, 775,
      776, 779, 780, 781, 782, 784, 785, 786, 787, 789, 790, 793, 795,
    ],
  ],
  [
    '855240501',
    '27238',
    'Aurora Village Transit Center',
    [
      680, 681, 682, 684, 685, 685, 687, 687, 690, 692, 698, 701, 703, 704, 705, 706, 707, 708, 709, 710, 712, 714, 715,
      716, 719, 720, 721, 722, 723, 725, 726, 727, 728, 730, 732, 734,
    ],
  ],
  [
    '855240511',
    '27238',
    'Aurora Village Transit Center',
    [
      690, 691, 692, 694, 695, 695, 697, 697, 700, 702, 708, 711, 713, 714, 715, 716, 717, 718, 719, 720, 722, 724, 725,
      726, 729, 730, 731, 732, 733, 735, 736, 737, 738, 740, 742, 744,
    ],
  ],
  [
    '855240531',
    '27238',
    'Aurora Village Transit Center',
    [
      660, 661, 662, 664, 665, 665, 667, 667, 670, 672, 678, 681, 683, 684, 685, 686, 687, 688, 689, 690, 692, 694, 695,
      696, 699, 700, 701, 702, 703, 705, 706, 707, 708, 710, 712, 714,
    ],
  ],
  [
    '855240541',
    '27238',
    'Aurora Village Transit Center',
    [
      670, 671, 672, 674, 675, 675, 677, 677, 680, 682, 688, 691, 693, 694, 695, 696, 697, 698, 699, 700, 702, 704, 705,
      706, 709, 710, 711, 712, 713, 715, 716, 717, 718, 720, 722, 724,
    ],
  ],
  [
    '855240551',
    '27238',
    'Aurora Village Transit Center',
    [
      640, 641, 642, 644, 645, 645, 647, 647, 650, 652, 658, 661, 663, 664, 665, 666, 667, 668, 669, 670, 672, 674, 675,
      676, 679, 680, 681, 682, 683, 684, 685, 686, 687, 689, 691, 693,
    ],
  ],
  [
    '855240561',
    '27238',
    'Aurora Village Transit Center',
    [
      610, 611, 612, 614, 615, 615, 617, 617, 620, 622, 628, 631, 632, 633, 634, 635, 636, 637, 638, 639, 641, 643, 644,
      645, 648, 649, 650, 651, 652, 653, 654, 655, 656, 658, 660, 662,
    ],
  ],
  [
    '855240591',
    '27238',
    'Aurora Village Transit Center',
    [
      540, 541, 542, 544, 545, 545, 546, 547, 550, 551, 557, 560, 561, 562, 563, 564, 565, 566, 567, 568, 570, 572, 573,
      574, 577, 578, 579, 579, 580, 582, 583, 584, 585, 586, 588, 590,
    ],
  ],
  [
    '855240601',
    '27238',
    'Aurora Village Transit Center',
    [
      455, 456, 457, 459, 460, 460, 461, 462, 465, 466, 472, 475, 476, 477, 478, 479, 480, 481, 482, 483, 485, 487, 488,
      489, 492, 493, 493, 494, 495, 496, 497, 498, 499, 500, 502, 504,
    ],
  ],
  [
    '855240611',
    '27238',
    'Aurora Village Transit Center',
    [
      520, 521, 522, 524, 525, 525, 526, 527, 530, 531, 537, 540, 541, 542, 543, 544, 545, 546, 547, 548, 550, 552, 553,
      554, 557, 558, 559, 559, 560, 562, 563, 564, 565, 566, 568, 570,
    ],
  ],
  [
    '855240621',
    '27238',
    'Aurora Village Transit Center',
    [
      470, 471, 472, 474, 475, 475, 476, 477, 480, 481, 487, 490, 491, 492, 493, 494, 495, 496, 497, 498, 500, 502, 503,
      504, 507, 508, 508, 509, 510, 511, 512, 513, 514, 515, 517, 519,
    ],
  ],
  [
    '855240651',
    '27238',
    'Aurora Village Transit Center',
    [
      500, 501, 502, 504, 505, 505, 506, 507, 510, 511, 517, 520, 521, 522, 523, 524, 525, 526, 527, 528, 530, 532, 533,
      534, 537, 538, 539, 539, 540, 542, 543, 544, 545, 546, 548, 550,
    ],
  ],
  [
    '855240661',
    '27238',
    'Aurora Village Transit Center',
    [
      590, 591, 592, 594, 595, 595, 596, 597, 600, 601, 607, 610, 611, 612, 613, 614, 615, 616, 617, 618, 620, 622, 623,
      624, 627, 628, 629, 630, 631, 632, 633, 634, 635, 637, 639, 641,
    ],
  ],
  [
    '855240691',
    '27238',
    'Aurora Village Transit Center',
    [
      530, 531, 532, 534, 535, 535, 536, 537, 540, 541, 547, 550, 551, 552, 553, 554, 555, 556, 557, 558, 560, 562, 563,
      564, 567, 568, 569, 569, 570, 572, 573, 574, 575, 576, 578, 580,
    ],
  ],
  [
    '855240731',
    '27238',
    'Aurora Village Transit Center',
    [
      300, 301, 302, 304, 305, 305, 306, 307, 310, 311, 317, 319, 320, 321, 322, 323, 324, 324, 325, 326, 328, 330, 331,
      332, 335, 335, 336, 337, 337, 338, 339, 340, 340, 341, 343, 345,
    ],
  ],
  [
    '855240751',
    '27238',
    'Aurora Village Transit Center',
    [
      330, 331, 332, 334, 335, 335, 336, 337, 340, 341, 347, 349, 350, 351, 352, 353, 354, 354, 355, 356, 358, 360, 361,
      362, 365, 366, 366, 367, 368, 369, 369, 370, 371, 372, 374, 376,
    ],
  ],
  [
    '855240761',
    '27238',
    'Aurora Village Transit Center',
    [
      375, 376, 377, 379, 380, 380, 381, 382, 385, 386, 392, 395, 396, 397, 398, 399, 400, 400, 401, 402, 404, 406, 407,
      408, 411, 412, 412, 413, 414, 415, 416, 417, 418, 419, 421, 423,
    ],
  ],
  [
    '855240771',
    '27238',
    'Aurora Village Transit Center',
    [
      395, 396, 397, 399, 400, 400, 401, 402, 405, 406, 412, 415, 416, 417, 418, 419, 420, 420, 421, 422, 424, 426, 427,
      428, 431, 432, 432, 433, 434, 435, 436, 437, 438, 439, 441, 443,
    ],
  ],
  [
    '811973131',
    '28118',
    'Aurora Village Transit Center',
    [
      1100, 1101, 1103, 1105, 1106, 1106, 1107, 1108, 1111, 1112, 1118, 1121, 1123, 1124, 1125, 1126, 1127, 1128, 1129,
      1130, 1132, 1134, 1135, 1136, 1139, 1140, 1140, 1141, 1142, 1143, 1144, 1145, 1146, 1147, 1149, 1151,
    ],
  ],
  [
    '811973181',
    '28118',
    'Aurora Village Transit Center',
    [
      1200, 1201, 1203, 1205, 1206, 1206, 1207, 1208, 1211, 1212, 1218, 1221, 1222, 1223, 1224, 1225, 1226, 1227, 1228,
      1229, 1231, 1233, 1234, 1235, 1238, 1239, 1239, 1240, 1241, 1242, 1242, 1243, 1244, 1245, 1247, 1249,
    ],
  ],
  [
    '811973191',
    '28118',
    'Aurora Village Transit Center',
    [
      960, 961, 963, 965, 966, 966, 967, 968, 971, 972, 978, 981, 983, 984, 985, 986, 987, 988, 989, 990, 992, 994, 995,
      996, 999, 1000, 1001, 1001, 1002, 1004, 1005, 1006, 1007, 1008, 1010, 1012,
    ],
  ],
  [
    '811973261',
    '28118',
    'Aurora Village Transit Center',
    [
      900, 901, 903, 905, 906, 906, 907, 908, 911, 912, 918, 921, 923, 924, 925, 926, 927, 928, 929, 930, 932, 934, 935,
      936, 939, 940, 941, 941, 942, 944, 945, 946, 947, 948, 950, 952,
    ],
  ],
  [
    '811973291',
    '28118',
    'Aurora Village Transit Center',
    [
      1180, 1181, 1183, 1185, 1186, 1186, 1187, 1188, 1191, 1192, 1198, 1201, 1203, 1204, 1205, 1206, 1207, 1208, 1209,
      1210, 1212, 1214, 1215, 1216, 1219, 1220, 1220, 1221, 1222, 1223, 1223, 1224, 1225, 1226, 1228, 1230,
    ],
  ],
  [
    '811973301',
    '28118',
    'Aurora Village Transit Center',
    [
      1040, 1041, 1043, 1045, 1046, 1046, 1047, 1048, 1051, 1052, 1058, 1061, 1063, 1064, 1065, 1066, 1067, 1068, 1069,
      1070, 1072, 1074, 1075, 1076, 1079, 1080, 1080, 1081, 1082, 1083, 1084, 1085, 1086, 1087, 1089, 1091,
    ],
  ],
  [
    '811973391',
    '28118',
    'Aurora Village Transit Center',
    [
      760, 761, 763, 765, 766, 766, 767, 768, 771, 772, 778, 781, 783, 784, 785, 786, 787, 788, 789, 790, 792, 794, 795,
      796, 799, 800, 801, 801, 802, 804, 805, 806, 807, 808, 810, 812,
    ],
  ],
  [
    '811973621',
    '28118',
    'Aurora Village Transit Center',
    [
      620, 621, 623, 625, 626, 626, 627, 628, 631, 632, 638, 641, 643, 644, 645, 646, 646, 647, 648, 649, 651, 653, 654,
      655, 657, 658, 658, 659, 660, 661, 662, 663, 664, 665, 667, 669,
    ],
  ],
  [
    '811973861',
    '28118',
    'Aurora Village Transit Center',
    [
      490, 491, 493, 495, 496, 496, 497, 498, 501, 502, 508, 511, 512, 513, 514, 515, 515, 516, 517, 518, 520, 522, 523,
      524, 526, 527, 527, 528, 529, 530, 530, 531, 532, 533, 535, 536,
    ],
  ],
  [
    '811973931',
    '28118',
    'Aurora Village Transit Center',
    [
      354, 355, 357, 359, 359, 360, 361, 362, 364, 366, 371, 374, 375, 376, 377, 378, 378, 379, 380, 381, 383, 385, 386,
      387, 389, 390, 390, 391, 392, 393, 393, 394, 395, 396, 398, 399,
    ],
  ],
  [
    '811983531',
    '28118',
    'Aurora Village Transit Center',
    [
      1000, 1001, 1003, 1005, 1006, 1006, 1007, 1008, 1011, 1012, 1018, 1021, 1023, 1024, 1025, 1026, 1027, 1028, 1029,
      1030, 1032, 1034, 1035, 1036, 1039, 1040, 1041, 1041, 1042, 1044, 1045, 1046, 1047, 1048, 1050, 1052,
    ],
  ],
  [
    '811983551',
    '28118',
    'Aurora Village Transit Center',
    [
      1120, 1121, 1123, 1125, 1126, 1126, 1127, 1128, 1131, 1132, 1138, 1141, 1143, 1144, 1145, 1146, 1147, 1148, 1149,
      1150, 1152, 1154, 1155, 1156, 1159, 1160, 1160, 1161, 1162, 1163, 1164, 1165, 1166, 1167, 1169, 1171,
    ],
  ],
  [
    '811983561',
    '28118',
    'Aurora Village Transit Center',
    [
      1140, 1141, 1143, 1145, 1146, 1146, 1147, 1148, 1151, 1152, 1158, 1161, 1163, 1164, 1165, 1166, 1167, 1168, 1169,
      1170, 1172, 1174, 1175, 1176, 1179, 1180, 1180, 1181, 1182, 1183, 1184, 1185, 1186, 1187, 1189, 1191,
    ],
  ],
  [
    '811983601',
    '28118',
    'Aurora Village Transit Center',
    [
      1070, 1071, 1073, 1075, 1076, 1076, 1077, 1078, 1081, 1082, 1088, 1091, 1093, 1094, 1095, 1096, 1097, 1098, 1099,
      1100, 1102, 1104, 1105, 1106, 1109, 1110, 1110, 1111, 1112, 1113, 1114, 1115, 1116, 1117, 1119, 1121,
    ],
  ],
  [
    '811983651',
    '28118',
    'Aurora Village Transit Center',
    [
      980, 981, 983, 985, 986, 986, 987, 988, 991, 992, 998, 1001, 1003, 1004, 1005, 1006, 1007, 1008, 1009, 1010, 1012,
      1014, 1015, 1016, 1019, 1020, 1021, 1021, 1022, 1024, 1025, 1026, 1027, 1028, 1030, 1032,
    ],
  ],
  [
    '811983691',
    '28118',
    'Aurora Village Transit Center',
    [
      1160, 1161, 1163, 1165, 1166, 1166, 1167, 1168, 1171, 1172, 1178, 1181, 1183, 1184, 1185, 1186, 1187, 1188, 1189,
      1190, 1192, 1194, 1195, 1196, 1199, 1200, 1200, 1201, 1202, 1203, 1204, 1205, 1206, 1207, 1209, 1211,
    ],
  ],
  [
    '811983721',
    '28118',
    'Aurora Village Transit Center',
    [
      1020, 1021, 1023, 1025, 1026, 1026, 1027, 1028, 1031, 1032, 1038, 1041, 1043, 1044, 1045, 1046, 1047, 1048, 1049,
      1050, 1052, 1054, 1055, 1056, 1059, 1060, 1060, 1061, 1062, 1063, 1064, 1065, 1066, 1067, 1069, 1071,
    ],
  ],
  [
    '811983741',
    '28118',
    'Aurora Village Transit Center',
    [
      930, 931, 933, 935, 936, 936, 937, 938, 941, 942, 948, 951, 953, 954, 955, 956, 957, 958, 959, 960, 962, 964, 965,
      966, 969, 970, 971, 971, 972, 974, 975, 976, 977, 978, 980, 982,
    ],
  ],
  [
    '811983751',
    '28118',
    'Aurora Village Transit Center',
    [
      860, 861, 863, 865, 866, 866, 867, 868, 871, 872, 878, 881, 883, 884, 885, 886, 887, 888, 889, 890, 892, 894, 895,
      896, 899, 900, 901, 901, 902, 904, 905, 906, 907, 908, 910, 912,
    ],
  ],
  [
    '811983771',
    '28118',
    'Aurora Village Transit Center',
    [
      880, 881, 883, 885, 886, 886, 887, 888, 891, 892, 898, 901, 903, 904, 905, 906, 907, 908, 909, 910, 912, 914, 915,
      916, 919, 920, 921, 921, 922, 924, 925, 926, 927, 928, 930, 932,
    ],
  ],
  [
    '811983791',
    '28118',
    'Aurora Village Transit Center',
    [
      840, 841, 843, 845, 846, 846, 847, 848, 851, 852, 858, 861, 863, 864, 865, 866, 867, 868, 869, 870, 872, 874, 875,
      876, 879, 880, 881, 881, 882, 884, 885, 886, 887, 888, 890, 892,
    ],
  ],
  [
    '811983801',
    '28118',
    'Aurora Village Transit Center',
    [
      810, 811, 813, 815, 816, 816, 817, 818, 821, 822, 828, 831, 833, 834, 835, 836, 837, 838, 839, 840, 842, 844, 845,
      846, 849, 850, 851, 851, 852, 854, 855, 856, 857, 858, 860, 862,
    ],
  ],
  [
    '811983831',
    '28118',
    'Aurora Village Transit Center',
    [
      870, 871, 873, 875, 876, 876, 877, 878, 881, 882, 888, 891, 893, 894, 895, 896, 897, 898, 899, 900, 902, 904, 905,
      906, 909, 910, 911, 911, 912, 914, 915, 916, 917, 918, 920, 922,
    ],
  ],
  [
    '811983851',
    '28118',
    'Aurora Village Transit Center',
    [
      1010, 1011, 1013, 1015, 1016, 1016, 1017, 1018, 1021, 1022, 1028, 1031, 1033, 1034, 1035, 1036, 1037, 1038, 1039,
      1040, 1042, 1044, 1045, 1046, 1049, 1050, 1051, 1051, 1052, 1054, 1055, 1056, 1057, 1058, 1060, 1062,
    ],
  ],
  [
    '811983891',
    '28118',
    'Aurora Village Transit Center',
    [
      1150, 1151, 1153, 1155, 1156, 1156, 1157, 1158, 1161, 1162, 1168, 1171, 1173, 1174, 1175, 1176, 1177, 1178, 1179,
      1180, 1182, 1184, 1185, 1186, 1189, 1190, 1190, 1191, 1192, 1193, 1194, 1195, 1196, 1197, 1199, 1201,
    ],
  ],
  [
    '811983931',
    '28118',
    'Aurora Village Transit Center',
    [
      790, 791, 793, 795, 796, 796, 797, 798, 801, 802, 808, 811, 813, 814, 815, 816, 817, 818, 819, 820, 822, 824, 825,
      826, 829, 830, 831, 831, 832, 834, 835, 836, 837, 838, 840, 842,
    ],
  ],
  [
    '811983941',
    '28118',
    'Aurora Village Transit Center',
    [
      730, 731, 733, 735, 736, 736, 737, 738, 741, 742, 748, 751, 753, 754, 755, 756, 757, 758, 759, 760, 762, 764, 765,
      766, 769, 770, 771, 771, 772, 774, 775, 776, 777, 778, 780, 782,
    ],
  ],
  [
    '811983951',
    '28118',
    'Aurora Village Transit Center',
    [
      720, 721, 723, 725, 726, 726, 727, 728, 731, 732, 738, 741, 743, 744, 745, 746, 747, 748, 749, 750, 752, 754, 755,
      756, 759, 760, 761, 761, 762, 764, 765, 766, 767, 768, 770, 772,
    ],
  ],
  [
    '811983981',
    '28118',
    'Aurora Village Transit Center',
    [
      740, 741, 743, 745, 746, 746, 747, 748, 751, 752, 758, 761, 763, 764, 765, 766, 767, 768, 769, 770, 772, 774, 775,
      776, 779, 780, 781, 781, 782, 784, 785, 786, 787, 788, 790, 792,
    ],
  ],
  [
    '811983991',
    '28118',
    'Aurora Village Transit Center',
    [
      700, 701, 703, 705, 706, 706, 707, 708, 711, 712, 718, 721, 723, 724, 725, 726, 727, 728, 729, 730, 732, 734, 735,
      736, 739, 740, 741, 741, 742, 744, 745, 746, 747, 748, 750, 752,
    ],
  ],
  [
    '811984001',
    '28118',
    'Aurora Village Transit Center',
    [
      850, 851, 853, 855, 856, 856, 857, 858, 861, 862, 868, 871, 873, 874, 875, 876, 877, 878, 879, 880, 882, 884, 885,
      886, 889, 890, 891, 891, 892, 894, 895, 896, 897, 898, 900, 902,
    ],
  ],
  [
    '811984031',
    '28118',
    'Aurora Village Transit Center',
    [
      710, 711, 713, 715, 716, 716, 717, 718, 721, 722, 728, 731, 733, 734, 735, 736, 737, 738, 739, 740, 742, 744, 745,
      746, 749, 750, 751, 751, 752, 754, 755, 756, 757, 758, 760, 762,
    ],
  ],
  [
    '811984041',
    '28118',
    'Aurora Village Transit Center',
    [
      990, 991, 993, 995, 996, 996, 997, 998, 1001, 1002, 1008, 1011, 1013, 1014, 1015, 1016, 1017, 1018, 1019, 1020,
      1022, 1024, 1025, 1026, 1029, 1030, 1031, 1031, 1032, 1034, 1035, 1036, 1037, 1038, 1040, 1042,
    ],
  ],
  [
    '811984051',
    '28118',
    'Aurora Village Transit Center',
    [
      670, 671, 673, 675, 676, 676, 677, 678, 681, 682, 688, 691, 693, 694, 695, 696, 697, 698, 699, 700, 702, 704, 705,
      706, 709, 710, 710, 711, 712, 713, 714, 715, 716, 717, 719, 721,
    ],
  ],
  [
    '811984061',
    '28118',
    'Aurora Village Transit Center',
    [
      1130, 1131, 1133, 1135, 1136, 1136, 1137, 1138, 1141, 1142, 1148, 1151, 1153, 1154, 1155, 1156, 1157, 1158, 1159,
      1160, 1162, 1164, 1165, 1166, 1169, 1170, 1170, 1171, 1172, 1173, 1174, 1175, 1176, 1177, 1179, 1181,
    ],
  ],
  [
    '811984151',
    '28118',
    'Aurora Village Transit Center',
    [
      650, 651, 653, 655, 656, 656, 657, 658, 661, 662, 668, 671, 673, 674, 675, 676, 677, 678, 679, 680, 682, 684, 685,
      686, 689, 690, 690, 691, 692, 693, 694, 695, 696, 697, 699, 701,
    ],
  ],
  [
    '811984171',
    '28118',
    'Aurora Village Transit Center',
    [
      800, 801, 803, 805, 806, 806, 807, 808, 811, 812, 818, 821, 823, 824, 825, 826, 827, 828, 829, 830, 832, 834, 835,
      836, 839, 840, 841, 841, 842, 844, 845, 846, 847, 848, 850, 852,
    ],
  ],
  [
    '811984201',
    '28118',
    'Aurora Village Transit Center',
    [
      660, 661, 663, 665, 666, 666, 667, 668, 671, 672, 678, 681, 683, 684, 685, 686, 687, 688, 689, 690, 692, 694, 695,
      696, 699, 700, 700, 701, 702, 703, 704, 705, 706, 707, 709, 711,
    ],
  ],
  [
    '811984211',
    '28118',
    'Aurora Village Transit Center',
    [
      940, 941, 943, 945, 946, 946, 947, 948, 951, 952, 958, 961, 963, 964, 965, 966, 967, 968, 969, 970, 972, 974, 975,
      976, 979, 980, 981, 981, 982, 984, 985, 986, 987, 988, 990, 992,
    ],
  ],
  [
    '811984241',
    '28118',
    'Aurora Village Transit Center',
    [
      590, 591, 593, 595, 596, 596, 597, 598, 601, 602, 608, 611, 612, 613, 614, 615, 615, 616, 617, 618, 620, 622, 623,
      624, 626, 627, 627, 628, 629, 630, 631, 632, 633, 634, 636, 638,
    ],
  ],
  [
    '811984271',
    '28118',
    'Aurora Village Transit Center',
    [
      1080, 1081, 1083, 1085, 1086, 1086, 1087, 1088, 1091, 1092, 1098, 1101, 1103, 1104, 1105, 1106, 1107, 1108, 1109,
      1110, 1112, 1114, 1115, 1116, 1119, 1120, 1120, 1121, 1122, 1123, 1124, 1125, 1126, 1127, 1129, 1131,
    ],
  ],
  [
    '811984311',
    '28118',
    'Aurora Village Transit Center',
    [
      600, 601, 603, 605, 606, 606, 607, 608, 611, 612, 618, 621, 622, 623, 624, 625, 625, 626, 627, 628, 630, 632, 633,
      634, 636, 637, 637, 638, 639, 640, 641, 642, 643, 644, 646, 648,
    ],
  ],
  [
    '811984321',
    '28118',
    'Aurora Village Transit Center',
    [
      570, 571, 573, 575, 576, 576, 577, 578, 581, 582, 588, 591, 592, 593, 594, 595, 595, 596, 597, 598, 600, 602, 603,
      604, 606, 607, 607, 608, 609, 610, 611, 612, 613, 614, 616, 618,
    ],
  ],
  [
    '811984331',
    '28118',
    'Aurora Village Transit Center',
    [
      560, 561, 563, 565, 566, 566, 567, 568, 571, 572, 578, 581, 582, 583, 584, 585, 585, 586, 587, 588, 590, 592, 593,
      594, 596, 597, 597, 598, 599, 600, 601, 602, 603, 604, 606, 608,
    ],
  ],
  [
    '811984341',
    '28118',
    'Aurora Village Transit Center',
    [
      580, 581, 583, 585, 586, 586, 587, 588, 591, 592, 598, 601, 602, 603, 604, 605, 605, 606, 607, 608, 610, 612, 613,
      614, 616, 617, 617, 618, 619, 620, 621, 622, 623, 624, 626, 628,
    ],
  ],
  [
    '811984361',
    '28118',
    'Aurora Village Transit Center',
    [
      530, 531, 533, 535, 536, 536, 537, 538, 541, 542, 548, 551, 552, 553, 554, 555, 555, 556, 557, 558, 560, 562, 563,
      564, 566, 567, 567, 568, 569, 570, 570, 571, 572, 573, 575, 577,
    ],
  ],
  [
    '811984391',
    '28118',
    'Aurora Village Transit Center',
    [
      520, 521, 523, 525, 526, 526, 527, 528, 531, 532, 538, 541, 542, 543, 544, 545, 545, 546, 547, 548, 550, 552, 553,
      554, 556, 557, 557, 558, 559, 560, 560, 561, 562, 563, 565, 567,
    ],
  ],
  [
    '811984441',
    '28118',
    'Aurora Village Transit Center',
    [
      470, 471, 473, 475, 476, 476, 477, 478, 481, 482, 488, 491, 492, 493, 494, 495, 495, 496, 497, 498, 500, 502, 503,
      504, 506, 507, 507, 508, 509, 510, 510, 511, 512, 513, 515, 516,
    ],
  ],
  [
    '811984451',
    '28118',
    'Aurora Village Transit Center',
    [
      455, 456, 458, 460, 461, 461, 462, 463, 466, 467, 473, 476, 477, 478, 479, 480, 480, 481, 482, 483, 485, 487, 488,
      489, 491, 492, 492, 493, 494, 495, 495, 496, 497, 498, 500, 501,
    ],
  ],
  [
    '811984471',
    '28118',
    'Aurora Village Transit Center',
    [
      435, 436, 438, 440, 441, 441, 442, 443, 446, 447, 453, 456, 457, 458, 459, 460, 460, 461, 462, 463, 465, 467, 468,
      469, 471, 472, 472, 473, 474, 475, 475, 476, 477, 478, 480, 481,
    ],
  ],
  [
    '811984491',
    '28118',
    'Aurora Village Transit Center',
    [
      395, 396, 398, 400, 401, 401, 402, 403, 406, 407, 413, 416, 417, 418, 419, 420, 420, 421, 422, 423, 425, 427, 428,
      429, 431, 432, 432, 433, 434, 435, 435, 436, 437, 438, 440, 441,
    ],
  ],
  [
    '816562011',
    '28118',
    'Aurora Village Transit Center',
    [
      1249, 1250, 1252, 1254, 1255, 1255, 1256, 1257, 1260, 1261, 1267, 1270, 1271, 1272, 1273, 1274, 1275, 1276, 1277,
      1278, 1280, 1282, 1283, 1284, 1287, 1288, 1288, 1289, 1290, 1291, 1291, 1292, 1293, 1294, 1296, 1297,
    ],
  ],
  [
    '816562081',
    '28118',
    'Aurora Village Transit Center',
    [
      1514, 1515, 1517, 1519, 1520, 1520, 1522, 1522, 1525, 1527, 1533, 1536, 1537, 1538, 1539, 1540, 1541, 1541, 1542,
      1543, 1545, 1547, 1548, 1549, 1552, 1552, 1553, 1554, 1554, 1555, 1556, 1557, 1557, 1558, 1560, 1561,
    ],
  ],
  [
    '816562101',
    '28118',
    'Aurora Village Transit Center',
    [
      1394, 1395, 1397, 1399, 1400, 1400, 1402, 1402, 1405, 1407, 1413, 1416, 1417, 1418, 1419, 1420, 1421, 1421, 1422,
      1423, 1425, 1427, 1428, 1429, 1432, 1432, 1433, 1434, 1434, 1435, 1436, 1437, 1437, 1438, 1440, 1441,
    ],
  ],
  [
    '816562301',
    '28118',
    'Aurora Village Transit Center',
    [
      1574, 1575, 1577, 1579, 1580, 1580, 1582, 1582, 1585, 1587, 1593, 1596, 1597, 1598, 1599, 1600, 1601, 1601, 1602,
      1603, 1605, 1607, 1608, 1609, 1612, 1612, 1613, 1614, 1614, 1615, 1616, 1617, 1617, 1618, 1620, 1621,
    ],
  ],
  [
    '816564391',
    '28118',
    'Aurora Village Transit Center',
    [
      1424, 1425, 1427, 1429, 1430, 1430, 1432, 1432, 1435, 1437, 1443, 1446, 1447, 1448, 1449, 1450, 1451, 1451, 1452,
      1453, 1455, 1457, 1458, 1459, 1462, 1462, 1463, 1464, 1464, 1465, 1466, 1467, 1467, 1468, 1470, 1471,
    ],
  ],
  [
    '816564401',
    '28118',
    'Aurora Village Transit Center',
    [
      1544, 1545, 1547, 1549, 1550, 1550, 1552, 1552, 1555, 1557, 1563, 1566, 1567, 1568, 1569, 1570, 1571, 1571, 1572,
      1573, 1575, 1577, 1578, 1579, 1582, 1582, 1583, 1584, 1584, 1585, 1586, 1587, 1587, 1588, 1590, 1591,
    ],
  ],
  [
    '816564441',
    '28118',
    'Aurora Village Transit Center',
    [
      1264, 1265, 1267, 1269, 1270, 1270, 1271, 1272, 1275, 1276, 1282, 1285, 1286, 1287, 1288, 1289, 1290, 1291, 1292,
      1293, 1295, 1297, 1298, 1299, 1302, 1303, 1303, 1304, 1305, 1306, 1306, 1307, 1308, 1309, 1311, 1312,
    ],
  ],
  [
    '816564671',
    '28118',
    'Aurora Village Transit Center',
    [
      1309, 1310, 1312, 1314, 1315, 1315, 1316, 1317, 1320, 1321, 1327, 1330, 1331, 1332, 1333, 1334, 1335, 1335, 1336,
      1337, 1339, 1341, 1342, 1343, 1346, 1347, 1347, 1348, 1349, 1350, 1350, 1351, 1352, 1353, 1355, 1356,
    ],
  ],
  [
    '816565031',
    '28118',
    'Aurora Village Transit Center',
    [
      1279, 1280, 1282, 1284, 1285, 1285, 1286, 1287, 1290, 1291, 1297, 1300, 1301, 1302, 1303, 1304, 1305, 1305, 1306,
      1307, 1309, 1311, 1312, 1313, 1316, 1317, 1317, 1318, 1319, 1320, 1320, 1321, 1322, 1323, 1325, 1326,
    ],
  ],
  [
    '816565231',
    '28118',
    'Aurora Village Transit Center',
    [
      1223, 1224, 1226, 1228, 1229, 1229, 1230, 1231, 1234, 1235, 1241, 1244, 1245, 1246, 1247, 1248, 1249, 1250, 1251,
      1252, 1254, 1256, 1257, 1258, 1261, 1262, 1262, 1263, 1264, 1265, 1265, 1266, 1267, 1268, 1270, 1271,
    ],
  ],
  [
    '816565241',
    '28118',
    'Aurora Village Transit Center',
    [
      1354, 1355, 1357, 1359, 1360, 1360, 1362, 1362, 1365, 1367, 1373, 1376, 1377, 1378, 1379, 1380, 1381, 1381, 1382,
      1383, 1385, 1387, 1388, 1389, 1392, 1392, 1393, 1394, 1394, 1395, 1396, 1397, 1397, 1398, 1400, 1401,
    ],
  ],
  [
    '855201771',
    '28118',
    'Aurora Village Transit Center',
    [
      1669, 1670, 1672, 1674, 1675, 1675, 1677, 1677, 1680, 1682, 1688, 1691, 1692, 1693, 1694, 1695, 1696, 1696, 1697,
      1698, 1700, 1702, 1703, 1704, 1707, 1707, 1708, 1709, 1709, 1710, 1711, 1712, 1712, 1713, 1715, 1716,
    ],
  ],
  [
    '855243701',
    '28118',
    'Aurora Village Transit Center',
    [
      300, 301, 303, 305, 305, 306, 307, 308, 310, 312, 317, 319, 320, 321, 322, 323, 323, 324, 325, 326, 327, 329, 330,
      331, 333, 334, 334, 335, 336, 337, 337, 338, 339, 340, 342, 343,
    ],
  ],
  [
    '855243711',
    '28118',
    'Aurora Village Transit Center',
    [
      416, 417, 419, 421, 422, 422, 423, 424, 427, 428, 434, 437, 438, 439, 440, 441, 441, 442, 443, 444, 446, 448, 449,
      450, 452, 453, 453, 454, 455, 456, 456, 457, 458, 459, 461, 462,
    ],
  ],
  [
    '855243731',
    '28118',
    'Aurora Village Transit Center',
    [
      375, 376, 378, 380, 380, 381, 382, 383, 385, 387, 392, 395, 396, 397, 398, 399, 399, 400, 401, 402, 404, 406, 407,
      408, 410, 411, 411, 412, 413, 414, 414, 415, 416, 417, 419, 420,
    ],
  ],
  [
    '855243761',
    '28118',
    'Aurora Village Transit Center',
    [
      500, 501, 503, 505, 506, 506, 507, 508, 511, 512, 518, 521, 522, 523, 524, 525, 525, 526, 527, 528, 530, 532, 533,
      534, 536, 537, 537, 538, 539, 540, 540, 541, 542, 543, 545, 547,
    ],
  ],
  [
    '855243791',
    '28118',
    'Aurora Village Transit Center',
    [
      550, 551, 553, 555, 556, 556, 557, 558, 561, 562, 568, 571, 572, 573, 574, 575, 575, 576, 577, 578, 580, 582, 583,
      584, 586, 587, 587, 588, 589, 590, 591, 592, 593, 594, 596, 598,
    ],
  ],
  [
    '855243801',
    '28118',
    'Aurora Village Transit Center',
    [
      610, 611, 613, 615, 616, 616, 617, 618, 621, 622, 628, 631, 632, 633, 634, 635, 635, 636, 637, 638, 640, 642, 643,
      644, 646, 647, 647, 648, 649, 650, 651, 652, 653, 654, 656, 658,
    ],
  ],
  [
    '855243821',
    '28118',
    'Aurora Village Transit Center',
    [
      480, 481, 483, 485, 486, 486, 487, 488, 491, 492, 498, 501, 502, 503, 504, 505, 505, 506, 507, 508, 510, 512, 513,
      514, 516, 517, 517, 518, 519, 520, 520, 521, 522, 523, 525, 526,
    ],
  ],
  [
    '855243841',
    '28118',
    'Aurora Village Transit Center',
    [
      690, 691, 693, 695, 696, 696, 697, 698, 701, 702, 708, 711, 713, 714, 715, 716, 717, 718, 719, 720, 722, 724, 725,
      726, 729, 730, 731, 731, 732, 734, 735, 736, 737, 738, 740, 742,
    ],
  ],
  [
    '855243861',
    '28118',
    'Aurora Village Transit Center',
    [
      630, 631, 633, 635, 636, 636, 637, 638, 641, 642, 648, 651, 653, 654, 655, 656, 656, 657, 658, 659, 661, 663, 664,
      665, 667, 668, 668, 669, 670, 671, 672, 673, 674, 675, 677, 679,
    ],
  ],
  [
    '855243871',
    '28118',
    'Aurora Village Transit Center',
    [
      770, 771, 773, 775, 776, 776, 777, 778, 781, 782, 788, 791, 793, 794, 795, 796, 797, 798, 799, 800, 802, 804, 805,
      806, 809, 810, 811, 811, 812, 814, 815, 816, 817, 818, 820, 822,
    ],
  ],
  [
    '855243891',
    '28118',
    'Aurora Village Transit Center',
    [
      750, 751, 753, 755, 756, 756, 757, 758, 761, 762, 768, 771, 773, 774, 775, 776, 777, 778, 779, 780, 782, 784, 785,
      786, 789, 790, 791, 791, 792, 794, 795, 796, 797, 798, 800, 802,
    ],
  ],
  [
    '855243911',
    '28118',
    'Aurora Village Transit Center',
    [
      780, 781, 783, 785, 786, 786, 787, 788, 791, 792, 798, 801, 803, 804, 805, 806, 807, 808, 809, 810, 812, 814, 815,
      816, 819, 820, 821, 821, 822, 824, 825, 826, 827, 828, 830, 832,
    ],
  ],
  [
    '855243921',
    '28118',
    'Aurora Village Transit Center',
    [
      510, 511, 513, 515, 516, 516, 517, 518, 521, 522, 528, 531, 532, 533, 534, 535, 535, 536, 537, 538, 540, 542, 543,
      544, 546, 547, 547, 548, 549, 550, 550, 551, 552, 553, 555, 557,
    ],
  ],
  [
    '855243941',
    '28118',
    'Aurora Village Transit Center',
    [
      640, 641, 643, 645, 646, 646, 647, 648, 651, 652, 658, 661, 663, 664, 665, 666, 666, 667, 668, 669, 671, 673, 674,
      675, 677, 678, 678, 679, 680, 681, 682, 683, 684, 685, 687, 689,
    ],
  ],
  [
    '855243981',
    '28118',
    'Aurora Village Transit Center',
    [
      830, 831, 833, 835, 836, 836, 837, 838, 841, 842, 848, 851, 853, 854, 855, 856, 857, 858, 859, 860, 862, 864, 865,
      866, 869, 870, 871, 871, 872, 874, 875, 876, 877, 878, 880, 882,
    ],
  ],
  [
    '855243991',
    '28118',
    'Aurora Village Transit Center',
    [
      890, 891, 893, 895, 896, 896, 897, 898, 901, 902, 908, 911, 913, 914, 915, 916, 917, 918, 919, 920, 922, 924, 925,
      926, 929, 930, 931, 931, 932, 934, 935, 936, 937, 938, 940, 942,
    ],
  ],
  [
    '855244011',
    '28118',
    'Aurora Village Transit Center',
    [
      920, 921, 923, 925, 926, 926, 927, 928, 931, 932, 938, 941, 943, 944, 945, 946, 947, 948, 949, 950, 952, 954, 955,
      956, 959, 960, 961, 961, 962, 964, 965, 966, 967, 968, 970, 972,
    ],
  ],
  [
    '855244031',
    '28118',
    'Aurora Village Transit Center',
    [
      910, 911, 913, 915, 916, 916, 917, 918, 921, 922, 928, 931, 933, 934, 935, 936, 937, 938, 939, 940, 942, 944, 945,
      946, 949, 950, 951, 951, 952, 954, 955, 956, 957, 958, 960, 962,
    ],
  ],
  [
    '855244051',
    '28118',
    'Aurora Village Transit Center',
    [
      1050, 1051, 1053, 1055, 1056, 1056, 1057, 1058, 1061, 1062, 1068, 1071, 1073, 1074, 1075, 1076, 1077, 1078, 1079,
      1080, 1082, 1084, 1085, 1086, 1089, 1090, 1090, 1091, 1092, 1093, 1094, 1095, 1096, 1097, 1099, 1101,
    ],
  ],
  [
    '855244061',
    '28118',
    'Aurora Village Transit Center',
    [
      970, 971, 973, 975, 976, 976, 977, 978, 981, 982, 988, 991, 993, 994, 995, 996, 997, 998, 999, 1000, 1002, 1004,
      1005, 1006, 1009, 1010, 1011, 1011, 1012, 1014, 1015, 1016, 1017, 1018, 1020, 1022,
    ],
  ],
  [
    '855244091',
    '28118',
    'Aurora Village Transit Center',
    [
      1030, 1031, 1033, 1035, 1036, 1036, 1037, 1038, 1041, 1042, 1048, 1051, 1053, 1054, 1055, 1056, 1057, 1058, 1059,
      1060, 1062, 1064, 1065, 1066, 1069, 1070, 1070, 1071, 1072, 1073, 1074, 1075, 1076, 1077, 1079, 1081,
    ],
  ],
  [
    '855244101',
    '28118',
    'Aurora Village Transit Center',
    [
      1060, 1061, 1063, 1065, 1066, 1066, 1067, 1068, 1071, 1072, 1078, 1081, 1083, 1084, 1085, 1086, 1087, 1088, 1089,
      1090, 1092, 1094, 1095, 1096, 1099, 1100, 1100, 1101, 1102, 1103, 1104, 1105, 1106, 1107, 1109, 1111,
    ],
  ],
  [
    '855244111',
    '28118',
    'Aurora Village Transit Center',
    [
      1190, 1191, 1193, 1195, 1196, 1196, 1197, 1198, 1201, 1202, 1208, 1211, 1212, 1213, 1214, 1215, 1216, 1217, 1218,
      1219, 1221, 1223, 1224, 1225, 1228, 1229, 1229, 1230, 1231, 1232, 1232, 1233, 1234, 1235, 1237, 1239,
    ],
  ],
  [
    '855244141',
    '28118',
    'Aurora Village Transit Center',
    [
      1110, 1111, 1113, 1115, 1116, 1116, 1117, 1118, 1121, 1122, 1128, 1131, 1133, 1134, 1135, 1136, 1137, 1138, 1139,
      1140, 1142, 1144, 1145, 1146, 1149, 1150, 1150, 1151, 1152, 1153, 1154, 1155, 1156, 1157, 1159, 1161,
    ],
  ],
  [
    '855244161',
    '28118',
    'Aurora Village Transit Center',
    [
      1170, 1171, 1173, 1175, 1176, 1176, 1177, 1178, 1181, 1182, 1188, 1191, 1193, 1194, 1195, 1196, 1197, 1198, 1199,
      1200, 1202, 1204, 1205, 1206, 1209, 1210, 1210, 1211, 1212, 1213, 1213, 1214, 1215, 1216, 1218, 1220,
    ],
  ],
  [
    '855244171',
    '28118',
    'Aurora Village Transit Center',
    [
      1210, 1211, 1213, 1215, 1216, 1216, 1217, 1218, 1221, 1222, 1228, 1231, 1232, 1233, 1234, 1235, 1236, 1237, 1238,
      1239, 1241, 1243, 1244, 1245, 1248, 1249, 1249, 1250, 1251, 1252, 1252, 1253, 1254, 1255, 1257, 1259,
    ],
  ],
  [
    '855244201',
    '28118',
    'Aurora Village Transit Center',
    [
      820, 821, 823, 825, 826, 826, 827, 828, 831, 832, 838, 841, 843, 844, 845, 846, 847, 848, 849, 850, 852, 854, 855,
      856, 859, 860, 861, 861, 862, 864, 865, 866, 867, 868, 870, 872,
    ],
  ],
  [
    '855244221',
    '28118',
    'Aurora Village Transit Center',
    [
      680, 681, 683, 685, 686, 686, 687, 688, 691, 692, 698, 701, 703, 704, 705, 706, 707, 708, 709, 710, 712, 714, 715,
      716, 719, 720, 720, 721, 722, 723, 724, 725, 726, 727, 729, 731,
    ],
  ],
  [
    '855244231',
    '28118',
    'Aurora Village Transit Center',
    [
      540, 541, 543, 545, 546, 546, 547, 548, 551, 552, 558, 561, 562, 563, 564, 565, 565, 566, 567, 568, 570, 572, 573,
      574, 576, 577, 577, 578, 579, 580, 581, 582, 583, 584, 586, 588,
    ],
  ],
  [
    '855244271',
    '28118',
    'Aurora Village Transit Center',
    [
      1324, 1325, 1327, 1329, 1330, 1330, 1332, 1332, 1335, 1337, 1343, 1346, 1347, 1348, 1349, 1350, 1351, 1351, 1352,
      1353, 1355, 1357, 1358, 1359, 1362, 1363, 1363, 1364, 1365, 1366, 1366, 1367, 1368, 1369, 1371, 1372,
    ],
  ],
  [
    '855244291',
    '28118',
    'Aurora Village Transit Center',
    [
      1339, 1340, 1342, 1344, 1345, 1345, 1347, 1347, 1350, 1352, 1358, 1361, 1362, 1363, 1364, 1365, 1366, 1366, 1367,
      1368, 1370, 1372, 1373, 1374, 1377, 1378, 1378, 1379, 1380, 1381, 1381, 1382, 1383, 1384, 1386, 1387,
    ],
  ],
  [
    '855244301',
    '28118',
    'Aurora Village Transit Center',
    [
      1484, 1485, 1487, 1489, 1490, 1490, 1492, 1492, 1495, 1497, 1503, 1506, 1507, 1508, 1509, 1510, 1511, 1511, 1512,
      1513, 1515, 1517, 1518, 1519, 1522, 1522, 1523, 1524, 1524, 1525, 1526, 1527, 1527, 1528, 1530, 1531,
    ],
  ],
  [
    '855244331',
    '28118',
    'Aurora Village Transit Center',
    [
      1369, 1370, 1372, 1374, 1375, 1375, 1377, 1377, 1380, 1382, 1388, 1391, 1392, 1393, 1394, 1395, 1396, 1396, 1397,
      1398, 1400, 1402, 1403, 1404, 1407, 1407, 1408, 1409, 1409, 1410, 1411, 1412, 1412, 1413, 1415, 1416,
    ],
  ],
  [
    '855244341',
    '28118',
    'Aurora Village Transit Center',
    [
      1236, 1237, 1239, 1241, 1242, 1242, 1243, 1244, 1247, 1248, 1254, 1257, 1258, 1259, 1260, 1261, 1262, 1263, 1264,
      1265, 1267, 1269, 1270, 1271, 1274, 1275, 1275, 1276, 1277, 1278, 1278, 1279, 1280, 1281, 1283, 1284,
    ],
  ],
  [
    '855244371',
    '28118',
    'Aurora Village Transit Center',
    [
      1090, 1091, 1093, 1095, 1096, 1096, 1097, 1098, 1101, 1102, 1108, 1111, 1113, 1114, 1115, 1116, 1117, 1118, 1119,
      1120, 1122, 1124, 1125, 1126, 1129, 1130, 1130, 1131, 1132, 1133, 1134, 1135, 1136, 1137, 1139, 1141,
    ],
  ],
  [
    '855244381',
    '28118',
    'Aurora Village Transit Center',
    [
      950, 951, 953, 955, 956, 956, 957, 958, 961, 962, 968, 971, 973, 974, 975, 976, 977, 978, 979, 980, 982, 984, 985,
      986, 989, 990, 991, 991, 992, 994, 995, 996, 997, 998, 1000, 1002,
    ],
  ],
  [
    '855244391',
    '28118',
    'Aurora Village Transit Center',
    [
      1294, 1295, 1297, 1299, 1300, 1300, 1301, 1302, 1305, 1306, 1312, 1315, 1316, 1317, 1318, 1319, 1320, 1320, 1321,
      1322, 1324, 1326, 1327, 1328, 1331, 1332, 1332, 1333, 1334, 1335, 1335, 1336, 1337, 1338, 1340, 1341,
    ],
  ],
  [
    '855244421',
    '28118',
    'Aurora Village Transit Center',
    [
      1604, 1605, 1607, 1609, 1610, 1610, 1612, 1612, 1615, 1617, 1623, 1626, 1627, 1628, 1629, 1630, 1631, 1631, 1632,
      1633, 1635, 1637, 1638, 1639, 1642, 1642, 1643, 1644, 1644, 1645, 1646, 1647, 1647, 1648, 1650, 1651,
    ],
  ],
  [
    '855244451',
    '28118',
    'Aurora Village Transit Center',
    [
      1454, 1455, 1457, 1459, 1460, 1460, 1462, 1462, 1465, 1467, 1473, 1476, 1477, 1478, 1479, 1480, 1481, 1481, 1482,
      1483, 1485, 1487, 1488, 1489, 1492, 1492, 1493, 1494, 1494, 1495, 1496, 1497, 1497, 1498, 1500, 1501,
    ],
  ],
];
export const STOPS_E_1: [string, string][] = [
  ['16100', 'Aurora Village Transit Center - Bay 10'],
  ['75700', 'Aurora Ave N & N 200th St'],
  ['75730', 'Aurora Ave N & N 192nd St'],
  ['75740', 'Aurora Ave N & N 185th St'],
  ['75750', 'Aurora Ave N & N 180th St'],
  ['75760', 'Aurora Ave N & N 175th St'],
  ['75770', 'Aurora Ave N & N 170th St'],
  ['75780', 'Aurora Ave N & N 165th St'],
  ['75790', 'Aurora Ave N & N 160th St'],
  ['75800', 'Aurora Ave N & N 155th St'],
  ['75810', 'Aurora Ave N & N 152nd St'],
  ['6950', 'Aurora Ave N & N 145th St'],
  ['6990', 'Aurora Ave N & N 135th St'],
  ['7000', 'Aurora Ave N & N 130th St'],
  ['7010', 'Aurora Ave N & N 125th St'],
  ['7040', 'Aurora Ave N & N 115th St'],
  ['7080', 'Aurora Ave N & N 105th St'],
  ['7100', 'Aurora Ave N & N 100th St'],
  ['7120', 'Aurora Ave N & N 95th St'],
  ['7140', 'Aurora Ave N & N 90th St'],
  ['7160', 'Aurora Ave N & N 85th St'],
  ['7180', 'Aurora Ave N & N 80th St'],
  ['7200', 'Aurora Ave N & N 76th St'],
  ['7210', 'Aurora Ave N & N 65th St'],
  ['75408', 'Aurora Ave N & N 46th St'],
  ['6070', 'Aurora Ave N & Lynn St'],
  ['6100', 'Aurora Ave N & Galer St'],
  ['6176', '7th Ave N & Thomas St'],
  ['7430', 'Wall St & 5th Ave'],
  ['400', '3rd Ave & Bell St'],
  ['420', '3rd Ave & Virginia St'],
  ['431', '3rd Ave & Pike St'],
  ['468', '3rd Ave & Seneca St'],
  ['490', '3rd Ave & Cherry St'],
  ['625', 'S Washington St & 4th Ave S'],
];
export const TRIPS_E_1: [string, string, string, number[]][] = [
  [
    '849268761',
    '139986',
    'Downtown Seattle',
    [
      310, 310, 311, 312, 313, 314, 315, 315, 316, 317, 317, 319, 320, 321, 322, 324, 326, 327, 328, 328, 330, 330, 331,
      334, 336, 341, 342, 345, 346, 347, 348, 349, 351, 353, 356,
    ],
  ],
  [
    '849268801',
    '139986',
    'Downtown Seattle',
    [
      270, 270, 271, 272, 273, 274, 275, 275, 276, 277, 277, 279, 280, 281, 282, 284, 286, 287, 288, 288, 290, 290, 291,
      294, 296, 301, 302, 305, 306, 307, 308, 309, 311, 313, 316,
    ],
  ],
  [
    '849268851',
    '139986',
    'Downtown Seattle',
    [
      290, 290, 291, 292, 293, 294, 295, 295, 296, 297, 297, 299, 300, 301, 302, 304, 306, 307, 308, 308, 310, 310, 311,
      314, 316, 321, 322, 325, 326, 327, 328, 329, 331, 333, 336,
    ],
  ],
  [
    '849268861',
    '139986',
    'Downtown Seattle',
    [
      580, 580, 582, 583, 584, 585, 586, 587, 588, 589, 590, 592, 594, 595, 596, 598, 601, 602, 603, 604, 606, 606, 607,
      610, 613, 618, 620, 623, 624, 625, 626, 627, 629, 631, 634,
    ],
  ],
  [
    '849268891',
    '139986',
    'Downtown Seattle',
    [
      704, 704, 706, 707, 708, 709, 710, 711, 712, 713, 714, 716, 718, 719, 720, 722, 725, 726, 727, 728, 730, 730, 731,
      734, 737, 742, 744, 747, 748, 749, 750, 751, 753, 755, 758,
    ],
  ],
  [
    '849268921',
    '139986',
    'Downtown Seattle',
    [
      646, 646, 648, 649, 650, 651, 652, 653, 654, 655, 656, 658, 660, 661, 662, 664, 667, 668, 669, 670, 672, 672, 673,
      676, 679, 684, 686, 689, 690, 691, 692, 693, 695, 697, 700,
    ],
  ],
  [
    '849268941',
    '139986',
    'Downtown Seattle',
    [
      360, 360, 362, 363, 364, 364, 365, 366, 367, 368, 368, 370, 371, 372, 373, 375, 377, 378, 379, 380, 382, 382, 383,
      386, 389, 394, 396, 399, 400, 401, 402, 403, 405, 407, 410,
    ],
  ],
  [
    '849268951',
    '139986',
    'Downtown Seattle',
    [
      502, 502, 504, 505, 506, 507, 508, 509, 510, 511, 511, 513, 515, 516, 517, 519, 522, 523, 524, 525, 527, 528, 529,
      532, 535, 541, 543, 546, 547, 549, 550, 551, 553, 555, 558,
    ],
  ],
  [
    '849268971',
    '139986',
    'Downtown Seattle',
    [
      792, 792, 794, 796, 797, 798, 799, 800, 801, 802, 803, 805, 807, 808, 809, 811, 814, 815, 816, 817, 819, 819, 820,
      823, 826, 831, 833, 836, 837, 838, 839, 840, 842, 845, 848,
    ],
  ],
  [
    '849268981',
    '139986',
    'Downtown Seattle',
    [
      460, 460, 462, 463, 464, 465, 466, 467, 468, 469, 469, 471, 473, 474, 475, 477, 480, 481, 482, 483, 485, 486, 487,
      490, 493, 499, 501, 504, 505, 507, 508, 509, 511, 513, 516,
    ],
  ],
  [
    '849268991',
    '139986',
    'Downtown Seattle',
    [
      856, 856, 858, 860, 861, 862, 863, 864, 865, 866, 867, 869, 871, 872, 873, 875, 878, 879, 880, 881, 883, 884, 885,
      888, 891, 896, 898, 901, 902, 903, 904, 905, 907, 910, 913,
    ],
  ],
  [
    '849269011',
    '139986',
    'Downtown Seattle',
    [
      330, 330, 331, 332, 333, 334, 335, 335, 336, 337, 337, 339, 340, 341, 342, 344, 346, 347, 348, 348, 350, 350, 351,
      354, 356, 361, 362, 365, 366, 367, 368, 369, 371, 373, 376,
    ],
  ],
  [
    '849269031',
    '139986',
    'Downtown Seattle',
    [
      944, 944, 946, 948, 949, 950, 951, 952, 953, 954, 955, 957, 959, 960, 961, 964, 966, 968, 969, 970, 972, 973, 974,
      977, 980, 986, 989, 992, 993, 995, 995, 997, 999, 1002, 1005,
    ],
  ],
  [
    '849269061',
    '139986',
    'Downtown Seattle',
    [
      472, 472, 474, 475, 476, 477, 478, 479, 480, 481, 481, 483, 485, 486, 487, 489, 492, 493, 494, 495, 497, 498, 499,
      502, 505, 511, 513, 516, 517, 519, 520, 521, 523, 525, 528,
    ],
  ],
  [
    '849269071',
    '139986',
    'Downtown Seattle',
    [
      1010, 1010, 1013, 1014, 1015, 1016, 1018, 1019, 1020, 1021, 1022, 1024, 1026, 1027, 1028, 1030, 1033, 1034, 1035,
      1036, 1038, 1039, 1040, 1043, 1046, 1052, 1055, 1058, 1059, 1061, 1061, 1063, 1065, 1068, 1071,
    ],
  ],
  [
    '849269081',
    '139986',
    'Downtown Seattle',
    [
      340, 340, 341, 342, 343, 344, 345, 345, 346, 347, 347, 349, 350, 351, 352, 354, 356, 357, 358, 358, 360, 360, 361,
      364, 367, 372, 374, 377, 378, 379, 380, 381, 383, 385, 388,
    ],
  ],
  [
    '849269101',
    '139986',
    'Downtown Seattle',
    [
      490, 490, 492, 493, 494, 495, 496, 497, 498, 499, 499, 501, 503, 504, 505, 507, 510, 511, 512, 513, 515, 516, 517,
      520, 523, 529, 531, 534, 535, 537, 538, 539, 541, 543, 546,
    ],
  ],
  [
    '849269141',
    '139986',
    'Downtown Seattle',
    [
      1110, 1110, 1112, 1113, 1114, 1115, 1116, 1117, 1118, 1119, 1120, 1122, 1124, 1125, 1126, 1128, 1131, 1132, 1133,
      1134, 1136, 1137, 1138, 1141, 1144, 1149, 1151, 1154, 1155, 1156, 1157, 1158, 1160, 1162, 1165,
    ],
  ],
  [
    '849269151',
    '139986',
    'Downtown Seattle',
    [
      508, 508, 510, 511, 512, 513, 514, 515, 516, 517, 517, 519, 521, 522, 523, 525, 528, 529, 530, 531, 533, 534, 535,
      538, 541, 547, 549, 552, 553, 555, 556, 557, 559, 561, 564,
    ],
  ],
  [
    '849269171',
    '139986',
    'Downtown Seattle',
    [
      370, 370, 372, 373, 374, 374, 375, 376, 377, 378, 378, 380, 381, 382, 383, 385, 387, 388, 389, 390, 392, 392, 393,
      396, 399, 404, 406, 409, 410, 411, 412, 413, 415, 417, 420,
    ],
  ],
  [
    '849269211',
    '139986',
    'Downtown Seattle',
    [
      520, 520, 522, 523, 524, 525, 526, 527, 528, 529, 529, 531, 533, 534, 535, 537, 540, 541, 542, 543, 545, 545, 546,
      549, 552, 558, 560, 563, 564, 566, 567, 568, 570, 572, 575,
    ],
  ],
  [
    '849269221',
    '139986',
    'Downtown Seattle',
    [
      1248, 1248, 1250, 1251, 1252, 1253, 1254, 1255, 1256, 1257, 1257, 1259, 1261, 1262, 1263, 1265, 1267, 1268, 1269,
      1270, 1272, 1272, 1273, 1276, 1279, 1284, 1285, 1288, 1289, 1290, 1291, 1292, 1294, 1296, 1299,
    ],
  ],
  [
    '849269241',
    '139986',
    'Downtown Seattle',
    [
      550, 550, 552, 553, 554, 555, 556, 557, 558, 559, 559, 561, 563, 564, 565, 567, 570, 571, 572, 573, 575, 575, 576,
      579, 582, 587, 589, 592, 593, 594, 595, 596, 598, 600, 603,
    ],
  ],
  [
    '849269251',
    '139986',
    'Downtown Seattle',
    [
      436, 436, 438, 439, 440, 440, 441, 442, 443, 444, 444, 446, 447, 448, 449, 451, 453, 454, 455, 456, 458, 458, 459,
      462, 465, 471, 473, 476, 477, 479, 480, 481, 483, 485, 488,
    ],
  ],
  [
    '849269261',
    '139986',
    'Downtown Seattle',
    [
      514, 514, 516, 517, 518, 519, 520, 521, 522, 523, 523, 525, 527, 528, 529, 531, 534, 535, 536, 537, 539, 540, 541,
      544, 547, 553, 555, 558, 559, 561, 562, 563, 565, 567, 570,
    ],
  ],
  [
    '849269271',
    '139986',
    'Downtown Seattle',
    [
      418, 418, 420, 421, 422, 422, 423, 424, 425, 426, 426, 428, 429, 430, 431, 433, 435, 436, 437, 438, 440, 440, 441,
      444, 447, 452, 454, 457, 458, 459, 460, 461, 463, 465, 468,
    ],
  ],
  [
    '849269291',
    '139986',
    'Downtown Seattle',
    [
      1020, 1020, 1023, 1024, 1025, 1026, 1028, 1029, 1030, 1031, 1032, 1034, 1036, 1037, 1038, 1040, 1043, 1044, 1045,
      1046, 1048, 1049, 1050, 1053, 1056, 1062, 1065, 1068, 1069, 1071, 1071, 1073, 1075, 1078, 1081,
    ],
  ],
  [
    '849269301',
    '139986',
    'Downtown Seattle',
    [
      1170, 1170, 1172, 1173, 1174, 1175, 1176, 1177, 1178, 1179, 1179, 1181, 1183, 1184, 1185, 1187, 1189, 1190, 1191,
      1192, 1194, 1194, 1195, 1198, 1201, 1206, 1207, 1210, 1211, 1212, 1213, 1214, 1216, 1218, 1221,
    ],
  ],
  [
    '849269321',
    '139986',
    'Downtown Seattle',
    [
      720, 720, 722, 723, 724, 725, 726, 727, 728, 729, 730, 732, 734, 735, 736, 738, 741, 742, 743, 744, 746, 746, 747,
      750, 753, 758, 760, 763, 764, 765, 766, 767, 769, 771, 774,
    ],
  ],
  [
    '849269341',
    '139986',
    'Downtown Seattle',
    [
      598, 598, 600, 601, 602, 603, 604, 605, 606, 607, 608, 610, 612, 613, 614, 616, 619, 620, 621, 622, 624, 624, 625,
      628, 631, 636, 638, 641, 642, 643, 644, 645, 647, 649, 652,
    ],
  ],
  [
    '849269361',
    '139986',
    'Downtown Seattle',
    [
      864, 864, 866, 868, 869, 870, 871, 872, 873, 874, 875, 877, 879, 880, 881, 884, 886, 888, 889, 890, 892, 893, 894,
      897, 900, 906, 909, 912, 913, 915, 915, 917, 919, 922, 925,
    ],
  ],
  [
    '849269401',
    '139986',
    'Downtown Seattle',
    [
      448, 448, 450, 451, 452, 452, 453, 454, 455, 456, 456, 458, 460, 461, 462, 464, 467, 468, 469, 470, 472, 472, 473,
      476, 479, 485, 487, 490, 491, 493, 494, 495, 497, 499, 502,
    ],
  ],
  [
    '849269411',
    '139986',
    'Downtown Seattle',
    [
      424, 424, 426, 427, 428, 428, 429, 430, 431, 432, 432, 434, 435, 436, 437, 439, 441, 442, 443, 444, 446, 446, 447,
      450, 453, 459, 461, 464, 465, 467, 468, 469, 471, 473, 476,
    ],
  ],
  [
    '849269421',
    '139986',
    'Downtown Seattle',
    [
      562, 562, 564, 565, 566, 567, 568, 569, 570, 571, 571, 573, 575, 576, 577, 579, 582, 583, 584, 585, 587, 587, 588,
      591, 594, 599, 601, 604, 605, 606, 607, 608, 610, 612, 615,
    ],
  ],
  [
    '849269451',
    '139986',
    'Downtown Seattle',
    [
      1224, 1224, 1226, 1227, 1228, 1229, 1230, 1231, 1232, 1233, 1233, 1235, 1237, 1238, 1239, 1241, 1243, 1244, 1245,
      1246, 1248, 1248, 1249, 1252, 1255, 1260, 1261, 1264, 1265, 1266, 1267, 1268, 1270, 1272, 1275,
    ],
  ],
  [
    '849269471',
    '139986',
    'Downtown Seattle',
    [
      1080, 1080, 1082, 1084, 1085, 1086, 1087, 1088, 1089, 1090, 1091, 1093, 1095, 1096, 1097, 1099, 1102, 1103, 1104,
      1105, 1107, 1108, 1109, 1112, 1115, 1120, 1122, 1125, 1126, 1127, 1128, 1129, 1131, 1134, 1137,
    ],
  ],
  [
    '849269491',
    '139986',
    'Downtown Seattle',
    [
      622, 622, 624, 625, 626, 627, 628, 629, 630, 631, 632, 634, 636, 637, 638, 640, 643, 644, 645, 646, 648, 648, 649,
      652, 655, 660, 662, 665, 666, 667, 668, 669, 671, 673, 676,
    ],
  ],
  [
    '849269501',
    '139986',
    'Downtown Seattle',
    [
      760, 760, 762, 764, 765, 766, 767, 768, 769, 770, 771, 773, 775, 776, 777, 779, 782, 783, 784, 785, 787, 787, 788,
      791, 794, 799, 801, 804, 805, 806, 807, 808, 810, 812, 815,
    ],
  ],
  [
    '849269511',
    '139986',
    'Downtown Seattle',
    [
      912, 912, 914, 916, 917, 918, 919, 920, 921, 922, 923, 925, 927, 928, 929, 932, 934, 936, 937, 938, 940, 941, 942,
      945, 948, 954, 957, 960, 961, 963, 963, 965, 967, 970, 973,
    ],
  ],
  [
    '849269531',
    '139986',
    'Downtown Seattle',
    [
      880, 880, 882, 884, 885, 886, 887, 888, 889, 890, 891, 893, 895, 896, 897, 900, 902, 904, 905, 906, 908, 909, 910,
      913, 916, 922, 925, 928, 929, 931, 931, 933, 935, 938, 941,
    ],
  ],
  [
    '849269541',
    '139986',
    'Downtown Seattle',
    [
      1050, 1050, 1052, 1054, 1055, 1056, 1057, 1058, 1059, 1060, 1061, 1063, 1065, 1066, 1067, 1069, 1072, 1073, 1074,
      1075, 1077, 1078, 1079, 1082, 1085, 1091, 1094, 1097, 1098, 1100, 1100, 1102, 1104, 1107, 1110,
    ],
  ],
  [
    '849269551',
    '139986',
    'Downtown Seattle',
    [
      1335, 1335, 1337, 1338, 1339, 1339, 1340, 1341, 1342, 1343, 1343, 1345, 1346, 1347, 1348, 1350, 1352, 1353, 1354,
      1355, 1357, 1357, 1358, 1361, 1364, 1369, 1370, 1373, 1374, 1375, 1376, 1377, 1379, 1380, 1383,
    ],
  ],
  [
    '849269581',
    '139986',
    'Downtown Seattle',
    [
      1200, 1200, 1202, 1203, 1204, 1205, 1206, 1207, 1208, 1209, 1209, 1211, 1213, 1214, 1215, 1217, 1219, 1220, 1221,
      1222, 1224, 1224, 1225, 1228, 1231, 1236, 1237, 1240, 1241, 1242, 1243, 1244, 1246, 1248, 1251,
    ],
  ],
  [
    '849269601',
    '139986',
    'Downtown Seattle',
    [
      728, 728, 730, 731, 732, 733, 734, 735, 736, 737, 738, 740, 742, 743, 744, 746, 749, 750, 751, 752, 754, 754, 755,
      758, 761, 766, 768, 771, 772, 773, 774, 775, 777, 779, 782,
    ],
  ],
  [
    '849269631',
    '139986',
    'Downtown Seattle',
    [
      1180, 1180, 1182, 1183, 1184, 1185, 1186, 1187, 1188, 1189, 1189, 1191, 1193, 1194, 1195, 1197, 1199, 1200, 1201,
      1202, 1204, 1204, 1205, 1208, 1211, 1216, 1217, 1220, 1221, 1222, 1223, 1224, 1226, 1228, 1231,
    ],
  ],
  [
    '849269641',
    '139986',
    'Downtown Seattle',
    [
      1030, 1030, 1033, 1034, 1035, 1036, 1038, 1039, 1040, 1041, 1042, 1044, 1046, 1047, 1048, 1050, 1053, 1054, 1055,
      1056, 1058, 1059, 1060, 1063, 1066, 1072, 1075, 1078, 1079, 1081, 1081, 1083, 1085, 1088, 1091,
    ],
  ],
  [
    '849269661',
    '139986',
    'Downtown Seattle',
    [
      872, 872, 874, 876, 877, 878, 879, 880, 881, 882, 883, 885, 887, 888, 889, 892, 894, 896, 897, 898, 900, 901, 902,
      905, 908, 914, 917, 920, 921, 923, 923, 925, 927, 930, 933,
    ],
  ],
  [
    '849269681',
    '139986',
    'Downtown Seattle',
    [
      1305, 1305, 1307, 1308, 1309, 1310, 1311, 1312, 1313, 1314, 1314, 1316, 1318, 1319, 1320, 1322, 1324, 1325, 1326,
      1327, 1329, 1329, 1330, 1333, 1336, 1341, 1342, 1345, 1346, 1347, 1348, 1349, 1351, 1352, 1355,
    ],
  ],
  [
    '849269751',
    '139986',
    'Downtown Seattle',
    [
      1070, 1070, 1072, 1074, 1075, 1076, 1077, 1078, 1079, 1080, 1081, 1083, 1085, 1086, 1087, 1089, 1092, 1093, 1094,
      1095, 1097, 1098, 1099, 1102, 1105, 1110, 1112, 1115, 1116, 1117, 1118, 1119, 1121, 1124, 1127,
    ],
  ],
  [
    '849269771',
    '139986',
    'Downtown Seattle',
    [
      1090, 1090, 1092, 1094, 1095, 1096, 1097, 1098, 1099, 1100, 1101, 1103, 1105, 1106, 1107, 1109, 1112, 1113, 1114,
      1115, 1117, 1118, 1119, 1122, 1125, 1130, 1132, 1135, 1136, 1137, 1138, 1139, 1141, 1144, 1147,
    ],
  ],
  [
    '849269821',
    '139986',
    'Downtown Seattle',
    [
      1120, 1120, 1122, 1123, 1124, 1125, 1126, 1127, 1128, 1129, 1130, 1132, 1134, 1135, 1136, 1138, 1141, 1142, 1143,
      1144, 1146, 1147, 1148, 1151, 1154, 1159, 1161, 1164, 1165, 1166, 1167, 1168, 1170, 1172, 1175,
    ],
  ],
  [
    '849269841',
    '139986',
    'Downtown Seattle',
    [
      1260, 1260, 1262, 1263, 1264, 1265, 1266, 1267, 1268, 1269, 1269, 1271, 1273, 1274, 1275, 1277, 1279, 1280, 1281,
      1282, 1284, 1284, 1285, 1288, 1291, 1296, 1297, 1300, 1301, 1302, 1303, 1304, 1306, 1308, 1311,
    ],
  ],
  [
    '849269861',
    '139986',
    'Downtown Seattle',
    [
      1395, 1395, 1397, 1398, 1399, 1399, 1400, 1401, 1402, 1403, 1403, 1405, 1406, 1407, 1408, 1410, 1412, 1413, 1414,
      1414, 1416, 1416, 1417, 1420, 1423, 1428, 1429, 1432, 1433, 1434, 1435, 1436, 1438, 1439, 1442,
    ],
  ],
  [
    '849269881',
    '139986',
    'Downtown Seattle',
    [
      1140, 1140, 1142, 1143, 1144, 1145, 1146, 1147, 1148, 1149, 1150, 1152, 1154, 1155, 1156, 1158, 1161, 1162, 1163,
      1164, 1166, 1166, 1167, 1170, 1173, 1178, 1179, 1182, 1183, 1184, 1185, 1186, 1188, 1190, 1193,
    ],
  ],
  [
    '849269931',
    '139986',
    'Downtown Seattle',
    [
      1672, 1672, 1673, 1674, 1675, 1676, 1677, 1677, 1678, 1679, 1679, 1681, 1682, 1683, 1684, 1686, 1688, 1689, 1690,
      1690, 1692, 1692, 1693, 1696, 1699, 1704, 1705, 1708, 1709, 1710, 1711, 1712, 1714, 1715, 1718,
    ],
  ],
  [
    '849269951',
    '139986',
    'Downtown Seattle',
    [
      1545, 1545, 1546, 1547, 1548, 1549, 1550, 1550, 1551, 1552, 1552, 1554, 1555, 1556, 1557, 1559, 1561, 1562, 1563,
      1563, 1565, 1565, 1566, 1569, 1572, 1577, 1578, 1581, 1582, 1583, 1584, 1585, 1587, 1588, 1591,
    ],
  ],
  [
    '849269971',
    '139986',
    'Downtown Seattle',
    [
      1425, 1425, 1427, 1428, 1429, 1429, 1430, 1431, 1432, 1433, 1433, 1435, 1436, 1437, 1438, 1440, 1442, 1443, 1444,
      1444, 1446, 1446, 1447, 1450, 1453, 1458, 1459, 1462, 1463, 1464, 1465, 1466, 1468, 1469, 1472,
    ],
  ],
  [
    '849269981',
    '139986',
    'Downtown Seattle',
    [
      1160, 1160, 1162, 1163, 1164, 1165, 1166, 1167, 1168, 1169, 1169, 1171, 1173, 1174, 1175, 1177, 1179, 1180, 1181,
      1182, 1184, 1184, 1185, 1188, 1191, 1196, 1197, 1200, 1201, 1202, 1203, 1204, 1206, 1208, 1211,
    ],
  ],
  [
    '849270011',
    '139986',
    'Downtown Seattle',
    [
      1290, 1290, 1292, 1293, 1294, 1295, 1296, 1297, 1298, 1299, 1299, 1301, 1303, 1304, 1305, 1307, 1309, 1310, 1311,
      1312, 1314, 1314, 1315, 1318, 1321, 1326, 1327, 1330, 1331, 1332, 1333, 1334, 1336, 1337, 1340,
    ],
  ],
  [
    '849270021',
    '139986',
    'Downtown Seattle',
    [
      1605, 1605, 1606, 1607, 1608, 1609, 1610, 1610, 1611, 1612, 1612, 1614, 1615, 1616, 1617, 1619, 1621, 1622, 1623,
      1623, 1625, 1625, 1626, 1629, 1632, 1637, 1638, 1641, 1642, 1643, 1644, 1645, 1647, 1648, 1651,
    ],
  ],
  [
    '849270041',
    '139986',
    'Downtown Seattle',
    [
      1485, 1485, 1486, 1487, 1488, 1489, 1490, 1490, 1491, 1492, 1492, 1494, 1495, 1496, 1497, 1499, 1501, 1502, 1503,
      1503, 1505, 1505, 1506, 1509, 1512, 1517, 1518, 1521, 1522, 1523, 1524, 1525, 1527, 1528, 1531,
    ],
  ],
  [
    '849270081',
    '139986',
    'Downtown Seattle',
    [
      1350, 1350, 1352, 1353, 1354, 1354, 1355, 1356, 1357, 1358, 1358, 1360, 1361, 1362, 1363, 1365, 1367, 1368, 1369,
      1370, 1372, 1372, 1373, 1376, 1379, 1384, 1385, 1388, 1389, 1390, 1391, 1392, 1394, 1395, 1398,
    ],
  ],
  [
    '849270091',
    '139986',
    'Downtown Seattle',
    [
      1212, 1212, 1214, 1215, 1216, 1217, 1218, 1219, 1220, 1221, 1221, 1223, 1225, 1226, 1227, 1229, 1231, 1232, 1233,
      1234, 1236, 1236, 1237, 1240, 1243, 1248, 1249, 1252, 1253, 1254, 1255, 1256, 1258, 1260, 1263,
    ],
  ],
  [
    '849270101',
    '139986',
    'Downtown Seattle',
    [
      350, 350, 351, 352, 353, 354, 355, 355, 356, 357, 357, 359, 360, 361, 362, 364, 366, 367, 368, 368, 370, 370, 371,
      374, 377, 382, 384, 387, 388, 389, 390, 391, 393, 395, 398,
    ],
  ],
  [
    '849270131',
    '139986',
    'Downtown Seattle',
    [
      394, 394, 396, 397, 398, 398, 399, 400, 401, 402, 402, 404, 405, 406, 407, 409, 411, 412, 413, 414, 416, 416, 417,
      420, 423, 428, 430, 433, 434, 435, 436, 437, 439, 441, 444,
    ],
  ],
  [
    '849270141',
    '139986',
    'Downtown Seattle',
    [
      402, 402, 404, 405, 406, 406, 407, 408, 409, 410, 410, 412, 413, 414, 415, 417, 419, 420, 421, 422, 424, 424, 425,
      428, 431, 436, 438, 441, 442, 443, 444, 445, 447, 449, 452,
    ],
  ],
  [
    '849270151',
    '139986',
    'Downtown Seattle',
    [
      478, 478, 480, 481, 482, 483, 484, 485, 486, 487, 487, 489, 491, 492, 493, 495, 498, 499, 500, 501, 503, 504, 505,
      508, 511, 517, 519, 522, 523, 525, 526, 527, 529, 531, 534,
    ],
  ],
  [
    '849270171',
    '139986',
    'Downtown Seattle',
    [
      532, 532, 534, 535, 536, 537, 538, 539, 540, 541, 541, 543, 545, 546, 547, 549, 552, 553, 554, 555, 557, 557, 558,
      561, 564, 570, 572, 575, 576, 578, 579, 580, 582, 584, 587,
    ],
  ],
  [
    '849270191',
    '139986',
    'Downtown Seattle',
    [
      410, 410, 412, 413, 414, 414, 415, 416, 417, 418, 418, 420, 421, 422, 423, 425, 427, 428, 429, 430, 432, 432, 433,
      436, 439, 444, 446, 449, 450, 451, 452, 453, 455, 457, 460,
    ],
  ],
  [
    '849270201',
    '139986',
    'Downtown Seattle',
    [
      568, 568, 570, 571, 572, 573, 574, 575, 576, 577, 577, 579, 581, 582, 583, 585, 588, 589, 590, 591, 593, 593, 594,
      597, 600, 605, 607, 610, 611, 612, 613, 614, 616, 618, 621,
    ],
  ],
  [
    '849270211',
    '139986',
    'Downtown Seattle',
    [
      544, 544, 546, 547, 548, 549, 550, 551, 552, 553, 553, 555, 557, 558, 559, 561, 564, 565, 566, 567, 569, 569, 570,
      573, 576, 581, 583, 586, 587, 588, 589, 590, 592, 594, 597,
    ],
  ],
  [
    '849270271',
    '139986',
    'Downtown Seattle',
    [
      586, 586, 588, 589, 590, 591, 592, 593, 594, 595, 596, 598, 600, 601, 602, 604, 607, 608, 609, 610, 612, 612, 613,
      616, 619, 624, 626, 629, 630, 631, 632, 633, 635, 637, 640,
    ],
  ],
  [
    '849270281',
    '139986',
    'Downtown Seattle',
    [
      688, 688, 690, 691, 692, 693, 694, 695, 696, 697, 698, 700, 702, 703, 704, 706, 709, 710, 711, 712, 714, 714, 715,
      718, 721, 726, 728, 731, 732, 733, 734, 735, 737, 739, 742,
    ],
  ],
  [
    '849270291',
    '139986',
    'Downtown Seattle',
    [
      672, 672, 674, 675, 676, 677, 678, 679, 680, 681, 682, 684, 686, 687, 688, 690, 693, 694, 695, 696, 698, 698, 699,
      702, 705, 710, 712, 715, 716, 717, 718, 719, 721, 723, 726,
    ],
  ],
  [
    '849270301',
    '139986',
    'Downtown Seattle',
    [
      712, 712, 714, 715, 716, 717, 718, 719, 720, 721, 722, 724, 726, 727, 728, 730, 733, 734, 735, 736, 738, 738, 739,
      742, 745, 750, 752, 755, 756, 757, 758, 759, 761, 763, 766,
    ],
  ],
  [
    '849270341',
    '139986',
    'Downtown Seattle',
    [
      736, 736, 738, 740, 741, 742, 743, 744, 745, 746, 747, 749, 751, 752, 753, 755, 758, 759, 760, 761, 763, 763, 764,
      767, 770, 775, 777, 780, 781, 782, 783, 784, 786, 788, 791,
    ],
  ],
  [
    '849270351',
    '139986',
    'Downtown Seattle',
    [
      454, 454, 456, 457, 458, 459, 460, 461, 462, 463, 463, 465, 467, 468, 469, 471, 474, 475, 476, 477, 479, 479, 480,
      483, 486, 492, 494, 497, 498, 500, 501, 502, 504, 506, 509,
    ],
  ],
  [
    '849270361',
    '139986',
    'Downtown Seattle',
    [
      604, 604, 606, 607, 608, 609, 610, 611, 612, 613, 614, 616, 618, 619, 620, 622, 625, 626, 627, 628, 630, 630, 631,
      634, 637, 642, 644, 647, 648, 649, 650, 651, 653, 655, 658,
    ],
  ],
  [
    '849270391',
    '139986',
    'Downtown Seattle',
    [
      832, 832, 834, 836, 837, 838, 839, 840, 841, 842, 843, 845, 847, 848, 849, 851, 854, 855, 856, 857, 859, 860, 861,
      864, 867, 872, 874, 877, 878, 879, 880, 881, 883, 886, 889,
    ],
  ],
  [
    '849270401',
    '139986',
    'Downtown Seattle',
    [
      816, 816, 818, 820, 821, 822, 823, 824, 825, 826, 827, 829, 831, 832, 833, 835, 838, 839, 840, 841, 843, 844, 845,
      848, 851, 856, 858, 861, 862, 863, 864, 865, 867, 870, 873,
    ],
  ],
  [
    '849270421',
    '139986',
    'Downtown Seattle',
    [
      848, 848, 850, 852, 853, 854, 855, 856, 857, 858, 859, 861, 863, 864, 865, 867, 870, 871, 872, 873, 875, 876, 877,
      880, 883, 888, 890, 893, 894, 895, 896, 897, 899, 902, 905,
    ],
  ],
  [
    '849270431',
    '139986',
    'Downtown Seattle',
    [
      610, 610, 612, 613, 614, 615, 616, 617, 618, 619, 620, 622, 624, 625, 626, 628, 631, 632, 633, 634, 636, 636, 637,
      640, 643, 648, 650, 653, 654, 655, 656, 657, 659, 661, 664,
    ],
  ],
  [
    '849270441',
    '139986',
    'Downtown Seattle',
    [
      744, 744, 746, 748, 749, 750, 751, 752, 753, 754, 755, 757, 759, 760, 761, 763, 766, 767, 768, 769, 771, 771, 772,
      775, 778, 783, 785, 788, 789, 790, 791, 792, 794, 796, 799,
    ],
  ],
  [
    '849270501',
    '139986',
    'Downtown Seattle',
    [
      888, 888, 890, 892, 893, 894, 895, 896, 897, 898, 899, 901, 903, 904, 905, 908, 910, 912, 913, 914, 916, 917, 918,
      921, 924, 930, 933, 936, 937, 939, 939, 941, 943, 946, 949,
    ],
  ],
  [
    '849270511',
    '139986',
    'Downtown Seattle',
    [
      466, 466, 468, 469, 470, 471, 472, 473, 474, 475, 475, 477, 479, 480, 481, 483, 486, 487, 488, 489, 491, 492, 493,
      496, 499, 505, 507, 510, 511, 513, 514, 515, 517, 519, 522,
    ],
  ],
  [
    '849270531',
    '139986',
    'Downtown Seattle',
    [
      768, 768, 770, 772, 773, 774, 775, 776, 777, 778, 779, 781, 783, 784, 785, 787, 790, 791, 792, 793, 795, 795, 796,
      799, 802, 807, 809, 812, 813, 814, 815, 816, 818, 820, 823,
    ],
  ],
  [
    '849270541',
    '139986',
    'Downtown Seattle',
    [
      896, 896, 898, 900, 901, 902, 903, 904, 905, 906, 907, 909, 911, 912, 913, 916, 918, 920, 921, 922, 924, 925, 926,
      929, 932, 938, 941, 944, 945, 947, 947, 949, 951, 954, 957,
    ],
  ],
  [
    '849270551',
    '139986',
    'Downtown Seattle',
    [
      484, 484, 486, 487, 488, 489, 490, 491, 492, 493, 493, 495, 497, 498, 499, 501, 504, 505, 506, 507, 509, 510, 511,
      514, 517, 523, 525, 528, 529, 531, 532, 533, 535, 537, 540,
    ],
  ],
  [
    '849270581',
    '139986',
    'Downtown Seattle',
    [
      920, 920, 922, 924, 925, 926, 927, 928, 929, 930, 931, 933, 935, 936, 937, 940, 942, 944, 945, 946, 948, 949, 950,
      953, 956, 962, 965, 968, 969, 971, 971, 973, 975, 978, 981,
    ],
  ],
  [
    '849270591',
    '139986',
    'Downtown Seattle',
    [
      634, 634, 636, 637, 638, 639, 640, 641, 642, 643, 644, 646, 648, 649, 650, 652, 655, 656, 657, 658, 660, 660, 661,
      664, 667, 672, 674, 677, 678, 679, 680, 681, 683, 685, 688,
    ],
  ],
  [
    '849270611',
    '139986',
    'Downtown Seattle',
    [
      960, 960, 963, 964, 965, 966, 968, 969, 970, 971, 972, 974, 976, 977, 978, 981, 983, 985, 986, 987, 989, 990, 991,
      994, 997, 1003, 1006, 1009, 1010, 1012, 1012, 1014, 1016, 1019, 1022,
    ],
  ],
  [
    '849270631',
    '139986',
    'Downtown Seattle',
    [
      980, 980, 983, 984, 985, 986, 988, 989, 990, 991, 992, 994, 996, 997, 998, 1001, 1003, 1005, 1006, 1007, 1009,
      1010, 1011, 1014, 1017, 1023, 1026, 1029, 1030, 1032, 1032, 1034, 1036, 1039, 1042,
    ],
  ],
  [
    '849270641',
    '139986',
    'Downtown Seattle',
    [
      640, 640, 642, 643, 644, 645, 646, 647, 648, 649, 650, 652, 654, 655, 656, 658, 661, 662, 663, 664, 666, 666, 667,
      670, 673, 678, 680, 683, 684, 685, 686, 687, 689, 691, 694,
    ],
  ],
  [
    '849270681',
    '139986',
    'Downtown Seattle',
    [
      776, 776, 778, 780, 781, 782, 783, 784, 785, 786, 787, 789, 791, 792, 793, 795, 798, 799, 800, 801, 803, 803, 804,
      807, 810, 815, 817, 820, 821, 822, 823, 824, 826, 828, 831,
    ],
  ],
  [
    '849270691',
    '139986',
    'Downtown Seattle',
    [
      928, 928, 930, 932, 933, 934, 935, 936, 937, 938, 939, 941, 943, 944, 945, 948, 950, 952, 953, 954, 956, 957, 958,
      961, 964, 970, 973, 976, 977, 979, 979, 981, 983, 986, 989,
    ],
  ],
  [
    '849270711',
    '139986',
    'Downtown Seattle',
    [
      496, 496, 498, 499, 500, 501, 502, 503, 504, 505, 505, 507, 509, 510, 511, 513, 516, 517, 518, 519, 521, 522, 523,
      526, 529, 535, 537, 540, 541, 543, 544, 545, 547, 549, 552,
    ],
  ],
  [
    '849270771',
    '139986',
    'Downtown Seattle',
    [
      658, 658, 660, 661, 662, 663, 664, 665, 666, 667, 668, 670, 672, 673, 674, 676, 679, 680, 681, 682, 684, 684, 685,
      688, 691, 696, 698, 701, 702, 703, 704, 705, 707, 709, 712,
    ],
  ],
  [
    '849270791',
    '139986',
    'Downtown Seattle',
    [
      526, 526, 528, 529, 530, 531, 532, 533, 534, 535, 535, 537, 539, 540, 541, 543, 546, 547, 548, 549, 551, 551, 552,
      555, 558, 564, 566, 569, 570, 572, 573, 574, 576, 578, 581,
    ],
  ],
  [
    '849270801',
    '139986',
    'Downtown Seattle',
    [
      800, 800, 802, 804, 805, 806, 807, 808, 809, 810, 811, 813, 815, 816, 817, 819, 822, 823, 824, 825, 827, 828, 829,
      832, 835, 840, 842, 845, 846, 847, 848, 849, 851, 854, 857,
    ],
  ],
  [
    '849270831',
    '139986',
    'Downtown Seattle',
    [
      1130, 1130, 1132, 1133, 1134, 1135, 1136, 1137, 1138, 1139, 1140, 1142, 1144, 1145, 1146, 1148, 1151, 1152, 1153,
      1154, 1156, 1156, 1157, 1160, 1163, 1168, 1169, 1172, 1173, 1174, 1175, 1176, 1178, 1180, 1183,
    ],
  ],
  [
    '849270851',
    '139986',
    'Downtown Seattle',
    [
      952, 952, 955, 956, 957, 958, 960, 961, 962, 963, 964, 966, 968, 969, 970, 973, 975, 977, 978, 979, 981, 982, 983,
      986, 989, 995, 998, 1001, 1002, 1004, 1004, 1006, 1008, 1011, 1014,
    ],
  ],
  [
    '849270871',
    '139986',
    'Downtown Seattle',
    [
      538, 538, 540, 541, 542, 543, 544, 545, 546, 547, 547, 549, 551, 552, 553, 555, 558, 559, 560, 561, 563, 563, 564,
      567, 570, 575, 577, 580, 581, 582, 583, 584, 586, 588, 591,
    ],
  ],
  [
    '849270881',
    '139986',
    'Downtown Seattle',
    [
      664, 664, 666, 667, 668, 669, 670, 671, 672, 673, 674, 676, 678, 679, 680, 682, 685, 686, 687, 688, 690, 690, 691,
      694, 697, 702, 704, 707, 708, 709, 710, 711, 713, 715, 718,
    ],
  ],
  [
    '849270901',
    '139986',
    'Downtown Seattle',
    [
      808, 808, 810, 812, 813, 814, 815, 816, 817, 818, 819, 821, 823, 824, 825, 827, 830, 831, 832, 833, 835, 836, 837,
      840, 843, 848, 850, 853, 854, 855, 856, 857, 859, 862, 865,
    ],
  ],
  [
    '849270941',
    '139986',
    'Downtown Seattle',
    [
      556, 556, 558, 559, 560, 561, 562, 563, 564, 565, 565, 567, 569, 570, 571, 573, 576, 577, 578, 579, 581, 581, 582,
      585, 588, 593, 595, 598, 599, 600, 601, 602, 604, 606, 609,
    ],
  ],
  [
    '849270951',
    '139986',
    'Downtown Seattle',
    [
      680, 680, 682, 683, 684, 685, 686, 687, 688, 689, 690, 692, 694, 695, 696, 698, 701, 702, 703, 704, 706, 706, 707,
      710, 713, 718, 720, 723, 724, 725, 726, 727, 729, 731, 734,
    ],
  ],
  [
    '849270971',
    '139986',
    'Downtown Seattle',
    [
      824, 824, 826, 828, 829, 830, 831, 832, 833, 834, 835, 837, 839, 840, 841, 843, 846, 847, 848, 849, 851, 852, 853,
      856, 859, 864, 866, 869, 870, 871, 872, 873, 875, 878, 881,
    ],
  ],
  [
    '849270991',
    '139986',
    'Downtown Seattle',
    [
      696, 696, 698, 699, 700, 701, 702, 703, 704, 705, 706, 708, 710, 711, 712, 714, 717, 718, 719, 720, 722, 722, 723,
      726, 729, 734, 736, 739, 740, 741, 742, 743, 745, 747, 750,
    ],
  ],
  [
    '849271001',
    '139986',
    'Downtown Seattle',
    [
      574, 574, 576, 577, 578, 579, 580, 581, 582, 583, 584, 586, 588, 589, 590, 592, 595, 596, 597, 598, 600, 600, 601,
      604, 607, 612, 614, 617, 618, 619, 620, 621, 623, 625, 628,
    ],
  ],
  [
    '849271041',
    '139986',
    'Downtown Seattle',
    [
      990, 990, 993, 994, 995, 996, 998, 999, 1000, 1001, 1002, 1004, 1006, 1007, 1008, 1011, 1013, 1015, 1016, 1017,
      1019, 1020, 1021, 1024, 1027, 1033, 1036, 1039, 1040, 1042, 1042, 1044, 1046, 1049, 1052,
    ],
  ],
  [
    '849271051',
    '139986',
    'Downtown Seattle',
    [
      1275, 1275, 1277, 1278, 1279, 1280, 1281, 1282, 1283, 1284, 1284, 1286, 1288, 1289, 1290, 1292, 1294, 1295, 1296,
      1297, 1299, 1299, 1300, 1303, 1306, 1311, 1312, 1315, 1316, 1317, 1318, 1319, 1321, 1323, 1326,
    ],
  ],
  [
    '849271061',
    '139986',
    'Downtown Seattle',
    [
      752, 752, 754, 756, 757, 758, 759, 760, 761, 762, 763, 765, 767, 768, 769, 771, 774, 775, 776, 777, 779, 779, 780,
      783, 786, 791, 793, 796, 797, 798, 799, 800, 802, 804, 807,
    ],
  ],
  [
    '849271071',
    '139986',
    'Downtown Seattle',
    [
      904, 904, 906, 908, 909, 910, 911, 912, 913, 914, 915, 917, 919, 920, 921, 924, 926, 928, 929, 930, 932, 933, 934,
      937, 940, 946, 949, 952, 953, 955, 955, 957, 959, 962, 965,
    ],
  ],
  [
    '849271081',
    '139986',
    'Downtown Seattle',
    [
      628, 628, 630, 631, 632, 633, 634, 635, 636, 637, 638, 640, 642, 643, 644, 646, 649, 650, 651, 652, 654, 654, 655,
      658, 661, 666, 668, 671, 672, 673, 674, 675, 677, 679, 682,
    ],
  ],
  [
    '849271121',
    '139986',
    'Downtown Seattle',
    [
      1060, 1060, 1062, 1064, 1065, 1066, 1067, 1068, 1069, 1070, 1071, 1073, 1075, 1076, 1077, 1079, 1082, 1083, 1084,
      1085, 1087, 1088, 1089, 1092, 1095, 1100, 1102, 1105, 1106, 1107, 1108, 1109, 1111, 1114, 1117,
    ],
  ],
  [
    '849271151',
    '139986',
    'Downtown Seattle',
    [
      1236, 1236, 1238, 1239, 1240, 1241, 1242, 1243, 1244, 1245, 1245, 1247, 1249, 1250, 1251, 1253, 1255, 1256, 1257,
      1258, 1260, 1260, 1261, 1264, 1267, 1272, 1273, 1276, 1277, 1278, 1279, 1280, 1282, 1284, 1287,
    ],
  ],
  [
    '849271161',
    '139986',
    'Downtown Seattle',
    [
      652, 652, 654, 655, 656, 657, 658, 659, 660, 661, 662, 664, 666, 667, 668, 670, 673, 674, 675, 676, 678, 678, 679,
      682, 685, 690, 692, 695, 696, 697, 698, 699, 701, 703, 706,
    ],
  ],
  [
    '849271171',
    '139986',
    'Downtown Seattle',
    [
      936, 936, 938, 940, 941, 942, 943, 944, 945, 946, 947, 949, 951, 952, 953, 956, 958, 960, 961, 962, 964, 965, 966,
      969, 972, 978, 981, 984, 985, 987, 987, 989, 991, 994, 997,
    ],
  ],
  [
    '849271201',
    '139986',
    'Downtown Seattle',
    [
      784, 784, 786, 788, 789, 790, 791, 792, 793, 794, 795, 797, 799, 800, 801, 803, 806, 807, 808, 809, 811, 811, 812,
      815, 818, 823, 825, 828, 829, 830, 831, 832, 834, 837, 840,
    ],
  ],
  [
    '849271221',
    '139986',
    'Downtown Seattle',
    [
      1100, 1100, 1102, 1103, 1104, 1105, 1106, 1107, 1108, 1109, 1110, 1112, 1114, 1115, 1116, 1118, 1121, 1122, 1123,
      1124, 1126, 1127, 1128, 1131, 1134, 1139, 1141, 1144, 1145, 1146, 1147, 1148, 1150, 1153, 1156,
    ],
  ],
  [
    '849271241',
    '139986',
    'Downtown Seattle',
    [
      1365, 1365, 1367, 1368, 1369, 1369, 1370, 1371, 1372, 1373, 1373, 1375, 1376, 1377, 1378, 1380, 1382, 1383, 1384,
      1385, 1387, 1387, 1388, 1391, 1394, 1399, 1400, 1403, 1404, 1405, 1406, 1407, 1409, 1410, 1413,
    ],
  ],
  [
    '849271271',
    '139986',
    'Downtown Seattle',
    [
      1515, 1515, 1516, 1517, 1518, 1519, 1520, 1520, 1521, 1522, 1522, 1524, 1525, 1526, 1527, 1529, 1531, 1532, 1533,
      1533, 1535, 1535, 1536, 1539, 1542, 1547, 1548, 1551, 1552, 1553, 1554, 1555, 1557, 1558, 1561,
    ],
  ],
  [
    '849271301',
    '139986',
    'Downtown Seattle',
    [
      840, 840, 842, 844, 845, 846, 847, 848, 849, 850, 851, 853, 855, 856, 857, 859, 862, 863, 864, 865, 867, 868, 869,
      872, 875, 880, 882, 885, 886, 887, 888, 889, 891, 894, 897,
    ],
  ],
  [
    '849271321',
    '139986',
    'Downtown Seattle',
    [
      1150, 1150, 1152, 1153, 1154, 1155, 1156, 1157, 1158, 1159, 1160, 1162, 1164, 1165, 1166, 1168, 1170, 1171, 1172,
      1173, 1175, 1175, 1176, 1179, 1182, 1187, 1188, 1191, 1192, 1193, 1194, 1195, 1197, 1199, 1202,
    ],
  ],
  [
    '849271331',
    '139986',
    'Downtown Seattle',
    [
      1000, 1000, 1003, 1004, 1005, 1006, 1008, 1009, 1010, 1011, 1012, 1014, 1016, 1017, 1018, 1021, 1023, 1025, 1026,
      1027, 1029, 1030, 1031, 1034, 1037, 1043, 1046, 1049, 1050, 1052, 1052, 1054, 1056, 1059, 1062,
    ],
  ],
  [
    '849271341',
    '139986',
    'Downtown Seattle',
    [
      1190, 1190, 1192, 1193, 1194, 1195, 1196, 1197, 1198, 1199, 1199, 1201, 1203, 1204, 1205, 1207, 1209, 1210, 1211,
      1212, 1214, 1214, 1215, 1218, 1221, 1226, 1227, 1230, 1231, 1232, 1233, 1234, 1236, 1238, 1241,
    ],
  ],
  [
    '849271351',
    '139986',
    'Downtown Seattle',
    [
      1320, 1320, 1322, 1323, 1324, 1324, 1325, 1326, 1327, 1328, 1328, 1330, 1331, 1332, 1333, 1335, 1337, 1338, 1339,
      1340, 1342, 1342, 1343, 1346, 1349, 1354, 1355, 1358, 1359, 1360, 1361, 1362, 1364, 1365, 1368,
    ],
  ],
  [
    '849271371',
    '139986',
    'Downtown Seattle',
    [
      1455, 1455, 1457, 1458, 1459, 1459, 1460, 1461, 1462, 1463, 1463, 1465, 1466, 1467, 1468, 1470, 1472, 1473, 1474,
      1474, 1476, 1476, 1477, 1480, 1483, 1488, 1489, 1492, 1493, 1494, 1495, 1496, 1498, 1499, 1502,
    ],
  ],
  [
    '849271401',
    '139986',
    'Downtown Seattle',
    [
      1040, 1040, 1042, 1044, 1045, 1046, 1047, 1048, 1049, 1050, 1051, 1053, 1055, 1056, 1057, 1059, 1062, 1063, 1064,
      1065, 1067, 1068, 1069, 1072, 1075, 1081, 1084, 1087, 1088, 1090, 1090, 1092, 1094, 1097, 1100,
    ],
  ],
  [
    '849271421',
    '139986',
    'Downtown Seattle',
    [
      616, 616, 618, 619, 620, 621, 622, 623, 624, 625, 626, 628, 630, 631, 632, 634, 637, 638, 639, 640, 642, 642, 643,
      646, 649, 654, 656, 659, 660, 661, 662, 663, 665, 667, 670,
    ],
  ],
  [
    '849271451',
    '139986',
    'Downtown Seattle',
    [
      970, 970, 973, 974, 975, 976, 978, 979, 980, 981, 982, 984, 986, 987, 988, 991, 993, 995, 996, 997, 999, 1000,
      1001, 1004, 1007, 1013, 1016, 1019, 1020, 1022, 1022, 1024, 1026, 1029, 1032,
    ],
  ],
  [
    '854202771',
    '139986',
    'Downtown Seattle',
    [
      378, 378, 380, 381, 382, 382, 383, 384, 385, 386, 386, 388, 389, 390, 391, 393, 395, 396, 397, 398, 400, 400, 401,
      404, 407, 412, 414, 417, 418, 419, 420, 421, 423, 425, 428,
    ],
  ],
  [
    '854202821',
    '139986',
    'Downtown Seattle',
    [
      386, 386, 388, 389, 390, 390, 391, 392, 393, 394, 394, 396, 397, 398, 399, 401, 403, 404, 405, 406, 408, 408, 409,
      412, 415, 420, 422, 425, 426, 427, 428, 429, 431, 433, 436,
    ],
  ],
  [
    '854203021',
    '139986',
    'Downtown Seattle',
    [
      430, 430, 432, 433, 434, 434, 435, 436, 437, 438, 438, 440, 441, 442, 443, 445, 447, 448, 449, 450, 452, 452, 453,
      456, 459, 465, 467, 470, 471, 473, 474, 475, 477, 479, 482,
    ],
  ],
  [
    '854203081',
    '139986',
    'Downtown Seattle',
    [
      442, 442, 444, 445, 446, 446, 447, 448, 449, 450, 450, 452, 454, 455, 456, 458, 461, 462, 463, 464, 466, 466, 467,
      470, 473, 479, 481, 484, 485, 487, 488, 489, 491, 493, 496,
    ],
  ],
  [
    '854203451',
    '139986',
    'Downtown Seattle',
    [
      592, 592, 594, 595, 596, 597, 598, 599, 600, 601, 602, 604, 606, 607, 608, 610, 613, 614, 615, 616, 618, 618, 619,
      622, 625, 630, 632, 635, 636, 637, 638, 639, 641, 643, 646,
    ],
  ],
  [
    '845636081',
    '27238',
    'Downtown Seattle',
    [
      295, 295, 296, 297, 298, 299, 300, 300, 301, 302, 302, 304, 305, 306, 307, 309, 311, 312, 313, 313, 315, 315, 316,
      318, 320, 325, 327, 330, 331, 332, 333, 334, 336, 337, 340,
    ],
  ],
  [
    '845636151',
    '27238',
    'Downtown Seattle',
    [
      423, 423, 425, 426, 427, 427, 428, 429, 430, 431, 431, 433, 434, 435, 436, 438, 440, 441, 442, 442, 444, 444, 445,
      447, 449, 454, 456, 459, 460, 461, 462, 463, 465, 466, 469,
    ],
  ],
  [
    '845636251',
    '27238',
    'Downtown Seattle',
    [
      560, 560, 562, 563, 564, 565, 566, 567, 568, 569, 570, 572, 574, 575, 576, 578, 580, 581, 582, 583, 585, 585, 586,
      589, 591, 596, 598, 601, 602, 603, 604, 605, 607, 609, 612,
    ],
  ],
  [
    '845636401',
    '27238',
    'Downtown Seattle',
    [
      700, 700, 702, 704, 705, 706, 707, 708, 709, 710, 711, 713, 715, 716, 717, 719, 721, 722, 723, 724, 726, 726, 727,
      730, 733, 739, 741, 744, 745, 746, 747, 748, 750, 753, 756,
    ],
  ],
  [
    '845636511',
    '27238',
    'Downtown Seattle',
    [
      800, 800, 802, 804, 805, 806, 807, 808, 809, 810, 811, 813, 815, 816, 817, 819, 821, 822, 823, 824, 826, 826, 827,
      830, 833, 839, 841, 844, 845, 847, 848, 849, 851, 854, 857,
    ],
  ],
  [
    '845636521',
    '27238',
    'Downtown Seattle',
    [
      820, 820, 822, 824, 825, 826, 827, 828, 829, 830, 831, 833, 835, 836, 837, 839, 841, 842, 843, 844, 846, 846, 847,
      850, 853, 859, 861, 864, 865, 867, 868, 869, 871, 874, 877,
    ],
  ],
  [
    '845636541',
    '27238',
    'Downtown Seattle',
    [
      850, 850, 852, 854, 855, 856, 857, 858, 859, 860, 861, 863, 865, 866, 867, 869, 871, 872, 873, 874, 876, 876, 877,
      880, 883, 889, 891, 894, 895, 897, 898, 899, 901, 904, 907,
    ],
  ],
  [
    '845636701',
    '27238',
    'Downtown Seattle',
    [
      337, 337, 338, 339, 340, 341, 342, 342, 343, 344, 344, 346, 347, 348, 349, 351, 353, 354, 355, 355, 357, 357, 358,
      360, 362, 367, 369, 372, 373, 374, 375, 376, 378, 379, 382,
    ],
  ],
  [
    '845636721',
    '27238',
    'Downtown Seattle',
    [
      620, 620, 622, 624, 625, 626, 627, 628, 629, 630, 631, 633, 635, 636, 637, 639, 641, 642, 643, 644, 646, 646, 647,
      650, 653, 658, 660, 663, 664, 665, 666, 667, 669, 672, 675,
    ],
  ],
  [
    '845636741',
    '27238',
    'Downtown Seattle',
    [
      480, 480, 482, 483, 484, 485, 486, 487, 488, 489, 489, 491, 492, 493, 494, 496, 498, 499, 500, 501, 503, 503, 504,
      506, 508, 513, 515, 518, 519, 520, 521, 522, 524, 526, 529,
    ],
  ],
  [
    '845636761',
    '27238',
    'Downtown Seattle',
    [
      970, 970, 972, 974, 975, 976, 977, 978, 979, 980, 981, 983, 985, 986, 987, 989, 991, 992, 993, 994, 996, 996, 997,
      1000, 1003, 1009, 1011, 1014, 1015, 1017, 1018, 1019, 1021, 1024, 1027,
    ],
  ],
  [
    '845636771',
    '27238',
    'Downtown Seattle',
    [
      950, 950, 952, 954, 955, 956, 957, 958, 959, 960, 961, 963, 965, 966, 967, 969, 971, 972, 973, 974, 976, 976, 977,
      980, 983, 989, 991, 994, 995, 997, 998, 999, 1001, 1004, 1007,
    ],
  ],
  [
    '845636791',
    '27238',
    'Downtown Seattle',
    [
      1020, 1020, 1022, 1024, 1025, 1026, 1027, 1028, 1029, 1030, 1031, 1033, 1035, 1036, 1037, 1039, 1041, 1042, 1043,
      1044, 1046, 1046, 1047, 1050, 1053, 1059, 1061, 1064, 1065, 1067, 1068, 1069, 1071, 1074, 1077,
    ],
  ],
  [
    '845636821',
    '27238',
    'Downtown Seattle',
    [
      1000, 1000, 1002, 1004, 1005, 1006, 1007, 1008, 1009, 1010, 1011, 1013, 1015, 1016, 1017, 1019, 1021, 1022, 1023,
      1024, 1026, 1026, 1027, 1030, 1033, 1039, 1041, 1044, 1045, 1047, 1048, 1049, 1051, 1054, 1057,
    ],
  ],
  [
    '845636851',
    '27238',
    'Downtown Seattle',
    [
      930, 930, 932, 934, 935, 936, 937, 938, 939, 940, 941, 943, 945, 946, 947, 949, 951, 952, 953, 954, 956, 956, 957,
      960, 963, 969, 971, 974, 975, 977, 978, 979, 981, 984, 987,
    ],
  ],
  [
    '845636901',
    '27238',
    'Downtown Seattle',
    [
      500, 500, 502, 503, 504, 505, 506, 507, 508, 509, 509, 511, 512, 513, 514, 516, 518, 519, 520, 521, 523, 523, 524,
      526, 528, 533, 535, 538, 539, 540, 541, 542, 544, 546, 549,
    ],
  ],
  [
    '845636921',
    '27238',
    'Downtown Seattle',
    [
      780, 780, 782, 784, 785, 786, 787, 788, 789, 790, 791, 793, 795, 796, 797, 799, 801, 802, 803, 804, 806, 806, 807,
      810, 813, 819, 821, 824, 825, 827, 828, 829, 831, 834, 837,
    ],
  ],
  [
    '845636931',
    '27238',
    'Downtown Seattle',
    [
      640, 640, 642, 644, 645, 646, 647, 648, 649, 650, 651, 653, 655, 656, 657, 659, 661, 662, 663, 664, 666, 666, 667,
      670, 673, 678, 680, 683, 684, 685, 686, 687, 689, 692, 695,
    ],
  ],
  [
    '845636941',
    '27238',
    'Downtown Seattle',
    [
      357, 357, 358, 359, 360, 361, 362, 362, 363, 364, 364, 366, 367, 368, 369, 371, 373, 374, 375, 375, 377, 377, 378,
      380, 382, 387, 389, 392, 393, 394, 395, 396, 398, 399, 402,
    ],
  ],
  [
    '845637031',
    '27238',
    'Downtown Seattle',
    [
      990, 990, 992, 994, 995, 996, 997, 998, 999, 1000, 1001, 1003, 1005, 1006, 1007, 1009, 1011, 1012, 1013, 1014,
      1016, 1016, 1017, 1020, 1023, 1029, 1031, 1034, 1035, 1037, 1038, 1039, 1041, 1044, 1047,
    ],
  ],
  [
    '845637061',
    '27238',
    'Downtown Seattle',
    [
      840, 840, 842, 844, 845, 846, 847, 848, 849, 850, 851, 853, 855, 856, 857, 859, 861, 862, 863, 864, 866, 866, 867,
      870, 873, 879, 881, 884, 885, 887, 888, 889, 891, 894, 897,
    ],
  ],
  [
    '845637071',
    '27238',
    'Downtown Seattle',
    [
      550, 550, 552, 553, 554, 555, 556, 557, 558, 559, 560, 562, 563, 564, 565, 567, 569, 570, 571, 572, 574, 574, 575,
      578, 580, 585, 587, 590, 591, 592, 593, 594, 596, 598, 601,
    ],
  ],
  [
    '845637091',
    '27238',
    'Downtown Seattle',
    [
      1070, 1070, 1072, 1074, 1075, 1076, 1077, 1078, 1079, 1080, 1081, 1083, 1085, 1086, 1087, 1089, 1091, 1092, 1093,
      1094, 1096, 1096, 1097, 1100, 1103, 1109, 1111, 1114, 1115, 1117, 1118, 1119, 1121, 1124, 1127,
    ],
  ],
  [
    '845637111',
    '27238',
    'Downtown Seattle',
    [
      408, 408, 410, 411, 412, 412, 413, 414, 415, 416, 416, 418, 419, 420, 421, 423, 425, 426, 427, 427, 429, 429, 430,
      432, 434, 439, 441, 444, 445, 446, 447, 448, 450, 451, 454,
    ],
  ],
  [
    '845637121',
    '27238',
    'Downtown Seattle',
    [
      690, 690, 692, 694, 695, 696, 697, 698, 699, 700, 701, 703, 705, 706, 707, 709, 711, 712, 713, 714, 716, 716, 717,
      720, 723, 729, 731, 734, 735, 736, 737, 738, 740, 743, 746,
    ],
  ],
  [
    '845637141',
    '27238',
    'Downtown Seattle',
    [
      1080, 1080, 1082, 1083, 1084, 1085, 1086, 1087, 1088, 1089, 1090, 1092, 1094, 1095, 1096, 1098, 1100, 1101, 1102,
      1103, 1105, 1105, 1106, 1109, 1112, 1118, 1120, 1123, 1124, 1126, 1127, 1128, 1130, 1132, 1135,
    ],
  ],
  [
    '845637151',
    '27238',
    'Downtown Seattle',
    [
      490, 490, 492, 493, 494, 495, 496, 497, 498, 499, 499, 501, 502, 503, 504, 506, 508, 509, 510, 511, 513, 513, 514,
      516, 518, 523, 525, 528, 529, 530, 531, 532, 534, 536, 539,
    ],
  ],
  [
    '845637171',
    '27238',
    'Downtown Seattle',
    [
      919, 919, 921, 923, 924, 925, 926, 927, 928, 929, 930, 932, 934, 935, 936, 938, 940, 941, 942, 943, 945, 945, 946,
      949, 952, 958, 960, 963, 964, 966, 967, 968, 970, 973, 976,
    ],
  ],
  [
    '845637201',
    '27238',
    'Downtown Seattle',
    [
      770, 770, 772, 774, 775, 776, 777, 778, 779, 780, 781, 783, 785, 786, 787, 789, 791, 792, 793, 794, 796, 796, 797,
      800, 803, 809, 811, 814, 815, 817, 818, 819, 821, 824, 827,
    ],
  ],
  [
    '845637241',
    '27238',
    'Downtown Seattle',
    [
      630, 630, 632, 634, 635, 636, 637, 638, 639, 640, 641, 643, 645, 646, 647, 649, 651, 652, 653, 654, 656, 656, 657,
      660, 663, 668, 670, 673, 674, 675, 676, 677, 679, 682, 685,
    ],
  ],
  [
    '845637251',
    '27238',
    'Downtown Seattle',
    [
      1120, 1120, 1122, 1123, 1124, 1125, 1126, 1127, 1128, 1129, 1130, 1132, 1133, 1134, 1135, 1137, 1139, 1140, 1141,
      1142, 1144, 1144, 1145, 1148, 1151, 1157, 1159, 1162, 1163, 1164, 1165, 1166, 1168, 1170, 1173,
    ],
  ],
  [
    '845637271',
    '27238',
    'Downtown Seattle',
    [
      1100, 1100, 1102, 1103, 1104, 1105, 1106, 1107, 1108, 1109, 1110, 1112, 1113, 1114, 1115, 1117, 1119, 1120, 1121,
      1122, 1124, 1124, 1125, 1128, 1131, 1137, 1139, 1142, 1143, 1144, 1145, 1146, 1148, 1150, 1153,
    ],
  ],
  [
    '845637291',
    '27238',
    'Downtown Seattle',
    [
      1170, 1170, 1172, 1173, 1174, 1175, 1176, 1177, 1178, 1179, 1180, 1182, 1183, 1184, 1185, 1187, 1189, 1190, 1191,
      1192, 1194, 1194, 1195, 1198, 1201, 1206, 1208, 1211, 1212, 1213, 1214, 1215, 1217, 1218, 1221,
    ],
  ],
  [
    '845637311',
    '27238',
    'Downtown Seattle',
    [
      1150, 1150, 1152, 1153, 1154, 1155, 1156, 1157, 1158, 1159, 1160, 1162, 1163, 1164, 1165, 1167, 1169, 1170, 1171,
      1172, 1174, 1174, 1175, 1178, 1181, 1186, 1188, 1191, 1192, 1193, 1194, 1195, 1197, 1199, 1202,
    ],
  ],
  [
    '845637381',
    '27238',
    'Downtown Seattle',
    [
      1140, 1140, 1142, 1143, 1144, 1145, 1146, 1147, 1148, 1149, 1150, 1152, 1153, 1154, 1155, 1157, 1159, 1160, 1161,
      1162, 1164, 1164, 1165, 1168, 1171, 1176, 1178, 1181, 1182, 1183, 1184, 1185, 1187, 1189, 1192,
    ],
  ],
  [
    '845637421',
    '27238',
    'Downtown Seattle',
    [
      438, 438, 440, 441, 442, 442, 443, 444, 445, 446, 446, 448, 449, 450, 451, 453, 455, 456, 457, 457, 459, 459, 460,
      462, 464, 469, 471, 474, 475, 476, 477, 478, 480, 482, 485,
    ],
  ],
  [
    '845637451',
    '27238',
    'Downtown Seattle',
    [
      869, 869, 871, 873, 874, 875, 876, 877, 878, 879, 880, 882, 884, 885, 886, 888, 890, 891, 892, 893, 895, 895, 896,
      899, 902, 908, 910, 913, 914, 916, 917, 918, 920, 923, 926,
    ],
  ],
  [
    '845637471',
    '27238',
    'Downtown Seattle',
    [
      720, 720, 722, 724, 725, 726, 727, 728, 729, 730, 731, 733, 735, 736, 737, 739, 741, 742, 743, 744, 746, 746, 747,
      750, 753, 759, 761, 764, 765, 767, 768, 769, 771, 774, 777,
    ],
  ],
  [
    '845637501',
    '27238',
    'Downtown Seattle',
    [
      580, 580, 582, 584, 585, 586, 587, 588, 589, 590, 591, 593, 595, 596, 597, 599, 601, 602, 603, 604, 606, 606, 607,
      610, 612, 617, 619, 622, 623, 624, 625, 626, 628, 630, 633,
    ],
  ],
  [
    '845637511',
    '27238',
    'Downtown Seattle',
    [
      650, 650, 652, 654, 655, 656, 657, 658, 659, 660, 661, 663, 665, 666, 667, 669, 671, 672, 673, 674, 676, 676, 677,
      680, 683, 688, 690, 693, 694, 695, 696, 697, 699, 702, 705,
    ],
  ],
  [
    '845637521',
    '27238',
    'Downtown Seattle',
    [
      510, 510, 512, 513, 514, 515, 516, 517, 518, 519, 519, 521, 522, 523, 524, 526, 528, 529, 530, 531, 533, 533, 534,
      536, 538, 543, 545, 548, 549, 550, 551, 552, 554, 556, 559,
    ],
  ],
  [
    '845637531',
    '27238',
    'Downtown Seattle',
    [
      940, 940, 942, 944, 945, 946, 947, 948, 949, 950, 951, 953, 955, 956, 957, 959, 961, 962, 963, 964, 966, 966, 967,
      970, 973, 979, 981, 984, 985, 987, 988, 989, 991, 994, 997,
    ],
  ],
  [
    '845637571',
    '27238',
    'Downtown Seattle',
    [
      1230, 1230, 1232, 1233, 1234, 1235, 1236, 1237, 1238, 1239, 1239, 1241, 1242, 1243, 1244, 1246, 1248, 1249, 1250,
      1251, 1253, 1253, 1254, 1257, 1260, 1265, 1267, 1270, 1271, 1272, 1273, 1274, 1276, 1277, 1280,
    ],
  ],
  [
    '845637591',
    '27238',
    'Downtown Seattle',
    [
      790, 790, 792, 794, 795, 796, 797, 798, 799, 800, 801, 803, 805, 806, 807, 809, 811, 812, 813, 814, 816, 816, 817,
      820, 823, 829, 831, 834, 835, 837, 838, 839, 841, 844, 847,
    ],
  ],
  [
    '845637601',
    '27238',
    'Downtown Seattle',
    [
      1090, 1090, 1092, 1093, 1094, 1095, 1096, 1097, 1098, 1099, 1100, 1102, 1104, 1105, 1106, 1108, 1110, 1111, 1112,
      1113, 1115, 1115, 1116, 1119, 1122, 1128, 1130, 1133, 1134, 1136, 1137, 1138, 1140, 1142, 1145,
    ],
  ],
  [
    '845637641',
    '27238',
    'Downtown Seattle',
    [
      1260, 1260, 1262, 1263, 1264, 1265, 1266, 1267, 1268, 1269, 1269, 1271, 1272, 1273, 1274, 1276, 1278, 1279, 1280,
      1281, 1283, 1283, 1284, 1287, 1290, 1295, 1297, 1300, 1301, 1302, 1303, 1304, 1306, 1307, 1310,
    ],
  ],
  [
    '845637781',
    '27238',
    'Downtown Seattle',
    [
      1320, 1320, 1322, 1323, 1324, 1325, 1326, 1327, 1328, 1329, 1329, 1331, 1332, 1333, 1334, 1336, 1338, 1339, 1340,
      1341, 1343, 1343, 1344, 1347, 1349, 1354, 1356, 1359, 1360, 1361, 1362, 1363, 1365, 1366, 1369,
    ],
  ],
  [
    '845637811',
    '27238',
    'Downtown Seattle',
    [
      1290, 1290, 1292, 1293, 1294, 1295, 1296, 1297, 1298, 1299, 1299, 1301, 1302, 1303, 1304, 1306, 1308, 1309, 1310,
      1311, 1313, 1313, 1314, 1317, 1319, 1324, 1326, 1329, 1330, 1331, 1332, 1333, 1335, 1336, 1339,
    ],
  ],
  [
    '845637871',
    '27238',
    'Downtown Seattle',
    [
      1455, 1455, 1456, 1457, 1458, 1459, 1460, 1460, 1461, 1462, 1462, 1464, 1465, 1466, 1467, 1469, 1471, 1472, 1473,
      1474, 1476, 1476, 1477, 1479, 1481, 1486, 1488, 1491, 1492, 1493, 1494, 1495, 1497, 1498, 1501,
    ],
  ],
  [
    '845637881',
    '27238',
    'Downtown Seattle',
    [
      1485, 1485, 1486, 1487, 1488, 1489, 1490, 1490, 1491, 1492, 1492, 1494, 1495, 1496, 1497, 1499, 1501, 1502, 1503,
      1504, 1506, 1506, 1507, 1509, 1511, 1516, 1517, 1520, 1521, 1522, 1523, 1524, 1526, 1527, 1530,
    ],
  ],
  [
    '845637941',
    '27238',
    'Downtown Seattle',
    [
      1611, 1611, 1612, 1613, 1614, 1615, 1616, 1616, 1617, 1618, 1618, 1620, 1621, 1622, 1623, 1625, 1627, 1628, 1629,
      1629, 1631, 1631, 1632, 1634, 1636, 1641, 1642, 1645, 1646, 1647, 1648, 1649, 1651, 1652, 1655,
    ],
  ],
  [
    '845637991',
    '27238',
    'Downtown Seattle',
    [
      530, 530, 532, 533, 534, 535, 536, 537, 538, 539, 539, 541, 542, 543, 544, 546, 548, 549, 550, 551, 553, 553, 554,
      557, 559, 564, 566, 569, 570, 571, 572, 573, 575, 577, 580,
    ],
  ],
  [
    '845638031',
    '27238',
    'Downtown Seattle',
    [
      670, 670, 672, 674, 675, 676, 677, 678, 679, 680, 681, 683, 685, 686, 687, 689, 691, 692, 693, 694, 696, 696, 697,
      700, 703, 709, 711, 714, 715, 716, 717, 718, 720, 723, 726,
    ],
  ],
  [
    '845638061',
    '27238',
    'Downtown Seattle',
    [
      1245, 1245, 1247, 1248, 1249, 1250, 1251, 1252, 1253, 1254, 1254, 1256, 1257, 1258, 1259, 1261, 1263, 1264, 1265,
      1266, 1268, 1268, 1269, 1272, 1275, 1280, 1282, 1285, 1286, 1287, 1288, 1289, 1291, 1292, 1295,
    ],
  ],
  [
    '845638071',
    '27238',
    'Downtown Seattle',
    [
      1395, 1395, 1397, 1398, 1399, 1400, 1401, 1402, 1403, 1404, 1404, 1406, 1407, 1408, 1409, 1411, 1413, 1414, 1415,
      1416, 1418, 1418, 1419, 1422, 1424, 1429, 1431, 1434, 1435, 1436, 1437, 1438, 1440, 1441, 1444,
    ],
  ],
  [
    '855239831',
    '27238',
    'Downtown Seattle',
    [
      1673, 1673, 1674, 1675, 1676, 1677, 1678, 1678, 1679, 1680, 1680, 1682, 1683, 1684, 1685, 1687, 1689, 1690, 1691,
      1691, 1693, 1693, 1694, 1696, 1698, 1703, 1704, 1707, 1708, 1709, 1710, 1711, 1713, 1714, 1717,
    ],
  ],
  [
    '855239841',
    '27238',
    'Downtown Seattle',
    [
      1547, 1547, 1548, 1549, 1550, 1551, 1552, 1552, 1553, 1554, 1554, 1556, 1557, 1558, 1559, 1561, 1563, 1564, 1565,
      1566, 1568, 1568, 1569, 1571, 1573, 1578, 1579, 1582, 1583, 1584, 1585, 1586, 1588, 1589, 1592,
    ],
  ],
  [
    '855239871',
    '27238',
    'Downtown Seattle',
    [
      1515, 1515, 1516, 1517, 1518, 1519, 1520, 1520, 1521, 1522, 1522, 1524, 1525, 1526, 1527, 1529, 1531, 1532, 1533,
      1534, 1536, 1536, 1537, 1539, 1541, 1546, 1547, 1550, 1551, 1552, 1553, 1554, 1556, 1557, 1560,
    ],
  ],
  [
    '855239891',
    '27238',
    'Downtown Seattle',
    [
      1365, 1365, 1367, 1368, 1369, 1370, 1371, 1372, 1373, 1374, 1374, 1376, 1377, 1378, 1379, 1381, 1383, 1384, 1385,
      1386, 1388, 1388, 1389, 1392, 1394, 1399, 1401, 1404, 1405, 1406, 1407, 1408, 1410, 1411, 1414,
    ],
  ],
  [
    '855239901',
    '27238',
    'Downtown Seattle',
    [
      1350, 1350, 1352, 1353, 1354, 1355, 1356, 1357, 1358, 1359, 1359, 1361, 1362, 1363, 1364, 1366, 1368, 1369, 1370,
      1371, 1373, 1373, 1374, 1377, 1379, 1384, 1386, 1389, 1390, 1391, 1392, 1393, 1395, 1396, 1399,
    ],
  ],
  [
    '855239911',
    '27238',
    'Downtown Seattle',
    [
      1335, 1335, 1337, 1338, 1339, 1340, 1341, 1342, 1343, 1344, 1344, 1346, 1347, 1348, 1349, 1351, 1353, 1354, 1355,
      1356, 1358, 1358, 1359, 1362, 1364, 1369, 1371, 1374, 1375, 1376, 1377, 1378, 1380, 1381, 1384,
    ],
  ],
  [
    '855239951',
    '27238',
    'Downtown Seattle',
    [
      1305, 1305, 1307, 1308, 1309, 1310, 1311, 1312, 1313, 1314, 1314, 1316, 1317, 1318, 1319, 1321, 1323, 1324, 1325,
      1326, 1328, 1328, 1329, 1332, 1334, 1339, 1341, 1344, 1345, 1346, 1347, 1348, 1350, 1351, 1354,
    ],
  ],
  [
    '855239971',
    '27238',
    'Downtown Seattle',
    [
      1215, 1215, 1217, 1218, 1219, 1220, 1221, 1222, 1223, 1224, 1224, 1226, 1227, 1228, 1229, 1231, 1233, 1234, 1235,
      1236, 1238, 1238, 1239, 1242, 1245, 1250, 1252, 1255, 1256, 1257, 1258, 1259, 1261, 1262, 1265,
    ],
  ],
  [
    '855239981',
    '27238',
    'Downtown Seattle',
    [
      1190, 1190, 1192, 1193, 1194, 1195, 1196, 1197, 1198, 1199, 1200, 1202, 1203, 1204, 1205, 1207, 1209, 1210, 1211,
      1212, 1214, 1214, 1215, 1218, 1221, 1226, 1228, 1231, 1232, 1233, 1234, 1235, 1237, 1238, 1241,
    ],
  ],
  [
    '855239991',
    '27238',
    'Downtown Seattle',
    [
      1200, 1200, 1202, 1203, 1204, 1205, 1206, 1207, 1208, 1209, 1209, 1211, 1212, 1213, 1214, 1216, 1218, 1219, 1220,
      1221, 1223, 1223, 1224, 1227, 1230, 1235, 1237, 1240, 1241, 1242, 1243, 1244, 1246, 1247, 1250,
    ],
  ],
  [
    '855240001',
    '27238',
    'Downtown Seattle',
    [
      1160, 1160, 1162, 1163, 1164, 1165, 1166, 1167, 1168, 1169, 1170, 1172, 1173, 1174, 1175, 1177, 1179, 1180, 1181,
      1182, 1184, 1184, 1185, 1188, 1191, 1196, 1198, 1201, 1202, 1203, 1204, 1205, 1207, 1208, 1211,
    ],
  ],
  [
    '855240051',
    '27238',
    'Downtown Seattle',
    [
      1030, 1030, 1032, 1034, 1035, 1036, 1037, 1038, 1039, 1040, 1041, 1043, 1045, 1046, 1047, 1049, 1051, 1052, 1053,
      1054, 1056, 1056, 1057, 1060, 1063, 1069, 1071, 1074, 1075, 1077, 1078, 1079, 1081, 1084, 1087,
    ],
  ],
  [
    '855240061',
    '27238',
    'Downtown Seattle',
    [
      1050, 1050, 1052, 1054, 1055, 1056, 1057, 1058, 1059, 1060, 1061, 1063, 1065, 1066, 1067, 1069, 1071, 1072, 1073,
      1074, 1076, 1076, 1077, 1080, 1083, 1089, 1091, 1094, 1095, 1097, 1098, 1099, 1101, 1104, 1107,
    ],
  ],
  [
    '855240071',
    '27238',
    'Downtown Seattle',
    [
      1040, 1040, 1042, 1044, 1045, 1046, 1047, 1048, 1049, 1050, 1051, 1053, 1055, 1056, 1057, 1059, 1061, 1062, 1063,
      1064, 1066, 1066, 1067, 1070, 1073, 1079, 1081, 1084, 1085, 1087, 1088, 1089, 1091, 1094, 1097,
    ],
  ],
  [
    '855240091',
    '27238',
    'Downtown Seattle',
    [
      1180, 1180, 1182, 1183, 1184, 1185, 1186, 1187, 1188, 1189, 1190, 1192, 1193, 1194, 1195, 1197, 1199, 1200, 1201,
      1202, 1204, 1204, 1205, 1208, 1211, 1216, 1218, 1221, 1222, 1223, 1224, 1225, 1227, 1228, 1231,
    ],
  ],
  [
    '855240101',
    '27238',
    'Downtown Seattle',
    [
      1060, 1060, 1062, 1064, 1065, 1066, 1067, 1068, 1069, 1070, 1071, 1073, 1075, 1076, 1077, 1079, 1081, 1082, 1083,
      1084, 1086, 1086, 1087, 1090, 1093, 1099, 1101, 1104, 1105, 1107, 1108, 1109, 1111, 1114, 1117,
    ],
  ],
  [
    '855240111',
    '27238',
    'Downtown Seattle',
    [
      1010, 1010, 1012, 1014, 1015, 1016, 1017, 1018, 1019, 1020, 1021, 1023, 1025, 1026, 1027, 1029, 1031, 1032, 1033,
      1034, 1036, 1036, 1037, 1040, 1043, 1049, 1051, 1054, 1055, 1057, 1058, 1059, 1061, 1064, 1067,
    ],
  ],
  [
    '855240161',
    '27238',
    'Downtown Seattle',
    [
      910, 910, 912, 914, 915, 916, 917, 918, 919, 920, 921, 923, 925, 926, 927, 929, 931, 932, 933, 934, 936, 936, 937,
      940, 943, 949, 951, 954, 955, 957, 958, 959, 961, 964, 967,
    ],
  ],
  [
    '855240171',
    '27238',
    'Downtown Seattle',
    [
      900, 900, 902, 904, 905, 906, 907, 908, 909, 910, 911, 913, 915, 916, 917, 919, 921, 922, 923, 924, 926, 926, 927,
      930, 933, 939, 941, 944, 945, 947, 948, 949, 951, 954, 957,
    ],
  ],
  [
    '855240201',
    '27238',
    'Downtown Seattle',
    [
      980, 980, 982, 984, 985, 986, 987, 988, 989, 990, 991, 993, 995, 996, 997, 999, 1001, 1002, 1003, 1004, 1006,
      1006, 1007, 1010, 1013, 1019, 1021, 1024, 1025, 1027, 1028, 1029, 1031, 1034, 1037,
    ],
  ],
  [
    '855240211',
    '27238',
    'Downtown Seattle',
    [
      1130, 1130, 1132, 1133, 1134, 1135, 1136, 1137, 1138, 1139, 1140, 1142, 1143, 1144, 1145, 1147, 1149, 1150, 1151,
      1152, 1154, 1154, 1155, 1158, 1161, 1167, 1169, 1172, 1173, 1174, 1175, 1176, 1178, 1180, 1183,
    ],
  ],
  [
    '855240241',
    '27238',
    'Downtown Seattle',
    [
      890, 890, 892, 894, 895, 896, 897, 898, 899, 900, 901, 903, 905, 906, 907, 909, 911, 912, 913, 914, 916, 916, 917,
      920, 923, 929, 931, 934, 935, 937, 938, 939, 941, 944, 947,
    ],
  ],
  [
    '855240251',
    '27238',
    'Downtown Seattle',
    [
      880, 880, 882, 884, 885, 886, 887, 888, 889, 890, 891, 893, 895, 896, 897, 899, 901, 902, 903, 904, 906, 906, 907,
      910, 913, 919, 921, 924, 925, 927, 928, 929, 931, 934, 937,
    ],
  ],
  [
    '855240261',
    '27238',
    'Downtown Seattle',
    [
      860, 860, 862, 864, 865, 866, 867, 868, 869, 870, 871, 873, 875, 876, 877, 879, 881, 882, 883, 884, 886, 886, 887,
      890, 893, 899, 901, 904, 905, 907, 908, 909, 911, 914, 917,
    ],
  ],
  [
    '855240281',
    '27238',
    'Downtown Seattle',
    [
      830, 830, 832, 834, 835, 836, 837, 838, 839, 840, 841, 843, 845, 846, 847, 849, 851, 852, 853, 854, 856, 856, 857,
      860, 863, 869, 871, 874, 875, 877, 878, 879, 881, 884, 887,
    ],
  ],
  [
    '855240341',
    '27238',
    'Downtown Seattle',
    [
      1275, 1275, 1277, 1278, 1279, 1280, 1281, 1282, 1283, 1284, 1284, 1286, 1287, 1288, 1289, 1291, 1293, 1294, 1295,
      1296, 1298, 1298, 1299, 1302, 1304, 1309, 1311, 1314, 1315, 1316, 1317, 1318, 1320, 1321, 1324,
    ],
  ],
  [
    '855240351',
    '27238',
    'Downtown Seattle',
    [
      810, 810, 812, 814, 815, 816, 817, 818, 819, 820, 821, 823, 825, 826, 827, 829, 831, 832, 833, 834, 836, 836, 837,
      840, 843, 849, 851, 854, 855, 857, 858, 859, 861, 864, 867,
    ],
  ],
  [
    '855240371',
    '27238',
    'Downtown Seattle',
    [
      1425, 1425, 1427, 1428, 1429, 1430, 1431, 1432, 1433, 1434, 1434, 1436, 1437, 1438, 1439, 1441, 1443, 1444, 1445,
      1446, 1448, 1448, 1449, 1452, 1454, 1459, 1461, 1464, 1465, 1466, 1467, 1468, 1470, 1471, 1474,
    ],
  ],
  [
    '855240401',
    '27238',
    'Downtown Seattle',
    [
      1110, 1110, 1112, 1113, 1114, 1115, 1116, 1117, 1118, 1119, 1120, 1122, 1123, 1124, 1125, 1127, 1129, 1130, 1131,
      1132, 1134, 1134, 1135, 1138, 1141, 1147, 1149, 1152, 1153, 1154, 1155, 1156, 1158, 1160, 1163,
    ],
  ],
  [
    '855240411',
    '27238',
    'Downtown Seattle',
    [
      960, 960, 962, 964, 965, 966, 967, 968, 969, 970, 971, 973, 975, 976, 977, 979, 981, 982, 983, 984, 986, 986, 987,
      990, 993, 999, 1001, 1004, 1005, 1007, 1008, 1009, 1011, 1014, 1017,
    ],
  ],
  [
    '855240421',
    '27238',
    'Downtown Seattle',
    [
      760, 760, 762, 764, 765, 766, 767, 768, 769, 770, 771, 773, 775, 776, 777, 779, 781, 782, 783, 784, 786, 786, 787,
      790, 793, 799, 801, 804, 805, 807, 808, 809, 811, 814, 817,
    ],
  ],
  [
    '855240431',
    '27238',
    'Downtown Seattle',
    [
      740, 740, 742, 744, 745, 746, 747, 748, 749, 750, 751, 753, 755, 756, 757, 759, 761, 762, 763, 764, 766, 766, 767,
      770, 773, 779, 781, 784, 785, 787, 788, 789, 791, 794, 797,
    ],
  ],
  [
    '855240451',
    '27238',
    'Downtown Seattle',
    [
      750, 750, 752, 754, 755, 756, 757, 758, 759, 760, 761, 763, 765, 766, 767, 769, 771, 772, 773, 774, 776, 776, 777,
      780, 783, 789, 791, 794, 795, 797, 798, 799, 801, 804, 807,
    ],
  ],
  [
    '855240461',
    '27238',
    'Downtown Seattle',
    [
      709, 709, 711, 713, 714, 715, 716, 717, 718, 719, 720, 722, 724, 725, 726, 728, 730, 731, 732, 733, 735, 735, 736,
      739, 742, 748, 750, 753, 754, 756, 757, 758, 760, 763, 766,
    ],
  ],
  [
    '855240471',
    '27238',
    'Downtown Seattle',
    [
      730, 730, 732, 734, 735, 736, 737, 738, 739, 740, 741, 743, 745, 746, 747, 749, 751, 752, 753, 754, 756, 756, 757,
      760, 763, 769, 771, 774, 775, 777, 778, 779, 781, 784, 787,
    ],
  ],
  [
    '855240491',
    '27238',
    'Downtown Seattle',
    [
      679, 679, 681, 683, 684, 685, 686, 687, 688, 689, 690, 692, 694, 695, 696, 698, 700, 701, 702, 703, 705, 705, 706,
      709, 712, 718, 720, 723, 724, 725, 726, 727, 729, 732, 735,
    ],
  ],
  [
    '855240521',
    '27238',
    'Downtown Seattle',
    [
      660, 660, 662, 664, 665, 666, 667, 668, 669, 670, 671, 673, 675, 676, 677, 679, 681, 682, 683, 684, 686, 686, 687,
      690, 693, 699, 701, 704, 705, 706, 707, 708, 710, 713, 716,
    ],
  ],
  [
    '855240571',
    '27238',
    'Downtown Seattle',
    [
      600, 600, 602, 604, 605, 606, 607, 608, 609, 610, 611, 613, 615, 616, 617, 619, 621, 622, 623, 624, 626, 626, 627,
      630, 633, 638, 640, 643, 644, 645, 646, 647, 649, 652, 655,
    ],
  ],
  [
    '855240581',
    '27238',
    'Downtown Seattle',
    [
      610, 610, 612, 614, 615, 616, 617, 618, 619, 620, 621, 623, 625, 626, 627, 629, 631, 632, 633, 634, 636, 636, 637,
      640, 643, 648, 650, 653, 654, 655, 656, 657, 659, 662, 665,
    ],
  ],
  [
    '855240631',
    '27238',
    'Downtown Seattle',
    [
      520, 520, 522, 523, 524, 525, 526, 527, 528, 529, 529, 531, 532, 533, 534, 536, 538, 539, 540, 541, 543, 543, 544,
      547, 549, 554, 556, 559, 560, 561, 562, 563, 565, 567, 570,
    ],
  ],
  [
    '855240641',
    '27238',
    'Downtown Seattle',
    [
      468, 468, 470, 471, 472, 473, 474, 475, 476, 477, 477, 479, 480, 481, 482, 484, 486, 487, 488, 488, 490, 490, 491,
      493, 495, 500, 502, 505, 506, 507, 508, 509, 511, 513, 516,
    ],
  ],
  [
    '855240671',
    '27238',
    'Downtown Seattle',
    [
      453, 453, 455, 456, 457, 458, 459, 460, 461, 462, 462, 464, 465, 466, 467, 469, 471, 472, 473, 473, 475, 475, 476,
      478, 480, 485, 487, 490, 491, 492, 493, 494, 496, 498, 501,
    ],
  ],
  [
    '855240681',
    '27238',
    'Downtown Seattle',
    [
      590, 590, 592, 594, 595, 596, 597, 598, 599, 600, 601, 603, 605, 606, 607, 609, 611, 612, 613, 614, 616, 616, 617,
      620, 622, 627, 629, 632, 633, 634, 635, 636, 638, 640, 643,
    ],
  ],
  [
    '855240701',
    '27238',
    'Downtown Seattle',
    [
      540, 540, 542, 543, 544, 545, 546, 547, 548, 549, 550, 552, 553, 554, 555, 557, 559, 560, 561, 562, 564, 564, 565,
      568, 570, 575, 577, 580, 581, 582, 583, 584, 586, 588, 591,
    ],
  ],
  [
    '855240711',
    '27238',
    'Downtown Seattle',
    [
      570, 570, 572, 573, 574, 575, 576, 577, 578, 579, 580, 582, 584, 585, 586, 588, 590, 591, 592, 593, 595, 595, 596,
      599, 601, 606, 608, 611, 612, 613, 614, 615, 617, 619, 622,
    ],
  ],
  [
    '855240721',
    '27238',
    'Downtown Seattle',
    [
      393, 393, 395, 396, 397, 397, 398, 399, 400, 401, 401, 403, 404, 405, 406, 408, 410, 411, 412, 412, 414, 414, 415,
      417, 419, 424, 426, 429, 430, 431, 432, 433, 435, 436, 439,
    ],
  ],
  [
    '855240741',
    '27238',
    'Downtown Seattle',
    [
      377, 377, 379, 380, 381, 381, 382, 383, 384, 385, 385, 387, 388, 389, 390, 392, 394, 395, 396, 396, 398, 398, 399,
      401, 403, 408, 410, 413, 414, 415, 416, 417, 419, 420, 423,
    ],
  ],
  [
    '845642201',
    '28118',
    'Downtown Seattle',
    [
      1425, 1425, 1427, 1428, 1429, 1429, 1430, 1431, 1432, 1433, 1433, 1435, 1436, 1437, 1438, 1440, 1442, 1443, 1444,
      1445, 1447, 1447, 1448, 1450, 1452, 1457, 1458, 1461, 1462, 1463, 1464, 1465, 1467, 1468, 1471,
    ],
  ],
  [
    '845642231',
    '28118',
    'Downtown Seattle',
    [
      1455, 1455, 1457, 1458, 1459, 1459, 1460, 1461, 1462, 1463, 1463, 1465, 1466, 1467, 1468, 1470, 1472, 1473, 1474,
      1475, 1477, 1477, 1478, 1480, 1482, 1487, 1488, 1491, 1492, 1493, 1494, 1495, 1497, 1498, 1501,
    ],
  ],
  [
    '845642271',
    '28118',
    'Downtown Seattle',
    [
      1170, 1170, 1172, 1173, 1174, 1175, 1176, 1177, 1178, 1179, 1179, 1181, 1182, 1183, 1184, 1186, 1188, 1189, 1190,
      1191, 1193, 1193, 1194, 1197, 1200, 1205, 1207, 1210, 1211, 1212, 1213, 1214, 1216, 1217, 1220,
    ],
  ],
  [
    '845642281',
    '28118',
    'Downtown Seattle',
    [
      1320, 1320, 1322, 1323, 1324, 1324, 1325, 1326, 1327, 1328, 1328, 1330, 1331, 1332, 1333, 1335, 1337, 1338, 1339,
      1340, 1342, 1342, 1343, 1345, 1347, 1352, 1353, 1356, 1357, 1358, 1359, 1360, 1362, 1363, 1366,
    ],
  ],
  [
    '845642291',
    '28118',
    'Downtown Seattle',
    [
      1030, 1030, 1032, 1034, 1035, 1036, 1037, 1038, 1039, 1040, 1041, 1043, 1045, 1046, 1047, 1049, 1051, 1052, 1053,
      1054, 1056, 1056, 1057, 1060, 1063, 1068, 1070, 1073, 1074, 1075, 1076, 1077, 1079, 1080, 1083,
    ],
  ],
  [
    '845642341',
    '28118',
    'Downtown Seattle',
    [
      1130, 1130, 1132, 1133, 1134, 1135, 1136, 1137, 1138, 1139, 1140, 1142, 1143, 1144, 1145, 1147, 1149, 1150, 1151,
      1152, 1154, 1154, 1155, 1158, 1161, 1166, 1168, 1171, 1172, 1173, 1174, 1175, 1177, 1178, 1181,
    ],
  ],
  [
    '845642371',
    '28118',
    'Downtown Seattle',
    [
      970, 970, 972, 974, 975, 976, 977, 978, 979, 980, 981, 983, 985, 986, 987, 989, 991, 992, 993, 994, 996, 996, 997,
      1000, 1003, 1008, 1010, 1013, 1014, 1015, 1016, 1017, 1019, 1020, 1023,
    ],
  ],
  [
    '845642391',
    '28118',
    'Downtown Seattle',
    [
      1110, 1110, 1112, 1113, 1114, 1115, 1116, 1117, 1118, 1119, 1120, 1122, 1124, 1125, 1126, 1128, 1130, 1131, 1132,
      1133, 1135, 1135, 1136, 1139, 1142, 1147, 1149, 1152, 1153, 1154, 1155, 1156, 1158, 1159, 1162,
    ],
  ],
  [
    '845642431',
    '28118',
    'Downtown Seattle',
    [
      830, 830, 832, 834, 835, 836, 837, 838, 839, 840, 841, 843, 845, 846, 847, 849, 851, 852, 853, 854, 856, 856, 857,
      860, 863, 868, 870, 873, 874, 875, 876, 877, 879, 880, 883,
    ],
  ],
  [
    '845642651',
    '28118',
    'Downtown Seattle',
    [
      690, 690, 692, 694, 695, 696, 697, 698, 699, 700, 701, 703, 705, 706, 707, 709, 711, 712, 713, 714, 716, 716, 717,
      720, 723, 728, 729, 732, 733, 734, 735, 736, 738, 740, 743,
    ],
  ],
  [
    '845642931',
    '28118',
    'Downtown Seattle',
    [
      550, 550, 552, 553, 554, 554, 555, 556, 557, 558, 558, 560, 561, 562, 563, 565, 567, 568, 569, 570, 572, 572, 573,
      576, 578, 583, 584, 587, 588, 589, 590, 591, 593, 594, 597,
    ],
  ],
  [
    '845643001',
    '28118',
    'Downtown Seattle',
    [
      293, 293, 294, 295, 296, 297, 298, 298, 299, 300, 300, 302, 303, 304, 305, 306, 308, 309, 310, 311, 312, 312, 313,
      315, 317, 321, 323, 325, 326, 327, 328, 329, 331, 332, 335,
    ],
  ],
  [
    '845643061',
    '28118',
    'Downtown Seattle',
    [
      421, 421, 423, 424, 425, 425, 426, 427, 428, 429, 429, 431, 432, 433, 434, 436, 438, 439, 440, 440, 442, 442, 443,
      445, 447, 452, 453, 456, 457, 458, 459, 460, 462, 463, 466,
    ],
  ],
  [
    '845644341',
    '28118',
    'Downtown Seattle',
    [
      1190, 1190, 1192, 1193, 1194, 1195, 1196, 1197, 1198, 1199, 1199, 1201, 1202, 1203, 1204, 1206, 1208, 1209, 1210,
      1211, 1213, 1213, 1214, 1216, 1219, 1224, 1226, 1229, 1230, 1231, 1232, 1233, 1235, 1236, 1239,
    ],
  ],
  [
    '845644371',
    '28118',
    'Downtown Seattle',
    [
      1335, 1335, 1337, 1338, 1339, 1339, 1340, 1341, 1342, 1343, 1343, 1345, 1346, 1347, 1348, 1350, 1352, 1353, 1354,
      1355, 1357, 1357, 1358, 1360, 1362, 1367, 1368, 1371, 1372, 1373, 1374, 1375, 1377, 1378, 1381,
    ],
  ],
  [
    '845644381',
    '28118',
    'Downtown Seattle',
    [
      1605, 1605, 1606, 1607, 1608, 1608, 1609, 1610, 1610, 1611, 1612, 1613, 1614, 1615, 1616, 1618, 1620, 1621, 1622,
      1622, 1624, 1624, 1625, 1627, 1629, 1634, 1635, 1638, 1639, 1640, 1641, 1642, 1644, 1645, 1648,
    ],
  ],
  [
    '845644391',
    '28118',
    'Downtown Seattle',
    [
      1485, 1485, 1487, 1488, 1489, 1489, 1490, 1491, 1492, 1493, 1493, 1495, 1496, 1497, 1498, 1500, 1502, 1503, 1504,
      1505, 1507, 1507, 1508, 1510, 1512, 1517, 1518, 1521, 1522, 1523, 1524, 1525, 1527, 1528, 1531,
    ],
  ],
  [
    '845644441',
    '28118',
    'Downtown Seattle',
    [
      1050, 1050, 1052, 1054, 1055, 1056, 1057, 1058, 1059, 1060, 1061, 1063, 1065, 1066, 1067, 1069, 1071, 1072, 1073,
      1074, 1076, 1076, 1077, 1080, 1083, 1088, 1090, 1093, 1094, 1095, 1096, 1097, 1099, 1100, 1103,
    ],
  ],
  [
    '845644471',
    '28118',
    'Downtown Seattle',
    [
      1070, 1070, 1072, 1074, 1075, 1076, 1077, 1078, 1079, 1080, 1081, 1083, 1085, 1086, 1087, 1089, 1091, 1092, 1093,
      1094, 1096, 1096, 1097, 1100, 1103, 1108, 1110, 1113, 1114, 1115, 1116, 1117, 1119, 1120, 1123,
    ],
  ],
  [
    '845644491',
    '28118',
    'Downtown Seattle',
    [
      1000, 1000, 1002, 1004, 1005, 1006, 1007, 1008, 1009, 1010, 1011, 1013, 1015, 1016, 1017, 1019, 1021, 1022, 1023,
      1024, 1026, 1026, 1027, 1030, 1033, 1038, 1040, 1043, 1044, 1045, 1046, 1047, 1049, 1050, 1053,
    ],
  ],
  [
    '845644521',
    '28118',
    'Downtown Seattle',
    [
      1275, 1275, 1277, 1278, 1279, 1280, 1281, 1282, 1283, 1284, 1284, 1286, 1287, 1288, 1289, 1291, 1293, 1294, 1295,
      1296, 1298, 1298, 1299, 1301, 1303, 1308, 1309, 1312, 1313, 1314, 1315, 1316, 1318, 1319, 1322,
    ],
  ],
  [
    '845644541',
    '28118',
    'Downtown Seattle',
    [
      910, 910, 912, 914, 915, 916, 917, 918, 919, 920, 921, 923, 925, 926, 927, 929, 931, 932, 933, 934, 936, 936, 937,
      940, 943, 948, 950, 953, 954, 955, 956, 957, 959, 960, 963,
    ],
  ],
  [
    '845644561',
    '28118',
    'Downtown Seattle',
    [
      930, 930, 932, 934, 935, 936, 937, 938, 939, 940, 941, 943, 945, 946, 947, 949, 951, 952, 953, 954, 956, 956, 957,
      960, 963, 968, 970, 973, 974, 975, 976, 977, 979, 980, 983,
    ],
  ],
  [
    '845644581',
    '28118',
    'Downtown Seattle',
    [
      1230, 1230, 1232, 1233, 1234, 1235, 1236, 1237, 1238, 1239, 1239, 1241, 1242, 1243, 1244, 1246, 1248, 1249, 1250,
      1251, 1253, 1253, 1254, 1256, 1259, 1264, 1266, 1269, 1270, 1271, 1272, 1273, 1275, 1276, 1279,
    ],
  ],
  [
    '845644601',
    '28118',
    'Downtown Seattle',
    [
      1090, 1090, 1092, 1094, 1095, 1096, 1097, 1098, 1099, 1100, 1101, 1103, 1105, 1106, 1107, 1109, 1111, 1112, 1113,
      1114, 1116, 1116, 1117, 1120, 1123, 1128, 1130, 1133, 1134, 1135, 1136, 1137, 1139, 1140, 1143,
    ],
  ],
  [
    '845644611',
    '28118',
    'Downtown Seattle',
    [
      950, 950, 952, 954, 955, 956, 957, 958, 959, 960, 961, 963, 965, 966, 967, 969, 971, 972, 973, 974, 976, 976, 977,
      980, 983, 988, 990, 993, 994, 995, 996, 997, 999, 1000, 1003,
    ],
  ],
  [
    '845644661',
    '28118',
    'Downtown Seattle',
    [
      880, 880, 882, 884, 885, 886, 887, 888, 889, 890, 891, 893, 895, 896, 897, 899, 901, 902, 903, 904, 906, 906, 907,
      910, 913, 918, 920, 923, 924, 925, 926, 927, 929, 930, 933,
    ],
  ],
  [
    '845644681',
    '28118',
    'Downtown Seattle',
    [
      860, 860, 862, 864, 865, 866, 867, 868, 869, 870, 871, 873, 875, 876, 877, 879, 881, 882, 883, 884, 886, 886, 887,
      890, 893, 898, 900, 903, 904, 905, 906, 907, 909, 910, 913,
    ],
  ],
  [
    '845644711',
    '28118',
    'Downtown Seattle',
    [
      810, 810, 812, 814, 815, 816, 817, 818, 819, 820, 821, 823, 825, 826, 827, 829, 831, 832, 833, 834, 836, 836, 837,
      840, 843, 848, 850, 853, 854, 855, 856, 857, 859, 860, 863,
    ],
  ],
  [
    '845644721',
    '28118',
    'Downtown Seattle',
    [
      940, 940, 942, 944, 945, 946, 947, 948, 949, 950, 951, 953, 955, 956, 957, 959, 961, 962, 963, 964, 966, 966, 967,
      970, 973, 978, 980, 983, 984, 985, 986, 987, 989, 990, 993,
    ],
  ],
  [
    '845644741',
    '28118',
    'Downtown Seattle',
    [
      800, 800, 802, 804, 805, 806, 807, 808, 809, 810, 811, 813, 815, 816, 817, 819, 821, 822, 823, 824, 826, 826, 827,
      830, 833, 838, 840, 843, 844, 845, 846, 847, 849, 850, 853,
    ],
  ],
  [
    '845644761',
    '28118',
    'Downtown Seattle',
    [
      770, 770, 772, 774, 775, 776, 777, 778, 779, 780, 781, 783, 785, 786, 787, 789, 791, 792, 793, 794, 796, 796, 797,
      800, 803, 808, 810, 813, 814, 815, 816, 817, 819, 820, 823,
    ],
  ],
  [
    '845644771',
    '28118',
    'Downtown Seattle',
    [
      790, 790, 792, 794, 795, 796, 797, 798, 799, 800, 801, 803, 805, 806, 807, 809, 811, 812, 813, 814, 816, 816, 817,
      820, 823, 828, 830, 833, 834, 835, 836, 837, 839, 840, 843,
    ],
  ],
  [
    '845644781',
    '28118',
    'Downtown Seattle',
    [
      1080, 1080, 1082, 1084, 1085, 1086, 1087, 1088, 1089, 1090, 1091, 1093, 1095, 1096, 1097, 1099, 1101, 1102, 1103,
      1104, 1106, 1106, 1107, 1110, 1113, 1118, 1120, 1123, 1124, 1125, 1126, 1127, 1129, 1130, 1133,
    ],
  ],
  [
    '845644861',
    '28118',
    'Downtown Seattle',
    [
      740, 740, 742, 744, 745, 746, 747, 748, 749, 750, 751, 753, 755, 756, 757, 759, 761, 762, 763, 764, 766, 766, 767,
      770, 773, 778, 779, 782, 783, 784, 785, 786, 788, 789, 792,
    ],
  ],
  [
    '845644871',
    '28118',
    'Downtown Seattle',
    [
      720, 720, 722, 724, 725, 726, 727, 728, 729, 730, 731, 733, 735, 736, 737, 739, 741, 742, 743, 744, 746, 746, 747,
      750, 753, 758, 759, 762, 763, 764, 765, 766, 768, 770, 773,
    ],
  ],
  [
    '845644911',
    '28118',
    'Downtown Seattle',
    [
      780, 780, 782, 784, 785, 786, 787, 788, 789, 790, 791, 793, 795, 796, 797, 799, 801, 802, 803, 804, 806, 806, 807,
      810, 813, 818, 820, 823, 824, 825, 826, 827, 829, 830, 833,
    ],
  ],
  [
    '845644921',
    '28118',
    'Downtown Seattle',
    [
      920, 920, 922, 924, 925, 926, 927, 928, 929, 930, 931, 933, 935, 936, 937, 939, 941, 942, 943, 944, 946, 946, 947,
      950, 953, 958, 960, 963, 964, 965, 966, 967, 969, 970, 973,
    ],
  ],
  [
    '845644971',
    '28118',
    'Downtown Seattle',
    [
      1060, 1060, 1062, 1064, 1065, 1066, 1067, 1068, 1069, 1070, 1071, 1073, 1075, 1076, 1077, 1079, 1081, 1082, 1083,
      1084, 1086, 1086, 1087, 1090, 1093, 1098, 1100, 1103, 1104, 1105, 1106, 1107, 1109, 1110, 1113,
    ],
  ],
  [
    '845644981',
    '28118',
    'Downtown Seattle',
    [
      1200, 1200, 1202, 1203, 1204, 1205, 1206, 1207, 1208, 1209, 1209, 1211, 1212, 1213, 1214, 1216, 1218, 1219, 1220,
      1221, 1223, 1223, 1224, 1226, 1229, 1234, 1236, 1239, 1240, 1241, 1242, 1243, 1245, 1246, 1249,
    ],
  ],
  [
    '845645001',
    '28118',
    'Downtown Seattle',
    [
      670, 670, 672, 673, 674, 675, 676, 677, 678, 679, 680, 682, 684, 685, 686, 688, 690, 691, 692, 693, 695, 695, 696,
      699, 702, 707, 708, 711, 712, 713, 714, 715, 717, 719, 722,
    ],
  ],
  [
    '845645011',
    '28118',
    'Downtown Seattle',
    [
      1350, 1350, 1352, 1353, 1354, 1354, 1355, 1356, 1357, 1358, 1358, 1360, 1361, 1362, 1363, 1365, 1367, 1368, 1369,
      1370, 1372, 1372, 1373, 1375, 1377, 1382, 1383, 1386, 1387, 1388, 1389, 1390, 1392, 1393, 1396,
    ],
  ],
  [
    '845645021',
    '28118',
    'Downtown Seattle',
    [
      640, 640, 642, 643, 644, 645, 646, 647, 648, 649, 650, 652, 653, 654, 655, 657, 659, 660, 661, 662, 664, 664, 665,
      668, 671, 676, 677, 680, 681, 682, 683, 684, 686, 688, 691,
    ],
  ],
  [
    '845645031',
    '28118',
    'Downtown Seattle',
    [
      660, 660, 662, 663, 664, 665, 666, 667, 668, 669, 670, 672, 674, 675, 676, 678, 680, 681, 682, 683, 685, 685, 686,
      689, 692, 697, 698, 701, 702, 703, 704, 705, 707, 709, 712,
    ],
  ],
  [
    '845645041',
    '28118',
    'Downtown Seattle',
    [
      650, 650, 652, 653, 654, 655, 656, 657, 658, 659, 660, 662, 664, 665, 666, 668, 670, 671, 672, 673, 675, 675, 676,
      679, 682, 687, 688, 691, 692, 693, 694, 695, 697, 699, 702,
    ],
  ],
  [
    '845645061',
    '28118',
    'Downtown Seattle',
    [
      630, 630, 632, 633, 634, 635, 636, 637, 638, 639, 640, 642, 643, 644, 645, 647, 649, 650, 651, 652, 654, 654, 655,
      658, 661, 666, 667, 670, 671, 672, 673, 674, 676, 678, 681,
    ],
  ],
  [
    '845645081',
    '28118',
    'Downtown Seattle',
    [
      590, 590, 592, 593, 594, 595, 596, 597, 598, 599, 599, 601, 602, 603, 604, 606, 608, 609, 610, 611, 613, 613, 614,
      617, 619, 624, 625, 628, 629, 630, 631, 632, 634, 635, 638,
    ],
  ],
  [
    '845645091',
    '28118',
    'Downtown Seattle',
    [
      730, 730, 732, 734, 735, 736, 737, 738, 739, 740, 741, 743, 745, 746, 747, 749, 751, 752, 753, 754, 756, 756, 757,
      760, 763, 768, 769, 772, 773, 774, 775, 776, 778, 780, 783,
    ],
  ],
  [
    '845645121',
    '28118',
    'Downtown Seattle',
    [
      870, 870, 872, 874, 875, 876, 877, 878, 879, 880, 881, 883, 885, 886, 887, 889, 891, 892, 893, 894, 896, 896, 897,
      900, 903, 908, 910, 913, 914, 915, 916, 917, 919, 920, 923,
    ],
  ],
  [
    '845645131',
    '28118',
    'Downtown Seattle',
    [
      1010, 1010, 1012, 1014, 1015, 1016, 1017, 1018, 1019, 1020, 1021, 1023, 1025, 1026, 1027, 1029, 1031, 1032, 1033,
      1034, 1036, 1036, 1037, 1040, 1043, 1048, 1050, 1053, 1054, 1055, 1056, 1057, 1059, 1060, 1063,
    ],
  ],
  [
    '845645151',
    '28118',
    'Downtown Seattle',
    [
      600, 600, 602, 603, 604, 605, 606, 607, 608, 609, 609, 611, 612, 613, 614, 616, 618, 619, 620, 621, 623, 623, 624,
      627, 629, 634, 635, 638, 639, 640, 641, 642, 644, 645, 648,
    ],
  ],
  [
    '845645161',
    '28118',
    'Downtown Seattle',
    [
      1150, 1150, 1152, 1153, 1154, 1155, 1156, 1157, 1158, 1159, 1160, 1162, 1163, 1164, 1165, 1167, 1169, 1170, 1171,
      1172, 1174, 1174, 1175, 1178, 1181, 1186, 1188, 1191, 1192, 1193, 1194, 1195, 1197, 1198, 1201,
    ],
  ],
  [
    '845645181',
    '28118',
    'Downtown Seattle',
    [
      1290, 1290, 1292, 1293, 1294, 1294, 1295, 1296, 1297, 1298, 1298, 1300, 1301, 1302, 1303, 1305, 1307, 1308, 1309,
      1310, 1312, 1312, 1313, 1315, 1317, 1322, 1323, 1326, 1327, 1328, 1329, 1330, 1332, 1333, 1336,
    ],
  ],
  [
    '845645251',
    '28118',
    'Downtown Seattle',
    [
      580, 580, 582, 583, 584, 585, 586, 587, 588, 589, 589, 591, 592, 593, 594, 596, 598, 599, 600, 601, 603, 603, 604,
      607, 609, 614, 615, 618, 619, 620, 621, 622, 624, 625, 628,
    ],
  ],
  [
    '845645271',
    '28118',
    'Downtown Seattle',
    [
      530, 530, 532, 533, 534, 534, 535, 536, 537, 538, 538, 540, 541, 542, 543, 545, 547, 548, 549, 550, 552, 552, 553,
      556, 558, 563, 564, 567, 568, 569, 570, 571, 573, 574, 577,
    ],
  ],
  [
    '845645281',
    '28118',
    'Downtown Seattle',
    [
      520, 520, 522, 523, 524, 524, 525, 526, 527, 528, 528, 530, 531, 532, 533, 535, 537, 538, 539, 540, 542, 542, 543,
      546, 548, 553, 554, 557, 558, 559, 560, 561, 563, 564, 567,
    ],
  ],
  [
    '845645301',
    '28118',
    'Downtown Seattle',
    [
      510, 510, 512, 513, 514, 514, 515, 516, 517, 518, 518, 520, 521, 522, 523, 525, 527, 528, 529, 530, 532, 532, 533,
      535, 537, 542, 543, 546, 547, 548, 549, 550, 552, 553, 556,
    ],
  ],
  [
    '845645311',
    '28118',
    'Downtown Seattle',
    [
      500, 500, 502, 503, 504, 504, 505, 506, 507, 508, 508, 510, 511, 512, 513, 515, 517, 518, 519, 520, 522, 522, 523,
      525, 527, 532, 533, 536, 537, 538, 539, 540, 542, 543, 546,
    ],
  ],
  [
    '845645321',
    '28118',
    'Downtown Seattle',
    [
      490, 490, 492, 493, 494, 494, 495, 496, 497, 498, 498, 500, 501, 502, 503, 505, 507, 508, 509, 510, 512, 512, 513,
      515, 517, 522, 523, 526, 527, 528, 529, 530, 532, 533, 536,
    ],
  ],
  [
    '845645331',
    '28118',
    'Downtown Seattle',
    [
      468, 468, 470, 471, 472, 472, 473, 474, 475, 476, 476, 478, 479, 480, 481, 483, 485, 486, 487, 487, 489, 489, 490,
      492, 494, 499, 500, 503, 504, 505, 506, 507, 509, 510, 513,
    ],
  ],
  [
    '845645361',
    '28118',
    'Downtown Seattle',
    [
      453, 453, 455, 456, 457, 457, 458, 459, 460, 461, 461, 463, 464, 465, 466, 468, 470, 471, 472, 472, 474, 474, 475,
      477, 479, 484, 485, 488, 489, 490, 491, 492, 494, 495, 498,
    ],
  ],
  [
    '845645381',
    '28118',
    'Downtown Seattle',
    [
      408, 408, 409, 410, 411, 412, 413, 413, 414, 415, 415, 417, 418, 419, 420, 422, 424, 425, 426, 426, 428, 428, 429,
      431, 433, 438, 439, 442, 443, 444, 445, 446, 448, 449, 452,
    ],
  ],
  [
    '845645401',
    '28118',
    'Downtown Seattle',
    [
      377, 377, 378, 379, 380, 381, 382, 382, 383, 384, 384, 386, 387, 388, 389, 390, 392, 393, 394, 395, 396, 396, 397,
      399, 401, 406, 407, 410, 411, 412, 413, 414, 416, 417, 420,
    ],
  ],
  [
    '845645411',
    '28118',
    'Downtown Seattle',
    [
      393, 393, 394, 395, 396, 397, 398, 398, 399, 400, 400, 402, 403, 404, 405, 407, 409, 410, 411, 411, 413, 413, 414,
      416, 418, 423, 424, 427, 428, 429, 430, 431, 433, 434, 437,
    ],
  ],
  [
    '845645421',
    '28118',
    'Downtown Seattle',
    [
      337, 337, 338, 339, 340, 341, 342, 342, 343, 344, 344, 346, 347, 348, 349, 350, 352, 353, 354, 355, 356, 356, 357,
      359, 361, 365, 367, 369, 370, 371, 372, 373, 375, 376, 379,
    ],
  ],
  [
    '855243721',
    '28118',
    'Downtown Seattle',
    [
      356, 356, 357, 358, 359, 360, 361, 361, 362, 363, 363, 365, 366, 367, 368, 369, 371, 372, 373, 374, 375, 375, 376,
      378, 380, 385, 386, 389, 390, 391, 392, 393, 395, 396, 399,
    ],
  ],
  [
    '855243741',
    '28118',
    'Downtown Seattle',
    [
      437, 437, 439, 440, 441, 441, 442, 443, 444, 445, 445, 447, 448, 449, 450, 452, 454, 455, 456, 456, 458, 458, 459,
      461, 463, 468, 469, 472, 473, 474, 475, 476, 478, 479, 482,
    ],
  ],
  [
    '855243751',
    '28118',
    'Downtown Seattle',
    [
      480, 480, 482, 483, 484, 484, 485, 486, 487, 488, 488, 490, 491, 492, 493, 495, 497, 498, 499, 500, 502, 502, 503,
      505, 507, 512, 513, 516, 517, 518, 519, 520, 522, 523, 526,
    ],
  ],
  [
    '855243771',
    '28118',
    'Downtown Seattle',
    [
      560, 560, 562, 563, 564, 564, 565, 566, 567, 568, 568, 570, 571, 572, 573, 575, 577, 578, 579, 580, 582, 582, 583,
      586, 588, 593, 594, 597, 598, 599, 600, 601, 603, 604, 607,
    ],
  ],
  [
    '855243781',
    '28118',
    'Downtown Seattle',
    [
      620, 620, 622, 623, 624, 625, 626, 627, 628, 629, 629, 631, 632, 633, 634, 636, 638, 639, 640, 641, 643, 643, 644,
      647, 650, 655, 656, 659, 660, 661, 662, 663, 665, 667, 670,
    ],
  ],
  [
    '855243811',
    '28118',
    'Downtown Seattle',
    [
      540, 540, 542, 543, 544, 544, 545, 546, 547, 548, 548, 550, 551, 552, 553, 555, 557, 558, 559, 560, 562, 562, 563,
      566, 568, 573, 574, 577, 578, 579, 580, 581, 583, 584, 587,
    ],
  ],
  [
    '855243831',
    '28118',
    'Downtown Seattle',
    [
      700, 700, 702, 704, 705, 706, 707, 708, 709, 710, 711, 713, 715, 716, 717, 719, 721, 722, 723, 724, 726, 726, 727,
      730, 733, 738, 739, 742, 743, 744, 745, 746, 748, 750, 753,
    ],
  ],
  [
    '855243851',
    '28118',
    'Downtown Seattle',
    [
      680, 680, 682, 684, 685, 686, 687, 688, 689, 690, 691, 693, 695, 696, 697, 699, 701, 702, 703, 704, 706, 706, 707,
      710, 713, 718, 719, 722, 723, 724, 725, 726, 728, 730, 733,
    ],
  ],
  [
    '855243881',
    '28118',
    'Downtown Seattle',
    [
      760, 760, 762, 764, 765, 766, 767, 768, 769, 770, 771, 773, 775, 776, 777, 779, 781, 782, 783, 784, 786, 786, 787,
      790, 793, 798, 800, 803, 804, 805, 806, 807, 809, 810, 813,
    ],
  ],
  [
    '855243901',
    '28118',
    'Downtown Seattle',
    [
      710, 710, 712, 714, 715, 716, 717, 718, 719, 720, 721, 723, 725, 726, 727, 729, 731, 732, 733, 734, 736, 736, 737,
      740, 743, 748, 749, 752, 753, 754, 755, 756, 758, 760, 763,
    ],
  ],
  [
    '855243931',
    '28118',
    'Downtown Seattle',
    [
      570, 570, 572, 573, 574, 575, 576, 577, 578, 579, 579, 581, 582, 583, 584, 586, 588, 589, 590, 591, 593, 593, 594,
      597, 599, 604, 605, 608, 609, 610, 611, 612, 614, 615, 618,
    ],
  ],
  [
    '855243951',
    '28118',
    'Downtown Seattle',
    [
      850, 850, 852, 854, 855, 856, 857, 858, 859, 860, 861, 863, 865, 866, 867, 869, 871, 872, 873, 874, 876, 876, 877,
      880, 883, 888, 890, 893, 894, 895, 896, 897, 899, 900, 903,
    ],
  ],
  [
    '855243961',
    '28118',
    'Downtown Seattle',
    [
      840, 840, 842, 844, 845, 846, 847, 848, 849, 850, 851, 853, 855, 856, 857, 859, 861, 862, 863, 864, 866, 866, 867,
      870, 873, 878, 880, 883, 884, 885, 886, 887, 889, 890, 893,
    ],
  ],
  [
    '855243971',
    '28118',
    'Downtown Seattle',
    [
      900, 900, 902, 904, 905, 906, 907, 908, 909, 910, 911, 913, 915, 916, 917, 919, 921, 922, 923, 924, 926, 926, 927,
      930, 933, 938, 940, 943, 944, 945, 946, 947, 949, 950, 953,
    ],
  ],
  [
    '855244001',
    '28118',
    'Downtown Seattle',
    [
      820, 820, 822, 824, 825, 826, 827, 828, 829, 830, 831, 833, 835, 836, 837, 839, 841, 842, 843, 844, 846, 846, 847,
      850, 853, 858, 860, 863, 864, 865, 866, 867, 869, 870, 873,
    ],
  ],
  [
    '855244021',
    '28118',
    'Downtown Seattle',
    [
      990, 990, 992, 994, 995, 996, 997, 998, 999, 1000, 1001, 1003, 1005, 1006, 1007, 1009, 1011, 1012, 1013, 1014,
      1016, 1016, 1017, 1020, 1023, 1028, 1030, 1033, 1034, 1035, 1036, 1037, 1039, 1040, 1043,
    ],
  ],
  [
    '855244041',
    '28118',
    'Downtown Seattle',
    [
      980, 980, 982, 984, 985, 986, 987, 988, 989, 990, 991, 993, 995, 996, 997, 999, 1001, 1002, 1003, 1004, 1006,
      1006, 1007, 1010, 1013, 1018, 1020, 1023, 1024, 1025, 1026, 1027, 1029, 1030, 1033,
    ],
  ],
  [
    '855244071',
    '28118',
    'Downtown Seattle',
    [
      1040, 1040, 1042, 1044, 1045, 1046, 1047, 1048, 1049, 1050, 1051, 1053, 1055, 1056, 1057, 1059, 1061, 1062, 1063,
      1064, 1066, 1066, 1067, 1070, 1073, 1078, 1080, 1083, 1084, 1085, 1086, 1087, 1089, 1090, 1093,
    ],
  ],
  [
    '855244081',
    '28118',
    'Downtown Seattle',
    [
      960, 960, 962, 964, 965, 966, 967, 968, 969, 970, 971, 973, 975, 976, 977, 979, 981, 982, 983, 984, 986, 986, 987,
      990, 993, 998, 1000, 1003, 1004, 1005, 1006, 1007, 1009, 1010, 1013,
    ],
  ],
  [
    '855244121',
    '28118',
    'Downtown Seattle',
    [
      1120, 1120, 1122, 1123, 1124, 1125, 1126, 1127, 1128, 1129, 1130, 1132, 1134, 1135, 1136, 1138, 1140, 1141, 1142,
      1143, 1145, 1145, 1146, 1149, 1152, 1157, 1159, 1162, 1163, 1164, 1165, 1166, 1168, 1169, 1172,
    ],
  ],
  [
    '855244131',
    '28118',
    'Downtown Seattle',
    [
      1180, 1180, 1182, 1183, 1184, 1185, 1186, 1187, 1188, 1189, 1189, 1191, 1192, 1193, 1194, 1196, 1198, 1199, 1200,
      1201, 1203, 1203, 1204, 1206, 1209, 1214, 1216, 1219, 1220, 1221, 1222, 1223, 1225, 1226, 1229,
    ],
  ],
  [
    '855244151',
    '28118',
    'Downtown Seattle',
    [
      1100, 1100, 1102, 1103, 1104, 1105, 1106, 1107, 1108, 1109, 1110, 1112, 1114, 1115, 1116, 1118, 1120, 1121, 1122,
      1123, 1125, 1125, 1126, 1129, 1132, 1137, 1139, 1142, 1143, 1144, 1145, 1146, 1148, 1149, 1152,
    ],
  ],
  [
    '855244181',
    '28118',
    'Downtown Seattle',
    [
      1140, 1140, 1142, 1143, 1144, 1145, 1146, 1147, 1148, 1149, 1150, 1152, 1153, 1154, 1155, 1157, 1159, 1160, 1161,
      1162, 1164, 1164, 1165, 1168, 1171, 1176, 1178, 1181, 1182, 1183, 1184, 1185, 1187, 1188, 1191,
    ],
  ],
  [
    '855244191',
    '28118',
    'Downtown Seattle',
    [
      890, 890, 892, 894, 895, 896, 897, 898, 899, 900, 901, 903, 905, 906, 907, 909, 911, 912, 913, 914, 916, 916, 917,
      920, 923, 928, 930, 933, 934, 935, 936, 937, 939, 940, 943,
    ],
  ],
  [
    '855244211',
    '28118',
    'Downtown Seattle',
    [
      750, 750, 752, 754, 755, 756, 757, 758, 759, 760, 761, 763, 765, 766, 767, 769, 771, 772, 773, 774, 776, 776, 777,
      780, 783, 788, 790, 793, 794, 795, 796, 797, 799, 800, 803,
    ],
  ],
  [
    '855244241',
    '28118',
    'Downtown Seattle',
    [
      610, 610, 612, 613, 614, 615, 616, 617, 618, 619, 619, 621, 622, 623, 624, 626, 628, 629, 630, 631, 633, 633, 634,
      637, 640, 645, 646, 649, 650, 651, 652, 653, 655, 656, 659,
    ],
  ],
  [
    '855244251',
    '28118',
    'Downtown Seattle',
    [
      1260, 1260, 1262, 1263, 1264, 1265, 1266, 1267, 1268, 1269, 1269, 1271, 1272, 1273, 1274, 1276, 1278, 1279, 1280,
      1281, 1283, 1283, 1284, 1286, 1289, 1294, 1296, 1299, 1300, 1301, 1302, 1303, 1305, 1306, 1309,
    ],
  ],
  [
    '855244261',
    '28118',
    'Downtown Seattle',
    [
      1245, 1245, 1247, 1248, 1249, 1250, 1251, 1252, 1253, 1254, 1254, 1256, 1257, 1258, 1259, 1261, 1263, 1264, 1265,
      1266, 1268, 1268, 1269, 1271, 1274, 1279, 1281, 1284, 1285, 1286, 1287, 1288, 1290, 1291, 1294,
    ],
  ],
  [
    '855244281',
    '28118',
    'Downtown Seattle',
    [
      1395, 1395, 1397, 1398, 1399, 1399, 1400, 1401, 1402, 1403, 1403, 1405, 1406, 1407, 1408, 1410, 1412, 1413, 1414,
      1415, 1417, 1417, 1418, 1420, 1422, 1427, 1428, 1431, 1432, 1433, 1434, 1435, 1437, 1438, 1441,
    ],
  ],
  [
    '855244311',
    '28118',
    'Downtown Seattle',
    [
      1545, 1545, 1546, 1547, 1548, 1548, 1549, 1550, 1550, 1551, 1552, 1553, 1554, 1555, 1556, 1558, 1560, 1561, 1562,
      1562, 1564, 1564, 1565, 1567, 1569, 1574, 1575, 1578, 1579, 1580, 1581, 1582, 1584, 1585, 1588,
    ],
  ],
  [
    '855244321',
    '28118',
    'Downtown Seattle',
    [
      1160, 1160, 1162, 1163, 1164, 1165, 1166, 1167, 1168, 1169, 1170, 1172, 1173, 1174, 1175, 1177, 1179, 1180, 1181,
      1182, 1184, 1184, 1185, 1188, 1191, 1196, 1198, 1201, 1202, 1203, 1204, 1205, 1207, 1208, 1211,
    ],
  ],
  [
    '855244351',
    '28118',
    'Downtown Seattle',
    [
      1305, 1305, 1307, 1308, 1309, 1309, 1310, 1311, 1312, 1313, 1313, 1315, 1316, 1317, 1318, 1320, 1322, 1323, 1324,
      1325, 1327, 1327, 1328, 1330, 1332, 1337, 1338, 1341, 1342, 1343, 1344, 1345, 1347, 1348, 1351,
    ],
  ],
  [
    '855244361',
    '28118',
    'Downtown Seattle',
    [
      1020, 1020, 1022, 1024, 1025, 1026, 1027, 1028, 1029, 1030, 1031, 1033, 1035, 1036, 1037, 1039, 1041, 1042, 1043,
      1044, 1046, 1046, 1047, 1050, 1053, 1058, 1060, 1063, 1064, 1065, 1066, 1067, 1069, 1070, 1073,
    ],
  ],
  [
    '855244401',
    '28118',
    'Downtown Seattle',
    [
      1215, 1215, 1217, 1218, 1219, 1220, 1221, 1222, 1223, 1224, 1224, 1226, 1227, 1228, 1229, 1231, 1233, 1234, 1235,
      1236, 1238, 1238, 1239, 1241, 1244, 1249, 1251, 1254, 1255, 1256, 1257, 1258, 1260, 1261, 1264,
    ],
  ],
  [
    '855244411',
    '28118',
    'Downtown Seattle',
    [
      1365, 1365, 1367, 1368, 1369, 1369, 1370, 1371, 1372, 1373, 1373, 1375, 1376, 1377, 1378, 1380, 1382, 1383, 1384,
      1385, 1387, 1387, 1388, 1390, 1392, 1397, 1398, 1401, 1402, 1403, 1404, 1405, 1407, 1408, 1411,
    ],
  ],
  [
    '855244431',
    '28118',
    'Downtown Seattle',
    [
      1666, 1666, 1667, 1668, 1669, 1669, 1670, 1671, 1671, 1672, 1673, 1674, 1675, 1676, 1677, 1679, 1681, 1682, 1683,
      1683, 1685, 1685, 1686, 1688, 1690, 1695, 1696, 1699, 1700, 1701, 1702, 1703, 1705, 1706, 1709,
    ],
  ],
  [
    '855244441',
    '28118',
    'Downtown Seattle',
    [
      1515, 1515, 1516, 1517, 1518, 1518, 1519, 1520, 1520, 1521, 1522, 1523, 1524, 1525, 1526, 1528, 1530, 1531, 1532,
      1532, 1534, 1534, 1535, 1537, 1539, 1544, 1545, 1548, 1549, 1550, 1551, 1552, 1554, 1555, 1558,
    ],
  ],
];
export const STOPS_44_0: [string, string][] = [
  ['25240', 'Montlake Blvd NE & NE Pacific Pl - Bay 3'],
  ['29405', 'NE Pacific St & Montlake Blvd NE - Bay 2'],
  ['29420', 'NE Pacific St & 15th Ave NE'],
  ['29440', '15th Ave NE & NE Campus Pkwy'],
  ['11352', '15th Ave NE & NE 42nd St'],
  ['9587', 'U District Station - Bay 1'],
  ['29455', 'NE 45th St & 9th Ave NE'],
  ['29480', 'NE 45th St & Latona Ave NE'],
  ['29500', 'N 45th St & Sunnyside Ave N'],
  ['17310', 'N 45th St & Wallingford Ave N'],
  ['29530', 'N 45th St & Woodlawn Ave N'],
  ['29540', 'N 45th St & Stone Way N'],
  ['29557', 'N 46th St & Green Lake Way N'],
  ['29581', 'N 46th St & Linden Ave N'],
  ['29600', 'N 46th St & Phinney Ave N'],
  ['29620', 'NW Market St & NW 48th St'],
  ['29630', 'NW Market St & NW 50th St'],
  ['29640', 'NW Market St & 3rd Ave NW'],
  ['29650', 'NW Market St & 5th Ave NW'],
  ['29660', 'NW Market St & 8th Ave NW'],
  ['29680', 'NW Market St & 11th Ave NW'],
  ['29700', 'NW Market St & 15th Ave NW'],
  ['29720', 'NW Market St & 20th Ave NW'],
  ['18740', 'NW Market St & Ballard Ave NW'],
  ['18760', 'NW Market St & 28th Ave NW'],
  ['18785', 'NW Market St & 30th Ave NW'],
  ['18085', '32nd Ave NW & NW Market St'],
];
export const TRIPS_44_0: [string, string, string, number[]][] = [
  [
    '635654751',
    '139986',
    'Ballard Wallingford',
    [
      1625, 1625, 1627, 1628, 1630, 1631, 1632, 1633, 1634, 1635, 1636, 1637, 1637, 1638, 1640, 1640, 1641, 1642, 1643,
      1643, 1644, 1646, 1647, 1648, 1649, 1650, 1651,
    ],
  ],
  [
    '635656161',
    '139986',
    'Ballard Wallingford',
    [
      1670, 1670, 1672, 1673, 1675, 1676, 1677, 1678, 1679, 1680, 1681, 1682, 1682, 1683, 1685, 1685, 1686, 1687, 1688,
      1688, 1689, 1691, 1692, 1693, 1694, 1695, 1696,
    ],
  ],
  [
    '664046411',
    '139986',
    'Ballard Wallingford',
    [
      1580, 1580, 1582, 1583, 1585, 1586, 1587, 1589, 1590, 1591, 1592, 1593, 1593, 1594, 1596, 1596, 1597, 1598, 1599,
      1599, 1600, 1602, 1603, 1604, 1605, 1606, 1607,
    ],
  ],
  [
    '664046471',
    '139986',
    'Ballard Wallingford',
    [
      1465, 1465, 1467, 1468, 1470, 1471, 1472, 1474, 1476, 1477, 1478, 1479, 1480, 1481, 1483, 1483, 1484, 1485, 1486,
      1486, 1487, 1489, 1490, 1491, 1492, 1493, 1494,
    ],
  ],
  [
    '664046491',
    '139986',
    'Ballard Wallingford',
    [
      1490, 1490, 1492, 1493, 1495, 1496, 1497, 1499, 1501, 1502, 1503, 1504, 1505, 1506, 1508, 1508, 1509, 1510, 1511,
      1511, 1512, 1514, 1515, 1516, 1517, 1518, 1519,
    ],
  ],
  [
    '664046511',
    '139986',
    'Ballard Wallingford',
    [
      1535, 1535, 1537, 1538, 1540, 1541, 1542, 1544, 1545, 1546, 1547, 1548, 1548, 1549, 1551, 1551, 1552, 1553, 1554,
      1554, 1555, 1557, 1558, 1559, 1560, 1561, 1562,
    ],
  ],
  [
    '664046551',
    '139986',
    'Ballard Wallingford',
    [
      1275, 1275, 1277, 1279, 1280, 1282, 1283, 1285, 1287, 1288, 1290, 1291, 1292, 1293, 1295, 1295, 1296, 1297, 1298,
      1298, 1299, 1301, 1302, 1303, 1304, 1306, 1307,
    ],
  ],
  [
    '664046571',
    '139986',
    'Ballard Wallingford',
    [
      1305, 1305, 1307, 1309, 1310, 1312, 1313, 1315, 1317, 1318, 1320, 1321, 1322, 1323, 1325, 1325, 1326, 1327, 1328,
      1328, 1329, 1331, 1332, 1333, 1334, 1336, 1337,
    ],
  ],
  [
    '664046581',
    '139986',
    'Ballard Wallingford',
    [
      1405, 1405, 1407, 1409, 1410, 1412, 1413, 1415, 1417, 1418, 1419, 1420, 1421, 1422, 1424, 1424, 1425, 1426, 1427,
      1427, 1428, 1430, 1431, 1432, 1433, 1434, 1435,
    ],
  ],
  [
    '664046591',
    '139986',
    'Ballard Wallingford',
    [
      1290, 1290, 1292, 1294, 1295, 1297, 1298, 1300, 1302, 1303, 1305, 1306, 1307, 1308, 1310, 1310, 1311, 1312, 1313,
      1313, 1314, 1316, 1317, 1318, 1319, 1321, 1322,
    ],
  ],
  [
    '664046631',
    '139986',
    'Ballard Wallingford',
    [
      1365, 1365, 1367, 1369, 1370, 1372, 1373, 1375, 1377, 1378, 1379, 1380, 1381, 1382, 1384, 1384, 1385, 1386, 1387,
      1387, 1388, 1390, 1391, 1392, 1393, 1394, 1395,
    ],
  ],
  [
    '664046641',
    '139986',
    'Ballard Wallingford',
    [
      1445, 1445, 1447, 1448, 1450, 1451, 1452, 1454, 1456, 1457, 1458, 1459, 1460, 1461, 1463, 1463, 1464, 1465, 1466,
      1466, 1467, 1469, 1470, 1471, 1472, 1473, 1474,
    ],
  ],
  [
    '664046651',
    '139986',
    'Ballard Wallingford',
    [
      1385, 1385, 1387, 1389, 1390, 1392, 1393, 1395, 1397, 1398, 1399, 1400, 1401, 1402, 1404, 1404, 1405, 1406, 1407,
      1407, 1408, 1410, 1411, 1412, 1413, 1414, 1415,
    ],
  ],
  [
    '664046691',
    '139986',
    'Ballard Wallingford',
    [
      1210, 1212, 1214, 1215, 1217, 1218, 1220, 1222, 1223, 1225, 1226, 1227, 1228, 1230, 1231, 1231, 1232, 1233, 1234,
      1235, 1236, 1238, 1239, 1240, 1242, 1243,
    ],
  ],
  [
    '664046761',
    '139986',
    'Ballard Wallingford',
    [
      1116, 1117, 1119, 1121, 1122, 1124, 1126, 1128, 1130, 1132, 1133, 1135, 1136, 1137, 1139, 1140, 1141, 1142, 1143,
      1144, 1145, 1147, 1148, 1150, 1152, 1153, 1155,
    ],
  ],
  [
    '664046821',
    '139986',
    'Ballard Wallingford',
    [
      1064, 1065, 1067, 1069, 1071, 1073, 1075, 1077, 1079, 1081, 1082, 1084, 1085, 1086, 1089, 1090, 1091, 1092, 1093,
      1094, 1096, 1098, 1099, 1101, 1103, 1104, 1106,
    ],
  ],
  [
    '664046841',
    '139986',
    'Ballard Wallingford',
    [
      1024, 1025, 1027, 1029, 1031, 1033, 1035, 1037, 1039, 1041, 1042, 1044, 1045, 1046, 1049, 1050, 1051, 1052, 1053,
      1054, 1056, 1058, 1059, 1061, 1063, 1064, 1066,
    ],
  ],
  [
    '664046881',
    '139986',
    'Ballard Wallingford',
    [
      1104, 1105, 1107, 1109, 1110, 1112, 1114, 1116, 1118, 1120, 1121, 1123, 1124, 1125, 1127, 1128, 1129, 1130, 1131,
      1132, 1133, 1135, 1136, 1138, 1140, 1141, 1143,
    ],
  ],
  [
    '664046891',
    '139986',
    'Ballard Wallingford',
    [
      995, 996, 998, 1000, 1002, 1004, 1006, 1008, 1010, 1012, 1013, 1015, 1016, 1017, 1020, 1021, 1022, 1023, 1024,
      1025, 1027, 1029, 1030, 1032, 1034, 1035, 1037,
    ],
  ],
  [
    '664046931',
    '139986',
    'Ballard Wallingford',
    [
      946, 948, 950, 952, 954, 956, 958, 960, 962, 963, 965, 966, 967, 969, 970, 971, 972, 973, 974, 976, 978, 979, 981,
      982, 984, 985,
    ],
  ],
  [
    '664046941',
    '139986',
    'Ballard Wallingford',
    [
      985, 986, 988, 990, 992, 994, 996, 998, 1000, 1002, 1003, 1005, 1006, 1007, 1010, 1011, 1012, 1013, 1014, 1015,
      1017, 1019, 1020, 1022, 1024, 1025, 1027,
    ],
  ],
  [
    '664046951',
    '139986',
    'Ballard Wallingford',
    [
      909, 911, 913, 915, 917, 919, 921, 923, 924, 926, 927, 928, 929, 931, 932, 933, 934, 935, 936, 937, 939, 940, 942,
      943, 945, 946,
    ],
  ],
  [
    '664046971',
    '139986',
    'Ballard Wallingford',
    [
      875, 876, 878, 880, 881, 883, 885, 887, 889, 890, 892, 893, 894, 895, 898, 899, 899, 901, 901, 902, 903, 905, 907,
      908, 910, 911, 913,
    ],
  ],
  [
    '664046981',
    '139986',
    'Ballard Wallingford',
    [
      965, 966, 968, 970, 972, 974, 976, 978, 980, 982, 983, 985, 986, 987, 990, 991, 992, 993, 994, 995, 997, 999,
      1000, 1002, 1004, 1005, 1007,
    ],
  ],
  [
    '664047021',
    '139986',
    'Ballard Wallingford',
    [
      1086, 1087, 1089, 1091, 1092, 1094, 1096, 1098, 1100, 1102, 1103, 1105, 1106, 1107, 1110, 1111, 1112, 1113, 1114,
      1115, 1116, 1118, 1119, 1121, 1123, 1124, 1126,
    ],
  ],
  [
    '664047041',
    '139986',
    'Ballard Wallingford',
    [
      851, 852, 854, 856, 857, 859, 861, 863, 865, 866, 868, 869, 870, 871, 874, 875, 875, 877, 877, 878, 879, 881, 883,
      884, 886, 887, 889,
    ],
  ],
  [
    '664047081',
    '139986',
    'Ballard Wallingford',
    [
      886, 888, 890, 892, 894, 896, 898, 900, 901, 903, 904, 905, 906, 908, 909, 910, 911, 912, 913, 914, 916, 917, 919,
      920, 922, 923,
    ],
  ],
  [
    '664047091',
    '139986',
    'Ballard Wallingford',
    [
      767, 768, 770, 772, 773, 775, 777, 779, 781, 782, 784, 785, 786, 787, 789, 790, 790, 792, 792, 793, 794, 796, 798,
      799, 801, 802, 804,
    ],
  ],
  [
    '664047191',
    '139986',
    'Ballard Wallingford',
    [
      1186, 1187, 1189, 1191, 1192, 1194, 1195, 1197, 1199, 1200, 1202, 1203, 1204, 1205, 1207, 1208, 1208, 1209, 1210,
      1211, 1212, 1213, 1215, 1216, 1218, 1219, 1221,
    ],
  ],
  [
    '664047221',
    '139986',
    'Ballard Wallingford',
    [
      1075, 1076, 1078, 1080, 1082, 1084, 1086, 1088, 1090, 1092, 1093, 1095, 1096, 1097, 1100, 1101, 1102, 1103, 1104,
      1105, 1106, 1108, 1109, 1111, 1113, 1114, 1116,
    ],
  ],
  [
    '664047231',
    '139986',
    'Ballard Wallingford',
    [
      955, 956, 958, 960, 962, 964, 966, 968, 970, 972, 973, 975, 976, 977, 980, 981, 982, 983, 984, 985, 987, 989, 990,
      992, 994, 995, 997,
    ],
  ],
  [
    '664047271',
    '139986',
    'Ballard Wallingford',
    [
      589, 589, 591, 593, 594, 596, 597, 599, 601, 602, 604, 605, 606, 607, 609, 610, 610, 611, 612, 613, 614, 615, 617,
      618, 620, 621, 623,
    ],
  ],
  [
    '664047281',
    '139986',
    'Ballard Wallingford',
    [
      1034, 1035, 1037, 1039, 1041, 1043, 1045, 1047, 1049, 1051, 1052, 1054, 1055, 1056, 1059, 1060, 1061, 1062, 1063,
      1064, 1066, 1068, 1069, 1071, 1073, 1074, 1076,
    ],
  ],
  [
    '664047321',
    '139986',
    'Ballard Wallingford',
    [
      731, 732, 734, 736, 737, 739, 741, 743, 745, 746, 748, 749, 750, 751, 753, 754, 754, 756, 756, 757, 758, 760, 762,
      763, 765, 766, 768,
    ],
  ],
  [
    '664047331',
    '139986',
    'Ballard Wallingford',
    [
      695, 696, 698, 700, 701, 703, 705, 707, 709, 710, 712, 713, 714, 715, 717, 718, 718, 720, 720, 721, 722, 724, 726,
      727, 729, 730, 732,
    ],
  ],
  [
    '664047341',
    '139986',
    'Ballard Wallingford',
    [
      623, 623, 625, 627, 628, 630, 631, 633, 635, 636, 638, 639, 640, 641, 643, 644, 644, 646, 646, 647, 648, 650, 652,
      653, 655, 656, 658,
    ],
  ],
  [
    '664047351',
    '139986',
    'Ballard Wallingford',
    [
      803, 804, 806, 808, 809, 811, 813, 815, 817, 818, 820, 821, 822, 823, 825, 826, 826, 828, 828, 829, 830, 832, 834,
      835, 837, 838, 840,
    ],
  ],
  [
    '664047371',
    '139986',
    'Ballard Wallingford',
    [
      915, 916, 918, 920, 921, 923, 925, 927, 929, 931, 932, 934, 935, 936, 939, 940, 941, 942, 943, 944, 945, 947, 948,
      950, 952, 953, 955,
    ],
  ],
  [
    '664047391',
    '139986',
    'Ballard Wallingford',
    [
      839, 840, 842, 844, 845, 847, 849, 851, 853, 854, 856, 857, 858, 859, 862, 863, 863, 865, 865, 866, 867, 869, 871,
      872, 874, 875, 877,
    ],
  ],
  [
    '664047401',
    '139986',
    'Ballard Wallingford',
    [
      743, 744, 746, 748, 749, 751, 753, 755, 757, 758, 760, 761, 762, 763, 765, 766, 766, 768, 768, 769, 770, 772, 774,
      775, 777, 778, 780,
    ],
  ],
  [
    '664047411',
    '139986',
    'Ballard Wallingford',
    [
      1345, 1345, 1347, 1349, 1350, 1352, 1353, 1355, 1357, 1358, 1359, 1360, 1361, 1362, 1364, 1364, 1365, 1366, 1367,
      1367, 1368, 1370, 1371, 1372, 1373, 1374, 1375,
    ],
  ],
  [
    '664047421',
    '139986',
    'Ballard Wallingford',
    [
      635, 635, 637, 639, 640, 642, 643, 645, 647, 648, 650, 651, 652, 653, 655, 656, 656, 658, 658, 659, 660, 662, 664,
      665, 667, 668, 670,
    ],
  ],
  [
    '664047461',
    '139986',
    'Ballard Wallingford',
    [
      1151, 1152, 1154, 1156, 1157, 1159, 1161, 1163, 1165, 1166, 1168, 1169, 1170, 1171, 1173, 1174, 1174, 1175, 1176,
      1177, 1178, 1179, 1181, 1182, 1184, 1185, 1187,
    ],
  ],
  [
    '664047471',
    '139986',
    'Ballard Wallingford',
    [
      1245, 1245, 1247, 1249, 1250, 1252, 1253, 1255, 1257, 1258, 1260, 1261, 1262, 1263, 1265, 1265, 1266, 1267, 1268,
      1268, 1269, 1271, 1272, 1273, 1274, 1276, 1277,
    ],
  ],
  [
    '664047491',
    '139986',
    'Ballard Wallingford',
    [
      558, 560, 562, 563, 565, 566, 568, 570, 571, 573, 574, 575, 576, 578, 579, 579, 580, 581, 582, 583, 584, 586, 587,
      588, 590, 591,
    ],
  ],
  [
    '664047501',
    '139986',
    'Ballard Wallingford',
    [
      659, 659, 661, 663, 664, 666, 667, 669, 671, 672, 674, 675, 676, 677, 679, 680, 680, 682, 682, 683, 684, 686, 688,
      689, 691, 692, 694,
    ],
  ],
  [
    '664047531',
    '139986',
    'Ballard Wallingford',
    [
      520, 522, 524, 526, 528, 529, 531, 533, 534, 536, 537, 538, 539, 541, 542, 542, 543, 544, 545, 546, 547, 549, 550,
      551, 553, 554,
    ],
  ],
  [
    '664047541',
    '139986',
    'Ballard Wallingford',
    [
      539, 541, 543, 544, 546, 547, 549, 551, 552, 554, 555, 556, 557, 559, 560, 560, 561, 562, 563, 564, 565, 567, 568,
      569, 571, 572,
    ],
  ],
  [
    '664047571',
    '139986',
    'Ballard Wallingford',
    [
      490, 492, 494, 496, 498, 499, 501, 503, 504, 506, 507, 508, 509, 511, 512, 512, 514, 514, 515, 516, 518, 520, 521,
      522, 524, 525,
    ],
  ],
  [
    '664047641',
    '139986',
    'Ballard Wallingford',
    [
      707, 708, 710, 712, 713, 715, 717, 719, 721, 722, 724, 725, 726, 727, 729, 730, 730, 732, 732, 733, 734, 736, 738,
      739, 741, 742, 744,
    ],
  ],
  [
    '664047651',
    '139986',
    'Ballard Wallingford',
    [
      1044, 1045, 1047, 1049, 1051, 1053, 1055, 1057, 1059, 1061, 1062, 1064, 1065, 1066, 1069, 1070, 1071, 1072, 1073,
      1074, 1076, 1078, 1079, 1081, 1083, 1084, 1086,
    ],
  ],
  [
    '664047661',
    '139986',
    'Ballard Wallingford',
    [
      599, 599, 601, 603, 604, 606, 607, 609, 611, 612, 614, 615, 616, 617, 619, 620, 620, 622, 622, 623, 624, 626, 628,
      629, 631, 632, 634,
    ],
  ],
  [
    '664047701',
    '139986',
    'Ballard Wallingford',
    [
      815, 816, 818, 820, 821, 823, 825, 827, 829, 830, 832, 833, 834, 835, 837, 838, 838, 840, 840, 841, 842, 844, 846,
      847, 849, 850, 852,
    ],
  ],
  [
    '664047711',
    '139986',
    'Ballard Wallingford',
    [
      925, 926, 928, 930, 931, 933, 935, 937, 939, 941, 942, 944, 945, 946, 949, 950, 951, 952, 953, 954, 955, 957, 958,
      960, 962, 963, 965,
    ],
  ],
  [
    '664047721',
    '139986',
    'Ballard Wallingford',
    [
      501, 501, 503, 505, 506, 508, 509, 511, 513, 514, 516, 517, 518, 519, 521, 522, 522, 523, 524, 525, 526, 527, 529,
      530, 532, 533, 535,
    ],
  ],
  [
    '664047741',
    '139986',
    'Ballard Wallingford',
    [
      1162, 1163, 1165, 1167, 1168, 1170, 1171, 1173, 1175, 1176, 1178, 1179, 1180, 1181, 1183, 1184, 1184, 1185, 1186,
      1187, 1188, 1189, 1191, 1192, 1194, 1195, 1197,
    ],
  ],
  [
    '664047751',
    '139986',
    'Ballard Wallingford',
    [
      1258, 1258, 1260, 1262, 1263, 1265, 1266, 1268, 1270, 1271, 1273, 1274, 1275, 1276, 1278, 1278, 1279, 1280, 1281,
      1281, 1282, 1284, 1285, 1286, 1287, 1289, 1290,
    ],
  ],
  [
    '664047781',
    '139986',
    'Ballard Wallingford',
    [
      421, 423, 425, 426, 428, 429, 431, 433, 434, 435, 436, 436, 437, 439, 440, 440, 441, 442, 443, 444, 445, 447, 448,
      449, 451, 452,
    ],
  ],
  [
    '664047801',
    '139986',
    'Ballard Wallingford',
    [
      1015, 1016, 1018, 1020, 1022, 1024, 1026, 1028, 1030, 1032, 1033, 1035, 1036, 1037, 1040, 1041, 1042, 1043, 1044,
      1045, 1047, 1049, 1050, 1052, 1054, 1055, 1057,
    ],
  ],
  [
    '664047831',
    '139986',
    'Ballard Wallingford',
    [
      683, 684, 686, 688, 689, 691, 693, 695, 697, 698, 700, 701, 702, 703, 705, 706, 706, 708, 708, 709, 710, 712, 714,
      715, 717, 718, 720,
    ],
  ],
  [
    '664047851',
    '139986',
    'Ballard Wallingford',
    [
      401, 403, 405, 406, 408, 409, 411, 413, 414, 415, 416, 416, 417, 419, 419, 420, 421, 422, 422, 423, 425, 426, 427,
      428, 430, 431,
    ],
  ],
  [
    '664047861',
    '139986',
    'Ballard Wallingford',
    [
      579, 579, 581, 583, 584, 586, 587, 589, 591, 592, 594, 595, 596, 597, 599, 600, 600, 601, 602, 603, 604, 605, 607,
      608, 610, 611, 613,
    ],
  ],
  [
    '664047891',
    '139986',
    'Ballard Wallingford',
    [
      1140, 1141, 1143, 1145, 1146, 1148, 1150, 1152, 1154, 1155, 1157, 1158, 1159, 1160, 1162, 1163, 1164, 1165, 1166,
      1167, 1168, 1170, 1171, 1173, 1175, 1176, 1178,
    ],
  ],
  [
    '664047911',
    '139986',
    'Ballard Wallingford',
    [
      902, 903, 905, 907, 908, 910, 912, 914, 916, 918, 919, 921, 922, 923, 926, 927, 927, 929, 929, 930, 931, 933, 935,
      936, 938, 939, 941,
    ],
  ],
  [
    '664047971',
    '139986',
    'Ballard Wallingford',
    [
      791, 792, 794, 796, 797, 799, 801, 803, 805, 806, 808, 809, 810, 811, 813, 814, 814, 816, 816, 817, 818, 820, 822,
      823, 825, 826, 828,
    ],
  ],
  [
    '664047981',
    '139986',
    'Ballard Wallingford',
    [
      481, 481, 483, 485, 486, 488, 489, 491, 493, 494, 496, 497, 498, 499, 501, 502, 502, 503, 504, 505, 506, 507, 509,
      510, 512, 513, 515,
    ],
  ],
  [
    '664047991',
    '139986',
    'Ballard Wallingford',
    [
      388, 389, 391, 392, 394, 395, 397, 399, 400, 401, 402, 402, 403, 405, 405, 406, 407, 408, 408, 409, 411, 412, 413,
      414, 416, 417,
    ],
  ],
  [
    '664048021',
    '139986',
    'Ballard Wallingford',
    [
      470, 470, 472, 474, 475, 477, 478, 480, 482, 483, 485, 486, 487, 488, 490, 491, 491, 492, 493, 494, 495, 496, 498,
      499, 501, 502, 504,
    ],
  ],
  [
    '664048051',
    '139986',
    'Ballard Wallingford',
    [
      975, 976, 978, 980, 982, 984, 986, 988, 990, 992, 993, 995, 996, 997, 1000, 1001, 1002, 1003, 1004, 1005, 1007,
      1009, 1010, 1012, 1014, 1015, 1017,
    ],
  ],
  [
    '664048061',
    '139986',
    'Ballard Wallingford',
    [
      647, 647, 649, 651, 652, 654, 655, 657, 659, 660, 662, 663, 664, 665, 667, 668, 668, 670, 670, 671, 672, 674, 676,
      677, 679, 680, 682,
    ],
  ],
  [
    '664048071',
    '139986',
    'Ballard Wallingford',
    [
      549, 549, 551, 553, 554, 556, 557, 559, 561, 562, 564, 565, 566, 567, 569, 570, 570, 571, 572, 573, 574, 575, 577,
      578, 580, 581, 583,
    ],
  ],
  [
    '664048091',
    '139986',
    'Ballard Wallingford',
    [
      450, 450, 452, 454, 455, 457, 458, 460, 462, 463, 465, 466, 467, 468, 470, 470, 471, 472, 473, 473, 474, 476, 477,
      478, 480, 481, 483,
    ],
  ],
  [
    '664048111',
    '139986',
    'Ballard Wallingford',
    [
      362, 363, 365, 366, 368, 369, 371, 372, 373, 374, 375, 375, 376, 378, 378, 379, 380, 380, 381, 382, 383, 384, 385,
      386, 388, 389,
    ],
  ],
  [
    '664048141',
    '139986',
    'Ballard Wallingford',
    [
      755, 756, 758, 760, 761, 763, 765, 767, 769, 770, 772, 773, 774, 775, 777, 778, 778, 780, 780, 781, 782, 784, 786,
      787, 789, 790, 792,
    ],
  ],
  [
    '664048221',
    '139986',
    'Ballard Wallingford',
    [
      1094, 1095, 1097, 1099, 1100, 1102, 1104, 1106, 1108, 1110, 1111, 1113, 1114, 1115, 1118, 1119, 1120, 1121, 1122,
      1123, 1124, 1126, 1127, 1129, 1131, 1132, 1134,
    ],
  ],
  [
    '664048231',
    '139986',
    'Ballard Wallingford',
    [
      863, 864, 866, 868, 869, 871, 873, 875, 877, 878, 880, 881, 882, 883, 886, 887, 887, 889, 889, 890, 891, 893, 895,
      896, 898, 899, 901,
    ],
  ],
  [
    '664048291',
    '139986',
    'Ballard Wallingford',
    [
      531, 531, 533, 535, 536, 538, 539, 541, 543, 544, 546, 547, 548, 549, 551, 552, 552, 553, 554, 555, 556, 557, 559,
      560, 562, 563, 565,
    ],
  ],
  [
    '664048301',
    '139986',
    'Ballard Wallingford',
    [
      431, 431, 433, 434, 436, 437, 438, 440, 442, 443, 445, 446, 447, 448, 450, 450, 451, 452, 453, 453, 454, 456, 457,
      458, 460, 461, 463,
    ],
  ],
  [
    '664048321',
    '139986',
    'Ballard Wallingford',
    [
      339, 340, 342, 343, 345, 346, 347, 348, 349, 350, 351, 351, 352, 354, 354, 355, 356, 356, 357, 358, 359, 360, 361,
      362, 364, 365,
    ],
  ],
  [
    '664048351',
    '139986',
    'Ballard Wallingford',
    [
      611, 611, 613, 615, 616, 618, 619, 621, 623, 624, 626, 627, 628, 629, 631, 632, 632, 634, 634, 635, 636, 638, 640,
      641, 643, 644, 646,
    ],
  ],
  [
    '664048361',
    '139986',
    'Ballard Wallingford',
    [
      511, 511, 513, 515, 516, 518, 519, 521, 523, 524, 526, 527, 528, 529, 531, 532, 532, 533, 534, 535, 536, 537, 539,
      540, 542, 543, 545,
    ],
  ],
  [
    '664048421',
    '139986',
    'Ballard Wallingford',
    [
      935, 936, 938, 940, 942, 944, 946, 948, 950, 952, 953, 955, 956, 957, 960, 961, 962, 963, 964, 965, 967, 969, 970,
      972, 974, 975, 977,
    ],
  ],
  [
    '664048431',
    '139986',
    'Ballard Wallingford',
    [
      827, 828, 830, 832, 833, 835, 837, 839, 841, 842, 844, 845, 846, 847, 850, 851, 851, 853, 853, 854, 855, 857, 859,
      860, 862, 863, 865,
    ],
  ],
  [
    '664048471',
    '139986',
    'Ballard Wallingford',
    [
      719, 720, 722, 724, 725, 727, 729, 731, 733, 734, 736, 737, 738, 739, 741, 742, 742, 744, 744, 745, 746, 748, 750,
      751, 753, 754, 756,
    ],
  ],
  [
    '664048481',
    '139986',
    'Ballard Wallingford',
    [
      411, 411, 413, 414, 416, 417, 418, 420, 422, 423, 424, 425, 426, 427, 429, 429, 430, 431, 432, 432, 433, 435, 436,
      437, 439, 440, 442,
    ],
  ],
  [
    '664048491',
    '139986',
    'Ballard Wallingford',
    [
      324, 325, 327, 328, 330, 331, 332, 333, 334, 335, 336, 336, 337, 339, 339, 340, 341, 341, 342, 343, 344, 345, 346,
      347, 348, 349,
    ],
  ],
  [
    '664048501',
    '139986',
    'Ballard Wallingford',
    [
      1054, 1055, 1057, 1059, 1061, 1063, 1065, 1067, 1069, 1071, 1072, 1074, 1075, 1076, 1079, 1080, 1081, 1082, 1083,
      1084, 1086, 1088, 1089, 1091, 1093, 1094, 1096,
    ],
  ],
  [
    '664048531',
    '139986',
    'Ballard Wallingford',
    [
      394, 394, 396, 397, 399, 400, 401, 403, 404, 405, 406, 407, 408, 409, 411, 411, 412, 413, 413, 414, 415, 416, 417,
      418, 419, 421, 422,
    ],
  ],
  [
    '664048551',
    '139986',
    'Ballard Wallingford',
    [
      314, 315, 317, 318, 320, 321, 322, 323, 324, 325, 326, 326, 327, 329, 329, 330, 331, 331, 332, 333, 334, 335, 336,
      337, 338, 339,
    ],
  ],
  [
    '664048581',
    '139986',
    'Ballard Wallingford',
    [
      368, 368, 370, 371, 373, 374, 375, 377, 378, 379, 380, 381, 382, 383, 385, 385, 386, 387, 387, 388, 389, 390, 391,
      392, 393, 395, 396,
    ],
  ],
  [
    '664048631',
    '139986',
    'Ballard Wallingford',
    [
      895, 896, 898, 900, 901, 903, 905, 907, 909, 910, 912, 913, 914, 915, 918, 919, 919, 921, 921, 922, 923, 925, 927,
      928, 930, 931, 933,
    ],
  ],
  [
    '664048641',
    '139986',
    'Ballard Wallingford',
    [
      1325, 1325, 1327, 1329, 1330, 1332, 1333, 1335, 1337, 1338, 1340, 1341, 1342, 1343, 1345, 1345, 1346, 1347, 1348,
      1348, 1349, 1351, 1352, 1353, 1354, 1355, 1356,
    ],
  ],
  [
    '664048651',
    '139986',
    'Ballard Wallingford',
    [
      1230, 1230, 1232, 1234, 1235, 1237, 1238, 1240, 1242, 1243, 1245, 1246, 1247, 1248, 1250, 1251, 1251, 1252, 1253,
      1254, 1255, 1256, 1258, 1259, 1260, 1262, 1263,
    ],
  ],
  [
    '664048661',
    '139986',
    'Ballard Wallingford',
    [
      460, 460, 462, 464, 465, 467, 468, 470, 472, 473, 475, 476, 477, 478, 480, 480, 481, 482, 483, 483, 484, 486, 487,
      488, 490, 491, 493,
    ],
  ],
  [
    '664048671',
    '139986',
    'Ballard Wallingford',
    [
      671, 671, 673, 675, 676, 678, 679, 681, 683, 684, 686, 687, 688, 689, 691, 692, 692, 694, 694, 695, 696, 698, 700,
      701, 703, 704, 706,
    ],
  ],
  [
    '664048691',
    '139986',
    'Ballard Wallingford',
    [
      779, 780, 782, 784, 785, 787, 789, 791, 793, 794, 796, 797, 798, 799, 801, 802, 802, 804, 804, 805, 806, 808, 810,
      811, 813, 814, 816,
    ],
  ],
  [
    '664048701',
    '139986',
    'Ballard Wallingford',
    [
      1005, 1006, 1008, 1010, 1012, 1014, 1016, 1018, 1020, 1022, 1023, 1025, 1026, 1027, 1030, 1031, 1032, 1033, 1034,
      1035, 1037, 1039, 1040, 1042, 1044, 1045, 1047,
    ],
  ],
  [
    '664048711',
    '139986',
    'Ballard Wallingford',
    [
      1128, 1129, 1131, 1133, 1134, 1136, 1138, 1140, 1142, 1143, 1145, 1146, 1147, 1148, 1150, 1151, 1152, 1153, 1154,
      1155, 1156, 1158, 1159, 1161, 1163, 1164, 1166,
    ],
  ],
  [
    '664048741',
    '139986',
    'Ballard Wallingford',
    [
      1425, 1425, 1427, 1428, 1430, 1431, 1432, 1434, 1436, 1437, 1438, 1439, 1440, 1441, 1443, 1443, 1444, 1445, 1446,
      1446, 1447, 1449, 1450, 1451, 1452, 1453, 1454,
    ],
  ],
  [
    '664048771',
    '139986',
    'Ballard Wallingford',
    [
      569, 569, 571, 573, 574, 576, 577, 579, 581, 582, 584, 585, 586, 587, 589, 590, 590, 591, 592, 593, 594, 595, 597,
      598, 600, 601, 603,
    ],
  ],
  [
    '664048821',
    '139986',
    'Ballard Wallingford',
    [
      290, 291, 293, 294, 296, 297, 298, 299, 300, 301, 302, 302, 303, 305, 305, 306, 307, 307, 308, 309, 310, 311, 312,
      313, 314, 315,
    ],
  ],
  [
    '664048851',
    '139986',
    'Ballard Wallingford',
    [
      441, 441, 443, 444, 446, 447, 448, 450, 452, 453, 455, 456, 457, 458, 460, 460, 461, 462, 463, 463, 464, 466, 467,
      468, 470, 471, 473,
    ],
  ],
  [
    '664048861',
    '139986',
    'Ballard Wallingford',
    [
      348, 348, 350, 351, 353, 354, 355, 357, 358, 359, 360, 361, 362, 363, 365, 365, 366, 367, 367, 368, 369, 370, 371,
      372, 373, 375, 376,
    ],
  ],
  [
    '664048901',
    '139986',
    'Ballard Wallingford',
    [
      272, 273, 275, 276, 278, 279, 280, 281, 282, 283, 284, 284, 285, 287, 287, 288, 289, 289, 290, 291, 292, 293, 294,
      295, 296, 297,
    ],
  ],
  [
    '686456791',
    '139986',
    'Ballard Wallingford',
    [
      379, 380, 382, 383, 385, 386, 388, 390, 391, 392, 393, 393, 394, 396, 396, 397, 398, 399, 399, 400, 402, 403, 404,
      405, 407, 408,
    ],
  ],
  [
    '694058771',
    '139986',
    'Ballard Wallingford',
    [
      1197, 1198, 1200, 1202, 1203, 1205, 1206, 1208, 1210, 1211, 1213, 1214, 1215, 1216, 1218, 1219, 1219, 1220, 1221,
      1222, 1223, 1224, 1226, 1227, 1229, 1230, 1232,
    ],
  ],
  [
    '694058781',
    '139986',
    'Ballard Wallingford',
    [
      1173, 1175, 1177, 1179, 1181, 1183, 1185, 1187, 1189, 1190, 1192, 1193, 1194, 1196, 1197, 1197, 1198, 1199, 1200,
      1201, 1202, 1204, 1205, 1206, 1208, 1209,
    ],
  ],
  [
    '634036241',
    '27238',
    'Ballard Wallingford',
    [
      1171, 1171, 1173, 1174, 1176, 1177, 1178, 1180, 1182, 1183, 1185, 1186, 1187, 1188, 1190, 1191, 1191, 1193, 1193,
      1194, 1195, 1197, 1199, 1200, 1201, 1202, 1203,
    ],
  ],
  [
    '634036291',
    '27238',
    'Ballard Wallingford',
    [
      1140, 1140, 1142, 1143, 1145, 1146, 1147, 1149, 1151, 1152, 1154, 1155, 1156, 1157, 1160, 1161, 1161, 1163, 1163,
      1164, 1165, 1167, 1169, 1170, 1171, 1173, 1174,
    ],
  ],
  [
    '634036311',
    '27238',
    'Ballard Wallingford',
    [
      1427, 1427, 1429, 1430, 1432, 1433, 1434, 1436, 1438, 1439, 1441, 1442, 1442, 1443, 1445, 1446, 1446, 1447, 1448,
      1449, 1450, 1451, 1453, 1454, 1455, 1456, 1457,
    ],
  ],
  [
    '634036331',
    '27238',
    'Ballard Wallingford',
    [
      1327, 1327, 1329, 1330, 1332, 1333, 1334, 1336, 1338, 1339, 1341, 1342, 1342, 1343, 1345, 1346, 1346, 1347, 1348,
      1349, 1350, 1351, 1353, 1354, 1355, 1356, 1357,
    ],
  ],
  [
    '634036341',
    '27238',
    'Ballard Wallingford',
    [
      975, 975, 977, 979, 980, 982, 983, 985, 987, 988, 990, 991, 992, 993, 996, 997, 997, 999, 999, 1000, 1001, 1003,
      1005, 1006, 1007, 1009, 1010,
    ],
  ],
  [
    '634036361',
    '27238',
    'Ballard Wallingford',
    [
      1035, 1035, 1037, 1039, 1040, 1042, 1043, 1045, 1047, 1048, 1050, 1051, 1052, 1053, 1056, 1057, 1057, 1059, 1059,
      1060, 1061, 1063, 1065, 1066, 1067, 1069, 1070,
    ],
  ],
  [
    '634036391',
    '27238',
    'Ballard Wallingford',
    [
      1232, 1232, 1234, 1235, 1237, 1238, 1239, 1241, 1243, 1244, 1246, 1247, 1248, 1249, 1251, 1252, 1252, 1253, 1254,
      1255, 1256, 1257, 1259, 1260, 1261, 1262, 1263,
    ],
  ],
  [
    '634036401',
    '27238',
    'Ballard Wallingford',
    [
      1080, 1080, 1082, 1084, 1085, 1087, 1088, 1090, 1092, 1093, 1095, 1096, 1097, 1098, 1101, 1102, 1102, 1104, 1104,
      1105, 1106, 1108, 1110, 1111, 1112, 1114, 1115,
    ],
  ],
  [
    '634036421',
    '27238',
    'Ballard Wallingford',
    [
      1560, 1560, 1561, 1563, 1564, 1565, 1566, 1568, 1570, 1571, 1572, 1573, 1573, 1574, 1576, 1577, 1577, 1578, 1579,
      1580, 1581, 1582, 1584, 1585, 1586, 1587, 1588,
    ],
  ],
  [
    '634036461',
    '27238',
    'Ballard Wallingford',
    [
      1680, 1680, 1681, 1683, 1684, 1685, 1686, 1688, 1690, 1691, 1692, 1693, 1693, 1694, 1696, 1696, 1697, 1698, 1698,
      1699, 1700, 1701, 1702, 1703, 1704, 1705, 1706,
    ],
  ],
  [
    '634036571',
    '27238',
    'Ballard Wallingford',
    [
      930, 930, 932, 934, 935, 937, 938, 940, 942, 943, 945, 946, 947, 948, 951, 952, 952, 954, 954, 955, 956, 958, 960,
      961, 962, 964, 965,
    ],
  ],
  [
    '634036611',
    '27238',
    'Ballard Wallingford',
    [
      870, 870, 872, 874, 875, 877, 879, 881, 883, 884, 886, 887, 888, 889, 892, 893, 893, 895, 895, 896, 897, 899, 901,
      902, 903, 905, 906,
    ],
  ],
  [
    '634036631',
    '27238',
    'Ballard Wallingford',
    [
      825, 825, 827, 828, 830, 831, 833, 835, 837, 838, 840, 841, 842, 843, 846, 847, 847, 849, 849, 850, 851, 853, 855,
      856, 857, 859, 860,
    ],
  ],
  [
    '634036661',
    '27238',
    'Ballard Wallingford',
    [
      765, 765, 767, 768, 770, 771, 773, 775, 777, 778, 780, 781, 782, 783, 786, 787, 787, 789, 789, 790, 791, 793, 795,
      796, 797, 799, 800,
    ],
  ],
  [
    '634036691',
    '27238',
    'Ballard Wallingford',
    [
      720, 720, 722, 723, 725, 726, 727, 729, 731, 732, 734, 735, 736, 737, 740, 741, 741, 743, 743, 744, 745, 747, 749,
      750, 751, 753, 754,
    ],
  ],
  [
    '634036751',
    '27238',
    'Ballard Wallingford',
    [
      630, 630, 632, 633, 635, 636, 637, 639, 641, 642, 644, 645, 646, 647, 650, 651, 651, 652, 653, 654, 655, 656, 658,
      659, 660, 662, 663,
    ],
  ],
  [
    '634036821',
    '27238',
    'Ballard Wallingford',
    [
      1447, 1447, 1448, 1450, 1451, 1452, 1453, 1455, 1457, 1458, 1459, 1460, 1460, 1461, 1463, 1464, 1464, 1465, 1466,
      1467, 1468, 1469, 1471, 1472, 1473, 1474, 1475,
    ],
  ],
  [
    '634036841',
    '27238',
    'Ballard Wallingford',
    [
      1247, 1247, 1249, 1250, 1252, 1253, 1254, 1256, 1258, 1259, 1261, 1262, 1263, 1264, 1266, 1267, 1267, 1268, 1269,
      1270, 1271, 1272, 1274, 1275, 1276, 1277, 1278,
    ],
  ],
  [
    '634036871',
    '27238',
    'Ballard Wallingford',
    [
      1347, 1347, 1349, 1350, 1352, 1353, 1354, 1356, 1358, 1359, 1361, 1362, 1362, 1363, 1365, 1366, 1366, 1367, 1368,
      1369, 1370, 1371, 1373, 1374, 1375, 1376, 1377,
    ],
  ],
  [
    '634036881',
    '27238',
    'Ballard Wallingford',
    [
      855, 855, 857, 858, 860, 861, 863, 865, 867, 868, 870, 871, 872, 873, 876, 877, 877, 879, 879, 880, 881, 883, 885,
      886, 887, 889, 890,
    ],
  ],
  [
    '634036891',
    '27238',
    'Ballard Wallingford',
    [
      750, 750, 752, 753, 755, 756, 758, 760, 762, 763, 765, 766, 767, 768, 771, 772, 772, 774, 774, 775, 776, 778, 780,
      781, 782, 784, 785,
    ],
  ],
  [
    '634036901',
    '27238',
    'Ballard Wallingford',
    [
      570, 570, 572, 573, 575, 576, 577, 579, 581, 582, 584, 585, 586, 587, 590, 590, 591, 592, 593, 593, 594, 596, 597,
      598, 599, 601, 602,
    ],
  ],
  [
    '634036931',
    '27238',
    'Ballard Wallingford',
    [
      484, 485, 487, 488, 489, 490, 492, 494, 495, 496, 497, 498, 499, 501, 501, 502, 503, 504, 504, 505, 507, 508, 509,
      510, 511, 512,
    ],
  ],
  [
    '634036951',
    '27238',
    'Ballard Wallingford',
    [
      960, 960, 962, 964, 965, 967, 968, 970, 972, 973, 975, 976, 977, 978, 981, 982, 982, 984, 984, 985, 986, 988, 990,
      991, 992, 994, 995,
    ],
  ],
  [
    '634037001',
    '27238',
    'Ballard Wallingford',
    [
      654, 654, 656, 657, 659, 660, 661, 663, 665, 666, 668, 669, 670, 671, 674, 675, 675, 676, 677, 678, 679, 680, 682,
      683, 684, 686, 687,
    ],
  ],
  [
    '634037031',
    '27238',
    'Ballard Wallingford',
    [
      1065, 1065, 1067, 1069, 1070, 1072, 1073, 1075, 1077, 1078, 1080, 1081, 1082, 1083, 1086, 1087, 1087, 1089, 1089,
      1090, 1091, 1093, 1095, 1096, 1097, 1099, 1100,
    ],
  ],
  [
    '634037171',
    '27238',
    'Ballard Wallingford',
    [
      1125, 1125, 1127, 1128, 1130, 1131, 1132, 1134, 1136, 1137, 1139, 1140, 1141, 1142, 1145, 1146, 1146, 1148, 1148,
      1149, 1150, 1152, 1154, 1155, 1156, 1158, 1159,
    ],
  ],
  [
    '634037181',
    '27238',
    'Ballard Wallingford',
    [
      1217, 1217, 1219, 1220, 1222, 1223, 1224, 1226, 1228, 1229, 1231, 1232, 1233, 1234, 1236, 1237, 1237, 1238, 1239,
      1240, 1241, 1242, 1244, 1245, 1246, 1247, 1248,
    ],
  ],
  [
    '634037191',
    '27238',
    'Ballard Wallingford',
    [
      1407, 1407, 1409, 1410, 1412, 1413, 1414, 1416, 1418, 1419, 1421, 1422, 1422, 1423, 1425, 1426, 1426, 1427, 1428,
      1429, 1430, 1431, 1433, 1434, 1435, 1436, 1437,
    ],
  ],
  [
    '634037211',
    '27238',
    'Ballard Wallingford',
    [
      706, 706, 708, 709, 711, 712, 713, 715, 717, 718, 720, 721, 722, 723, 726, 727, 727, 729, 729, 730, 731, 733, 735,
      736, 737, 739, 740,
    ],
  ],
  [
    '634037221',
    '27238',
    'Ballard Wallingford',
    [
      810, 810, 812, 813, 815, 816, 818, 820, 822, 823, 825, 826, 827, 828, 831, 832, 832, 834, 834, 835, 836, 838, 840,
      841, 842, 844, 845,
    ],
  ],
  [
    '634037231',
    '27238',
    'Ballard Wallingford',
    [
      618, 618, 620, 621, 623, 624, 625, 627, 629, 630, 632, 633, 634, 635, 638, 638, 639, 640, 641, 641, 642, 644, 645,
      646, 647, 649, 650,
    ],
  ],
  [
    '634037251',
    '27238',
    'Ballard Wallingford',
    [
      535, 535, 536, 538, 539, 540, 541, 543, 545, 546, 547, 548, 549, 550, 552, 552, 553, 554, 555, 555, 556, 558, 559,
      560, 561, 562, 563,
    ],
  ],
  [
    '634037311',
    '27238',
    'Ballard Wallingford',
    [
      915, 915, 917, 919, 920, 922, 923, 925, 927, 928, 930, 931, 932, 933, 936, 937, 937, 939, 939, 940, 941, 943, 945,
      946, 947, 949, 950,
    ],
  ],
  [
    '634037321',
    '27238',
    'Ballard Wallingford',
    [
      1307, 1307, 1309, 1310, 1312, 1313, 1314, 1316, 1318, 1319, 1321, 1322, 1322, 1323, 1325, 1326, 1326, 1327, 1328,
      1329, 1330, 1331, 1333, 1334, 1335, 1336, 1337,
    ],
  ],
  [
    '634037331',
    '27238',
    'Ballard Wallingford',
    [
      1020, 1020, 1022, 1024, 1025, 1027, 1028, 1030, 1032, 1033, 1035, 1036, 1037, 1038, 1041, 1042, 1042, 1044, 1044,
      1045, 1046, 1048, 1050, 1051, 1052, 1054, 1055,
    ],
  ],
  [
    '634037501',
    '27238',
    'Ballard Wallingford',
    [
      511, 511, 512, 514, 515, 516, 517, 519, 521, 522, 523, 524, 525, 526, 528, 528, 529, 530, 531, 531, 532, 534, 535,
      536, 537, 538, 539,
    ],
  ],
  [
    '634037521',
    '27238',
    'Ballard Wallingford',
    [
      595, 595, 597, 598, 600, 601, 602, 604, 606, 607, 609, 610, 611, 612, 615, 615, 616, 617, 618, 618, 619, 621, 622,
      623, 624, 626, 627,
    ],
  ],
  [
    '634037621',
    '27238',
    'Ballard Wallingford',
    [
      1110, 1110, 1112, 1113, 1115, 1116, 1117, 1119, 1121, 1122, 1124, 1125, 1126, 1127, 1130, 1131, 1131, 1133, 1133,
      1134, 1135, 1137, 1139, 1140, 1141, 1143, 1144,
    ],
  ],
  [
    '634037631',
    '27238',
    'Ballard Wallingford',
    [
      524, 524, 525, 527, 528, 529, 530, 532, 534, 535, 536, 537, 538, 539, 541, 541, 542, 543, 544, 544, 545, 547, 548,
      549, 550, 551, 552,
    ],
  ],
  [
    '634037641',
    '27238',
    'Ballard Wallingford',
    [
      439, 439, 440, 442, 443, 444, 445, 447, 449, 450, 451, 452, 452, 453, 455, 455, 456, 457, 458, 458, 459, 461, 462,
      463, 464, 465, 466,
    ],
  ],
  [
    '634037661',
    '27238',
    'Ballard Wallingford',
    [
      606, 606, 608, 609, 611, 612, 613, 615, 617, 618, 620, 621, 622, 623, 626, 626, 627, 628, 629, 629, 630, 632, 633,
      634, 635, 637, 638,
    ],
  ],
  [
    '634037701',
    '27238',
    'Ballard Wallingford',
    [
      691, 691, 693, 694, 696, 697, 698, 700, 702, 703, 705, 706, 707, 708, 711, 712, 712, 713, 714, 715, 716, 717, 719,
      720, 721, 723, 724,
    ],
  ],
  [
    '634037731',
    '27238',
    'Ballard Wallingford',
    [
      795, 795, 797, 798, 800, 801, 803, 805, 807, 808, 810, 811, 812, 813, 816, 817, 817, 819, 819, 820, 821, 823, 825,
      826, 827, 829, 830,
    ],
  ],
  [
    '634037771',
    '27238',
    'Ballard Wallingford',
    [
      900, 900, 902, 904, 905, 907, 909, 911, 913, 914, 916, 917, 918, 919, 922, 923, 923, 925, 925, 926, 927, 929, 931,
      932, 933, 935, 936,
    ],
  ],
  [
    '634037781',
    '27238',
    'Ballard Wallingford',
    [
      1387, 1387, 1389, 1390, 1392, 1393, 1394, 1396, 1398, 1399, 1401, 1402, 1402, 1403, 1405, 1406, 1406, 1407, 1408,
      1409, 1410, 1411, 1413, 1414, 1415, 1416, 1417,
    ],
  ],
  [
    '634037821',
    '27238',
    'Ballard Wallingford',
    [
      1287, 1287, 1289, 1290, 1292, 1293, 1294, 1296, 1298, 1299, 1301, 1302, 1302, 1303, 1305, 1306, 1306, 1307, 1308,
      1309, 1310, 1311, 1313, 1314, 1315, 1316, 1317,
    ],
  ],
  [
    '634037831',
    '27238',
    'Ballard Wallingford',
    [
      1005, 1005, 1007, 1009, 1010, 1012, 1013, 1015, 1017, 1018, 1020, 1021, 1022, 1023, 1026, 1027, 1027, 1029, 1029,
      1030, 1031, 1033, 1035, 1036, 1037, 1039, 1040,
    ],
  ],
  [
    '634037861',
    '27238',
    'Ballard Wallingford',
    [
      1620, 1620, 1621, 1623, 1624, 1625, 1626, 1628, 1630, 1631, 1632, 1633, 1633, 1634, 1636, 1636, 1637, 1638, 1638,
      1639, 1640, 1641, 1642, 1643, 1644, 1645, 1646,
    ],
  ],
  [
    '634037881',
    '27238',
    'Ballard Wallingford',
    [
      1500, 1500, 1501, 1503, 1504, 1505, 1506, 1508, 1510, 1511, 1512, 1513, 1513, 1514, 1516, 1517, 1517, 1518, 1519,
      1520, 1521, 1522, 1524, 1525, 1526, 1527, 1528,
    ],
  ],
  [
    '634038081',
    '27238',
    'Ballard Wallingford',
    [
      497, 497, 498, 500, 501, 502, 503, 505, 507, 508, 509, 510, 511, 512, 514, 514, 515, 516, 517, 517, 518, 520, 521,
      522, 523, 524, 525,
    ],
  ],
  [
    '634038091',
    '27238',
    'Ballard Wallingford',
    [
      409, 409, 410, 412, 413, 414, 415, 417, 419, 420, 421, 422, 422, 423, 425, 425, 426, 427, 428, 428, 429, 431, 432,
      433, 434, 435, 436,
    ],
  ],
  [
    '634038151',
    '27238',
    'Ballard Wallingford',
    [
      583, 583, 585, 586, 588, 589, 590, 592, 594, 595, 597, 598, 599, 600, 603, 603, 604, 605, 606, 606, 607, 609, 610,
      611, 612, 614, 615,
    ],
  ],
  [
    '634038161',
    '27238',
    'Ballard Wallingford',
    [
      678, 678, 680, 681, 683, 684, 685, 687, 689, 690, 692, 693, 694, 695, 698, 699, 699, 700, 701, 702, 703, 704, 706,
      707, 708, 710, 711,
    ],
  ],
  [
    '634038181',
    '27238',
    'Ballard Wallingford',
    [
      780, 780, 782, 783, 785, 786, 788, 790, 792, 793, 795, 796, 797, 798, 801, 802, 802, 804, 804, 805, 806, 808, 810,
      811, 812, 814, 815,
    ],
  ],
  [
    '634038201',
    '27238',
    'Ballard Wallingford',
    [
      885, 885, 887, 889, 890, 892, 894, 896, 898, 899, 901, 902, 903, 904, 907, 908, 908, 910, 910, 911, 912, 914, 916,
      917, 918, 920, 921,
    ],
  ],
  [
    '634038231',
    '27238',
    'Ballard Wallingford',
    [
      1367, 1367, 1369, 1370, 1372, 1373, 1374, 1376, 1378, 1379, 1381, 1382, 1382, 1383, 1385, 1386, 1386, 1387, 1388,
      1389, 1390, 1391, 1393, 1394, 1395, 1396, 1397,
    ],
  ],
  [
    '634038271',
    '27238',
    'Ballard Wallingford',
    [
      990, 990, 992, 994, 995, 997, 998, 1000, 1002, 1003, 1005, 1006, 1007, 1008, 1011, 1012, 1012, 1014, 1014, 1015,
      1016, 1018, 1020, 1021, 1022, 1024, 1025,
    ],
  ],
  [
    '634038281',
    '27238',
    'Ballard Wallingford',
    [
      1095, 1095, 1097, 1099, 1100, 1102, 1103, 1105, 1107, 1108, 1110, 1111, 1112, 1113, 1116, 1117, 1117, 1119, 1119,
      1120, 1121, 1123, 1125, 1126, 1127, 1129, 1130,
    ],
  ],
  [
    '634038301',
    '27238',
    'Ballard Wallingford',
    [
      1187, 1187, 1189, 1190, 1192, 1193, 1194, 1196, 1198, 1199, 1201, 1202, 1203, 1204, 1206, 1207, 1207, 1208, 1209,
      1210, 1211, 1212, 1214, 1215, 1216, 1217, 1218,
    ],
  ],
  [
    '634038491',
    '27238',
    'Ballard Wallingford',
    [
      387, 387, 388, 390, 391, 392, 393, 395, 397, 398, 399, 400, 400, 401, 403, 403, 404, 405, 406, 406, 407, 409, 410,
      411, 412, 413, 414,
    ],
  ],
  [
    '634038511',
    '27238',
    'Ballard Wallingford',
    [
      469, 469, 470, 472, 473, 474, 475, 477, 479, 480, 481, 482, 483, 484, 486, 486, 487, 488, 489, 489, 490, 492, 493,
      494, 495, 496, 497,
    ],
  ],
  [
    '634038531',
    '27238',
    'Ballard Wallingford',
    [
      559, 559, 560, 562, 563, 564, 565, 567, 569, 570, 571, 572, 573, 574, 577, 577, 578, 579, 580, 580, 581, 583, 584,
      585, 586, 588, 589,
    ],
  ],
  [
    '634038561',
    '27238',
    'Ballard Wallingford',
    [
      641, 641, 643, 644, 646, 647, 648, 650, 652, 653, 655, 656, 657, 658, 661, 662, 662, 663, 664, 665, 666, 667, 669,
      670, 671, 673, 674,
    ],
  ],
  [
    '634038581',
    '27238',
    'Ballard Wallingford',
    [
      840, 840, 842, 843, 845, 846, 848, 850, 852, 853, 855, 856, 857, 858, 861, 862, 862, 864, 864, 865, 866, 868, 870,
      871, 872, 874, 875,
    ],
  ],
  [
    '634038601',
    '27238',
    'Ballard Wallingford',
    [
      735, 735, 737, 738, 740, 741, 743, 745, 747, 748, 750, 751, 752, 753, 756, 757, 757, 759, 759, 760, 761, 763, 765,
      766, 767, 769, 770,
    ],
  ],
  [
    '634038621',
    '27238',
    'Ballard Wallingford',
    [
      945, 945, 947, 949, 950, 952, 953, 955, 957, 958, 960, 961, 962, 963, 966, 967, 967, 969, 969, 970, 971, 973, 975,
      976, 977, 979, 980,
    ],
  ],
  [
    '634038651',
    '27238',
    'Ballard Wallingford',
    [
      1050, 1050, 1052, 1054, 1055, 1057, 1058, 1060, 1062, 1063, 1065, 1066, 1067, 1068, 1071, 1072, 1072, 1074, 1074,
      1075, 1076, 1078, 1080, 1081, 1082, 1084, 1085,
    ],
  ],
  [
    '663971111',
    '27238',
    'Ballard Wallingford',
    [
      1267, 1267, 1269, 1270, 1272, 1273, 1274, 1276, 1278, 1279, 1281, 1282, 1283, 1284, 1286, 1287, 1287, 1288, 1289,
      1290, 1291, 1292, 1294, 1295, 1296, 1297, 1298,
    ],
  ],
  [
    '697350501',
    '27238',
    'Ballard Wallingford',
    [
      1150, 1150, 1152, 1153, 1155, 1156, 1157, 1159, 1161, 1162, 1164, 1165, 1166, 1167, 1169, 1170, 1170, 1172, 1172,
      1173, 1174, 1176, 1178, 1179, 1180, 1182, 1183,
    ],
  ],
  [
    '727421291',
    '27238',
    'Ballard Wallingford',
    [
      666, 667, 669, 670, 671, 672, 674, 676, 677, 679, 680, 681, 682, 685, 686, 686, 687, 688, 689, 690, 691, 693, 694,
      695, 697, 698,
    ],
  ],
  [
    '727421331',
    '27238',
    'Ballard Wallingford',
    [
      548, 549, 551, 552, 553, 554, 556, 558, 559, 560, 561, 562, 563, 566, 566, 567, 568, 569, 569, 570, 572, 573, 574,
      575, 577, 578,
    ],
  ],
  [
    '727421631',
    '27238',
    'Ballard Wallingford',
    [
      454, 455, 457, 458, 459, 460, 462, 464, 465, 466, 467, 468, 469, 471, 471, 472, 473, 474, 474, 475, 477, 478, 479,
      480, 481, 482,
    ],
  ],
  [
    '727421871',
    '27238',
    'Ballard Wallingford',
    [
      424, 425, 427, 428, 429, 430, 432, 434, 435, 436, 437, 437, 438, 440, 440, 441, 442, 443, 443, 444, 446, 447, 448,
      449, 450, 451,
    ],
  ],
  [
    '727422181',
    '27238',
    'Ballard Wallingford',
    [
      358, 359, 360, 361, 362, 363, 365, 367, 368, 369, 370, 370, 371, 373, 373, 374, 375, 376, 376, 377, 379, 380, 381,
      382, 383, 384,
    ],
  ],
  [
    '727422191',
    '27238',
    'Ballard Wallingford',
    [
      327, 328, 329, 330, 331, 332, 334, 336, 337, 338, 339, 339, 340, 342, 342, 343, 344, 345, 345, 346, 348, 349, 350,
      351, 352, 353,
    ],
  ],
  [
    '727422461',
    '27238',
    'Ballard Wallingford',
    [
      295, 296, 297, 298, 299, 300, 302, 304, 305, 306, 307, 307, 308, 310, 310, 311, 312, 313, 313, 314, 316, 317, 318,
      319, 320, 321,
    ],
  ],
  [
    '761056671',
    '27238',
    'Ballard Wallingford',
    [
      1202, 1203, 1205, 1206, 1207, 1208, 1210, 1212, 1213, 1215, 1216, 1217, 1218, 1220, 1221, 1221, 1222, 1223, 1224,
      1225, 1226, 1228, 1229, 1230, 1231, 1232,
    ],
  ],
  [
    '562589901',
    '28118',
    'Ballard Wallingford',
    [
      902, 902, 904, 906, 907, 909, 910, 912, 914, 915, 916, 917, 918, 919, 922, 923, 923, 925, 925, 926, 927, 929, 931,
      932, 933, 934, 935,
    ],
  ],
  [
    '562590031',
    '28118',
    'Ballard Wallingford',
    [
      389, 389, 391, 392, 394, 395, 396, 397, 398, 399, 400, 401, 401, 402, 404, 404, 405, 406, 406, 407, 408, 409, 410,
      411, 412, 413, 414,
    ],
  ],
  [
    '562590071',
    '28118',
    'Ballard Wallingford',
    [
      484, 485, 487, 488, 489, 490, 492, 494, 495, 496, 497, 497, 498, 500, 500, 501, 502, 503, 503, 504, 506, 507, 508,
      509, 510, 511,
    ],
  ],
  [
    '562590131',
    '28118',
    'Ballard Wallingford',
    [
      559, 559, 561, 563, 564, 566, 567, 569, 571, 572, 573, 574, 574, 575, 577, 577, 578, 579, 580, 580, 581, 583, 584,
      585, 586, 587, 588,
    ],
  ],
  [
    '562590171',
    '28118',
    'Ballard Wallingford',
    [
      619, 619, 621, 623, 624, 626, 627, 629, 631, 632, 633, 634, 634, 635, 637, 638, 638, 640, 640, 641, 642, 644, 646,
      647, 648, 649, 650,
    ],
  ],
  [
    '562590211',
    '28118',
    'Ballard Wallingford',
    [
      679, 679, 681, 683, 684, 686, 687, 689, 691, 692, 693, 694, 694, 695, 697, 698, 698, 700, 700, 701, 702, 704, 706,
      707, 708, 709, 710,
    ],
  ],
  [
    '562590341',
    '28118',
    'Ballard Wallingford',
    [
      1287, 1287, 1289, 1291, 1292, 1294, 1295, 1297, 1298, 1299, 1300, 1301, 1301, 1302, 1304, 1304, 1305, 1306, 1306,
      1307, 1308, 1309, 1310, 1311, 1312, 1313, 1314,
    ],
  ],
  [
    '562590351',
    '28118',
    'Ballard Wallingford',
    [
      1327, 1327, 1329, 1330, 1332, 1333, 1334, 1335, 1336, 1337, 1338, 1339, 1339, 1340, 1342, 1342, 1343, 1344, 1344,
      1345, 1346, 1347, 1348, 1349, 1350, 1351, 1352,
    ],
  ],
  [
    '562590361',
    '28118',
    'Ballard Wallingford',
    [
      1347, 1347, 1349, 1350, 1352, 1353, 1354, 1355, 1356, 1357, 1358, 1359, 1359, 1360, 1362, 1362, 1363, 1364, 1364,
      1365, 1366, 1367, 1368, 1369, 1370, 1371, 1372,
    ],
  ],
  [
    '562590371',
    '28118',
    'Ballard Wallingford',
    [
      1387, 1387, 1389, 1390, 1392, 1393, 1394, 1395, 1396, 1397, 1398, 1399, 1399, 1400, 1402, 1402, 1403, 1404, 1404,
      1405, 1406, 1407, 1408, 1409, 1410, 1411, 1412,
    ],
  ],
  [
    '562590381',
    '28118',
    'Ballard Wallingford',
    [
      1407, 1407, 1409, 1410, 1412, 1413, 1414, 1415, 1416, 1417, 1418, 1419, 1419, 1420, 1422, 1422, 1423, 1424, 1424,
      1425, 1426, 1427, 1428, 1429, 1430, 1431, 1432,
    ],
  ],
  [
    '562590391',
    '28118',
    'Ballard Wallingford',
    [
      1427, 1427, 1429, 1430, 1432, 1433, 1434, 1435, 1436, 1437, 1438, 1439, 1439, 1440, 1442, 1442, 1443, 1443, 1444,
      1444, 1445, 1446, 1447, 1448, 1449, 1450, 1451,
    ],
  ],
  [
    '562590501',
    '28118',
    'Ballard Wallingford',
    [
      1307, 1307, 1309, 1311, 1312, 1314, 1315, 1317, 1318, 1319, 1320, 1321, 1321, 1322, 1324, 1324, 1325, 1326, 1326,
      1327, 1328, 1329, 1330, 1331, 1332, 1333, 1334,
    ],
  ],
  [
    '562590511',
    '28118',
    'Ballard Wallingford',
    [
      1367, 1367, 1369, 1370, 1372, 1373, 1374, 1375, 1376, 1377, 1378, 1379, 1379, 1380, 1382, 1382, 1383, 1384, 1384,
      1385, 1386, 1387, 1388, 1389, 1390, 1391, 1392,
    ],
  ],
  [
    '605392331',
    '28118',
    'Ballard Wallingford',
    [
      1447, 1447, 1449, 1450, 1452, 1453, 1454, 1455, 1456, 1457, 1458, 1459, 1459, 1460, 1462, 1462, 1463, 1463, 1464,
      1464, 1465, 1466, 1467, 1468, 1469, 1470, 1471,
    ],
  ],
  [
    '605409691',
    '28118',
    'Ballard Wallingford',
    [
      1507, 1507, 1509, 1510, 1512, 1513, 1514, 1515, 1516, 1517, 1518, 1519, 1519, 1520, 1522, 1522, 1523, 1523, 1524,
      1524, 1525, 1526, 1527, 1528, 1529, 1530, 1531,
    ],
  ],
  [
    '605409701',
    '28118',
    'Ballard Wallingford',
    [
      1567, 1567, 1569, 1570, 1572, 1573, 1574, 1575, 1576, 1577, 1578, 1579, 1579, 1580, 1582, 1582, 1583, 1583, 1584,
      1584, 1585, 1586, 1587, 1588, 1589, 1590, 1591,
    ],
  ],
  [
    '605409711',
    '28118',
    'Ballard Wallingford',
    [
      1627, 1627, 1629, 1630, 1632, 1633, 1634, 1635, 1636, 1637, 1638, 1639, 1639, 1640, 1642, 1642, 1643, 1643, 1644,
      1644, 1645, 1646, 1647, 1648, 1649, 1650, 1651,
    ],
  ],
  [
    '605409721',
    '28118',
    'Ballard Wallingford',
    [
      1687, 1687, 1689, 1690, 1692, 1693, 1694, 1695, 1696, 1697, 1698, 1699, 1699, 1700, 1702, 1702, 1703, 1703, 1704,
      1704, 1705, 1706, 1707, 1708, 1709, 1710, 1711,
    ],
  ],
  [
    '629474701',
    '28118',
    'Ballard Wallingford',
    [
      719, 719, 721, 723, 724, 726, 727, 729, 731, 732, 733, 734, 735, 736, 738, 739, 739, 741, 741, 742, 743, 745, 747,
      748, 749, 750, 751,
    ],
  ],
  [
    '629474711',
    '28118',
    'Ballard Wallingford',
    [
      744, 744, 746, 748, 749, 751, 752, 754, 756, 757, 758, 759, 760, 761, 763, 764, 764, 766, 766, 767, 768, 770, 772,
      773, 774, 775, 776,
    ],
  ],
  [
    '629474721',
    '28118',
    'Ballard Wallingford',
    [
      757, 757, 759, 761, 762, 764, 765, 767, 769, 770, 771, 772, 773, 774, 776, 777, 777, 779, 779, 780, 781, 783, 785,
      786, 787, 788, 789,
    ],
  ],
  [
    '629474731',
    '28118',
    'Ballard Wallingford',
    [
      781, 781, 783, 785, 786, 788, 789, 791, 793, 794, 795, 796, 797, 798, 801, 802, 802, 804, 804, 805, 806, 808, 810,
      811, 812, 813, 814,
    ],
  ],
  [
    '629474741',
    '28118',
    'Ballard Wallingford',
    [
      792, 792, 794, 796, 797, 799, 800, 802, 804, 805, 806, 807, 808, 809, 812, 813, 813, 815, 815, 816, 817, 819, 821,
      822, 823, 824, 825,
    ],
  ],
  [
    '629474751',
    '28118',
    'Ballard Wallingford',
    [
      817, 817, 819, 821, 822, 824, 825, 827, 829, 830, 831, 832, 833, 834, 837, 838, 838, 840, 840, 841, 842, 844, 846,
      847, 848, 849, 850,
    ],
  ],
  [
    '629474761',
    '28118',
    'Ballard Wallingford',
    [
      853, 853, 855, 857, 858, 860, 861, 863, 865, 866, 867, 868, 869, 870, 873, 874, 874, 876, 876, 877, 878, 880, 882,
      883, 884, 885, 886,
    ],
  ],
  [
    '629474771',
    '28118',
    'Ballard Wallingford',
    [
      875, 875, 877, 879, 880, 882, 883, 885, 887, 888, 889, 890, 891, 892, 895, 896, 896, 898, 898, 899, 900, 902, 904,
      905, 906, 907, 908,
    ],
  ],
  [
    '629474781',
    '28118',
    'Ballard Wallingford',
    [
      888, 888, 890, 892, 893, 895, 896, 898, 900, 901, 902, 903, 904, 905, 908, 909, 909, 911, 911, 912, 913, 915, 917,
      918, 919, 920, 921,
    ],
  ],
  [
    '629474801',
    '28118',
    'Ballard Wallingford',
    [
      916, 916, 918, 920, 921, 923, 924, 926, 928, 929, 930, 931, 932, 933, 936, 937, 937, 939, 939, 940, 941, 943, 945,
      946, 947, 948, 949,
    ],
  ],
  [
    '629474811',
    '28118',
    'Ballard Wallingford',
    [
      931, 931, 933, 935, 936, 938, 939, 941, 943, 944, 945, 946, 947, 948, 951, 952, 952, 954, 954, 955, 956, 958, 960,
      961, 962, 963, 964,
    ],
  ],
  [
    '629474821',
    '28118',
    'Ballard Wallingford',
    [
      946, 946, 948, 950, 951, 953, 954, 956, 958, 959, 960, 961, 962, 963, 966, 967, 967, 969, 969, 970, 971, 973, 975,
      976, 977, 978, 979,
    ],
  ],
  [
    '629474831',
    '28118',
    'Ballard Wallingford',
    [
      960, 960, 962, 964, 965, 967, 968, 970, 972, 973, 974, 975, 976, 977, 980, 981, 981, 983, 983, 984, 985, 987, 989,
      990, 991, 992, 993,
    ],
  ],
  [
    '629474841',
    '28118',
    'Ballard Wallingford',
    [
      975, 975, 977, 979, 980, 982, 983, 985, 987, 988, 989, 990, 991, 992, 995, 996, 996, 998, 998, 999, 1000, 1002,
      1004, 1005, 1006, 1007, 1008,
    ],
  ],
  [
    '629474851',
    '28118',
    'Ballard Wallingford',
    [
      990, 990, 992, 994, 995, 997, 998, 1000, 1002, 1003, 1004, 1005, 1006, 1007, 1010, 1011, 1011, 1013, 1013, 1014,
      1015, 1017, 1019, 1020, 1021, 1022, 1023,
    ],
  ],
  [
    '629474861',
    '28118',
    'Ballard Wallingford',
    [
      1005, 1005, 1007, 1009, 1010, 1012, 1013, 1015, 1017, 1018, 1019, 1020, 1021, 1022, 1024, 1025, 1025, 1027, 1027,
      1028, 1029, 1031, 1033, 1034, 1035, 1036, 1037,
    ],
  ],
  [
    '629474871',
    '28118',
    'Ballard Wallingford',
    [
      1020, 1020, 1022, 1024, 1025, 1027, 1028, 1030, 1032, 1033, 1034, 1035, 1036, 1037, 1039, 1040, 1040, 1042, 1042,
      1043, 1044, 1046, 1048, 1049, 1050, 1051, 1052,
    ],
  ],
  [
    '629474881',
    '28118',
    'Ballard Wallingford',
    [
      1036, 1036, 1038, 1040, 1041, 1043, 1044, 1046, 1048, 1049, 1050, 1051, 1052, 1053, 1055, 1056, 1056, 1058, 1058,
      1059, 1060, 1062, 1064, 1065, 1066, 1067, 1068,
    ],
  ],
  [
    '629474891',
    '28118',
    'Ballard Wallingford',
    [
      1081, 1081, 1083, 1085, 1086, 1088, 1089, 1091, 1093, 1094, 1095, 1096, 1097, 1098, 1100, 1100, 1101, 1102, 1103,
      1103, 1104, 1106, 1107, 1108, 1109, 1110, 1111,
    ],
  ],
  [
    '629474931',
    '28118',
    'Ballard Wallingford',
    [
      409, 409, 411, 412, 414, 415, 416, 417, 418, 419, 420, 421, 421, 422, 424, 424, 425, 426, 426, 427, 428, 429, 430,
      431, 432, 433, 434,
    ],
  ],
  [
    '629474951',
    '28118',
    'Ballard Wallingford',
    [
      455, 456, 458, 459, 460, 461, 463, 464, 465, 466, 467, 467, 468, 470, 470, 471, 472, 473, 473, 474, 476, 477, 478,
      479, 480, 481,
    ],
  ],
  [
    '629474971',
    '28118',
    'Ballard Wallingford',
    [
      469, 469, 471, 472, 474, 475, 476, 477, 478, 479, 480, 481, 481, 482, 484, 484, 485, 486, 486, 487, 488, 489, 490,
      491, 492, 493, 494,
    ],
  ],
  [
    '629474981',
    '28118',
    'Ballard Wallingford',
    [
      514, 514, 516, 517, 519, 520, 521, 523, 524, 525, 526, 527, 527, 528, 530, 530, 531, 532, 533, 533, 534, 536, 537,
      538, 539, 540, 541,
    ],
  ],
  [
    '629474991',
    '28118',
    'Ballard Wallingford',
    [
      499, 499, 501, 502, 504, 505, 506, 508, 509, 510, 511, 512, 512, 513, 515, 515, 516, 517, 518, 518, 519, 521, 522,
      523, 524, 525, 526,
    ],
  ],
  [
    '629475001',
    '28118',
    'Ballard Wallingford',
    [
      529, 529, 531, 532, 534, 535, 536, 538, 539, 540, 541, 542, 542, 543, 545, 545, 546, 547, 548, 548, 549, 551, 552,
      553, 554, 555, 556,
    ],
  ],
  [
    '629475041',
    '28118',
    'Ballard Wallingford',
    [
      574, 574, 576, 578, 579, 581, 582, 584, 586, 587, 588, 589, 589, 590, 592, 592, 593, 594, 595, 595, 596, 598, 599,
      600, 601, 602, 603,
    ],
  ],
  [
    '629475051',
    '28118',
    'Ballard Wallingford',
    [
      604, 604, 606, 608, 609, 611, 612, 614, 616, 617, 618, 619, 619, 620, 622, 623, 623, 625, 625, 626, 627, 629, 631,
      632, 633, 634, 635,
    ],
  ],
  [
    '629475071',
    '28118',
    'Ballard Wallingford',
    [
      634, 634, 636, 638, 639, 641, 642, 644, 646, 647, 648, 649, 649, 650, 652, 653, 653, 655, 655, 656, 657, 659, 661,
      662, 663, 664, 665,
    ],
  ],
  [
    '629475091',
    '28118',
    'Ballard Wallingford',
    [
      664, 664, 666, 668, 669, 671, 672, 674, 676, 677, 678, 679, 679, 680, 682, 683, 683, 685, 685, 686, 687, 689, 691,
      692, 693, 694, 695,
    ],
  ],
  [
    '629475111',
    '28118',
    'Ballard Wallingford',
    [
      693, 693, 695, 697, 698, 700, 701, 703, 705, 706, 707, 708, 708, 709, 711, 712, 712, 714, 714, 715, 716, 718, 720,
      721, 722, 723, 724,
    ],
  ],
  [
    '629475121',
    '28118',
    'Ballard Wallingford',
    [
      706, 706, 708, 710, 711, 713, 714, 716, 718, 719, 720, 721, 722, 723, 725, 726, 726, 728, 728, 729, 730, 732, 734,
      735, 736, 737, 738,
    ],
  ],
  [
    '629475131',
    '28118',
    'Ballard Wallingford',
    [
      769, 769, 771, 773, 774, 776, 777, 779, 781, 782, 783, 784, 785, 786, 789, 790, 790, 792, 792, 793, 794, 796, 798,
      799, 800, 801, 802,
    ],
  ],
  [
    '629475141',
    '28118',
    'Ballard Wallingford',
    [
      829, 829, 831, 833, 834, 836, 837, 839, 841, 842, 843, 844, 845, 846, 849, 850, 850, 852, 852, 853, 854, 856, 858,
      859, 860, 861, 862,
    ],
  ],
  [
    '629475151',
    '28118',
    'Ballard Wallingford',
    [
      841, 841, 843, 845, 846, 848, 849, 851, 853, 854, 855, 856, 857, 858, 861, 862, 862, 864, 864, 865, 866, 868, 870,
      871, 872, 873, 874,
    ],
  ],
  [
    '629475161',
    '28118',
    'Ballard Wallingford',
    [
      1066, 1066, 1068, 1070, 1071, 1073, 1074, 1076, 1078, 1079, 1080, 1081, 1082, 1083, 1085, 1085, 1086, 1087, 1088,
      1088, 1089, 1091, 1092, 1093, 1094, 1095, 1096,
    ],
  ],
  [
    '629475171',
    '28118',
    'Ballard Wallingford',
    [
      1111, 1111, 1113, 1115, 1116, 1118, 1119, 1121, 1123, 1124, 1125, 1126, 1127, 1128, 1130, 1130, 1131, 1132, 1133,
      1133, 1134, 1136, 1137, 1138, 1139, 1140, 1141,
    ],
  ],
  [
    '629475181',
    '28118',
    'Ballard Wallingford',
    [
      1141, 1141, 1143, 1145, 1146, 1148, 1149, 1151, 1153, 1154, 1155, 1156, 1157, 1158, 1160, 1160, 1161, 1162, 1163,
      1163, 1164, 1166, 1167, 1168, 1169, 1170, 1171,
    ],
  ],
  [
    '629475191',
    '28118',
    'Ballard Wallingford',
    [
      1171, 1171, 1173, 1175, 1176, 1178, 1179, 1181, 1183, 1184, 1185, 1186, 1187, 1188, 1190, 1190, 1191, 1192, 1193,
      1193, 1194, 1196, 1197, 1198, 1199, 1200, 1201,
    ],
  ],
  [
    '629475201',
    '28118',
    'Ballard Wallingford',
    [
      1201, 1201, 1203, 1205, 1206, 1208, 1209, 1211, 1212, 1213, 1214, 1215, 1215, 1216, 1218, 1218, 1219, 1220, 1221,
      1221, 1222, 1224, 1225, 1226, 1227, 1228, 1229,
    ],
  ],
  [
    '629475211',
    '28118',
    'Ballard Wallingford',
    [
      1231, 1231, 1233, 1235, 1236, 1238, 1239, 1241, 1242, 1243, 1244, 1245, 1245, 1246, 1248, 1248, 1249, 1250, 1251,
      1251, 1252, 1254, 1255, 1256, 1257, 1258, 1259,
    ],
  ],
  [
    '629475221',
    '28118',
    'Ballard Wallingford',
    [
      1268, 1268, 1270, 1272, 1273, 1275, 1276, 1278, 1279, 1280, 1281, 1282, 1282, 1283, 1285, 1285, 1286, 1287, 1287,
      1288, 1289, 1290, 1291, 1292, 1293, 1294, 1295,
    ],
  ],
  [
    '629475301',
    '28118',
    'Ballard Wallingford',
    [
      439, 439, 441, 442, 444, 445, 446, 447, 448, 449, 450, 451, 451, 452, 454, 454, 455, 456, 456, 457, 458, 459, 460,
      461, 462, 463, 464,
    ],
  ],
  [
    '629475321',
    '28118',
    'Ballard Wallingford',
    [
      1051, 1051, 1053, 1055, 1056, 1058, 1059, 1061, 1063, 1064, 1065, 1066, 1067, 1068, 1070, 1071, 1071, 1073, 1073,
      1074, 1075, 1077, 1079, 1080, 1081, 1082, 1083,
    ],
  ],
  [
    '629475331',
    '28118',
    'Ballard Wallingford',
    [
      1096, 1096, 1098, 1100, 1101, 1103, 1104, 1106, 1108, 1109, 1110, 1111, 1112, 1113, 1115, 1115, 1116, 1117, 1118,
      1118, 1119, 1121, 1122, 1123, 1124, 1125, 1126,
    ],
  ],
  [
    '629475341',
    '28118',
    'Ballard Wallingford',
    [
      1126, 1126, 1128, 1130, 1131, 1133, 1134, 1136, 1138, 1139, 1140, 1141, 1142, 1143, 1145, 1145, 1146, 1147, 1148,
      1148, 1149, 1151, 1152, 1153, 1154, 1155, 1156,
    ],
  ],
  [
    '629475351',
    '28118',
    'Ballard Wallingford',
    [
      1156, 1156, 1158, 1160, 1161, 1163, 1164, 1166, 1168, 1169, 1170, 1171, 1172, 1173, 1175, 1175, 1176, 1177, 1178,
      1178, 1179, 1181, 1182, 1183, 1184, 1185, 1186,
    ],
  ],
  [
    '629475371',
    '28118',
    'Ballard Wallingford',
    [
      1216, 1216, 1218, 1220, 1221, 1223, 1224, 1226, 1227, 1228, 1229, 1230, 1230, 1231, 1233, 1233, 1234, 1235, 1236,
      1236, 1237, 1239, 1240, 1241, 1242, 1243, 1244,
    ],
  ],
  [
    '629475381',
    '28118',
    'Ballard Wallingford',
    [
      1246, 1246, 1248, 1250, 1251, 1253, 1254, 1256, 1257, 1258, 1259, 1260, 1260, 1261, 1263, 1263, 1264, 1265, 1265,
      1266, 1267, 1268, 1269, 1270, 1271, 1272, 1273,
    ],
  ],
  [
    '629484901',
    '28118',
    'Ballard Wallingford',
    [
      544, 544, 546, 548, 549, 551, 552, 554, 555, 556, 557, 558, 558, 559, 561, 561, 562, 563, 564, 564, 565, 567, 568,
      569, 570, 571, 572,
    ],
  ],
  [
    '629484911',
    '28118',
    'Ballard Wallingford',
    [
      589, 589, 591, 593, 594, 596, 597, 599, 601, 602, 603, 604, 604, 605, 607, 608, 608, 610, 610, 611, 612, 614, 616,
      617, 618, 619, 620,
    ],
  ],
  [
    '629484931',
    '28118',
    'Ballard Wallingford',
    [
      649, 649, 651, 653, 654, 656, 657, 659, 661, 662, 663, 664, 664, 665, 667, 668, 668, 670, 670, 671, 672, 674, 676,
      677, 678, 679, 680,
    ],
  ],
  [
    '633999601',
    '28118',
    'Ballard Wallingford',
    [
      807, 808, 810, 811, 813, 814, 816, 818, 819, 820, 821, 822, 823, 825, 826, 826, 827, 828, 829, 830, 831, 833, 834,
      835, 836, 837,
    ],
  ],
  [
    '633999611',
    '28118',
    'Ballard Wallingford',
    [
      733, 734, 736, 737, 739, 740, 742, 744, 745, 746, 747, 748, 749, 751, 752, 752, 753, 754, 755, 756, 757, 759, 760,
      761, 762, 763,
    ],
  ],
  [
    '633999681',
    '28118',
    'Ballard Wallingford',
    [
      425, 426, 428, 429, 430, 431, 433, 434, 435, 436, 437, 437, 438, 440, 440, 441, 442, 443, 443, 444, 446, 447, 448,
      449, 450, 451,
    ],
  ],
  [
    '633999721',
    '28118',
    'Ballard Wallingford',
    [
      865, 865, 867, 869, 870, 872, 873, 875, 877, 878, 879, 880, 881, 882, 885, 886, 886, 888, 888, 889, 890, 892, 894,
      895, 896, 897, 898,
    ],
  ],
  [
    '635611931',
    '28118',
    'Ballard Wallingford',
    [
      1188, 1189, 1191, 1192, 1194, 1195, 1197, 1198, 1199, 1200, 1201, 1201, 1202, 1204, 1204, 1205, 1206, 1207, 1207,
      1208, 1210, 1211, 1212, 1213, 1214, 1215,
    ],
  ],
  [
    '663989701',
    '28118',
    'Ballard Wallingford',
    [
      329, 330, 332, 333, 334, 335, 336, 337, 338, 339, 340, 340, 341, 343, 343, 344, 345, 345, 346, 347, 348, 349, 350,
      351, 352, 353,
    ],
  ],
  [
    '663989711',
    '28118',
    'Ballard Wallingford',
    [
      359, 360, 362, 363, 364, 365, 367, 368, 369, 370, 371, 371, 372, 374, 374, 375, 376, 377, 377, 378, 380, 381, 382,
      383, 384, 385,
    ],
  ],
  [
    '663990071',
    '28118',
    'Ballard Wallingford',
    [
      299, 300, 302, 303, 304, 305, 306, 307, 308, 309, 310, 310, 311, 313, 313, 314, 315, 315, 316, 317, 318, 319, 320,
      321, 322, 323,
    ],
  ],
];
export const STOPS_44_1: [string, string][] = [
  ['18085', '32nd Ave NW & NW Market St'],
  ['18090', 'NW 54th St & 30th Ave NW'],
  ['18100', 'NW Market St & 28th Ave NW'],
  ['18120', 'NW Market St & Ballard Ave NW'],
  ['29213', 'NW Market St & 20th Ave NW'],
  ['29215', 'NW Market St & 15th Ave NW'],
  ['29217', 'NW Market St & 11th Ave NW'],
  ['29219', 'NW Market St & 8th Ave NW'],
  ['29220', 'NW Market St & 6th Ave NW'],
  ['75407', 'NW Market St & 3rd Ave NW'],
  ['29222', 'NW Market St & NW 50th St'],
  ['29223', 'NW Market St & NW 48th St'],
  ['29225', 'N 46th St & Phinney Ave N'],
  ['29582', 'N 46th St & Aurora Ave N'],
  ['29231', 'N 45th St & Stone Way N'],
  ['29232', 'N 45th St & Woodlawn Ave N'],
  ['17410', 'N 45th St & Wallingford Ave N'],
  ['29234', 'N 45th St & Corliss Ave N'],
  ['29236', 'NE 45th St & Thackeray Pl NE'],
  ['29865', 'NE 45th St & Roosevelt Way NE'],
  ['10911', 'U District Station - Bay 3'],
  ['10912', '15th Ave NE & NE 43rd St'],
  ['10914', '15th Ave NE & NE Campus Pkwy'],
  ['10917', '15th Ave NE & NE 40th St'],
  ['29240', 'NE Pacific St & 15th Ave NE'],
  ['29242', 'NE Pacific Pl & NE Pacific St'],
  ['29243', 'NE Pacific Pl & NE Pacific St'],
];
export const TRIPS_44_1: [string, string, string, number[]][] = [
  [
    '562510221',
    '139986',
    'University Of Washington Medical Center Wallingford',
    [
      363, 363, 363, 365, 365, 367, 368, 369, 370, 371, 372, 372, 374, 376, 378, 378, 379, 381, 382, 384, 386, 387, 388,
      389, 391, 392, 393,
    ],
  ],
  [
    '562511491',
    '139986',
    'University Of Washington Medical Center Wallingford',
    [
      585, 585, 586, 588, 589, 590, 592, 593, 594, 594, 595, 596, 598, 600, 603, 604, 605, 606, 608, 611, 613, 614, 616,
      617, 619, 621, 622,
    ],
  ],
  [
    '562536511',
    '139986',
    'University Of Washington Medical Center Wallingford',
    [
      307, 307, 307, 309, 309, 310, 311, 312, 313, 313, 314, 315, 316, 317, 319, 319, 320, 321, 322, 324, 325, 326, 327,
      328, 330, 331, 332,
    ],
  ],
  [
    '562536521',
    '139986',
    'University Of Washington Medical Center Wallingford',
    [
      325, 325, 325, 327, 327, 328, 329, 330, 331, 331, 332, 333, 334, 335, 337, 337, 338, 339, 340, 342, 343, 344, 345,
      346, 348, 349, 350,
    ],
  ],
  [
    '562536531',
    '139986',
    'University Of Washington Medical Center Wallingford',
    [
      349, 349, 349, 351, 351, 352, 353, 354, 355, 355, 356, 357, 358, 359, 361, 361, 362, 364, 365, 367, 369, 370, 371,
      372, 374, 375, 376,
    ],
  ],
  [
    '659992091',
    '139986',
    'University Of Washington Medical Center Wallingford',
    [
      569, 569, 570, 572, 573, 574, 576, 577, 578, 578, 579, 580, 582, 584, 587, 588, 589, 590, 592, 595, 597, 598, 600,
      601, 602, 604, 605,
    ],
  ],
  [
    '659992281',
    '139986',
    'University Of Washington Medical Center Wallingford',
    [
      540, 540, 541, 543, 544, 545, 547, 548, 549, 549, 550, 551, 553, 555, 558, 559, 560, 561, 563, 566, 568, 569, 571,
      572, 573, 575, 576,
    ],
  ],
  [
    '659992421',
    '139986',
    'University Of Washington Medical Center Wallingford',
    [
      550, 550, 551, 553, 554, 555, 557, 558, 559, 559, 560, 561, 563, 565, 568, 569, 570, 571, 573, 576, 578, 579, 581,
      582, 583, 585, 586,
    ],
  ],
  [
    '659992691',
    '139986',
    'University Of Washington Medical Center Wallingford',
    [
      530, 530, 531, 533, 534, 535, 537, 538, 539, 539, 540, 541, 543, 545, 548, 549, 550, 551, 553, 556, 558, 559, 561,
      562, 563, 565, 566,
    ],
  ],
  [
    '659992771',
    '139986',
    'University Of Washington Medical Center Wallingford',
    [
      400, 400, 400, 402, 402, 404, 405, 406, 407, 408, 409, 409, 411, 413, 415, 415, 416, 418, 419, 421, 423, 424, 426,
      427, 428, 430, 431,
    ],
  ],
  [
    '659992991',
    '139986',
    'University Of Washington Medical Center Wallingford',
    [
      378, 378, 378, 380, 380, 382, 383, 384, 385, 386, 387, 387, 389, 391, 393, 393, 394, 396, 397, 399, 401, 402, 403,
      404, 406, 407, 408,
    ],
  ],
  [
    '659993101',
    '139986',
    'University Of Washington Medical Center Wallingford',
    [
      560, 560, 561, 563, 564, 565, 567, 568, 569, 569, 570, 571, 573, 575, 578, 579, 580, 581, 583, 586, 588, 589, 591,
      592, 593, 595, 596,
    ],
  ],
  [
    '659993601',
    '139986',
    'University Of Washington Medical Center Wallingford',
    [
      390, 390, 390, 392, 392, 394, 395, 396, 397, 398, 399, 399, 401, 403, 405, 405, 406, 408, 409, 411, 413, 414, 415,
      416, 418, 419, 420,
    ],
  ],
  [
    '664046401',
    '139986',
    'University Of Washington Medical Center Wallingford',
    [
      1620, 1620, 1620, 1622, 1622, 1623, 1624, 1624, 1625, 1625, 1625, 1626, 1627, 1628, 1630, 1630, 1631, 1633, 1634,
      1636, 1638, 1639, 1641, 1642, 1643, 1645, 1646,
    ],
  ],
  [
    '664046451',
    '139986',
    'University Of Washington Medical Center Wallingford',
    [
      1530, 1530, 1530, 1532, 1532, 1533, 1534, 1534, 1535, 1535, 1535, 1536, 1537, 1538, 1540, 1540, 1541, 1543, 1544,
      1546, 1548, 1549, 1551, 1552, 1553, 1555, 1556,
    ],
  ],
  [
    '664046481',
    '139986',
    'University Of Washington Medical Center Wallingford',
    [
      1440, 1440, 1440, 1442, 1442, 1443, 1444, 1444, 1445, 1445, 1445, 1446, 1447, 1448, 1450, 1450, 1451, 1453, 1454,
      1456, 1458, 1459, 1461, 1462, 1463, 1465, 1466,
    ],
  ],
  [
    '664046531',
    '139986',
    'University Of Washington Medical Center Wallingford',
    [
      1575, 1575, 1575, 1577, 1577, 1578, 1579, 1579, 1580, 1580, 1580, 1581, 1582, 1583, 1585, 1585, 1586, 1588, 1589,
      1591, 1593, 1594, 1596, 1597, 1598, 1600, 1601,
    ],
  ],
  [
    '664046561',
    '139986',
    'University Of Washington Medical Center Wallingford',
    [
      1360, 1360, 1360, 1362, 1362, 1363, 1364, 1365, 1366, 1366, 1367, 1368, 1369, 1371, 1373, 1373, 1374, 1376, 1377,
      1380, 1382, 1383, 1385, 1386, 1387, 1389, 1390,
    ],
  ],
  [
    '664046601',
    '139986',
    'University Of Washington Medical Center Wallingford',
    [
      1320, 1320, 1320, 1322, 1322, 1323, 1324, 1325, 1326, 1326, 1327, 1328, 1329, 1331, 1333, 1333, 1334, 1336, 1337,
      1340, 1342, 1343, 1345, 1346, 1347, 1349, 1350,
    ],
  ],
  [
    '664046611',
    '139986',
    'University Of Washington Medical Center Wallingford',
    [
      1340, 1340, 1340, 1342, 1342, 1343, 1344, 1345, 1346, 1346, 1347, 1348, 1349, 1351, 1353, 1353, 1354, 1356, 1357,
      1360, 1362, 1363, 1365, 1366, 1367, 1369, 1370,
    ],
  ],
  [
    '664046621',
    '139986',
    'University Of Washington Medical Center Wallingford',
    [
      1400, 1400, 1400, 1402, 1402, 1403, 1404, 1405, 1405, 1406, 1406, 1407, 1408, 1410, 1412, 1412, 1413, 1415, 1416,
      1418, 1420, 1421, 1423, 1424, 1425, 1427, 1428,
    ],
  ],
  [
    '664046661',
    '139986',
    'University Of Washington Medical Center Wallingford',
    [
      1420, 1420, 1420, 1422, 1422, 1423, 1424, 1425, 1425, 1426, 1426, 1427, 1428, 1429, 1431, 1431, 1432, 1434, 1435,
      1437, 1439, 1440, 1442, 1443, 1444, 1446, 1447,
    ],
  ],
  [
    '664046671',
    '139986',
    'University Of Washington Medical Center Wallingford',
    [
      1470, 1470, 1470, 1472, 1472, 1473, 1474, 1474, 1475, 1475, 1475, 1476, 1477, 1478, 1480, 1480, 1481, 1483, 1484,
      1486, 1488, 1489, 1491, 1492, 1493, 1495, 1496,
    ],
  ],
  [
    '664046701',
    '139986',
    'University Of Washington Medical Center Wallingford',
    [
      1226, 1226, 1227, 1229, 1229, 1231, 1232, 1233, 1233, 1234, 1235, 1235, 1237, 1239, 1241, 1242, 1243, 1244, 1246,
      1249, 1251, 1252, 1254, 1255, 1256, 1258, 1259,
    ],
  ],
  [
    '664046711',
    '139986',
    'University Of Washington Medical Center Wallingford',
    [
      1246, 1246, 1247, 1249, 1249, 1251, 1252, 1253, 1253, 1254, 1255, 1255, 1257, 1259, 1261, 1262, 1263, 1264, 1266,
      1269, 1271, 1272, 1274, 1275, 1276, 1278, 1279,
    ],
  ],
  [
    '664046721',
    '139986',
    'University Of Washington Medical Center Wallingford',
    [
      1260, 1260, 1261, 1263, 1263, 1265, 1266, 1267, 1267, 1268, 1269, 1269, 1271, 1273, 1275, 1276, 1277, 1278, 1280,
      1283, 1285, 1286, 1288, 1289, 1290, 1292, 1293,
    ],
  ],
  [
    '664046811',
    '139986',
    'University Of Washington Medical Center Wallingford',
    [
      1055, 1055, 1056, 1058, 1059, 1060, 1062, 1063, 1064, 1064, 1065, 1066, 1068, 1071, 1074, 1075, 1076, 1078, 1079,
      1083, 1085, 1086, 1088, 1089, 1091, 1093, 1094,
    ],
  ],
  [
    '664046901',
    '139986',
    'University Of Washington Medical Center Wallingford',
    [
      1045, 1045, 1046, 1048, 1049, 1050, 1052, 1053, 1054, 1054, 1055, 1056, 1058, 1061, 1064, 1065, 1066, 1068, 1069,
      1073, 1075, 1076, 1078, 1079, 1081, 1083, 1084,
    ],
  ],
  [
    '664046911',
    '139986',
    'University Of Washington Medical Center Wallingford',
    [
      965, 965, 966, 968, 969, 970, 972, 973, 974, 974, 975, 976, 978, 981, 984, 985, 986, 988, 990, 994, 996, 997, 999,
      1000, 1002, 1004, 1005,
    ],
  ],
  [
    '664046921',
    '139986',
    'University Of Washington Medical Center Wallingford',
    [
      1005, 1005, 1006, 1008, 1009, 1010, 1012, 1013, 1014, 1014, 1015, 1016, 1018, 1021, 1024, 1025, 1026, 1028, 1030,
      1034, 1036, 1037, 1039, 1040, 1042, 1044, 1045,
    ],
  ],
  [
    '664046991',
    '139986',
    'University Of Washington Medical Center Wallingford',
    [
      1025, 1025, 1026, 1028, 1029, 1030, 1032, 1033, 1034, 1034, 1035, 1036, 1038, 1041, 1044, 1045, 1046, 1048, 1050,
      1054, 1056, 1057, 1059, 1060, 1062, 1064, 1065,
    ],
  ],
  [
    '664047011',
    '139986',
    'University Of Washington Medical Center Wallingford',
    [
      925, 925, 926, 928, 929, 930, 932, 933, 934, 934, 935, 936, 938, 941, 944, 945, 946, 948, 950, 954, 956, 957, 959,
      960, 962, 964, 965,
    ],
  ],
  [
    '664047031',
    '139986',
    'University Of Washington Medical Center Wallingford',
    [
      905, 905, 906, 908, 909, 910, 912, 913, 914, 914, 915, 916, 918, 921, 924, 925, 926, 928, 930, 934, 936, 937, 939,
      940, 942, 944, 945,
    ],
  ],
  [
    '664047071',
    '139986',
    'University Of Washington Medical Center Wallingford',
    [
      935, 935, 936, 938, 939, 940, 942, 943, 944, 944, 945, 946, 948, 951, 954, 955, 956, 958, 960, 964, 966, 967, 969,
      970, 972, 974, 975,
    ],
  ],
  [
    '664047101',
    '139986',
    'University Of Washington Medical Center Wallingford',
    [
      823, 823, 824, 826, 827, 828, 830, 831, 832, 832, 833, 834, 836, 838, 841, 842, 843, 845, 846, 850, 852, 853, 855,
      856, 858, 860, 861,
    ],
  ],
  [
    '664047111',
    '139986',
    'University Of Washington Medical Center Wallingford',
    [
      799, 799, 800, 802, 803, 804, 806, 807, 808, 808, 809, 810, 812, 814, 817, 818, 819, 821, 822, 826, 828, 829, 831,
      832, 834, 836, 837,
    ],
  ],
  [
    '664047141',
    '139986',
    'University Of Washington Medical Center Wallingford',
    [
      1300, 1300, 1301, 1303, 1303, 1305, 1306, 1307, 1307, 1308, 1309, 1309, 1311, 1313, 1315, 1315, 1316, 1318, 1319,
      1322, 1324, 1325, 1327, 1328, 1329, 1331, 1332,
    ],
  ],
  [
    '664047161',
    '139986',
    'University Of Washington Medical Center Wallingford',
    [
      1133, 1133, 1134, 1136, 1136, 1138, 1139, 1140, 1141, 1142, 1143, 1143, 1145, 1147, 1149, 1150, 1151, 1152, 1154,
      1157, 1159, 1160, 1162, 1163, 1164, 1166, 1167,
    ],
  ],
  [
    '664047171',
    '139986',
    'University Of Washington Medical Center Wallingford',
    [
      607, 607, 608, 610, 610, 612, 613, 614, 615, 616, 617, 617, 619, 621, 624, 625, 626, 627, 629, 632, 634, 635, 637,
      638, 640, 642, 643,
    ],
  ],
  [
    '664047201',
    '139986',
    'University Of Washington Medical Center Wallingford',
    [
      679, 679, 680, 682, 683, 684, 686, 687, 688, 688, 689, 690, 692, 694, 697, 698, 699, 701, 702, 706, 708, 709, 711,
      712, 714, 716, 717,
    ],
  ],
  [
    '664047211',
    '139986',
    'University Of Washington Medical Center Wallingford',
    [
      715, 715, 716, 718, 719, 720, 722, 723, 724, 724, 725, 726, 728, 730, 733, 734, 735, 737, 738, 742, 744, 745, 747,
      748, 750, 752, 753,
    ],
  ],
  [
    '664047241',
    '139986',
    'University Of Washington Medical Center Wallingford',
    [
      975, 975, 976, 978, 979, 980, 982, 983, 984, 984, 985, 986, 988, 991, 994, 995, 996, 998, 1000, 1004, 1006, 1007,
      1009, 1010, 1012, 1014, 1015,
    ],
  ],
  [
    '664047251',
    '139986',
    'University Of Washington Medical Center Wallingford',
    [
      1015, 1015, 1016, 1018, 1019, 1020, 1022, 1023, 1024, 1024, 1025, 1026, 1028, 1031, 1034, 1035, 1036, 1038, 1040,
      1044, 1046, 1047, 1049, 1050, 1052, 1054, 1055,
    ],
  ],
  [
    '664047261',
    '139986',
    'University Of Washington Medical Center Wallingford',
    [
      691, 691, 692, 694, 695, 696, 698, 699, 700, 700, 701, 702, 704, 706, 709, 710, 711, 713, 714, 718, 720, 721, 723,
      724, 726, 728, 729,
    ],
  ],
  [
    '664047291',
    '139986',
    'University Of Washington Medical Center Wallingford',
    [
      751, 751, 752, 754, 755, 756, 758, 759, 760, 760, 761, 762, 764, 766, 769, 770, 771, 773, 774, 778, 780, 781, 783,
      784, 786, 788, 789,
    ],
  ],
  [
    '664047301',
    '139986',
    'University Of Washington Medical Center Wallingford',
    [
      859, 859, 860, 862, 863, 864, 866, 867, 868, 868, 869, 870, 872, 875, 878, 879, 880, 882, 883, 887, 889, 890, 892,
      893, 895, 897, 898,
    ],
  ],
  [
    '664047311',
    '139986',
    'University Of Washington Medical Center Wallingford',
    [
      643, 643, 644, 646, 646, 648, 649, 650, 651, 652, 653, 653, 655, 657, 660, 661, 662, 664, 665, 669, 671, 672, 674,
      675, 677, 679, 680,
    ],
  ],
  [
    '664047381',
    '139986',
    'University Of Washington Medical Center Wallingford',
    [
      1095, 1095, 1096, 1098, 1098, 1100, 1101, 1102, 1103, 1104, 1105, 1105, 1107, 1109, 1112, 1113, 1114, 1116, 1117,
      1121, 1123, 1124, 1126, 1127, 1129, 1131, 1132,
    ],
  ],
  [
    '664047431',
    '139986',
    'University Of Washington Medical Center Wallingford',
    [
      787, 787, 788, 790, 791, 792, 794, 795, 796, 796, 797, 798, 800, 802, 805, 806, 807, 809, 810, 814, 816, 817, 819,
      820, 822, 824, 825,
    ],
  ],
  [
    '664047441',
    '139986',
    'University Of Washington Medical Center Wallingford',
    [
      895, 895, 896, 898, 899, 900, 902, 903, 904, 904, 905, 906, 908, 911, 914, 915, 916, 918, 920, 924, 926, 927, 929,
      930, 932, 934, 935,
    ],
  ],
  [
    '664047481',
    '139986',
    'University Of Washington Medical Center Wallingford',
    [
      1202, 1202, 1203, 1205, 1205, 1207, 1208, 1209, 1209, 1210, 1211, 1211, 1213, 1215, 1217, 1218, 1219, 1220, 1222,
      1225, 1227, 1228, 1230, 1231, 1232, 1234, 1235,
    ],
  ],
  [
    '664047611',
    '139986',
    'University Of Washington Medical Center Wallingford',
    [
      1214, 1214, 1215, 1217, 1217, 1219, 1220, 1221, 1221, 1222, 1223, 1223, 1225, 1227, 1229, 1230, 1231, 1232, 1234,
      1237, 1239, 1240, 1242, 1243, 1244, 1246, 1247,
    ],
  ],
  [
    '664047621',
    '139986',
    'University Of Washington Medical Center Wallingford',
    [
      1103, 1103, 1104, 1106, 1106, 1108, 1109, 1110, 1111, 1112, 1113, 1113, 1115, 1117, 1120, 1121, 1122, 1124, 1125,
      1129, 1131, 1132, 1134, 1135, 1137, 1139, 1140,
    ],
  ],
  [
    '664047631',
    '139986',
    'University Of Washington Medical Center Wallingford',
    [
      655, 655, 656, 658, 658, 660, 661, 662, 663, 664, 665, 665, 667, 669, 672, 673, 674, 676, 677, 681, 683, 684, 686,
      687, 689, 691, 692,
    ],
  ],
  [
    '664047671',
    '139986',
    'University Of Washington Medical Center Wallingford',
    [
      871, 871, 872, 874, 875, 876, 878, 879, 880, 880, 881, 882, 884, 887, 890, 891, 892, 894, 895, 899, 901, 902, 904,
      905, 907, 909, 910,
    ],
  ],
  [
    '664047681',
    '139986',
    'University Of Washington Medical Center Wallingford',
    [
      763, 763, 764, 766, 767, 768, 770, 771, 772, 772, 773, 774, 776, 778, 781, 782, 783, 785, 786, 790, 792, 793, 795,
      796, 798, 800, 801,
    ],
  ],
  [
    '664047731',
    '139986',
    'University Of Washington Medical Center Wallingford',
    [
      985, 985, 986, 988, 989, 990, 992, 993, 994, 994, 995, 996, 998, 1001, 1004, 1005, 1006, 1008, 1010, 1014, 1016,
      1017, 1019, 1020, 1022, 1024, 1025,
    ],
  ],
  [
    '664047811',
    '139986',
    'University Of Washington Medical Center Wallingford',
    [
      430, 430, 431, 433, 434, 435, 437, 438, 439, 439, 440, 441, 443, 445, 448, 448, 449, 451, 452, 455, 457, 458, 460,
      461, 462, 464, 465,
    ],
  ],
  [
    '664047821',
    '139986',
    'University Of Washington Medical Center Wallingford',
    [
      450, 450, 451, 453, 454, 455, 457, 458, 459, 459, 460, 461, 463, 465, 468, 468, 469, 471, 472, 475, 477, 478, 480,
      481, 482, 484, 485,
    ],
  ],
  [
    '664047871',
    '139986',
    'University Of Washington Medical Center Wallingford',
    [
      847, 847, 848, 850, 851, 852, 854, 855, 856, 856, 857, 858, 860, 863, 866, 867, 868, 870, 871, 875, 877, 878, 880,
      881, 883, 885, 886,
    ],
  ],
  [
    '664047901',
    '139986',
    'University Of Washington Medical Center Wallingford',
    [
      631, 631, 632, 634, 634, 636, 637, 638, 639, 640, 641, 641, 643, 645, 648, 649, 650, 652, 653, 657, 659, 660, 662,
      663, 665, 667, 668,
    ],
  ],
  [
    '664047921',
    '139986',
    'University Of Washington Medical Center Wallingford',
    [
      955, 955, 956, 958, 959, 960, 962, 963, 964, 964, 965, 966, 968, 971, 974, 975, 976, 978, 980, 984, 986, 987, 989,
      990, 992, 994, 995,
    ],
  ],
  [
    '664047931',
    '139986',
    'University Of Washington Medical Center Wallingford',
    [
      739, 739, 740, 742, 743, 744, 746, 747, 748, 748, 749, 750, 752, 754, 757, 758, 759, 761, 762, 766, 768, 769, 771,
      772, 774, 776, 777,
    ],
  ],
  [
    '664047941',
    '139986',
    'University Of Washington Medical Center Wallingford',
    [
      1075, 1075, 1076, 1078, 1079, 1080, 1082, 1083, 1084, 1084, 1085, 1086, 1088, 1090, 1093, 1094, 1095, 1097, 1098,
      1102, 1104, 1105, 1107, 1108, 1110, 1112, 1113,
    ],
  ],
  [
    '664048031',
    '139986',
    'University Of Washington Medical Center Wallingford',
    [
      915, 915, 916, 918, 919, 920, 922, 923, 924, 924, 925, 926, 928, 931, 934, 935, 936, 938, 940, 944, 946, 947, 949,
      950, 952, 954, 955,
    ],
  ],
  [
    '664048081',
    '139986',
    'University Of Washington Medical Center Wallingford',
    [
      595, 595, 596, 598, 599, 600, 602, 603, 604, 604, 605, 606, 608, 610, 613, 614, 615, 616, 618, 621, 623, 624, 626,
      627, 629, 631, 632,
    ],
  ],
  [
    '664048101',
    '139986',
    'University Of Washington Medical Center Wallingford',
    [
      500, 500, 501, 503, 504, 505, 507, 508, 509, 509, 510, 511, 513, 515, 518, 519, 520, 521, 523, 526, 528, 529, 531,
      532, 533, 535, 536,
    ],
  ],
  [
    '664048161',
    '139986',
    'University Of Washington Medical Center Wallingford',
    [
      703, 703, 704, 706, 707, 708, 710, 711, 712, 712, 713, 714, 716, 718, 721, 722, 723, 725, 726, 730, 732, 733, 735,
      736, 738, 740, 741,
    ],
  ],
  [
    '664048171',
    '139986',
    'University Of Washington Medical Center Wallingford',
    [
      1035, 1035, 1036, 1038, 1039, 1040, 1042, 1043, 1044, 1044, 1045, 1046, 1048, 1051, 1054, 1055, 1056, 1058, 1059,
      1063, 1065, 1066, 1068, 1069, 1071, 1073, 1074,
    ],
  ],
  [
    '664048211',
    '139986',
    'University Of Washington Medical Center Wallingford',
    [
      811, 811, 812, 814, 815, 816, 818, 819, 820, 820, 821, 822, 824, 826, 829, 830, 831, 833, 834, 838, 840, 841, 843,
      844, 846, 848, 849,
    ],
  ],
  [
    '664048241',
    '139986',
    'University Of Washington Medical Center Wallingford',
    [
      420, 420, 421, 423, 424, 425, 427, 428, 429, 429, 430, 431, 433, 435, 438, 438, 439, 441, 442, 445, 447, 448, 450,
      451, 452, 454, 455,
    ],
  ],
  [
    '664048271',
    '139986',
    'University Of Washington Medical Center Wallingford',
    [
      480, 480, 481, 483, 484, 485, 487, 488, 489, 489, 490, 491, 493, 495, 498, 498, 499, 501, 502, 505, 507, 508, 510,
      511, 512, 514, 515,
    ],
  ],
  [
    '664048381',
    '139986',
    'University Of Washington Medical Center Wallingford',
    [
      775, 775, 776, 778, 779, 780, 782, 783, 784, 784, 785, 786, 788, 790, 793, 794, 795, 797, 798, 802, 804, 805, 807,
      808, 810, 812, 813,
    ],
  ],
  [
    '664048391',
    '139986',
    'University Of Washington Medical Center Wallingford',
    [
      883, 883, 884, 886, 887, 888, 890, 891, 892, 892, 893, 894, 896, 899, 902, 903, 904, 906, 908, 912, 914, 915, 917,
      918, 920, 922, 923,
    ],
  ],
  [
    '664048401',
    '139986',
    'University Of Washington Medical Center Wallingford',
    [
      460, 460, 461, 463, 464, 465, 467, 468, 469, 469, 470, 471, 473, 475, 478, 478, 479, 481, 482, 485, 487, 488, 490,
      491, 492, 494, 495,
    ],
  ],
  [
    '664048411',
    '139986',
    'University Of Washington Medical Center Wallingford',
    [
      995, 995, 996, 998, 999, 1000, 1002, 1003, 1004, 1004, 1005, 1006, 1008, 1011, 1014, 1015, 1016, 1018, 1020, 1024,
      1026, 1027, 1029, 1030, 1032, 1034, 1035,
    ],
  ],
  [
    '664048461',
    '139986',
    'University Of Washington Medical Center Wallingford',
    [
      667, 667, 668, 670, 671, 672, 674, 675, 676, 676, 677, 678, 680, 682, 685, 686, 687, 689, 690, 694, 696, 697, 699,
      700, 702, 704, 705,
    ],
  ],
  [
    '664048591',
    '139986',
    'University Of Washington Medical Center Wallingford',
    [
      510, 510, 511, 513, 514, 515, 517, 518, 519, 519, 520, 521, 523, 525, 528, 529, 530, 531, 533, 536, 538, 539, 541,
      542, 543, 545, 546,
    ],
  ],
  [
    '664048601',
    '139986',
    'University Of Washington Medical Center Wallingford',
    [
      945, 945, 946, 948, 949, 950, 952, 953, 954, 954, 955, 956, 958, 961, 964, 965, 966, 968, 970, 974, 976, 977, 979,
      980, 982, 984, 985,
    ],
  ],
  [
    '664048611',
    '139986',
    'University Of Washington Medical Center Wallingford',
    [
      1065, 1065, 1066, 1068, 1069, 1070, 1072, 1073, 1074, 1074, 1075, 1076, 1078, 1081, 1084, 1085, 1086, 1088, 1089,
      1093, 1095, 1096, 1098, 1099, 1101, 1103, 1104,
    ],
  ],
  [
    '664048621',
    '139986',
    'University Of Washington Medical Center Wallingford',
    [
      835, 835, 836, 838, 839, 840, 842, 843, 844, 844, 845, 846, 848, 851, 854, 855, 856, 858, 859, 863, 865, 866, 868,
      869, 871, 873, 874,
    ],
  ],
  [
    '664048681',
    '139986',
    'University Of Washington Medical Center Wallingford',
    [
      727, 727, 728, 730, 731, 732, 734, 735, 736, 736, 737, 738, 740, 742, 745, 746, 747, 749, 750, 754, 756, 757, 759,
      760, 762, 764, 765,
    ],
  ],
  [
    '664048721',
    '139986',
    'University Of Washington Medical Center Wallingford',
    [
      1177, 1177, 1178, 1180, 1180, 1182, 1183, 1184, 1185, 1186, 1187, 1187, 1189, 1191, 1193, 1194, 1195, 1196, 1198,
      1201, 1203, 1204, 1206, 1207, 1208, 1210, 1211,
    ],
  ],
  [
    '664048731',
    '139986',
    'University Of Washington Medical Center Wallingford',
    [
      410, 410, 410, 412, 412, 414, 415, 416, 417, 418, 419, 419, 421, 423, 426, 426, 427, 429, 430, 433, 435, 436, 438,
      439, 440, 442, 443,
    ],
  ],
  [
    '664048751',
    '139986',
    'University Of Washington Medical Center Wallingford',
    [
      1380, 1380, 1380, 1382, 1382, 1383, 1384, 1385, 1385, 1386, 1386, 1387, 1388, 1390, 1392, 1392, 1393, 1395, 1396,
      1398, 1400, 1401, 1403, 1404, 1405, 1407, 1408,
    ],
  ],
  [
    '664048781',
    '139986',
    'University Of Washington Medical Center Wallingford',
    [
      1280, 1280, 1281, 1283, 1283, 1285, 1286, 1287, 1287, 1288, 1289, 1289, 1291, 1293, 1295, 1295, 1296, 1298, 1299,
      1302, 1304, 1305, 1307, 1308, 1309, 1311, 1312,
    ],
  ],
  [
    '664048791',
    '139986',
    'University Of Washington Medical Center Wallingford',
    [
      619, 619, 620, 622, 622, 624, 625, 626, 627, 628, 629, 629, 631, 633, 636, 637, 638, 639, 641, 644, 646, 647, 649,
      650, 652, 654, 655,
    ],
  ],
  [
    '694060191',
    '139986',
    'University Of Washington Medical Center Wallingford',
    [
      1149, 1149, 1150, 1152, 1152, 1154, 1155, 1156, 1157, 1158, 1159, 1159, 1161, 1163, 1165, 1166, 1167, 1168, 1170,
      1173, 1175, 1176, 1178, 1179, 1180, 1182, 1183,
    ],
  ],
  [
    '800584341',
    '139986',
    'University District',
    [
      1708, 1708, 1708, 1710, 1710, 1711, 1712, 1712, 1713, 1713, 1713, 1714, 1715, 1716, 1718, 1718, 1719, 1721, 1722,
      1724, 1726,
    ],
  ],
  [
    '800584371',
    '139986',
    'University District',
    [
      1500, 1500, 1500, 1502, 1502, 1503, 1504, 1504, 1505, 1505, 1505, 1506, 1507, 1508, 1510, 1510, 1511, 1513, 1514,
      1516, 1518,
    ],
  ],
  [
    '800584411',
    '139986',
    'University District',
    [
      1663, 1663, 1663, 1665, 1665, 1666, 1667, 1667, 1668, 1668, 1668, 1669, 1670, 1671, 1673, 1673, 1674, 1676, 1677,
      1679, 1681,
    ],
  ],
  [
    '800584661',
    '139986',
    'University District',
    [
      1163, 1163, 1164, 1166, 1166, 1168, 1169, 1170, 1171, 1172, 1173, 1173, 1175, 1177, 1179, 1180, 1181, 1182, 1184,
      1187, 1189,
    ],
  ],
  [
    '800584681',
    '139986',
    'University District',
    [
      1123, 1123, 1124, 1126, 1126, 1128, 1129, 1130, 1131, 1132, 1133, 1133, 1135, 1137, 1140, 1141, 1142, 1143, 1145,
      1148, 1150,
    ],
  ],
  [
    '800584741',
    '139986',
    'University District',
    [
      1085, 1085, 1086, 1088, 1088, 1090, 1091, 1092, 1093, 1094, 1095, 1095, 1097, 1099, 1102, 1103, 1104, 1106, 1107,
      1111, 1113,
    ],
  ],
  [
    '800584771',
    '139986',
    'University District',
    [
      1155, 1155, 1156, 1158, 1158, 1160, 1161, 1162, 1163, 1164, 1165, 1165, 1167, 1169, 1171, 1172, 1173, 1174, 1176,
      1179, 1181,
    ],
  ],
  [
    '800584911',
    '139986',
    'University District',
    [
      1140, 1140, 1141, 1143, 1143, 1145, 1146, 1147, 1148, 1149, 1150, 1150, 1152, 1154, 1156, 1157, 1158, 1159, 1161,
      1164, 1166,
    ],
  ],
  [
    '800585041',
    '139986',
    'University District',
    [
      1546, 1546, 1546, 1548, 1548, 1549, 1550, 1550, 1551, 1551, 1551, 1552, 1553, 1554, 1556, 1556, 1557, 1559, 1560,
      1562, 1564,
    ],
  ],
  [
    '800585091',
    '139986',
    'University District',
    [
      1234, 1234, 1235, 1237, 1237, 1239, 1240, 1241, 1241, 1242, 1243, 1243, 1245, 1247, 1249, 1250, 1251, 1252, 1254,
      1257, 1259,
    ],
  ],
  [
    '800585681',
    '139986',
    'University District',
    [
      1308, 1308, 1309, 1311, 1311, 1313, 1314, 1315, 1315, 1316, 1317, 1317, 1319, 1321, 1323, 1323, 1324, 1326, 1327,
      1330, 1332,
    ],
  ],
  [
    '800585751',
    '139986',
    'University District',
    [
      1187, 1187, 1188, 1190, 1190, 1192, 1193, 1194, 1195, 1196, 1197, 1197, 1199, 1201, 1203, 1204, 1205, 1206, 1208,
      1211, 1213,
    ],
  ],
  [
    '800586191',
    '139986',
    'University District',
    [576, 576, 577, 579, 580, 581, 583, 584, 585, 585, 586, 587, 589, 591, 594, 595, 596, 597, 599, 602, 604],
  ],
  [
    '800586251',
    '139986',
    'University District',
    [
      1113, 1113, 1114, 1116, 1116, 1118, 1119, 1120, 1121, 1122, 1123, 1123, 1125, 1127, 1130, 1131, 1132, 1134, 1135,
      1139, 1141,
    ],
  ],
  [
    '800586671',
    '139986',
    'University District',
    [
      1486, 1486, 1486, 1488, 1488, 1489, 1490, 1490, 1491, 1491, 1491, 1492, 1493, 1494, 1496, 1496, 1497, 1499, 1500,
      1502, 1504,
    ],
  ],
  [
    '846331841',
    '139986',
    'University District',
    [470, 470, 471, 473, 474, 475, 477, 478, 479, 479, 480, 481, 483, 485, 488, 488, 489, 491, 492, 495, 497],
  ],
  [
    '846332441',
    '139986',
    'University District',
    [520, 520, 521, 523, 524, 525, 527, 528, 529, 529, 530, 531, 533, 535, 538, 539, 540, 541, 543, 546, 548],
  ],
  [
    '846332761',
    '139986',
    'University District',
    [440, 440, 441, 443, 444, 445, 447, 448, 449, 449, 450, 451, 453, 455, 458, 458, 459, 461, 462, 465, 467],
  ],
  [
    '846333081',
    '139986',
    'University District',
    [490, 490, 491, 493, 494, 495, 497, 498, 499, 499, 500, 501, 503, 505, 508, 508, 509, 511, 512, 515, 517],
  ],
  [
    '562570051',
    '27238',
    'University Of Washington Medical Center Wallingford',
    [
      1140, 1140, 1141, 1143, 1143, 1145, 1146, 1147, 1147, 1148, 1149, 1149, 1151, 1153, 1156, 1156, 1157, 1159, 1160,
      1163, 1165, 1166, 1167, 1168, 1170, 1171, 1172,
    ],
  ],
  [
    '562570091',
    '27238',
    'University District',
    [
      1155, 1155, 1156, 1158, 1158, 1160, 1161, 1162, 1162, 1163, 1164, 1164, 1166, 1168, 1171, 1171, 1172, 1174, 1175,
      1178, 1180,
    ],
  ],
  [
    '562570301',
    '27238',
    'University Of Washington Medical Center Wallingford',
    [
      1185, 1185, 1186, 1188, 1188, 1190, 1191, 1192, 1192, 1193, 1194, 1194, 1196, 1198, 1201, 1201, 1202, 1204, 1205,
      1208, 1210, 1211, 1212, 1213, 1215, 1216, 1217,
    ],
  ],
  [
    '562570671',
    '27238',
    'University Of Washington Medical Center Wallingford',
    [
      1170, 1170, 1171, 1173, 1173, 1175, 1176, 1177, 1177, 1178, 1179, 1179, 1181, 1183, 1186, 1186, 1187, 1189, 1190,
      1193, 1195, 1196, 1197, 1198, 1200, 1201, 1202,
    ],
  ],
  [
    '634036271',
    '27238',
    'University Of Washington Medical Center Wallingford',
    [
      1125, 1125, 1126, 1128, 1129, 1130, 1132, 1133, 1134, 1134, 1135, 1136, 1138, 1140, 1143, 1143, 1144, 1146, 1147,
      1150, 1152, 1153, 1154, 1155, 1157, 1158, 1159,
    ],
  ],
  [
    '634036301',
    '27238',
    'University Of Washington Medical Center Wallingford',
    [
      1380, 1380, 1380, 1382, 1382, 1384, 1385, 1386, 1386, 1387, 1388, 1388, 1390, 1392, 1394, 1394, 1395, 1397, 1398,
      1400, 1402, 1403, 1404, 1405, 1407, 1408, 1409,
    ],
  ],
  [
    '634036351',
    '27238',
    'University Of Washington Medical Center Wallingford',
    [
      1020, 1020, 1021, 1023, 1024, 1025, 1027, 1028, 1029, 1029, 1030, 1031, 1033, 1035, 1038, 1039, 1040, 1041, 1043,
      1046, 1048, 1049, 1051, 1052, 1053, 1055, 1056,
    ],
  ],
  [
    '634036371',
    '27238',
    'University Of Washington Medical Center Wallingford',
    [
      1280, 1280, 1281, 1283, 1283, 1285, 1286, 1287, 1287, 1288, 1289, 1289, 1291, 1293, 1295, 1295, 1296, 1298, 1299,
      1302, 1304, 1305, 1306, 1307, 1309, 1310, 1311,
    ],
  ],
  [
    '634036381',
    '27238',
    'University Of Washington Medical Center Wallingford',
    [
      975, 975, 976, 978, 979, 980, 982, 983, 984, 984, 985, 986, 988, 990, 993, 994, 995, 996, 998, 1001, 1003, 1004,
      1006, 1007, 1008, 1010, 1011,
    ],
  ],
  [
    '634036411',
    '27238',
    'University Of Washington Medical Center Wallingford',
    [
      1080, 1080, 1081, 1083, 1084, 1085, 1087, 1088, 1089, 1089, 1090, 1091, 1093, 1095, 1098, 1099, 1100, 1101, 1103,
      1106, 1108, 1109, 1111, 1112, 1113, 1115, 1116,
    ],
  ],
  [
    '634036431',
    '27238',
    'University Of Washington Medical Center Wallingford',
    [
      1600, 1600, 1600, 1602, 1602, 1603, 1604, 1605, 1605, 1606, 1606, 1607, 1608, 1609, 1611, 1611, 1612, 1613, 1614,
      1617, 1618, 1619, 1620, 1621, 1623, 1624, 1625,
    ],
  ],
  [
    '634036581',
    '27238',
    'University Of Washington Medical Center Wallingford',
    [
      915, 915, 916, 918, 919, 920, 922, 923, 924, 924, 925, 926, 928, 931, 934, 935, 936, 938, 939, 943, 945, 946, 948,
      949, 950, 952, 953,
    ],
  ],
  [
    '634036621',
    '27238',
    'University Of Washington Medical Center Wallingford',
    [
      870, 870, 871, 873, 873, 875, 876, 877, 878, 879, 880, 880, 882, 885, 888, 889, 890, 892, 893, 897, 899, 900, 902,
      903, 904, 906, 907,
    ],
  ],
  [
    '634036651',
    '27238',
    'University Of Washington Medical Center Wallingford',
    [
      810, 810, 811, 813, 813, 815, 816, 817, 818, 819, 820, 820, 822, 825, 828, 829, 830, 832, 833, 837, 839, 840, 842,
      843, 844, 846, 847,
    ],
  ],
  [
    '634036681',
    '27238',
    'University Of Washington Medical Center Wallingford',
    [
      765, 765, 766, 768, 768, 770, 771, 772, 773, 774, 775, 775, 777, 780, 783, 784, 785, 786, 788, 791, 793, 794, 796,
      797, 798, 800, 801,
    ],
  ],
  [
    '634036711',
    '27238',
    'University Of Washington Medical Center Wallingford',
    [
      708, 708, 709, 711, 711, 713, 714, 715, 716, 717, 718, 718, 720, 723, 726, 727, 728, 729, 731, 734, 736, 737, 739,
      740, 741, 743, 744,
    ],
  ],
  [
    '634036731',
    '27238',
    'University Of Washington Medical Center Wallingford',
    [
      672, 672, 673, 675, 675, 677, 678, 679, 680, 681, 682, 682, 684, 686, 688, 689, 690, 691, 693, 696, 698, 699, 701,
      702, 703, 705, 706,
    ],
  ],
  [
    '634036761',
    '27238',
    'University Of Washington Medical Center Wallingford',
    [
      588, 588, 589, 591, 591, 593, 594, 595, 596, 597, 598, 598, 600, 602, 604, 604, 605, 607, 608, 610, 612, 613, 614,
      615, 617, 618, 619,
    ],
  ],
  [
    '634036851',
    '27238',
    'University Of Washington Medical Center Wallingford',
    [
      1400, 1400, 1400, 1402, 1402, 1403, 1404, 1405, 1406, 1406, 1407, 1408, 1409, 1411, 1413, 1413, 1414, 1416, 1417,
      1419, 1421, 1422, 1423, 1424, 1426, 1427, 1428,
    ],
  ],
  [
    '634036911',
    '27238',
    'University Of Washington Medical Center Wallingford',
    [
      795, 795, 796, 798, 798, 800, 801, 802, 803, 804, 805, 805, 807, 810, 813, 814, 815, 817, 818, 822, 824, 825, 827,
      828, 829, 831, 832,
    ],
  ],
  [
    '634036921',
    '27238',
    'University Of Washington Medical Center Wallingford',
    [
      611, 611, 612, 614, 614, 616, 617, 618, 619, 620, 621, 621, 623, 625, 627, 627, 628, 630, 631, 633, 635, 636, 638,
      639, 640, 642, 643,
    ],
  ],
  [
    '634036941',
    '27238',
    'University Of Washington Medical Center Wallingford',
    [
      900, 900, 901, 903, 904, 905, 907, 908, 909, 909, 910, 911, 913, 916, 919, 920, 921, 923, 924, 928, 930, 931, 933,
      934, 935, 937, 938,
    ],
  ],
  [
    '634036961',
    '27238',
    'University Of Washington Medical Center Wallingford',
    [
      524, 524, 524, 526, 526, 528, 529, 530, 531, 532, 533, 533, 535, 537, 539, 539, 540, 542, 543, 545, 547, 548, 549,
      550, 552, 553, 554,
    ],
  ],
  [
    '634036971',
    '27238',
    'University Of Washington Medical Center Wallingford',
    [
      696, 696, 697, 699, 699, 701, 702, 703, 704, 705, 706, 706, 708, 711, 714, 715, 716, 717, 719, 722, 724, 725, 727,
      728, 729, 731, 732,
    ],
  ],
  [
    '634036991',
    '27238',
    'University Of Washington Medical Center Wallingford',
    [
      1300, 1300, 1301, 1303, 1303, 1305, 1306, 1307, 1307, 1308, 1309, 1309, 1311, 1313, 1315, 1315, 1316, 1318, 1319,
      1322, 1324, 1325, 1326, 1327, 1329, 1330, 1331,
    ],
  ],
  [
    '634037011',
    '27238',
    'University Of Washington Medical Center Wallingford',
    [
      1200, 1200, 1201, 1203, 1203, 1205, 1206, 1207, 1207, 1208, 1209, 1209, 1211, 1213, 1216, 1216, 1217, 1219, 1220,
      1223, 1225, 1226, 1227, 1228, 1230, 1231, 1232,
    ],
  ],
  [
    '634037021',
    '27238',
    'University Of Washington Medical Center Wallingford',
    [
      1005, 1005, 1006, 1008, 1009, 1010, 1012, 1013, 1014, 1014, 1015, 1016, 1018, 1020, 1023, 1024, 1025, 1026, 1028,
      1031, 1033, 1034, 1036, 1037, 1038, 1040, 1041,
    ],
  ],
  [
    '634037241',
    '27238',
    'University Of Washington Medical Center Wallingford',
    [
      576, 576, 577, 579, 579, 581, 582, 583, 584, 585, 586, 586, 588, 590, 592, 592, 593, 595, 596, 598, 600, 601, 602,
      603, 605, 606, 607,
    ],
  ],
  [
    '634037261',
    '27238',
    'University Of Washington Medical Center Wallingford',
    [
      660, 660, 661, 663, 663, 665, 666, 667, 668, 669, 670, 670, 672, 674, 676, 677, 678, 679, 681, 684, 686, 687, 689,
      690, 691, 693, 694,
    ],
  ],
  [
    '634037271',
    '27238',
    'University Of Washington Medical Center Wallingford',
    [
      495, 495, 495, 497, 497, 499, 500, 501, 501, 502, 503, 503, 505, 507, 509, 509, 510, 512, 513, 515, 517, 518, 519,
      520, 522, 523, 524,
    ],
  ],
  [
    '634037281',
    '27238',
    'University Of Washington Medical Center Wallingford',
    [
      1360, 1360, 1360, 1362, 1362, 1364, 1365, 1366, 1366, 1367, 1368, 1368, 1370, 1372, 1374, 1374, 1375, 1377, 1378,
      1380, 1382, 1383, 1384, 1385, 1387, 1388, 1389,
    ],
  ],
  [
    '634037291',
    '27238',
    'University Of Washington Medical Center Wallingford',
    [
      750, 750, 751, 753, 753, 755, 756, 757, 758, 759, 760, 760, 762, 765, 768, 769, 770, 771, 773, 776, 778, 779, 781,
      782, 783, 785, 786,
    ],
  ],
  [
    '634037301',
    '27238',
    'University Of Washington Medical Center Wallingford',
    [
      855, 855, 856, 858, 858, 860, 861, 862, 863, 864, 865, 865, 867, 870, 873, 874, 875, 877, 878, 882, 884, 885, 887,
      888, 889, 891, 892,
    ],
  ],
  [
    '634037341',
    '27238',
    'University Of Washington Medical Center Wallingford',
    [
      960, 960, 961, 963, 964, 965, 967, 968, 969, 969, 970, 971, 973, 975, 978, 979, 980, 981, 983, 986, 988, 989, 991,
      992, 993, 995, 996,
    ],
  ],
  [
    '634037361',
    '27238',
    'University Of Washington Medical Center Wallingford',
    [
      1260, 1260, 1261, 1263, 1263, 1265, 1266, 1267, 1267, 1268, 1269, 1269, 1271, 1273, 1275, 1275, 1276, 1278, 1279,
      1282, 1284, 1285, 1286, 1287, 1289, 1290, 1291,
    ],
  ],
  [
    '634037371',
    '27238',
    'University Of Washington Medical Center Wallingford',
    [
      1065, 1065, 1066, 1068, 1069, 1070, 1072, 1073, 1074, 1074, 1075, 1076, 1078, 1080, 1083, 1084, 1085, 1086, 1088,
      1091, 1093, 1094, 1096, 1097, 1098, 1100, 1101,
    ],
  ],
  [
    '634037511',
    '27238',
    'University Of Washington Medical Center Wallingford',
    [
      552, 552, 552, 554, 554, 556, 557, 558, 559, 560, 561, 561, 563, 565, 567, 567, 568, 570, 571, 573, 575, 576, 577,
      578, 580, 581, 582,
    ],
  ],
  [
    '634037541',
    '27238',
    'University Of Washington Medical Center Wallingford',
    [
      465, 465, 465, 467, 467, 468, 469, 470, 471, 471, 472, 473, 474, 476, 478, 478, 479, 480, 481, 484, 485, 486, 487,
      488, 490, 491, 492,
    ],
  ],
  [
    '634037651',
    '27238',
    'University Of Washington Medical Center Wallingford',
    [
      480, 480, 480, 482, 482, 483, 484, 485, 486, 486, 487, 488, 489, 491, 493, 493, 494, 495, 496, 499, 500, 501, 502,
      503, 505, 506, 507,
    ],
  ],
  [
    '634037671',
    '27238',
    'University Of Washington Medical Center Wallingford',
    [
      1440, 1440, 1440, 1442, 1442, 1443, 1444, 1445, 1446, 1446, 1447, 1448, 1449, 1451, 1453, 1453, 1454, 1456, 1457,
      1459, 1461, 1462, 1463, 1464, 1466, 1467, 1468,
    ],
  ],
  [
    '634037681',
    '27238',
    'University Of Washington Medical Center Wallingford',
    [
      564, 564, 564, 566, 566, 568, 569, 570, 571, 572, 573, 573, 575, 577, 579, 579, 580, 582, 583, 585, 587, 588, 589,
      590, 592, 593, 594,
    ],
  ],
  [
    '634037691',
    '27238',
    'University Of Washington Medical Center Wallingford',
    [
      648, 648, 649, 651, 651, 653, 654, 655, 656, 657, 658, 658, 660, 662, 664, 665, 666, 667, 669, 672, 674, 675, 677,
      678, 679, 681, 682,
    ],
  ],
  [
    '634037741',
    '27238',
    'University Of Washington Medical Center Wallingford',
    [
      735, 735, 736, 738, 738, 740, 741, 742, 743, 744, 745, 745, 747, 750, 753, 754, 755, 756, 758, 761, 763, 764, 766,
      767, 768, 770, 771,
    ],
  ],
  [
    '634037751',
    '27238',
    'University Of Washington Medical Center Wallingford',
    [
      840, 840, 841, 843, 843, 845, 846, 847, 848, 849, 850, 850, 852, 855, 858, 859, 860, 862, 863, 867, 869, 870, 872,
      873, 874, 876, 877,
    ],
  ],
  [
    '634037761',
    '27238',
    'University Of Washington Medical Center Wallingford',
    [
      1245, 1245, 1246, 1248, 1248, 1250, 1251, 1252, 1252, 1253, 1254, 1254, 1256, 1258, 1261, 1261, 1262, 1264, 1265,
      1268, 1270, 1271, 1272, 1273, 1275, 1276, 1277,
    ],
  ],
  [
    '634037801',
    '27238',
    'University Of Washington Medical Center Wallingford',
    [
      1340, 1340, 1341, 1343, 1343, 1345, 1346, 1347, 1347, 1348, 1349, 1349, 1351, 1353, 1355, 1355, 1356, 1358, 1359,
      1361, 1363, 1364, 1365, 1366, 1368, 1369, 1370,
    ],
  ],
  [
    '634037811',
    '27238',
    'University Of Washington Medical Center Wallingford',
    [
      945, 945, 946, 948, 949, 950, 952, 953, 954, 954, 955, 956, 958, 961, 964, 965, 966, 967, 969, 972, 974, 975, 977,
      978, 979, 981, 982,
    ],
  ],
  [
    '634037841',
    '27238',
    'University Of Washington Medical Center Wallingford',
    [
      1050, 1050, 1051, 1053, 1054, 1055, 1057, 1058, 1059, 1059, 1060, 1061, 1063, 1065, 1068, 1069, 1070, 1071, 1073,
      1076, 1078, 1079, 1081, 1082, 1083, 1085, 1086,
    ],
  ],
  [
    '634037871',
    '27238',
    'University Of Washington Medical Center Wallingford',
    [
      1540, 1540, 1540, 1542, 1542, 1543, 1544, 1545, 1546, 1546, 1547, 1548, 1549, 1551, 1553, 1553, 1554, 1556, 1557,
      1559, 1561, 1562, 1563, 1564, 1566, 1567, 1568,
    ],
  ],
  [
    '634038041',
    '27238',
    'University Of Washington Medical Center Wallingford',
    [
      394, 394, 394, 396, 396, 397, 398, 399, 400, 400, 401, 402, 403, 405, 407, 407, 408, 409, 410, 413, 414, 415, 416,
      417, 419, 420, 421,
    ],
  ],
  [
    '634038101',
    '27238',
    'University Of Washington Medical Center Wallingford',
    [
      450, 450, 450, 452, 452, 453, 454, 455, 456, 456, 457, 458, 459, 461, 463, 463, 464, 465, 466, 469, 470, 471, 472,
      473, 475, 476, 477,
    ],
  ],
  [
    '634038111',
    '27238',
    'University Of Washington Medical Center Wallingford',
    [
      363, 363, 363, 365, 365, 366, 367, 368, 369, 369, 370, 371, 372, 374, 376, 376, 377, 378, 379, 382, 383, 384, 385,
      386, 388, 389, 390,
    ],
  ],
  [
    '634038131',
    '27238',
    'University Of Washington Medical Center Wallingford',
    [
      540, 540, 540, 542, 542, 544, 545, 546, 547, 548, 549, 549, 551, 553, 555, 555, 556, 558, 559, 561, 563, 564, 565,
      566, 568, 569, 570,
    ],
  ],
  [
    '634038141',
    '27238',
    'University Of Washington Medical Center Wallingford',
    [
      624, 624, 625, 627, 627, 629, 630, 631, 632, 633, 634, 634, 636, 638, 640, 641, 642, 643, 645, 648, 650, 651, 653,
      654, 655, 657, 658,
    ],
  ],
  [
    '634038191',
    '27238',
    'University Of Washington Medical Center Wallingford',
    [
      720, 720, 721, 723, 723, 725, 726, 727, 728, 729, 730, 730, 732, 735, 738, 739, 740, 741, 743, 746, 748, 749, 751,
      752, 753, 755, 756,
    ],
  ],
  [
    '634038211',
    '27238',
    'University Of Washington Medical Center Wallingford',
    [
      825, 825, 826, 828, 828, 830, 831, 832, 833, 834, 835, 835, 837, 840, 843, 844, 845, 847, 848, 852, 854, 855, 857,
      858, 859, 861, 862,
    ],
  ],
  [
    '634038241',
    '27238',
    'University Of Washington Medical Center Wallingford',
    [
      930, 930, 931, 933, 934, 935, 937, 938, 939, 939, 940, 941, 943, 946, 949, 950, 951, 952, 954, 957, 959, 960, 962,
      963, 964, 966, 967,
    ],
  ],
  [
    '634038251',
    '27238',
    'University Of Washington Medical Center Wallingford',
    [
      1320, 1320, 1321, 1323, 1323, 1325, 1326, 1327, 1327, 1328, 1329, 1329, 1331, 1333, 1335, 1335, 1336, 1338, 1339,
      1342, 1344, 1345, 1346, 1347, 1349, 1350, 1351,
    ],
  ],
  [
    '634038291',
    '27238',
    'University Of Washington Medical Center Wallingford',
    [
      1035, 1035, 1036, 1038, 1039, 1040, 1042, 1043, 1044, 1044, 1045, 1046, 1048, 1050, 1053, 1054, 1055, 1056, 1058,
      1061, 1063, 1064, 1066, 1067, 1068, 1070, 1071,
    ],
  ],
  [
    '634038481',
    '27238',
    'University Of Washington Medical Center Wallingford',
    [
      331, 331, 331, 333, 333, 334, 335, 336, 337, 337, 338, 339, 340, 341, 343, 343, 344, 345, 346, 349, 350, 351, 352,
      353, 354, 355, 356,
    ],
  ],
  [
    '634038501',
    '27238',
    'University Of Washington Medical Center Wallingford',
    [
      424, 424, 424, 426, 426, 427, 428, 429, 430, 430, 431, 432, 433, 435, 437, 437, 438, 439, 440, 443, 444, 445, 446,
      447, 449, 450, 451,
    ],
  ],
  [
    '634038521',
    '27238',
    'University Of Washington Medical Center Wallingford',
    [
      510, 510, 510, 512, 512, 514, 515, 516, 516, 517, 518, 518, 520, 522, 524, 524, 525, 527, 528, 530, 532, 533, 534,
      535, 537, 538, 539,
    ],
  ],
  [
    '634038541',
    '27238',
    'University Of Washington Medical Center Wallingford',
    [
      600, 600, 601, 603, 603, 605, 606, 607, 608, 609, 610, 610, 612, 614, 616, 616, 617, 619, 620, 622, 624, 625, 626,
      627, 629, 630, 631,
    ],
  ],
  [
    '634038591',
    '27238',
    'University Of Washington Medical Center Wallingford',
    [
      780, 780, 781, 783, 783, 785, 786, 787, 788, 789, 790, 790, 792, 795, 798, 799, 800, 802, 803, 807, 809, 810, 812,
      813, 814, 816, 817,
    ],
  ],
  [
    '634038611',
    '27238',
    'University Of Washington Medical Center Wallingford',
    [
      885, 885, 886, 888, 888, 890, 891, 892, 893, 894, 895, 895, 897, 900, 903, 904, 905, 907, 908, 912, 914, 915, 917,
      918, 919, 921, 922,
    ],
  ],
  [
    '634038631',
    '27238',
    'University Of Washington Medical Center Wallingford',
    [
      990, 990, 991, 993, 994, 995, 997, 998, 999, 999, 1000, 1001, 1003, 1005, 1008, 1009, 1010, 1011, 1013, 1016,
      1018, 1019, 1021, 1022, 1023, 1025, 1026,
    ],
  ],
  [
    '663969641',
    '27238',
    'University Of Washington Medical Center Wallingford',
    [
      1215, 1215, 1216, 1218, 1218, 1220, 1221, 1222, 1222, 1223, 1224, 1224, 1226, 1228, 1231, 1231, 1232, 1234, 1235,
      1238, 1240, 1241, 1242, 1243, 1245, 1246, 1247,
    ],
  ],
  [
    '663970081',
    '27238',
    'University Of Washington Medical Center Wallingford',
    [
      1500, 1500, 1500, 1502, 1502, 1503, 1504, 1505, 1506, 1506, 1507, 1508, 1509, 1511, 1513, 1513, 1514, 1516, 1517,
      1519, 1521, 1522, 1523, 1524, 1526, 1527, 1528,
    ],
  ],
  [
    '663970531',
    '27238',
    'University Of Washington Medical Center Wallingford',
    [
      636, 636, 637, 639, 639, 641, 642, 643, 644, 645, 646, 646, 648, 650, 652, 653, 654, 655, 657, 660, 662, 663, 665,
      666, 667, 669, 670,
    ],
  ],
  [
    '663971311',
    '27238',
    'University Of Washington Medical Center Wallingford',
    [
      1095, 1095, 1096, 1098, 1099, 1100, 1102, 1103, 1104, 1104, 1105, 1106, 1108, 1110, 1113, 1113, 1114, 1116, 1117,
      1120, 1122, 1123, 1125, 1126, 1127, 1129, 1130,
    ],
  ],
  [
    '727421001',
    '27238',
    'University District',
    [
      1480, 1480, 1480, 1482, 1482, 1483, 1484, 1485, 1486, 1486, 1487, 1488, 1489, 1491, 1493, 1493, 1494, 1496, 1497,
      1499, 1501,
    ],
  ],
  [
    '727421161',
    '27238',
    'University District',
    [
      1720, 1720, 1720, 1722, 1722, 1723, 1724, 1725, 1725, 1726, 1726, 1727, 1728, 1729, 1731, 1731, 1732, 1733, 1734,
      1737, 1738,
    ],
  ],
  [
    '727421351',
    '27238',
    'University District',
    [
      1110, 1110, 1111, 1113, 1114, 1115, 1117, 1118, 1119, 1119, 1120, 1121, 1123, 1125, 1128, 1128, 1129, 1131, 1132,
      1135, 1137,
    ],
  ],
  [
    '727421591',
    '27238',
    'University District',
    [
      1460, 1460, 1460, 1462, 1462, 1463, 1464, 1465, 1466, 1466, 1467, 1468, 1469, 1471, 1473, 1473, 1474, 1476, 1477,
      1479, 1481,
    ],
  ],
  [
    '727422121',
    '27238',
    'University District',
    [
      1660, 1660, 1660, 1662, 1662, 1663, 1664, 1665, 1665, 1666, 1666, 1667, 1668, 1669, 1671, 1671, 1672, 1673, 1674,
      1677, 1678,
    ],
  ],
  [
    '727422291',
    '27238',
    'University District',
    [
      1420, 1420, 1420, 1422, 1422, 1423, 1424, 1425, 1426, 1426, 1427, 1428, 1429, 1431, 1433, 1433, 1434, 1436, 1437,
      1439, 1441,
    ],
  ],
  [
    '727422381',
    '27238',
    'University District',
    [
      1230, 1230, 1231, 1233, 1233, 1235, 1236, 1237, 1237, 1238, 1239, 1239, 1241, 1243, 1246, 1246, 1247, 1249, 1250,
      1253, 1255,
    ],
  ],
  [
    '727422561',
    '27238',
    'University District',
    [684, 684, 685, 687, 687, 689, 690, 691, 692, 693, 694, 694, 696, 698, 700, 701, 702, 703, 705, 708, 710],
  ],
  [
    '562590591',
    '28118',
    'University Of Washington Medical Center Wallingford',
    [
      465, 465, 466, 468, 468, 470, 471, 472, 472, 473, 474, 474, 476, 477, 479, 479, 480, 481, 482, 484, 485, 486, 487,
      488, 490, 491, 492,
    ],
  ],
  [
    '562590601',
    '28118',
    'University Of Washington Medical Center Wallingford',
    [
      450, 450, 451, 453, 453, 455, 456, 457, 457, 458, 459, 459, 461, 462, 464, 464, 465, 466, 467, 469, 470, 471, 472,
      473, 475, 476, 477,
    ],
  ],
  [
    '562590611',
    '28118',
    'University Of Washington Medical Center Wallingford',
    [
      495, 495, 496, 498, 498, 500, 501, 502, 502, 503, 504, 504, 506, 507, 509, 509, 510, 511, 512, 514, 515, 516, 517,
      518, 520, 521, 522,
    ],
  ],
  [
    '562590621',
    '28118',
    'University Of Washington Medical Center Wallingford',
    [
      510, 510, 511, 513, 513, 515, 516, 517, 517, 518, 519, 519, 521, 522, 524, 524, 525, 526, 527, 530, 531, 532, 533,
      534, 536, 537, 538,
    ],
  ],
  [
    '562590631',
    '28118',
    'University Of Washington Medical Center Wallingford',
    [
      525, 525, 526, 528, 528, 530, 531, 532, 532, 533, 534, 534, 536, 537, 539, 539, 540, 541, 542, 545, 546, 547, 548,
      549, 551, 552, 553,
    ],
  ],
  [
    '562590641',
    '28118',
    'University Of Washington Medical Center Wallingford',
    [
      540, 540, 541, 543, 543, 545, 546, 547, 548, 549, 550, 550, 552, 553, 555, 555, 556, 557, 558, 561, 562, 563, 564,
      565, 567, 568, 569,
    ],
  ],
  [
    '562590681',
    '28118',
    'University Of Washington Medical Center Wallingford',
    [
      600, 600, 601, 603, 603, 605, 606, 607, 608, 609, 610, 610, 612, 614, 616, 616, 617, 619, 620, 622, 624, 625, 626,
      627, 629, 630, 631,
    ],
  ],
  [
    '562590721',
    '28118',
    'University Of Washington Medical Center Wallingford',
    [
      660, 660, 661, 663, 663, 665, 666, 667, 668, 669, 670, 670, 672, 674, 676, 676, 677, 679, 680, 682, 684, 685, 686,
      687, 689, 690, 691,
    ],
  ],
  [
    '562590931',
    '28118',
    'University Of Washington Medical Center Wallingford',
    [
      975, 975, 976, 978, 979, 980, 982, 983, 984, 984, 985, 986, 988, 990, 993, 994, 995, 997, 998, 1002, 1004, 1005,
      1006, 1007, 1009, 1010, 1011,
    ],
  ],
  [
    '562590941',
    '28118',
    'University Of Washington Medical Center Wallingford',
    [
      990, 990, 991, 993, 994, 995, 997, 998, 999, 999, 1000, 1001, 1003, 1005, 1008, 1009, 1010, 1012, 1013, 1017,
      1019, 1020, 1021, 1022, 1024, 1025, 1026,
    ],
  ],
  [
    '562590951',
    '28118',
    'University Of Washington Medical Center Wallingford',
    [
      1005, 1005, 1006, 1008, 1009, 1010, 1012, 1013, 1014, 1014, 1015, 1016, 1018, 1020, 1023, 1024, 1025, 1026, 1028,
      1031, 1033, 1034, 1035, 1036, 1038, 1039, 1040,
    ],
  ],
  [
    '562590961',
    '28118',
    'University Of Washington Medical Center Wallingford',
    [
      1035, 1035, 1036, 1038, 1038, 1040, 1041, 1042, 1043, 1044, 1045, 1045, 1047, 1049, 1052, 1053, 1054, 1055, 1057,
      1060, 1062, 1063, 1064, 1065, 1067, 1068, 1069,
    ],
  ],
  [
    '562590971',
    '28118',
    'University Of Washington Medical Center Wallingford',
    [
      1065, 1065, 1066, 1068, 1068, 1070, 1071, 1072, 1073, 1074, 1075, 1075, 1077, 1079, 1082, 1083, 1084, 1085, 1087,
      1090, 1092, 1093, 1094, 1095, 1097, 1098, 1099,
    ],
  ],
  [
    '562590991',
    '28118',
    'University Of Washington Medical Center Wallingford',
    [
      1170, 1170, 1171, 1173, 1173, 1175, 1176, 1177, 1177, 1178, 1179, 1179, 1181, 1182, 1184, 1184, 1185, 1186, 1187,
      1190, 1191, 1192, 1193, 1194, 1196, 1197, 1198,
    ],
  ],
  [
    '562591001',
    '28118',
    'University Of Washington Medical Center Wallingford',
    [
      1200, 1200, 1201, 1203, 1203, 1205, 1206, 1207, 1207, 1208, 1209, 1209, 1211, 1212, 1214, 1214, 1215, 1216, 1217,
      1220, 1221, 1222, 1223, 1224, 1226, 1227, 1228,
    ],
  ],
  [
    '562591011',
    '28118',
    'University Of Washington Medical Center Wallingford',
    [
      1260, 1260, 1261, 1263, 1263, 1265, 1266, 1267, 1267, 1268, 1269, 1269, 1271, 1272, 1274, 1274, 1275, 1276, 1277,
      1280, 1281, 1282, 1283, 1284, 1286, 1287, 1288,
    ],
  ],
  [
    '562591021',
    '28118',
    'University Of Washington Medical Center Wallingford',
    [
      1320, 1320, 1321, 1323, 1323, 1325, 1326, 1327, 1327, 1328, 1329, 1329, 1331, 1332, 1334, 1334, 1335, 1336, 1337,
      1340, 1341, 1342, 1343, 1344, 1346, 1347, 1348,
    ],
  ],
  [
    '562591031',
    '28118',
    'University Of Washington Medical Center Wallingford',
    [
      1380, 1380, 1380, 1382, 1382, 1383, 1384, 1385, 1386, 1386, 1387, 1388, 1389, 1390, 1392, 1392, 1393, 1394, 1395,
      1398, 1399, 1400, 1401, 1402, 1404, 1405, 1406,
    ],
  ],
  [
    '562591061',
    '28118',
    'University Of Washington Medical Center Wallingford',
    [
      480, 480, 481, 483, 483, 485, 486, 487, 487, 488, 489, 489, 491, 492, 494, 494, 495, 496, 497, 499, 500, 501, 502,
      503, 505, 506, 507,
    ],
  ],
  [
    '562591081',
    '28118',
    'University Of Washington Medical Center Wallingford',
    [
      1360, 1360, 1360, 1362, 1362, 1364, 1365, 1366, 1366, 1367, 1368, 1368, 1370, 1371, 1373, 1373, 1374, 1375, 1376,
      1379, 1380, 1381, 1382, 1383, 1385, 1386, 1387,
    ],
  ],
  [
    '562591101',
    '28118',
    'University Of Washington Medical Center Wallingford',
    [
      1125, 1125, 1126, 1128, 1128, 1130, 1131, 1132, 1132, 1133, 1134, 1134, 1136, 1138, 1140, 1140, 1141, 1143, 1144,
      1146, 1148, 1149, 1150, 1151, 1153, 1154, 1155,
    ],
  ],
  [
    '562591131',
    '28118',
    'University Of Washington Medical Center Wallingford',
    [
      1020, 1020, 1021, 1023, 1023, 1025, 1026, 1027, 1028, 1029, 1030, 1030, 1032, 1034, 1037, 1038, 1039, 1040, 1042,
      1045, 1047, 1048, 1049, 1050, 1052, 1053, 1054,
    ],
  ],
  [
    '562591141',
    '28118',
    'University Of Washington Medical Center Wallingford',
    [
      1050, 1050, 1051, 1053, 1053, 1055, 1056, 1057, 1058, 1059, 1060, 1060, 1062, 1064, 1067, 1068, 1069, 1070, 1072,
      1075, 1077, 1078, 1079, 1080, 1082, 1083, 1084,
    ],
  ],
  [
    '562591151',
    '28118',
    'University Of Washington Medical Center Wallingford',
    [
      1110, 1110, 1111, 1113, 1113, 1115, 1116, 1117, 1118, 1119, 1120, 1120, 1122, 1124, 1127, 1127, 1128, 1130, 1131,
      1133, 1135, 1136, 1137, 1138, 1140, 1141, 1142,
    ],
  ],
  [
    '562591171',
    '28118',
    'University Of Washington Medical Center Wallingford',
    [
      1080, 1080, 1081, 1083, 1083, 1085, 1086, 1087, 1088, 1089, 1090, 1090, 1092, 1094, 1097, 1098, 1099, 1100, 1102,
      1105, 1107, 1108, 1109, 1110, 1112, 1113, 1114,
    ],
  ],
  [
    '562591181',
    '28118',
    'University Of Washington Medical Center Wallingford',
    [
      1340, 1340, 1340, 1342, 1342, 1344, 1345, 1346, 1346, 1347, 1348, 1348, 1350, 1351, 1353, 1353, 1354, 1355, 1356,
      1359, 1360, 1361, 1362, 1363, 1365, 1366, 1367,
    ],
  ],
  [
    '562591191',
    '28118',
    'University Of Washington Medical Center Wallingford',
    [
      1300, 1300, 1301, 1303, 1303, 1305, 1306, 1307, 1307, 1308, 1309, 1309, 1311, 1312, 1314, 1314, 1315, 1316, 1317,
      1320, 1321, 1322, 1323, 1324, 1326, 1327, 1328,
    ],
  ],
  [
    '562591211',
    '28118',
    'University Of Washington Medical Center Wallingford',
    [
      1280, 1280, 1281, 1283, 1283, 1285, 1286, 1287, 1287, 1288, 1289, 1289, 1291, 1292, 1294, 1294, 1295, 1296, 1297,
      1300, 1301, 1302, 1303, 1304, 1306, 1307, 1308,
    ],
  ],
  [
    '562591221',
    '28118',
    'University Of Washington Medical Center Wallingford',
    [
      1155, 1155, 1156, 1158, 1158, 1160, 1161, 1162, 1162, 1163, 1164, 1164, 1166, 1167, 1169, 1169, 1170, 1172, 1173,
      1175, 1177, 1178, 1179, 1180, 1182, 1183, 1184,
    ],
  ],
  [
    '562591231',
    '28118',
    'University Of Washington Medical Center Wallingford',
    [
      1185, 1185, 1186, 1188, 1188, 1190, 1191, 1192, 1192, 1193, 1194, 1194, 1196, 1197, 1199, 1199, 1200, 1201, 1202,
      1205, 1206, 1207, 1208, 1209, 1211, 1212, 1213,
    ],
  ],
  [
    '585830921',
    '28118',
    'University Of Washington Medical Center Wallingford',
    [
      1460, 1460, 1460, 1462, 1462, 1463, 1464, 1465, 1466, 1466, 1467, 1468, 1469, 1470, 1472, 1472, 1473, 1474, 1475,
      1477, 1478, 1479, 1480, 1481, 1483, 1484, 1485,
    ],
  ],
  [
    '605393041',
    '28118',
    'University Of Washington Medical Center Wallingford',
    [
      1400, 1400, 1400, 1402, 1402, 1403, 1404, 1405, 1406, 1406, 1407, 1408, 1409, 1410, 1412, 1412, 1413, 1414, 1415,
      1418, 1419, 1420, 1421, 1422, 1424, 1425, 1426,
    ],
  ],
  [
    '605409651',
    '28118',
    'University Of Washington Medical Center Wallingford',
    [
      1540, 1540, 1540, 1542, 1542, 1543, 1544, 1545, 1546, 1546, 1547, 1548, 1549, 1550, 1552, 1552, 1553, 1554, 1555,
      1557, 1558, 1559, 1560, 1561, 1563, 1564, 1565,
    ],
  ],
  [
    '605409661',
    '28118',
    'University Of Washington Medical Center Wallingford',
    [
      1600, 1600, 1600, 1602, 1602, 1603, 1604, 1605, 1606, 1606, 1607, 1608, 1609, 1610, 1612, 1612, 1613, 1614, 1615,
      1617, 1618, 1619, 1620, 1621, 1623, 1624, 1625,
    ],
  ],
  [
    '629475441',
    '28118',
    'University Of Washington Medical Center Wallingford',
    [
      335, 335, 336, 338, 338, 339, 340, 341, 342, 342, 343, 344, 345, 346, 348, 348, 349, 349, 350, 352, 353, 354, 355,
      356, 358, 359, 360,
    ],
  ],
  [
    '629475451',
    '28118',
    'University Of Washington Medical Center Wallingford',
    [
      365, 365, 366, 368, 368, 369, 370, 371, 372, 372, 373, 374, 375, 376, 378, 378, 379, 379, 380, 382, 383, 384, 385,
      386, 388, 389, 390,
    ],
  ],
  [
    '629475461',
    '28118',
    'University Of Washington Medical Center Wallingford',
    [
      395, 395, 396, 398, 398, 399, 400, 401, 402, 402, 403, 404, 405, 406, 408, 408, 409, 409, 410, 412, 413, 414, 415,
      416, 418, 419, 420,
    ],
  ],
  [
    '629475471',
    '28118',
    'University Of Washington Medical Center Wallingford',
    [
      425, 425, 426, 428, 428, 430, 431, 432, 432, 433, 434, 434, 436, 437, 439, 439, 440, 440, 441, 443, 444, 445, 446,
      447, 449, 450, 451,
    ],
  ],
  [
    '629475541',
    '28118',
    'University Of Washington Medical Center Wallingford',
    [
      555, 555, 556, 558, 558, 560, 561, 562, 563, 564, 565, 565, 567, 568, 570, 570, 571, 573, 574, 576, 578, 579, 580,
      581, 583, 584, 585,
    ],
  ],
  [
    '629475561',
    '28118',
    'University Of Washington Medical Center Wallingford',
    [
      585, 585, 586, 588, 588, 590, 591, 592, 593, 594, 595, 595, 597, 599, 601, 601, 602, 604, 605, 607, 609, 610, 611,
      612, 614, 615, 616,
    ],
  ],
  [
    '629475581',
    '28118',
    'University Of Washington Medical Center Wallingford',
    [
      615, 615, 616, 618, 618, 620, 621, 622, 623, 624, 625, 625, 627, 629, 631, 631, 632, 634, 635, 637, 639, 640, 641,
      642, 644, 645, 646,
    ],
  ],
  [
    '629475591',
    '28118',
    'University Of Washington Medical Center Wallingford',
    [
      630, 630, 631, 633, 633, 635, 636, 637, 638, 639, 640, 640, 642, 644, 646, 646, 647, 649, 650, 652, 654, 655, 656,
      657, 659, 660, 661,
    ],
  ],
  [
    '629475601',
    '28118',
    'University Of Washington Medical Center Wallingford',
    [
      645, 645, 646, 648, 648, 650, 651, 652, 653, 654, 655, 655, 657, 659, 661, 661, 662, 664, 665, 667, 669, 670, 671,
      672, 674, 675, 676,
    ],
  ],
  [
    '629475621',
    '28118',
    'University Of Washington Medical Center Wallingford',
    [
      675, 675, 676, 678, 678, 680, 681, 682, 683, 684, 685, 685, 687, 689, 691, 691, 692, 694, 695, 698, 700, 701, 702,
      703, 705, 706, 707,
    ],
  ],
  [
    '629475631',
    '28118',
    'University Of Washington Medical Center Wallingford',
    [
      690, 690, 691, 693, 693, 695, 696, 697, 698, 699, 700, 700, 702, 704, 706, 706, 707, 709, 710, 713, 715, 716, 717,
      718, 720, 721, 722,
    ],
  ],
  [
    '629475641',
    '28118',
    'University Of Washington Medical Center Wallingford',
    [
      705, 705, 706, 708, 708, 710, 711, 712, 713, 714, 715, 715, 717, 719, 721, 721, 722, 724, 725, 728, 730, 731, 732,
      733, 735, 736, 737,
    ],
  ],
  [
    '629475651',
    '28118',
    'University Of Washington Medical Center Wallingford',
    [
      719, 719, 720, 722, 723, 724, 726, 727, 728, 728, 729, 730, 732, 734, 736, 737, 738, 739, 741, 744, 746, 747, 748,
      749, 751, 752, 753,
    ],
  ],
  [
    '629475661',
    '28118',
    'University Of Washington Medical Center Wallingford',
    [
      733, 733, 734, 736, 737, 738, 740, 741, 742, 742, 743, 744, 746, 748, 750, 751, 752, 753, 755, 758, 760, 761, 762,
      763, 765, 766, 767,
    ],
  ],
  [
    '629475671',
    '28118',
    'University Of Washington Medical Center Wallingford',
    [
      747, 747, 748, 750, 751, 752, 754, 755, 756, 756, 757, 758, 760, 762, 764, 765, 766, 767, 769, 772, 774, 775, 776,
      777, 779, 780, 781,
    ],
  ],
  [
    '629475681',
    '28118',
    'University Of Washington Medical Center Wallingford',
    [
      762, 762, 763, 765, 766, 767, 769, 770, 771, 771, 772, 773, 775, 777, 780, 781, 782, 784, 785, 789, 791, 792, 793,
      794, 796, 797, 798,
    ],
  ],
  [
    '629475691',
    '28118',
    'University Of Washington Medical Center Wallingford',
    [
      777, 777, 778, 780, 781, 782, 784, 785, 786, 786, 787, 788, 790, 792, 795, 796, 797, 799, 800, 804, 806, 807, 808,
      809, 811, 812, 813,
    ],
  ],
  [
    '629475701',
    '28118',
    'University Of Washington Medical Center Wallingford',
    [
      792, 792, 793, 795, 796, 797, 799, 800, 801, 801, 802, 803, 805, 807, 810, 811, 812, 814, 815, 819, 821, 822, 823,
      824, 826, 827, 828,
    ],
  ],
  [
    '629475711',
    '28118',
    'University Of Washington Medical Center Wallingford',
    [
      804, 804, 805, 807, 808, 809, 811, 812, 813, 813, 814, 815, 817, 819, 822, 823, 824, 826, 827, 831, 833, 834, 835,
      836, 838, 839, 840,
    ],
  ],
  [
    '629475731',
    '28118',
    'University Of Washington Medical Center Wallingford',
    [
      816, 816, 817, 819, 820, 821, 823, 824, 825, 825, 826, 827, 829, 831, 834, 835, 836, 838, 839, 843, 845, 846, 847,
      848, 850, 851, 852,
    ],
  ],
  [
    '629475741',
    '28118',
    'University Of Washington Medical Center Wallingford',
    [
      828, 828, 829, 831, 832, 833, 835, 836, 837, 837, 838, 839, 841, 843, 846, 847, 848, 850, 851, 855, 857, 858, 859,
      860, 862, 863, 864,
    ],
  ],
  [
    '629475751',
    '28118',
    'University Of Washington Medical Center Wallingford',
    [
      864, 864, 865, 867, 868, 869, 871, 872, 873, 873, 874, 875, 877, 879, 882, 883, 884, 886, 887, 891, 893, 894, 895,
      896, 898, 899, 900,
    ],
  ],
  [
    '629475761',
    '28118',
    'University Of Washington Medical Center Wallingford',
    [
      876, 876, 877, 879, 880, 881, 883, 884, 885, 885, 886, 887, 889, 891, 894, 895, 896, 898, 899, 903, 905, 906, 907,
      908, 910, 911, 912,
    ],
  ],
  [
    '629475771',
    '28118',
    'University Of Washington Medical Center Wallingford',
    [
      888, 888, 889, 891, 892, 893, 895, 896, 897, 897, 898, 899, 901, 903, 906, 907, 908, 910, 911, 915, 917, 918, 919,
      920, 922, 923, 924,
    ],
  ],
  [
    '629475781',
    '28118',
    'University Of Washington Medical Center Wallingford',
    [
      912, 912, 913, 915, 916, 917, 919, 920, 921, 921, 922, 923, 925, 927, 930, 931, 932, 934, 935, 939, 941, 942, 943,
      944, 946, 947, 948,
    ],
  ],
  [
    '629475791',
    '28118',
    'University Of Washington Medical Center Wallingford',
    [
      924, 924, 925, 927, 928, 929, 931, 932, 933, 933, 934, 935, 937, 939, 942, 943, 944, 946, 947, 951, 953, 954, 955,
      956, 958, 959, 960,
    ],
  ],
  [
    '629475811',
    '28118',
    'University Of Washington Medical Center Wallingford',
    [
      948, 948, 949, 951, 952, 953, 955, 956, 957, 957, 958, 959, 961, 963, 966, 967, 968, 970, 971, 975, 977, 978, 979,
      980, 982, 983, 984,
    ],
  ],
  [
    '629475941',
    '28118',
    'University Of Washington Medical Center Wallingford',
    [
      1480, 1480, 1480, 1482, 1482, 1483, 1484, 1485, 1486, 1486, 1487, 1488, 1489, 1490, 1492, 1492, 1493, 1494, 1495,
      1497, 1498, 1499, 1500, 1501, 1503, 1504, 1505,
    ],
  ],
  [
    '629476011',
    '28118',
    'University Of Washington Medical Center Wallingford',
    [
      1225, 1225, 1226, 1228, 1228, 1230, 1231, 1232, 1232, 1233, 1234, 1234, 1236, 1237, 1239, 1239, 1240, 1241, 1242,
      1245, 1246, 1247, 1248, 1249, 1251, 1252, 1253,
    ],
  ],
  [
    '629476091',
    '28118',
    'University Of Washington Medical Center Wallingford',
    [
      1240, 1240, 1241, 1243, 1243, 1245, 1246, 1247, 1247, 1248, 1249, 1249, 1251, 1252, 1254, 1254, 1255, 1256, 1257,
      1260, 1261, 1262, 1263, 1264, 1266, 1267, 1268,
    ],
  ],
  [
    '629484921',
    '28118',
    'University Of Washington Medical Center Wallingford',
    [
      570, 570, 571, 573, 573, 575, 576, 577, 578, 579, 580, 580, 582, 584, 586, 586, 587, 589, 590, 592, 594, 595, 596,
      597, 599, 600, 601,
    ],
  ],
  [
    '633999541',
    '28118',
    'University Of Washington Medical Center Wallingford',
    [
      960, 960, 961, 963, 964, 965, 967, 968, 969, 969, 970, 971, 973, 975, 978, 979, 980, 982, 983, 987, 989, 990, 991,
      992, 994, 995, 996,
    ],
  ],
  [
    '633999761',
    '28118',
    'University Of Washington Medical Center Wallingford',
    [
      840, 840, 841, 843, 844, 845, 847, 848, 849, 849, 850, 851, 853, 855, 858, 859, 860, 862, 863, 867, 869, 870, 871,
      872, 874, 875, 876,
    ],
  ],
  [
    '633999781',
    '28118',
    'University Of Washington Medical Center Wallingford',
    [
      852, 852, 853, 855, 856, 857, 859, 860, 861, 861, 862, 863, 865, 867, 870, 871, 872, 874, 875, 879, 881, 882, 883,
      884, 886, 887, 888,
    ],
  ],
  [
    '633999811',
    '28118',
    'University Of Washington Medical Center Wallingford',
    [
      900, 900, 901, 903, 904, 905, 907, 908, 909, 909, 910, 911, 913, 915, 918, 919, 920, 922, 923, 927, 929, 930, 931,
      932, 934, 935, 936,
    ],
  ],
  [
    '846295391',
    '28118',
    'University District',
    [936, 936, 937, 940, 941, 942, 944, 945, 946, 946, 947, 948, 950, 952, 955, 956, 957, 959, 960, 964, 966],
  ],
  [
    '846295461',
    '28118',
    'University District',
    [
      1095, 1095, 1096, 1099, 1100, 1101, 1103, 1104, 1105, 1105, 1106, 1107, 1109, 1111, 1114, 1115, 1116, 1117, 1119,
      1122, 1124,
    ],
  ],
  [
    '846295521',
    '28118',
    'University District',
    [
      1440, 1440, 1441, 1443, 1443, 1444, 1445, 1446, 1447, 1447, 1448, 1449, 1450, 1451, 1453, 1453, 1454, 1455, 1456,
      1459, 1460,
    ],
  ],
  [
    '846295571',
    '28118',
    'University District',
    [
      1420, 1420, 1421, 1423, 1423, 1425, 1426, 1427, 1427, 1428, 1429, 1429, 1431, 1432, 1434, 1434, 1435, 1436, 1437,
      1440, 1441,
    ],
  ],
  [
    '846295641',
    '28118',
    'University District',
    [
      1140, 1140, 1141, 1144, 1144, 1146, 1147, 1148, 1149, 1150, 1151, 1151, 1153, 1155, 1157, 1157, 1158, 1160, 1161,
      1164, 1166,
    ],
  ],
  [
    '846295721',
    '28118',
    'University District',
    [
      1215, 1215, 1216, 1218, 1218, 1220, 1221, 1222, 1223, 1224, 1225, 1225, 1227, 1229, 1231, 1231, 1232, 1234, 1235,
      1237, 1239,
    ],
  ],
  [
    '846296041',
    '28118',
    'University District',
    [
      1350, 1350, 1351, 1353, 1353, 1355, 1356, 1357, 1357, 1358, 1359, 1359, 1361, 1362, 1364, 1364, 1365, 1366, 1367,
      1370, 1371,
    ],
  ],
  [
    '846296131',
    '28118',
    'University District',
    [
      1660, 1660, 1661, 1663, 1663, 1664, 1665, 1666, 1667, 1667, 1668, 1669, 1670, 1671, 1673, 1673, 1674, 1675, 1676,
      1678, 1679,
    ],
  ],
  [
    '846296141',
    '28118',
    'University District',
    [
      1720, 1720, 1721, 1723, 1723, 1724, 1725, 1726, 1727, 1727, 1728, 1729, 1730, 1731, 1733, 1733, 1734, 1735, 1736,
      1738, 1739,
    ],
  ],
];
export const CALENDARS: { service_id: string; weekdays: number[]; start: string; end: string }[] = [
  { service_id: '139986', weekdays: [1, 1, 1, 0, 0, 0, 0], start: '20260914', end: '20270326' },
  { service_id: '27238', weekdays: [0, 0, 0, 0, 0, 1, 0], start: '20260919', end: '20270320' },
  { service_id: '28118', weekdays: [0, 0, 0, 0, 0, 0, 1], start: '20260920', end: '20270321' },
];
export const EXCEPTIONS: { service_id: string; date: string; type: number }[] = [
  { service_id: '139986', date: '20261126', type: 2 },
  { service_id: '139986', date: '20270304', type: 1 },
  { service_id: '139986', date: '20261001', type: 1 },
  { service_id: '139986', date: '20261119', type: 1 },
  { service_id: '139986', date: '20260924', type: 1 },
  { service_id: '139986', date: '20261022', type: 1 },
  { service_id: '139986', date: '20261112', type: 1 },
  { service_id: '139986', date: '20261210', type: 1 },
  { service_id: '139986', date: '20270204', type: 1 },
  { service_id: '139986', date: '20270107', type: 1 },
  { service_id: '139986', date: '20260917', type: 1 },
  { service_id: '139986', date: '20261015', type: 1 },
  { service_id: '139986', date: '20261105', type: 1 },
  { service_id: '139986', date: '20261203', type: 1 },
  { service_id: '139986', date: '20270128', type: 1 },
  { service_id: '139986', date: '20261231', type: 1 },
  { service_id: '139986', date: '20270225', type: 1 },
  { service_id: '139986', date: '20261008', type: 1 },
  { service_id: '139986', date: '20270325', type: 1 },
  { service_id: '139986', date: '20270121', type: 1 },
  { service_id: '139986', date: '20261224', type: 1 },
  { service_id: '139986', date: '20270218', type: 1 },
  { service_id: '139986', date: '20261029', type: 1 },
  { service_id: '139986', date: '20270318', type: 1 },
  { service_id: '139986', date: '20270114', type: 1 },
  { service_id: '139986', date: '20261217', type: 1 },
  { service_id: '139986', date: '20270311', type: 1 },
  { service_id: '139986', date: '20270211', type: 1 },
  { service_id: '139986', date: '20270101', type: 2 },
  { service_id: '139986', date: '20261225', type: 2 },
  { service_id: '139986', date: '20261030', type: 1 },
  { service_id: '139986', date: '20270319', type: 1 },
  { service_id: '139986', date: '20261218', type: 1 },
  { service_id: '139986', date: '20270115', type: 1 },
  { service_id: '139986', date: '20270312', type: 1 },
  { service_id: '139986', date: '20270212', type: 1 },
  { service_id: '139986', date: '20270305', type: 1 },
  { service_id: '139986', date: '20270205', type: 1 },
  { service_id: '139986', date: '20270326', type: 1 },
  { service_id: '139986', date: '20261002', type: 1 },
  { service_id: '139986', date: '20261120', type: 1 },
  { service_id: '139986', date: '20260925', type: 1 },
  { service_id: '139986', date: '20261023', type: 1 },
  { service_id: '139986', date: '20261211', type: 1 },
  { service_id: '139986', date: '20261113', type: 1 },
  { service_id: '139986', date: '20270108', type: 1 },
  { service_id: '139986', date: '20261016', type: 1 },
  { service_id: '139986', date: '20260918', type: 1 },
  { service_id: '139986', date: '20261204', type: 1 },
  { service_id: '139986', date: '20261106', type: 1 },
  { service_id: '139986', date: '20270129', type: 1 },
  { service_id: '139986', date: '20270226', type: 1 },
  { service_id: '139986', date: '20261009', type: 1 },
  { service_id: '139986', date: '20261127', type: 1 },
  { service_id: '139986', date: '20270122', type: 1 },
  { service_id: '139986', date: '20270219', type: 1 },
  { service_id: '28118', date: '20270304', type: 2 },
  { service_id: '28118', date: '20261001', type: 2 },
  { service_id: '28118', date: '20261119', type: 2 },
  { service_id: '28118', date: '20260924', type: 2 },
  { service_id: '28118', date: '20261022', type: 2 },
  { service_id: '28118', date: '20261112', type: 2 },
  { service_id: '28118', date: '20261210', type: 2 },
  { service_id: '28118', date: '20270204', type: 2 },
  { service_id: '28118', date: '20270107', type: 2 },
  { service_id: '28118', date: '20261015', type: 2 },
  { service_id: '28118', date: '20261105', type: 2 },
  { service_id: '28118', date: '20261203', type: 2 },
  { service_id: '28118', date: '20270128', type: 2 },
  { service_id: '28118', date: '20261231', type: 2 },
  { service_id: '28118', date: '20270225', type: 2 },
  { service_id: '28118', date: '20261008', type: 2 },
  { service_id: '28118', date: '20270121', type: 2 },
  { service_id: '28118', date: '20261224', type: 2 },
  { service_id: '28118', date: '20270218', type: 2 },
  { service_id: '28118', date: '20261029', type: 2 },
  { service_id: '28118', date: '20270318', type: 2 },
  { service_id: '28118', date: '20270114', type: 2 },
  { service_id: '28118', date: '20261217', type: 2 },
  { service_id: '28118', date: '20270311', type: 2 },
  { service_id: '28118', date: '20270211', type: 2 },
  { service_id: '28118', date: '20261126', type: 1 },
  { service_id: '28118', date: '20261030', type: 2 },
  { service_id: '28118', date: '20270319', type: 2 },
  { service_id: '28118', date: '20261218', type: 2 },
  { service_id: '28118', date: '20270115', type: 2 },
  { service_id: '28118', date: '20270312', type: 2 },
  { service_id: '28118', date: '20270212', type: 2 },
  { service_id: '28118', date: '20270305', type: 2 },
  { service_id: '28118', date: '20270205', type: 2 },
  { service_id: '28118', date: '20261002', type: 2 },
  { service_id: '28118', date: '20261120', type: 2 },
  { service_id: '28118', date: '20260925', type: 2 },
  { service_id: '28118', date: '20261023', type: 2 },
  { service_id: '28118', date: '20261211', type: 2 },
  { service_id: '28118', date: '20261113', type: 2 },
  { service_id: '28118', date: '20270108', type: 2 },
  { service_id: '28118', date: '20261016', type: 2 },
  { service_id: '28118', date: '20261204', type: 2 },
  { service_id: '28118', date: '20261106', type: 2 },
  { service_id: '28118', date: '20270129', type: 2 },
  { service_id: '28118', date: '20270226', type: 2 },
  { service_id: '28118', date: '20261009', type: 2 },
  { service_id: '28118', date: '20261127', type: 2 },
  { service_id: '28118', date: '20270122', type: 2 },
  { service_id: '28118', date: '20270219', type: 2 },
  { service_id: '28118', date: '20270101', type: 1 },
  { service_id: '28118', date: '20261225', type: 1 },
];
